/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/__root'
import { Route as clientRouteRouteImport } from './app/(client)/route'
import { Route as ManagementRouteRouteImport } from './app/management/route'
import { Route as clientAuditsRouteRouteImport } from './app/(client)/audits/route'
import { Route as clientEntityScreeningRouteRouteImport } from './app/(client)/entity-screening/route'
import { Route as clientFilesRouteRouteImport } from './app/(client)/files/route'
import { Route as clientMyComponentsRouteRouteImport } from './app/(client)/my-components/route'
import { Route as clientMyStylesRouteRouteImport } from './app/(client)/my-styles/route'
import { Route as clientOrdersRouteRouteImport } from './app/(client)/orders/route'
import { Route as clientProductMappingRouteRouteImport } from './app/(client)/product-mapping/route'
import { Route as clientRiskRouteRouteImport } from './app/(client)/risk/route'
import { Route as clientSupplyChainMappingRouteRouteImport } from './app/(client)/supply-chain-mapping/route'
import { Route as DocsIndexRouteImport } from './app/docs/index'
import { Route as clientCapapagesRouteRouteImport } from './app/(client)/capa/(pages)/route'
import { Route as clientCertificationspagesRouteRouteImport } from './app/(client)/certifications/(pages)/route'
import { Route as clientCertifiedMaterialspagesRouteRouteImport } from './app/(client)/certified-materials/(pages)/route'
import { Route as clientCompanySettingspagesRouteRouteImport } from './app/(client)/company-settings/(pages)/route'
import { Route as clientDocumentspagesRouteRouteImport } from './app/(client)/documents/(pages)/route'
import { Route as clientMyComponentspagesRouteRouteImport } from './app/(client)/my-components/(pages)/route'
import { Route as clientMyStylespagesRouteRouteImport } from './app/(client)/my-styles/(pages)/route'
import { Route as clientNetworkpagesRouteRouteImport } from './app/(client)/network/(pages)/route'
import { Route as clientProfilepagesRouteRouteImport } from './app/(client)/profile/(pages)/route'
import { Route as clientQuestionnairespagesRouteRouteImport } from './app/(client)/questionnaires/(pages)/route'
import { Route as clientReportpagesRouteRouteImport } from './app/(client)/report/(pages)/route'
import { Route as clientSlcppagesRouteRouteImport } from './app/(client)/slcp/(pages)/route'
import { Route as loginpagesIndexRouteImport } from './app/(login)/(pages)/index'
import { Route as loginSingleSignOnCallbackIndexRouteImport } from './app/(login)/single-sign-on-callback/index'
import { Route as ManagementRiskManagementpagesRouteRouteImport } from './app/management/risk-management/(pages)/route'
import { Route as UnsubscribepagesIndexRouteImport } from './app/unsubscribe/(pages)/index'
import { Route as clientActivityFeedpagesIndexRouteImport } from './app/(client)/activity-feed/(pages)/index'
import { Route as clientAuditspageslistRouteRouteImport } from './app/(client)/audits/(pages)/(list)/route'
import { Route as clientAutomationRulespagesIndexRouteImport } from './app/(client)/automation-rules/(pages)/index'
import { Route as clientCapapagesdetailRouteRouteImport } from './app/(client)/capa/(pages)/(detail)/route'
import { Route as clientCapapageslistRouteRouteImport } from './app/(client)/capa/(pages)/(list)/route'
import { Route as clientCertificationspagesIndexRouteImport } from './app/(client)/certifications/(pages)/index'
import { Route as clientCertifiedMaterialspagesIndexRouteImport } from './app/(client)/certified-materials/(pages)/index'
import { Route as clientCompanySettingspagesApiKeysRouteImport } from './app/(client)/company-settings/(pages)/api-keys'
import { Route as clientCompanySettingspagesConstantsMappingRouteRouteImport } from './app/(client)/company-settings/(pages)/constants-mapping/route'
import { Route as clientCompanySettingspagesIntegrationsRouteRouteImport } from './app/(client)/company-settings/(pages)/integrations/route'
import { Route as clientCompanySettingspagesJoinRequestsRouteImport } from './app/(client)/company-settings/(pages)/join-requests'
import { Route as clientCompanySettingspagesUsersRouteImport } from './app/(client)/company-settings/(pages)/users'
import { Route as clientCompanySettingspagesWebshopSettingsRouteImport } from './app/(client)/company-settings/(pages)/webshop-settings'
import { Route as clientDashboardpagesIndexRouteImport } from './app/(client)/dashboard/(pages)/index'
import { Route as clientDocumentspageslistRouteRouteImport } from './app/(client)/documents/(pages)/(list)/route'
import { Route as clientEntityScreeningpagesIndexRouteImport } from './app/(client)/entity-screening/(pages)/index'
import { Route as clientMyComponentspagesdetailRouteRouteImport } from './app/(client)/my-components/(pages)/(detail)/route'
import { Route as clientMyComponentspageslistRouteRouteImport } from './app/(client)/my-components/(pages)/(list)/route'
import { Route as clientMyStylespagesdetailRouteRouteImport } from './app/(client)/my-styles/(pages)/(detail)/route'
import { Route as clientMyStylespageslistRouteRouteImport } from './app/(client)/my-styles/(pages)/(list)/route'
import { Route as clientNetworkpagesdetailRouteRouteImport } from './app/(client)/network/(pages)/(detail)/route'
import { Route as clientNetworkpageslistRouteRouteImport } from './app/(client)/network/(pages)/(list)/route'
import { Route as clientOrdersHubpagesIndexRouteImport } from './app/(client)/orders-hub/(pages)/index'
import { Route as clientOrdersHubpagesCreateRouteImport } from './app/(client)/orders-hub/(pages)/create'
import { Route as clientOrderspageslistRouteRouteImport } from './app/(client)/orders/(pages)/(list)/route'
import { Route as clientProductMappingpageslistRouteRouteImport } from './app/(client)/product-mapping/(pages)/(list)/route'
import { Route as clientQuestionnairespageslistRouteRouteImport } from './app/(client)/questionnaires/(pages)/(list)/route'
import { Route as clientRiskpagesdetailRouteRouteImport } from './app/(client)/risk/(pages)/(detail)/route'
import { Route as clientRiskpageseditRouteRouteImport } from './app/(client)/risk/(pages)/(edit)/route'
import { Route as clientRiskpageslistRouteRouteImport } from './app/(client)/risk/(pages)/(list)/route'
import { Route as clientSlcppageslistRouteRouteImport } from './app/(client)/slcp/(pages)/(list)/route'
import { Route as clientSupplyChainMappingpageslistRouteRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/route'
import { Route as DocsComponentsSlugIndexRouteImport } from './app/docs/components/$slug/index'
import { Route as DocsFoundationsSlugIndexRouteImport } from './app/docs/foundations/$slug/index'
import { Route as DocsGuidesSlugIndexRouteImport } from './app/docs/guides/$slug/index'
import { Route as DocsPatternsSlugIndexRouteImport } from './app/docs/patterns/$slug/index'
import { Route as ManagementAttachmentTemplatespagesIndexRouteImport } from './app/management/attachment-templates/(pages)/index'
import { Route as ManagementAuditTypespagesIndexRouteImport } from './app/management/audit-types/(pages)/index'
import { Route as ManagementAuditspagesIndexRouteImport } from './app/management/audits/(pages)/index'
import { Route as ManagementBackgroundJobspagesIndexRouteImport } from './app/management/background-jobs/(pages)/index'
import { Route as ManagementBadgespagesIndexRouteImport } from './app/management/badges/(pages)/index'
import { Route as ManagementCertificationspageslistRouteRouteImport } from './app/management/certifications/(pages)/(list)/route'
import { Route as ManagementCompaniespagesIndexRouteImport } from './app/management/companies/(pages)/index'
import { Route as ManagementCompaniespagesCompanyIdRouteRouteImport } from './app/management/companies/(pages)/$companyId/route'
import { Route as ManagementCompanyMergespagesIndexRouteImport } from './app/management/company-merges/(pages)/index'
import { Route as ManagementCsToolspagesIndexRouteImport } from './app/management/cs-tools/(pages)/index'
import { Route as ManagementCustomInformationFieldspagesIndexRouteImport } from './app/management/custom-information-fields/(pages)/index'
import { Route as ManagementDocumentTypespagesIndexRouteImport } from './app/management/document-types/(pages)/index'
import { Route as ManagementDocumentspageslistRouteRouteImport } from './app/management/documents/(pages)/(list)/route'
import { Route as ManagementEmailBounceTrackingpagesIndexRouteImport } from './app/management/email-bounce-tracking/(pages)/index'
import { Route as ManagementEntityHistorypagesIndexRouteImport } from './app/management/entity-history/(pages)/index'
import { Route as ManagementFacilityProcessespagesIndexRouteImport } from './app/management/facility-processes/(pages)/index'
import { Route as ManagementImpersonatepagesIndexRouteImport } from './app/management/impersonate/(pages)/index'
import { Route as ManagementMaterialspagesIndexRouteImport } from './app/management/materials/(pages)/index'
import { Route as ManagementOriginspagesIndexRouteImport } from './app/management/origins/(pages)/index'
import { Route as ManagementPermissionspagesIndexRouteImport } from './app/management/permissions/(pages)/index'
import { Route as ManagementPlatformFeaturespagesIndexRouteImport } from './app/management/platform-features/(pages)/index'
import { Route as ManagementProductCategoriespagesIndexRouteImport } from './app/management/product-categories/(pages)/index'
import { Route as ManagementProductDataPointspagesIndexRouteImport } from './app/management/product-data-points/(pages)/index'
import { Route as ManagementProductionProcessespagesIndexRouteImport } from './app/management/production-processes/(pages)/index'
import { Route as ManagementRiskManagementpageslistRouteRouteImport } from './app/management/risk-management/(pages)/(list)/route'
import { Route as ManagementRulespagesIndexRouteImport } from './app/management/rules/(pages)/index'
import { Route as ManagementScoringTemplatespageslistRouteRouteImport } from './app/management/scoring-templates/(pages)/(list)/route'
import { Route as ManagementSlcpDashboardpagesIndexRouteImport } from './app/management/slcp-dashboard/(pages)/index'
import { Route as ManagementSsopagesIndexRouteImport } from './app/management/sso/(pages)/index'
import { Route as ManagementStandardspagesIndexRouteImport } from './app/management/standards/(pages)/index'
import { Route as ManagementSupplierQuestionnaireTemplatespagesIndexRouteImport } from './app/management/supplier-questionnaire-templates/(pages)/index'
import { Route as ManagementTranslationspagesIndexRouteImport } from './app/management/translations/(pages)/index'
import { Route as ManagementUserspagesIndexRouteImport } from './app/management/users/(pages)/index'
import { Route as ManagementWebshopspagesIndexRouteImport } from './app/management/webshops/(pages)/index'
import { Route as OnboardingCompanySearchpagesIndexRouteImport } from './app/onboarding/company-search/(pages)/index'
import { Route as SsoOnboardingpagesTokenIndexRouteImport } from './app/sso-onboarding/(pages)/$token/index'
import { Route as SsoOnboardingpagesTestResultIndexRouteImport } from './app/sso-onboarding/(pages)/test-result/index'
import { Route as clientAuditspagesdetailAuditIdRouteRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/route'
import { Route as clientAuditspageslistAuditsForCompanyRouteRouteImport } from './app/(client)/audits/(pages)/(list)/audits-for-company/route'
import { Route as clientAuditspageslistNetworkAuditsRouteRouteImport } from './app/(client)/audits/(pages)/(list)/network-audits/route'
import { Route as clientCapapageslistActionsRouteRouteImport } from './app/(client)/capa/(pages)/(list)/actions/route'
import { Route as clientCapapageslistFindingsRouteRouteImport } from './app/(client)/capa/(pages)/(list)/findings/route'
import { Route as clientCapapageslistPlansRouteRouteImport } from './app/(client)/capa/(pages)/(list)/plans/route'
import { Route as clientCertificationspagesIdIndexRouteImport } from './app/(client)/certifications/(pages)/$id/index'
import { Route as clientCompanySettingspagesIntegrationsIndexRouteImport } from './app/(client)/company-settings/(pages)/integrations/index'
import { Route as clientCompanySettingspagesPermissionSetsIndexRouteImport } from './app/(client)/company-settings/(pages)/permission-sets/index'
import { Route as clientCompanySettingspagesPermissionSetsNewRouteImport } from './app/(client)/company-settings/(pages)/permission-sets/new'
import { Route as clientFilespageslistIndexRouteImport } from './app/(client)/files/(pages)/(list)/index'
import { Route as clientMyComponentspageslistComponentSkusRouteRouteImport } from './app/(client)/my-components/(pages)/(list)/component-skus/route'
import { Route as clientMyComponentspageslistComponentVariantsRouteRouteImport } from './app/(client)/my-components/(pages)/(list)/component-variants/route'
import { Route as clientMyComponentspageslistComponentsRouteRouteImport } from './app/(client)/my-components/(pages)/(list)/components/route'
import { Route as clientMyStylespageslistSkusRouteRouteImport } from './app/(client)/my-styles/(pages)/(list)/skus/route'
import { Route as clientMyStylespageslistStylesRouteRouteImport } from './app/(client)/my-styles/(pages)/(list)/styles/route'
import { Route as clientMyStylespageslistVariantsRouteRouteImport } from './app/(client)/my-styles/(pages)/(list)/variants/route'
import { Route as clientNetworkpagesdetailCompanyIdRouteRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/route'
import { Route as clientOrdersHubpagesdetailIdRouteRouteImport } from './app/(client)/orders-hub/(pages)/(detail)/$id/route'
import { Route as clientOrderspageslistInternalOrdersRouteRouteImport } from './app/(client)/orders/(pages)/(list)/internal-orders/route'
import { Route as clientOrderspageslistPurchaseOrdersRouteRouteImport } from './app/(client)/orders/(pages)/(list)/purchase-orders/route'
import { Route as clientOrderspageslistSalesOrdersRouteRouteImport } from './app/(client)/orders/(pages)/(list)/sales-orders/route'
import { Route as clientOrderspagesAttachmentTemplatesIndexRouteImport } from './app/(client)/orders/(pages)/attachment-templates/index'
import { Route as clientProfilepagesOverviewIndexRouteImport } from './app/(client)/profile/(pages)/overview/index'
import { Route as clientProfilepagesSettingsIndexRouteImport } from './app/(client)/profile/(pages)/settings/index'
import { Route as clientQuestionnairespagesdetailIdRouteRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id/route'
import { Route as clientQuestionnairespageslistMyQuestionnairesRouteRouteImport } from './app/(client)/questionnaires/(pages)/(list)/my-questionnaires/route'
import { Route as clientRiskpagesdetailAssessmentsRouteRouteImport } from './app/(client)/risk/(pages)/(detail)/assessments/route'
import { Route as clientSlcppageslistMyOwnRouteRouteImport } from './app/(client)/slcp/(pages)/(list)/my-own/route'
import { Route as clientSupplyChainMappingpageslistInsightsRouteRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/insights/route'
import { Route as clientSupplyChainMappingpageslistSupplyChainsRouteRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/route'
import { Route as clientUserspagesIdIndexRouteImport } from './app/(client)/users/(pages)/$id/index'
import { Route as ManagementAttachmentTemplatespagesIdIndexRouteImport } from './app/management/attachment-templates/(pages)/$id/index'
import { Route as ManagementAttachmentTemplatespagesCreateIndexRouteImport } from './app/management/attachment-templates/(pages)/create/index'
import { Route as ManagementCertificationspagesIdIndexRouteImport } from './app/management/certifications/(pages)/$id/index'
import { Route as ManagementCompaniespagesCompanyIdIndexRouteImport } from './app/management/companies/(pages)/$companyId/index'
import { Route as ManagementCompanyMergespagesMergeIdIndexRouteImport } from './app/management/company-merges/(pages)/$mergeId/index'
import { Route as ManagementCompanyMergespagesNewIndexRouteImport } from './app/management/company-merges/(pages)/new/index'
import { Route as ManagementEntityHistorypagesIdIndexRouteImport } from './app/management/entity-history/(pages)/$id/index'
import { Route as ManagementPlatformFeaturespagesFeatureIdIndexRouteImport } from './app/management/platform-features/(pages)/$featureId/index'
import { Route as ManagementScoringTemplatespageslistIndexRouteImport } from './app/management/scoring-templates/(pages)/(list)/index'
import { Route as ManagementSsopagesIdIndexRouteImport } from './app/management/sso/(pages)/$id/index'
import { Route as ManagementUserspagesIdIndexRouteImport } from './app/management/users/(pages)/$id/index'
import { Route as clientAuditspagesdetailAuditIdIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/index'
import { Route as clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRouteImport } from './app/(client)/company-settings/(pages)/constants-mapping/facility-processes/index'
import { Route as clientCompanySettingspagesConstantsMappingMaterialsIndexRouteImport } from './app/(client)/company-settings/(pages)/constants-mapping/materials/index'
import { Route as clientCompanySettingspagesConstantsMappingProductTypesIndexRouteImport } from './app/(client)/company-settings/(pages)/constants-mapping/product-types/index'
import { Route as clientCompanySettingspagesPermissionSetsSetKeyIndexRouteImport } from './app/(client)/company-settings/(pages)/permission-sets/$setKey/index'
import { Route as clientCompanySettingspagesPermissionSetsSetKeyEditRouteImport } from './app/(client)/company-settings/(pages)/permission-sets/$setKey/edit'
import { Route as clientDocumentspageslistArchivedIndexRouteImport } from './app/(client)/documents/(pages)/(list)/archived/index'
import { Route as clientDocumentspageslistMyDocumentsIndexRouteImport } from './app/(client)/documents/(pages)/(list)/my-documents/index'
import { Route as clientDocumentspageslistRequestAccessIndexRouteImport } from './app/(client)/documents/(pages)/(list)/request-access/index'
import { Route as clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRouteImport } from './app/(client)/entity-screening/(pages)/involved-orders/$companyId/index'
import { Route as clientMyComponentspagesdetailKindIdRouteRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/route'
import { Route as clientMyStylespagesdetailKindIdRouteRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/route'
import { Route as clientMyStylespageslistStylesCreatedForMeIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/styles-created-for-me/index'
import { Route as clientNetworkpagesdetailCompanyIdBadgesRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/badges'
import { Route as clientNetworkpagesdetailCompanyIdCapaRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/capa'
import { Route as clientNetworkpagesdetailCompanyIdClaimsRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/claims'
import { Route as clientNetworkpagesdetailCompanyIdCustomInformationRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/custom-information'
import { Route as clientNetworkpagesdetailCompanyIdCustomInformationFieldsRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/custom-information-fields'
import { Route as clientNetworkpagesdetailCompanyIdDocumentsRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/documents'
import { Route as clientNetworkpagesdetailCompanyIdEsgInfoRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/esg-info'
import { Route as clientNetworkpagesdetailCompanyIdGeneralInfoRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/general-info'
import { Route as clientNetworkpagesdetailCompanyIdHistoryRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/history'
import { Route as clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/integrations/route'
import { Route as clientNetworkpagesdetailCompanyIdProductsRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/products'
import { Route as clientNetworkpagesdetailCompanyIdQuestionnaireRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/questionnaire'
import { Route as clientNetworkpagesdetailCompanyIdRiskProfileRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/risk-profile'
import { Route as clientNetworkpagesdetailCompanyIdSlcpRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/slcp'
import { Route as clientNetworkpagesdetailCompanyIdUsersRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/users'
import { Route as clientNetworkpagesdetailCompanyIdWebshopProfileRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/webshop-profile'
import { Route as clientNetworkpageslistMyNetworkIndexRouteImport } from './app/(client)/network/(pages)/(list)/my-network/index'
import { Route as clientOrdersHubpagesdetailIdAttachmentsRouteImport } from './app/(client)/orders-hub/(pages)/(detail)/$id/attachments'
import { Route as clientOrdersHubpagesdetailIdLinesRouteImport } from './app/(client)/orders-hub/(pages)/(detail)/$id/lines'
import { Route as clientOrdersHubpagesdetailIdOverviewRouteImport } from './app/(client)/orders-hub/(pages)/(detail)/$id/overview'
import { Route as clientOrderspagesdetailInternalOrdersIoIdRouteRouteImport } from './app/(client)/orders/(pages)/(detail)/internal-orders/$ioId/route'
import { Route as clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteImport } from './app/(client)/orders/(pages)/(detail)/purchase-orders/$poId/route'
import { Route as clientOrderspagesdetailSalesOrdersSoIdRouteRouteImport } from './app/(client)/orders/(pages)/(detail)/sales-orders/$soId/route'
import { Route as clientOrderspagesAttachmentTemplatesIdIndexRouteImport } from './app/(client)/orders/(pages)/attachment-templates/$id/index'
import { Route as clientOrderspagesAttachmentTemplatesCreateIndexRouteImport } from './app/(client)/orders/(pages)/attachment-templates/create/index'
import { Route as clientProductMappingpagesdetailsCpmIdIndexRouteImport } from './app/(client)/product-mapping/(pages)/(details)/$cpmId/index'
import { Route as clientProductMappingpageslistActiveIndexRouteImport } from './app/(client)/product-mapping/(pages)/(list)/active/index'
import { Route as clientProductMappingpageslistArchiveIndexRouteImport } from './app/(client)/product-mapping/(pages)/(list)/archive/index'
import { Route as clientQuestionnairespageslistRequestsIndexRouteImport } from './app/(client)/questionnaires/(pages)/(list)/requests/index'
import { Route as clientQuestionnairespageslistTemplatesIndexRouteImport } from './app/(client)/questionnaires/(pages)/(list)/templates/index'
import { Route as clientReportpagesanalyticsAuditComplianceIndexRouteImport } from './app/(client)/report/(pages)/(analytics)/audit-compliance/index'
import { Route as clientReportpagesanalyticsCertificateComplianceIndexRouteImport } from './app/(client)/report/(pages)/(analytics)/certificate-compliance/index'
import { Route as clientReportpagesanalyticsTracingComplianceIndexRouteImport } from './app/(client)/report/(pages)/(analytics)/tracing-compliance/index'
import { Route as clientReportpagesanalyticsTracingOperationsIndexRouteImport } from './app/(client)/report/(pages)/(analytics)/tracing-operations/index'
import { Route as clientRiskpageslistAssessmentsIndexRouteImport } from './app/(client)/risk/(pages)/(list)/assessments/index'
import { Route as clientRiskpageslistLandscapeIndexRouteImport } from './app/(client)/risk/(pages)/(list)/landscape/index'
import { Route as clientRiskpageslistRulesIndexRouteImport } from './app/(client)/risk/(pages)/(list)/rules/index'
import { Route as clientSlcppageslistNetworkIndexRouteImport } from './app/(client)/slcp/(pages)/(list)/network/index'
import { Route as clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteImport } from './app/(client)/slcp/(pages)/assessments/(details)/$assessmentId/route'
import { Route as clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/route'
import { Route as clientSupplyChainMappingpageslistHistoryIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/history/index'
import { Route as ManagementAttachmentTemplatespagesIdEditIndexRouteImport } from './app/management/attachment-templates/(pages)/$id/edit/index'
import { Route as ManagementCertificationspageslistActiveIndexRouteImport } from './app/management/certifications/(pages)/(list)/active/index'
import { Route as ManagementCertificationspageslistArchivedIndexRouteImport } from './app/management/certifications/(pages)/(list)/archived/index'
import { Route as ManagementCompaniespagesCompanyIdApiKeysIndexRouteImport } from './app/management/companies/(pages)/$companyId/api-keys/index'
import { Route as ManagementCompaniespagesCompanyIdAutomationRulesIndexRouteImport } from './app/management/companies/(pages)/$companyId/automation-rules/index'
import { Route as ManagementCompaniespagesCompanyIdCreditsIndexRouteImport } from './app/management/companies/(pages)/$companyId/credits/index'
import { Route as ManagementCompaniespagesCompanyIdEmployeesIndexRouteImport } from './app/management/companies/(pages)/$companyId/employees/index'
import { Route as ManagementCompaniespagesCompanyIdGeneralInfoIndexRouteImport } from './app/management/companies/(pages)/$companyId/general-info/index'
import { Route as ManagementCompaniespagesCompanyIdNetworkIndexRouteImport } from './app/management/companies/(pages)/$companyId/network/index'
import { Route as ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRouteImport } from './app/management/companies/(pages)/$companyId/platform-features/index'
import { Route as ManagementCompaniespagesCompanyIdSupplyChainsIndexRouteImport } from './app/management/companies/(pages)/$companyId/supply-chains/index'
import { Route as ManagementCompaniespagesCompanyIdTechInsightsIndexRouteImport } from './app/management/companies/(pages)/$companyId/tech-insights/index'
import { Route as ManagementCompaniespagesCompanyIdTracingOrdersIndexRouteImport } from './app/management/companies/(pages)/$companyId/tracing-orders/index'
import { Route as ManagementDocumentspageslistActiveIndexRouteImport } from './app/management/documents/(pages)/(list)/active/index'
import { Route as ManagementDocumentspageslistArchivedIndexRouteImport } from './app/management/documents/(pages)/(list)/archived/index'
import { Route as ManagementProductCategoriespagesCategoryIdFieldsIndexRouteImport } from './app/management/product-categories/(pages)/$categoryId/fields/index'
import { Route as ManagementRiskManagementpageslistRiskGrossIndexRouteImport } from './app/management/risk-management/(pages)/(list)/risk-gross/index'
import { Route as ManagementRiskManagementpageslistRisksIndexRouteImport } from './app/management/risk-management/(pages)/(list)/risks/index'
import { Route as ManagementRiskManagementpageslistRuleTemplatesIndexRouteImport } from './app/management/risk-management/(pages)/(list)/rule-templates/index'
import { Route as ManagementScoringTemplatespagesIdEditIndexRouteImport } from './app/management/scoring-templates/(pages)/$id/edit/index'
import { Route as ManagementScoringTemplatespageslistGapsIndexRouteImport } from './app/management/scoring-templates/(pages)/(list)/gaps/index'
import { Route as ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRouteImport } from './app/management/supplier-questionnaire-templates/(pages)/$id/edit/index'
import { Route as ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRouteImport } from './app/management/supplier-questionnaire-templates/(pages)/$id/preview/index'
import { Route as clientAuditspagesdetailAuditIdCapaIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/capa/index'
import { Route as clientAuditspagesdetailAuditIdContentIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/content/index'
import { Route as clientAuditspagesdetailAuditIdFindingsIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/findings/index'
import { Route as clientAuditspagesdetailAuditIdOverviewIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/overview/index'
import { Route as clientAuditspagesdetailAuditIdScoreIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/score/index'
import { Route as clientAuditspagesdetailAuditIdViewIndexRouteImport } from './app/(client)/audits/(pages)/(detail)/$auditId/view/index'
import { Route as clientAuditspageslistAuditsForCompanyActiveIndexRouteImport } from './app/(client)/audits/(pages)/(list)/audits-for-company/active/index'
import { Route as clientAuditspageslistAuditsForCompanyArchiveIndexRouteImport } from './app/(client)/audits/(pages)/(list)/audits-for-company/archive/index'
import { Route as clientAuditspageslistNetworkAuditsActiveIndexRouteImport } from './app/(client)/audits/(pages)/(list)/network-audits/active/index'
import { Route as clientAuditspageslistNetworkAuditsArchiveIndexRouteImport } from './app/(client)/audits/(pages)/(list)/network-audits/archive/index'
import { Route as clientCapapagesdetailActionsIdIndexRouteImport } from './app/(client)/capa/(pages)/(detail)/actions/$id/index'
import { Route as clientCapapagesdetailPlansIdIndexRouteImport } from './app/(client)/capa/(pages)/(detail)/plans/$id/index'
import { Route as clientCapapageslistActionsActiveIndexRouteImport } from './app/(client)/capa/(pages)/(list)/actions/active/index'
import { Route as clientCapapageslistActionsArchivedIndexRouteImport } from './app/(client)/capa/(pages)/(list)/actions/archived/index'
import { Route as clientCapapageslistFindingsActiveIndexRouteImport } from './app/(client)/capa/(pages)/(list)/findings/active/index'
import { Route as clientCapapageslistFindingsArchivedIndexRouteImport } from './app/(client)/capa/(pages)/(list)/findings/archived/index'
import { Route as clientCapapageslistPlansActiveIndexRouteImport } from './app/(client)/capa/(pages)/(list)/plans/active/index'
import { Route as clientCapapageslistPlansArchivedIndexRouteImport } from './app/(client)/capa/(pages)/(list)/plans/archived/index'
import { Route as clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRouteImport } from './app/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/index'
import { Route as clientMyComponentspagesdetailKindIdBomRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/bom'
import { Route as clientMyComponentspagesdetailKindIdCertificationsRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/certifications'
import { Route as clientMyComponentspagesdetailKindIdDocumentsRouteRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/documents/route'
import { Route as clientMyComponentspagesdetailKindIdMaterialsRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/materials'
import { Route as clientMyComponentspagesdetailKindIdOverviewRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/overview'
import { Route as clientMyComponentspagesdetailKindIdQrCodeRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code'
import { Route as clientMyComponentspagesdetailKindIdSkusRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/skus'
import { Route as clientMyComponentspagesdetailKindIdSupplyChainRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain'
import { Route as clientMyComponentspagesdetailKindIdVariantsRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/variants'
import { Route as clientMyComponentspagesdetailKindIdWebshopPreviewRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/webshop-preview'
import { Route as clientMyComponentspageslistComponentSkusActiveIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/component-skus/active/index'
import { Route as clientMyComponentspageslistComponentSkusArchivedIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/component-skus/archived/index'
import { Route as clientMyComponentspageslistComponentVariantsActiveIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/component-variants/active/index'
import { Route as clientMyComponentspageslistComponentVariantsArchivedIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/component-variants/archived/index'
import { Route as clientMyComponentspageslistComponentsActiveIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/components/active/index'
import { Route as clientMyComponentspageslistComponentsArchivedIndexRouteImport } from './app/(client)/my-components/(pages)/(list)/components/archived/index'
import { Route as clientMyStylespagesdetailKindIdBomRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/bom'
import { Route as clientMyStylespagesdetailKindIdCertificationsRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications'
import { Route as clientMyStylespagesdetailKindIdDocumentsRouteRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/route'
import { Route as clientMyStylespagesdetailKindIdMaterialsRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/materials'
import { Route as clientMyStylespagesdetailKindIdOverviewRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/overview'
import { Route as clientMyStylespagesdetailKindIdQrCodeRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code'
import { Route as clientMyStylespagesdetailKindIdSkusRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/skus'
import { Route as clientMyStylespagesdetailKindIdSupplyChainRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain'
import { Route as clientMyStylespagesdetailKindIdVariantsRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/variants'
import { Route as clientMyStylespagesdetailKindIdWebshopPreviewRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview'
import { Route as clientMyStylespageslistSkusActiveIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/skus/active/index'
import { Route as clientMyStylespageslistSkusArchivedIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/skus/archived/index'
import { Route as clientMyStylespageslistStylesActiveIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/styles/active/index'
import { Route as clientMyStylespageslistStylesArchivedIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/styles/archived/index'
import { Route as clientMyStylespageslistVariantsActiveIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/variants/active/index'
import { Route as clientMyStylespageslistVariantsArchivedIndexRouteImport } from './app/(client)/my-styles/(pages)/(list)/variants/archived/index'
import { Route as clientNetworkpagesdetailCompanyIdAuditsIndexRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/audits/index'
import { Route as clientNetworkpagesdetailCompanyIdIntegrationsIndexRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/integrations/index'
import { Route as clientOrderspagescreatePurchaseOrdersCreateIndexRouteImport } from './app/(client)/orders/(pages)/(create)/purchase-orders/create/index'
import { Route as clientOrderspagescreateSalesOrdersCreateIndexRouteImport } from './app/(client)/orders/(pages)/(create)/sales-orders/create/index'
import { Route as clientOrderspagesdetailInternalOrdersIoIdDocumentsRouteImport } from './app/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents'
import { Route as clientOrderspagesdetailInternalOrdersIoIdOverviewRouteImport } from './app/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview'
import { Route as clientOrderspagesdetailInternalOrdersIoIdProductsRouteImport } from './app/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products'
import { Route as clientOrderspagesdetailInternalOrdersIoIdTracingRouteImport } from './app/(client)/orders/(pages)/(detail)/internal-orders/$ioId/tracing'
import { Route as clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRouteImport } from './app/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents'
import { Route as clientOrderspagesdetailPurchaseOrdersPoIdOverviewRouteImport } from './app/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview'
import { Route as clientOrderspagesdetailPurchaseOrdersPoIdProductsRouteImport } from './app/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products'
import { Route as clientOrderspagesdetailPurchaseOrdersPoIdTracingRouteImport } from './app/(client)/orders/(pages)/(detail)/purchase-orders/$poId/tracing'
import { Route as clientOrderspagesdetailSalesOrdersSoIdAttachmentsRouteImport } from './app/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments'
import { Route as clientOrderspagesdetailSalesOrdersSoIdOverviewRouteImport } from './app/(client)/orders/(pages)/(detail)/sales-orders/$soId/overview'
import { Route as clientOrderspagesdetailSalesOrdersSoIdProductsRouteImport } from './app/(client)/orders/(pages)/(detail)/sales-orders/$soId/products'
import { Route as clientOrderspagesdetailSalesOrdersSoIdTracingRouteImport } from './app/(client)/orders/(pages)/(detail)/sales-orders/$soId/tracing'
import { Route as clientOrderspageslistInternalOrdersActiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/internal-orders/active/index'
import { Route as clientOrderspageslistInternalOrdersArchiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/internal-orders/archive/index'
import { Route as clientOrderspageslistPurchaseOrdersActiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/purchase-orders/active/index'
import { Route as clientOrderspageslistPurchaseOrdersArchiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/purchase-orders/archive/index'
import { Route as clientOrderspageslistSalesOrdersActiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/sales-orders/active/index'
import { Route as clientOrderspageslistSalesOrdersArchiveIndexRouteImport } from './app/(client)/orders/(pages)/(list)/sales-orders/archive/index'
import { Route as clientOrderspagesAttachmentTemplatesIdEditIndexRouteImport } from './app/(client)/orders/(pages)/attachment-templates/$id/edit/index'
import { Route as clientQuestionnairespagesdetailIdEditIndexRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id/edit/index'
import { Route as clientQuestionnairespagesdetailIdReviewIndexRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id/review/index'
import { Route as clientQuestionnairespagesdetailIdSummaryIndexRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id/summary/index'
import { Route as clientQuestionnairespagesdetailIdAnswerIndexRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id_/answer/index'
import { Route as clientQuestionnairespagesdetailIdPreviewIndexRouteImport } from './app/(client)/questionnaires/(pages)/(detail)/$id_/preview/index'
import { Route as clientQuestionnairespageslistMyQuestionnairesActiveIndexRouteImport } from './app/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/index'
import { Route as clientQuestionnairespageslistMyQuestionnairesArchivedIndexRouteImport } from './app/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/index'
import { Route as clientRiskpagesdetailAssessmentsIdIndexRouteImport } from './app/(client)/risk/(pages)/(detail)/assessments/$id/index'
import { Route as clientRiskpagesdetailRulesIdIndexRouteImport } from './app/(client)/risk/(pages)/(detail)/rules/$id/index'
import { Route as clientSlcppageslistMyOwnActiveIndexRouteImport } from './app/(client)/slcp/(pages)/(list)/my-own/active/index'
import { Route as clientSlcppageslistMyOwnArchiveIndexRouteImport } from './app/(client)/slcp/(pages)/(list)/my-own/archive/index'
import { Route as clientSlcppagesAssessmentsdetailsAssessmentIdIndexRouteImport } from './app/(client)/slcp/(pages)/assessments/(details)/$assessmentId/index'
import { Route as clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/insights/collaborator-companies/index'
import { Route as clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/index'
import { Route as clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/index'
import { Route as clientSupplyChainMappingpageslistInsightsOverviewIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/insights/overview/index'
import { Route as clientSupplyChainMappingpageslistSupplyChainsActiveIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/index'
import { Route as clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/index'
import { Route as ManagementRiskManagementpagesRuleTemplatesIdEditIndexRouteImport } from './app/management/risk-management/(pages)/rule-templates/$id/edit/index'
import { Route as clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRouteImport } from './app/(client)/report/(pages)/(drilldown)/audit-compliance/drilldown/$chartType/index'
import { Route as clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRouteImport } from './app/(client)/report/(pages)/(drilldown)/certificate-compliance/drilldown/$chartType/index'
import { Route as clientRiskpageseditRulesIdEditIndexRouteImport } from './app/(client)/risk/(pages)/(edit)/rules/$id/edit/index'
import { Route as clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRouteImport } from './app/(client)/slcp/(pages)/assessments/(details)/$assessmentId/assessment/index'
import { Route as clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRouteImport } from './app/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/index'
import { Route as clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/index'
import { Route as clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/index'
import { Route as clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRouteImport } from './app/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/map/index'
import { Route as clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/documents/linked/index'
import { Route as clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRouteImport } from './app/(client)/my-components/(pages)/(detail)/$kind/$id/documents/product-only/index'
import { Route as clientMyStylespagesdetailKindIdDocumentsLinkedIndexRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/index'
import { Route as clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRouteImport } from './app/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/index'
import { Route as clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/audits/$auditId/findings/index'
import { Route as clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRouteImport } from './app/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/index'
import { Route as clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRouteImport } from './app/(client)/risk/(pages)/(detail)/assessments/$id/assessed/$assessmentId/index'

const clientRouteRoute = clientRouteRouteImport.update({
  id: '/(client)',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementRouteRoute = ManagementRouteRouteImport.update({
  id: '/management',
  path: '/management',
  getParentRoute: () => rootRouteImport,
} as any)
const clientAuditsRouteRoute = clientAuditsRouteRouteImport.update({
  id: '/audits',
  path: '/audits',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientEntityScreeningRouteRoute =
  clientEntityScreeningRouteRouteImport.update({
    id: '/entity-screening',
    path: '/entity-screening',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientFilesRouteRoute = clientFilesRouteRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientMyComponentsRouteRoute = clientMyComponentsRouteRouteImport.update({
  id: '/my-components',
  path: '/my-components',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientMyStylesRouteRoute = clientMyStylesRouteRouteImport.update({
  id: '/my-styles',
  path: '/my-styles',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientOrdersRouteRoute = clientOrdersRouteRouteImport.update({
  id: '/orders',
  path: '/orders',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientProductMappingRouteRoute =
  clientProductMappingRouteRouteImport.update({
    id: '/product-mapping',
    path: '/product-mapping',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientRiskRouteRoute = clientRiskRouteRouteImport.update({
  id: '/risk',
  path: '/risk',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientSupplyChainMappingRouteRoute =
  clientSupplyChainMappingRouteRouteImport.update({
    id: '/supply-chain-mapping',
    path: '/supply-chain-mapping',
    getParentRoute: () => clientRouteRoute,
  } as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/docs/',
  path: '/docs/',
  getParentRoute: () => rootRouteImport,
} as any)
const clientCapapagesRouteRoute = clientCapapagesRouteRouteImport.update({
  id: '/capa/(pages)',
  path: '/capa',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientCertificationspagesRouteRoute =
  clientCertificationspagesRouteRouteImport.update({
    id: '/certifications/(pages)',
    path: '/certifications',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientCertifiedMaterialspagesRouteRoute =
  clientCertifiedMaterialspagesRouteRouteImport.update({
    id: '/certified-materials/(pages)',
    path: '/certified-materials',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientCompanySettingspagesRouteRoute =
  clientCompanySettingspagesRouteRouteImport.update({
    id: '/company-settings/(pages)',
    path: '/company-settings',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientDocumentspagesRouteRoute =
  clientDocumentspagesRouteRouteImport.update({
    id: '/documents/(pages)',
    path: '/documents',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientMyComponentspagesRouteRoute =
  clientMyComponentspagesRouteRouteImport.update({
    id: '/(pages)',
    getParentRoute: () => clientMyComponentsRouteRoute,
  } as any)
const clientMyStylespagesRouteRoute =
  clientMyStylespagesRouteRouteImport.update({
    id: '/(pages)',
    getParentRoute: () => clientMyStylesRouteRoute,
  } as any)
const clientNetworkpagesRouteRoute = clientNetworkpagesRouteRouteImport.update({
  id: '/network/(pages)',
  path: '/network',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientProfilepagesRouteRoute = clientProfilepagesRouteRouteImport.update({
  id: '/profile/(pages)',
  path: '/profile',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientQuestionnairespagesRouteRoute =
  clientQuestionnairespagesRouteRouteImport.update({
    id: '/questionnaires/(pages)',
    path: '/questionnaires',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientReportpagesRouteRoute = clientReportpagesRouteRouteImport.update({
  id: '/report/(pages)',
  path: '/report',
  getParentRoute: () => clientRouteRoute,
} as any)
const clientSlcppagesRouteRoute = clientSlcppagesRouteRouteImport.update({
  id: '/slcp/(pages)',
  path: '/slcp',
  getParentRoute: () => clientRouteRoute,
} as any)
const loginpagesIndexRoute = loginpagesIndexRouteImport.update({
  id: '/(login)/(pages)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const loginSingleSignOnCallbackIndexRoute =
  loginSingleSignOnCallbackIndexRouteImport.update({
    id: '/(login)/single-sign-on-callback/',
    path: '/single-sign-on-callback/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ManagementRiskManagementpagesRouteRoute =
  ManagementRiskManagementpagesRouteRouteImport.update({
    id: '/risk-management/(pages)',
    path: '/risk-management',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const UnsubscribepagesIndexRoute = UnsubscribepagesIndexRouteImport.update({
  id: '/unsubscribe/(pages)/',
  path: '/unsubscribe/',
  getParentRoute: () => rootRouteImport,
} as any)
const clientActivityFeedpagesIndexRoute =
  clientActivityFeedpagesIndexRouteImport.update({
    id: '/activity-feed/(pages)/',
    path: '/activity-feed/',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientAuditspageslistRouteRoute =
  clientAuditspageslistRouteRouteImport.update({
    id: '/(pages)/(list)',
    getParentRoute: () => clientAuditsRouteRoute,
  } as any)
const clientAutomationRulespagesIndexRoute =
  clientAutomationRulespagesIndexRouteImport.update({
    id: '/automation-rules/(pages)/',
    path: '/automation-rules/',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientCapapagesdetailRouteRoute =
  clientCapapagesdetailRouteRouteImport.update({
    id: '/(detail)',
    getParentRoute: () => clientCapapagesRouteRoute,
  } as any)
const clientCapapageslistRouteRoute =
  clientCapapageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientCapapagesRouteRoute,
  } as any)
const clientCertificationspagesIndexRoute =
  clientCertificationspagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => clientCertificationspagesRouteRoute,
  } as any)
const clientCertifiedMaterialspagesIndexRoute =
  clientCertifiedMaterialspagesIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => clientCertifiedMaterialspagesRouteRoute,
  } as any)
const clientCompanySettingspagesApiKeysRoute =
  clientCompanySettingspagesApiKeysRouteImport.update({
    id: '/api-keys',
    path: '/api-keys',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesConstantsMappingRouteRoute =
  clientCompanySettingspagesConstantsMappingRouteRouteImport.update({
    id: '/constants-mapping',
    path: '/constants-mapping',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesIntegrationsRouteRoute =
  clientCompanySettingspagesIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesJoinRequestsRoute =
  clientCompanySettingspagesJoinRequestsRouteImport.update({
    id: '/join-requests',
    path: '/join-requests',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesUsersRoute =
  clientCompanySettingspagesUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesWebshopSettingsRoute =
  clientCompanySettingspagesWebshopSettingsRouteImport.update({
    id: '/webshop-settings',
    path: '/webshop-settings',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientDashboardpagesIndexRoute =
  clientDashboardpagesIndexRouteImport.update({
    id: '/dashboard/(pages)/',
    path: '/dashboard/',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientDocumentspageslistRouteRoute =
  clientDocumentspageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientDocumentspagesRouteRoute,
  } as any)
const clientEntityScreeningpagesIndexRoute =
  clientEntityScreeningpagesIndexRouteImport.update({
    id: '/(pages)/',
    path: '/',
    getParentRoute: () => clientEntityScreeningRouteRoute,
  } as any)
const clientMyComponentspagesdetailRouteRoute =
  clientMyComponentspagesdetailRouteRouteImport.update({
    id: '/(detail)',
    getParentRoute: () => clientMyComponentspagesRouteRoute,
  } as any)
const clientMyComponentspageslistRouteRoute =
  clientMyComponentspageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientMyComponentspagesRouteRoute,
  } as any)
const clientMyStylespagesdetailRouteRoute =
  clientMyStylespagesdetailRouteRouteImport.update({
    id: '/(detail)',
    getParentRoute: () => clientMyStylespagesRouteRoute,
  } as any)
const clientMyStylespageslistRouteRoute =
  clientMyStylespageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientMyStylespagesRouteRoute,
  } as any)
const clientNetworkpagesdetailRouteRoute =
  clientNetworkpagesdetailRouteRouteImport.update({
    id: '/(detail)',
    getParentRoute: () => clientNetworkpagesRouteRoute,
  } as any)
const clientNetworkpageslistRouteRoute =
  clientNetworkpageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientNetworkpagesRouteRoute,
  } as any)
const clientOrdersHubpagesIndexRoute =
  clientOrdersHubpagesIndexRouteImport.update({
    id: '/orders-hub/(pages)/',
    path: '/orders-hub/',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientOrdersHubpagesCreateRoute =
  clientOrdersHubpagesCreateRouteImport.update({
    id: '/orders-hub/(pages)/create',
    path: '/orders-hub/create',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientOrderspageslistRouteRoute =
  clientOrderspageslistRouteRouteImport.update({
    id: '/(pages)/(list)',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientProductMappingpageslistRouteRoute =
  clientProductMappingpageslistRouteRouteImport.update({
    id: '/(pages)/(list)',
    getParentRoute: () => clientProductMappingRouteRoute,
  } as any)
const clientQuestionnairespageslistRouteRoute =
  clientQuestionnairespageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientQuestionnairespagesRouteRoute,
  } as any)
const clientRiskpagesdetailRouteRoute =
  clientRiskpagesdetailRouteRouteImport.update({
    id: '/(pages)/(detail)',
    getParentRoute: () => clientRiskRouteRoute,
  } as any)
const clientRiskpageseditRouteRoute =
  clientRiskpageseditRouteRouteImport.update({
    id: '/(pages)/(edit)',
    getParentRoute: () => clientRiskRouteRoute,
  } as any)
const clientRiskpageslistRouteRoute =
  clientRiskpageslistRouteRouteImport.update({
    id: '/(pages)/(list)',
    getParentRoute: () => clientRiskRouteRoute,
  } as any)
const clientSlcppageslistRouteRoute =
  clientSlcppageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => clientSlcppagesRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistRouteRoute =
  clientSupplyChainMappingpageslistRouteRouteImport.update({
    id: '/(pages)/(list)',
    getParentRoute: () => clientSupplyChainMappingRouteRoute,
  } as any)
const DocsComponentsSlugIndexRoute = DocsComponentsSlugIndexRouteImport.update({
  id: '/docs/components/$slug/',
  path: '/docs/components/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsFoundationsSlugIndexRoute =
  DocsFoundationsSlugIndexRouteImport.update({
    id: '/docs/foundations/$slug/',
    path: '/docs/foundations/$slug/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DocsGuidesSlugIndexRoute = DocsGuidesSlugIndexRouteImport.update({
  id: '/docs/guides/$slug/',
  path: '/docs/guides/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsPatternsSlugIndexRoute = DocsPatternsSlugIndexRouteImport.update({
  id: '/docs/patterns/$slug/',
  path: '/docs/patterns/$slug/',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagementAttachmentTemplatespagesIndexRoute =
  ManagementAttachmentTemplatespagesIndexRouteImport.update({
    id: '/attachment-templates/(pages)/',
    path: '/attachment-templates/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementAuditTypespagesIndexRoute =
  ManagementAuditTypespagesIndexRouteImport.update({
    id: '/audit-types/(pages)/',
    path: '/audit-types/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementAuditspagesIndexRoute =
  ManagementAuditspagesIndexRouteImport.update({
    id: '/audits/(pages)/',
    path: '/audits/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementBackgroundJobspagesIndexRoute =
  ManagementBackgroundJobspagesIndexRouteImport.update({
    id: '/background-jobs/(pages)/',
    path: '/background-jobs/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementBadgespagesIndexRoute =
  ManagementBadgespagesIndexRouteImport.update({
    id: '/badges/(pages)/',
    path: '/badges/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCertificationspageslistRouteRoute =
  ManagementCertificationspageslistRouteRouteImport.update({
    id: '/certifications/(pages)/(list)',
    path: '/certifications',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCompaniespagesIndexRoute =
  ManagementCompaniespagesIndexRouteImport.update({
    id: '/companies/(pages)/',
    path: '/companies/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdRouteRoute =
  ManagementCompaniespagesCompanyIdRouteRouteImport.update({
    id: '/companies/(pages)/$companyId',
    path: '/companies/$companyId',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCompanyMergespagesIndexRoute =
  ManagementCompanyMergespagesIndexRouteImport.update({
    id: '/company-merges/(pages)/',
    path: '/company-merges/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCsToolspagesIndexRoute =
  ManagementCsToolspagesIndexRouteImport.update({
    id: '/cs-tools/(pages)/',
    path: '/cs-tools/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCustomInformationFieldspagesIndexRoute =
  ManagementCustomInformationFieldspagesIndexRouteImport.update({
    id: '/custom-information-fields/(pages)/',
    path: '/custom-information-fields/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementDocumentTypespagesIndexRoute =
  ManagementDocumentTypespagesIndexRouteImport.update({
    id: '/document-types/(pages)/',
    path: '/document-types/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementDocumentspageslistRouteRoute =
  ManagementDocumentspageslistRouteRouteImport.update({
    id: '/documents/(pages)/(list)',
    path: '/documents',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementEmailBounceTrackingpagesIndexRoute =
  ManagementEmailBounceTrackingpagesIndexRouteImport.update({
    id: '/email-bounce-tracking/(pages)/',
    path: '/email-bounce-tracking/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementEntityHistorypagesIndexRoute =
  ManagementEntityHistorypagesIndexRouteImport.update({
    id: '/entity-history/(pages)/',
    path: '/entity-history/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementFacilityProcessespagesIndexRoute =
  ManagementFacilityProcessespagesIndexRouteImport.update({
    id: '/facility-processes/(pages)/',
    path: '/facility-processes/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementImpersonatepagesIndexRoute =
  ManagementImpersonatepagesIndexRouteImport.update({
    id: '/impersonate/(pages)/',
    path: '/impersonate/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementMaterialspagesIndexRoute =
  ManagementMaterialspagesIndexRouteImport.update({
    id: '/materials/(pages)/',
    path: '/materials/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementOriginspagesIndexRoute =
  ManagementOriginspagesIndexRouteImport.update({
    id: '/origins/(pages)/',
    path: '/origins/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementPermissionspagesIndexRoute =
  ManagementPermissionspagesIndexRouteImport.update({
    id: '/permissions/(pages)/',
    path: '/permissions/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementPlatformFeaturespagesIndexRoute =
  ManagementPlatformFeaturespagesIndexRouteImport.update({
    id: '/platform-features/(pages)/',
    path: '/platform-features/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementProductCategoriespagesIndexRoute =
  ManagementProductCategoriespagesIndexRouteImport.update({
    id: '/product-categories/(pages)/',
    path: '/product-categories/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementProductDataPointspagesIndexRoute =
  ManagementProductDataPointspagesIndexRouteImport.update({
    id: '/product-data-points/(pages)/',
    path: '/product-data-points/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementProductionProcessespagesIndexRoute =
  ManagementProductionProcessespagesIndexRouteImport.update({
    id: '/production-processes/(pages)/',
    path: '/production-processes/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementRiskManagementpageslistRouteRoute =
  ManagementRiskManagementpageslistRouteRouteImport.update({
    id: '/(list)',
    getParentRoute: () => ManagementRiskManagementpagesRouteRoute,
  } as any)
const ManagementRulespagesIndexRoute =
  ManagementRulespagesIndexRouteImport.update({
    id: '/rules/(pages)/',
    path: '/rules/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementScoringTemplatespageslistRouteRoute =
  ManagementScoringTemplatespageslistRouteRouteImport.update({
    id: '/scoring-templates/(pages)/(list)',
    path: '/scoring-templates',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementSlcpDashboardpagesIndexRoute =
  ManagementSlcpDashboardpagesIndexRouteImport.update({
    id: '/slcp-dashboard/(pages)/',
    path: '/slcp-dashboard/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementSsopagesIndexRoute = ManagementSsopagesIndexRouteImport.update({
  id: '/sso/(pages)/',
  path: '/sso/',
  getParentRoute: () => ManagementRouteRoute,
} as any)
const ManagementStandardspagesIndexRoute =
  ManagementStandardspagesIndexRouteImport.update({
    id: '/standards/(pages)/',
    path: '/standards/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementSupplierQuestionnaireTemplatespagesIndexRoute =
  ManagementSupplierQuestionnaireTemplatespagesIndexRouteImport.update({
    id: '/supplier-questionnaire-templates/(pages)/',
    path: '/supplier-questionnaire-templates/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementTranslationspagesIndexRoute =
  ManagementTranslationspagesIndexRouteImport.update({
    id: '/translations/(pages)/',
    path: '/translations/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementUserspagesIndexRoute =
  ManagementUserspagesIndexRouteImport.update({
    id: '/users/(pages)/',
    path: '/users/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementWebshopspagesIndexRoute =
  ManagementWebshopspagesIndexRouteImport.update({
    id: '/webshops/(pages)/',
    path: '/webshops/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const OnboardingCompanySearchpagesIndexRoute =
  OnboardingCompanySearchpagesIndexRouteImport.update({
    id: '/onboarding/company-search/(pages)/',
    path: '/onboarding/company-search/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SsoOnboardingpagesTokenIndexRoute =
  SsoOnboardingpagesTokenIndexRouteImport.update({
    id: '/sso-onboarding/(pages)/$token/',
    path: '/sso-onboarding/$token/',
    getParentRoute: () => rootRouteImport,
  } as any)
const SsoOnboardingpagesTestResultIndexRoute =
  SsoOnboardingpagesTestResultIndexRouteImport.update({
    id: '/sso-onboarding/(pages)/test-result/',
    path: '/sso-onboarding/test-result/',
    getParentRoute: () => rootRouteImport,
  } as any)
const clientAuditspagesdetailAuditIdRouteRoute =
  clientAuditspagesdetailAuditIdRouteRouteImport.update({
    id: '/(pages)/(detail)/$auditId',
    path: '/$auditId',
    getParentRoute: () => clientAuditsRouteRoute,
  } as any)
const clientAuditspageslistAuditsForCompanyRouteRoute =
  clientAuditspageslistAuditsForCompanyRouteRouteImport.update({
    id: '/audits-for-company',
    path: '/audits-for-company',
    getParentRoute: () => clientAuditspageslistRouteRoute,
  } as any)
const clientAuditspageslistNetworkAuditsRouteRoute =
  clientAuditspageslistNetworkAuditsRouteRouteImport.update({
    id: '/network-audits',
    path: '/network-audits',
    getParentRoute: () => clientAuditspageslistRouteRoute,
  } as any)
const clientCapapageslistActionsRouteRoute =
  clientCapapageslistActionsRouteRouteImport.update({
    id: '/actions',
    path: '/actions',
    getParentRoute: () => clientCapapageslistRouteRoute,
  } as any)
const clientCapapageslistFindingsRouteRoute =
  clientCapapageslistFindingsRouteRouteImport.update({
    id: '/findings',
    path: '/findings',
    getParentRoute: () => clientCapapageslistRouteRoute,
  } as any)
const clientCapapageslistPlansRouteRoute =
  clientCapapageslistPlansRouteRouteImport.update({
    id: '/plans',
    path: '/plans',
    getParentRoute: () => clientCapapageslistRouteRoute,
  } as any)
const clientCertificationspagesIdIndexRoute =
  clientCertificationspagesIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => clientCertificationspagesRouteRoute,
  } as any)
const clientCompanySettingspagesIntegrationsIndexRoute =
  clientCompanySettingspagesIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => clientCompanySettingspagesIntegrationsRouteRoute,
  } as any)
const clientCompanySettingspagesPermissionSetsIndexRoute =
  clientCompanySettingspagesPermissionSetsIndexRouteImport.update({
    id: '/permission-sets/',
    path: '/permission-sets/',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesPermissionSetsNewRoute =
  clientCompanySettingspagesPermissionSetsNewRouteImport.update({
    id: '/permission-sets/new',
    path: '/permission-sets/new',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientFilespageslistIndexRoute =
  clientFilespageslistIndexRouteImport.update({
    id: '/(pages)/(list)/',
    path: '/',
    getParentRoute: () => clientFilesRouteRoute,
  } as any)
const clientMyComponentspageslistComponentSkusRouteRoute =
  clientMyComponentspageslistComponentSkusRouteRouteImport.update({
    id: '/component-skus',
    path: '/component-skus',
    getParentRoute: () => clientMyComponentspageslistRouteRoute,
  } as any)
const clientMyComponentspageslistComponentVariantsRouteRoute =
  clientMyComponentspageslistComponentVariantsRouteRouteImport.update({
    id: '/component-variants',
    path: '/component-variants',
    getParentRoute: () => clientMyComponentspageslistRouteRoute,
  } as any)
const clientMyComponentspageslistComponentsRouteRoute =
  clientMyComponentspageslistComponentsRouteRouteImport.update({
    id: '/components',
    path: '/components',
    getParentRoute: () => clientMyComponentspageslistRouteRoute,
  } as any)
const clientMyStylespageslistSkusRouteRoute =
  clientMyStylespageslistSkusRouteRouteImport.update({
    id: '/skus',
    path: '/skus',
    getParentRoute: () => clientMyStylespageslistRouteRoute,
  } as any)
const clientMyStylespageslistStylesRouteRoute =
  clientMyStylespageslistStylesRouteRouteImport.update({
    id: '/styles',
    path: '/styles',
    getParentRoute: () => clientMyStylespageslistRouteRoute,
  } as any)
const clientMyStylespageslistVariantsRouteRoute =
  clientMyStylespageslistVariantsRouteRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => clientMyStylespageslistRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdRouteRoute =
  clientNetworkpagesdetailCompanyIdRouteRouteImport.update({
    id: '/$companyId',
    path: '/$companyId',
    getParentRoute: () => clientNetworkpagesdetailRouteRoute,
  } as any)
const clientOrdersHubpagesdetailIdRouteRoute =
  clientOrdersHubpagesdetailIdRouteRouteImport.update({
    id: '/orders-hub/(pages)/(detail)/$id',
    path: '/orders-hub/$id',
    getParentRoute: () => clientRouteRoute,
  } as any)
const clientOrderspageslistInternalOrdersRouteRoute =
  clientOrderspageslistInternalOrdersRouteRouteImport.update({
    id: '/internal-orders',
    path: '/internal-orders',
    getParentRoute: () => clientOrderspageslistRouteRoute,
  } as any)
const clientOrderspageslistPurchaseOrdersRouteRoute =
  clientOrderspageslistPurchaseOrdersRouteRouteImport.update({
    id: '/purchase-orders',
    path: '/purchase-orders',
    getParentRoute: () => clientOrderspageslistRouteRoute,
  } as any)
const clientOrderspageslistSalesOrdersRouteRoute =
  clientOrderspageslistSalesOrdersRouteRouteImport.update({
    id: '/sales-orders',
    path: '/sales-orders',
    getParentRoute: () => clientOrderspageslistRouteRoute,
  } as any)
const clientOrderspagesAttachmentTemplatesIndexRoute =
  clientOrderspagesAttachmentTemplatesIndexRouteImport.update({
    id: '/(pages)/attachment-templates/',
    path: '/attachment-templates/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientProfilepagesOverviewIndexRoute =
  clientProfilepagesOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => clientProfilepagesRouteRoute,
  } as any)
const clientProfilepagesSettingsIndexRoute =
  clientProfilepagesSettingsIndexRouteImport.update({
    id: '/settings/',
    path: '/settings/',
    getParentRoute: () => clientProfilepagesRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdRouteRoute =
  clientQuestionnairespagesdetailIdRouteRouteImport.update({
    id: '/(detail)/$id',
    path: '/$id',
    getParentRoute: () => clientQuestionnairespagesRouteRoute,
  } as any)
const clientQuestionnairespageslistMyQuestionnairesRouteRoute =
  clientQuestionnairespageslistMyQuestionnairesRouteRouteImport.update({
    id: '/my-questionnaires',
    path: '/my-questionnaires',
    getParentRoute: () => clientQuestionnairespageslistRouteRoute,
  } as any)
const clientRiskpagesdetailAssessmentsRouteRoute =
  clientRiskpagesdetailAssessmentsRouteRouteImport.update({
    id: '/assessments',
    path: '/assessments',
    getParentRoute: () => clientRiskpagesdetailRouteRoute,
  } as any)
const clientSlcppageslistMyOwnRouteRoute =
  clientSlcppageslistMyOwnRouteRouteImport.update({
    id: '/my-own',
    path: '/my-own',
    getParentRoute: () => clientSlcppageslistRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistInsightsRouteRoute =
  clientSupplyChainMappingpageslistInsightsRouteRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => clientSupplyChainMappingpageslistRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistSupplyChainsRouteRoute =
  clientSupplyChainMappingpageslistSupplyChainsRouteRouteImport.update({
    id: '/supply-chains',
    path: '/supply-chains',
    getParentRoute: () => clientSupplyChainMappingpageslistRouteRoute,
  } as any)
const clientUserspagesIdIndexRoute = clientUserspagesIdIndexRouteImport.update({
  id: '/users/(pages)/$id/',
  path: '/users/$id/',
  getParentRoute: () => clientRouteRoute,
} as any)
const ManagementAttachmentTemplatespagesIdIndexRoute =
  ManagementAttachmentTemplatespagesIdIndexRouteImport.update({
    id: '/attachment-templates/(pages)/$id/',
    path: '/attachment-templates/$id/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementAttachmentTemplatespagesCreateIndexRoute =
  ManagementAttachmentTemplatespagesCreateIndexRouteImport.update({
    id: '/attachment-templates/(pages)/create/',
    path: '/attachment-templates/create/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCertificationspagesIdIndexRoute =
  ManagementCertificationspagesIdIndexRouteImport.update({
    id: '/certifications/(pages)/$id/',
    path: '/certifications/$id/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdIndexRoute =
  ManagementCompaniespagesCompanyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompanyMergespagesMergeIdIndexRoute =
  ManagementCompanyMergespagesMergeIdIndexRouteImport.update({
    id: '/company-merges/(pages)/$mergeId/',
    path: '/company-merges/$mergeId/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCompanyMergespagesNewIndexRoute =
  ManagementCompanyMergespagesNewIndexRouteImport.update({
    id: '/company-merges/(pages)/new/',
    path: '/company-merges/new/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementEntityHistorypagesIdIndexRoute =
  ManagementEntityHistorypagesIdIndexRouteImport.update({
    id: '/entity-history/(pages)/$id/',
    path: '/entity-history/$id/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementPlatformFeaturespagesFeatureIdIndexRoute =
  ManagementPlatformFeaturespagesFeatureIdIndexRouteImport.update({
    id: '/platform-features/(pages)/$featureId/',
    path: '/platform-features/$featureId/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementScoringTemplatespageslistIndexRoute =
  ManagementScoringTemplatespageslistIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => ManagementScoringTemplatespageslistRouteRoute,
  } as any)
const ManagementSsopagesIdIndexRoute =
  ManagementSsopagesIdIndexRouteImport.update({
    id: '/sso/(pages)/$id/',
    path: '/sso/$id/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementUserspagesIdIndexRoute =
  ManagementUserspagesIdIndexRouteImport.update({
    id: '/users/(pages)/$id/',
    path: '/users/$id/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdIndexRoute =
  clientAuditspagesdetailAuditIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute =
  clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRouteImport.update(
    {
      id: '/facility-processes/',
      path: '/facility-processes/',
      getParentRoute: () =>
        clientCompanySettingspagesConstantsMappingRouteRoute,
    } as any,
  )
const clientCompanySettingspagesConstantsMappingMaterialsIndexRoute =
  clientCompanySettingspagesConstantsMappingMaterialsIndexRouteImport.update({
    id: '/materials/',
    path: '/materials/',
    getParentRoute: () => clientCompanySettingspagesConstantsMappingRouteRoute,
  } as any)
const clientCompanySettingspagesConstantsMappingProductTypesIndexRoute =
  clientCompanySettingspagesConstantsMappingProductTypesIndexRouteImport.update(
    {
      id: '/product-types/',
      path: '/product-types/',
      getParentRoute: () =>
        clientCompanySettingspagesConstantsMappingRouteRoute,
    } as any,
  )
const clientCompanySettingspagesPermissionSetsSetKeyIndexRoute =
  clientCompanySettingspagesPermissionSetsSetKeyIndexRouteImport.update({
    id: '/permission-sets/$setKey/',
    path: '/permission-sets/$setKey/',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientCompanySettingspagesPermissionSetsSetKeyEditRoute =
  clientCompanySettingspagesPermissionSetsSetKeyEditRouteImport.update({
    id: '/permission-sets/$setKey/edit',
    path: '/permission-sets/$setKey/edit',
    getParentRoute: () => clientCompanySettingspagesRouteRoute,
  } as any)
const clientDocumentspageslistArchivedIndexRoute =
  clientDocumentspageslistArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientDocumentspageslistRouteRoute,
  } as any)
const clientDocumentspageslistMyDocumentsIndexRoute =
  clientDocumentspageslistMyDocumentsIndexRouteImport.update({
    id: '/my-documents/',
    path: '/my-documents/',
    getParentRoute: () => clientDocumentspageslistRouteRoute,
  } as any)
const clientDocumentspageslistRequestAccessIndexRoute =
  clientDocumentspageslistRequestAccessIndexRouteImport.update({
    id: '/request-access/',
    path: '/request-access/',
    getParentRoute: () => clientDocumentspageslistRouteRoute,
  } as any)
const clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute =
  clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRouteImport.update({
    id: '/(pages)/involved-orders/$companyId/',
    path: '/involved-orders/$companyId/',
    getParentRoute: () => clientEntityScreeningRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdRouteRoute =
  clientMyComponentspagesdetailKindIdRouteRouteImport.update({
    id: '/$kind/$id',
    path: '/$kind/$id',
    getParentRoute: () => clientMyComponentspagesdetailRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdRouteRoute =
  clientMyStylespagesdetailKindIdRouteRouteImport.update({
    id: '/$kind/$id',
    path: '/$kind/$id',
    getParentRoute: () => clientMyStylespagesdetailRouteRoute,
  } as any)
const clientMyStylespageslistStylesCreatedForMeIndexRoute =
  clientMyStylespageslistStylesCreatedForMeIndexRouteImport.update({
    id: '/styles-created-for-me/',
    path: '/styles-created-for-me/',
    getParentRoute: () => clientMyStylespageslistRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdBadgesRoute =
  clientNetworkpagesdetailCompanyIdBadgesRouteImport.update({
    id: '/badges',
    path: '/badges',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdCapaRoute =
  clientNetworkpagesdetailCompanyIdCapaRouteImport.update({
    id: '/capa',
    path: '/capa',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdClaimsRoute =
  clientNetworkpagesdetailCompanyIdClaimsRouteImport.update({
    id: '/claims',
    path: '/claims',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdCustomInformationRoute =
  clientNetworkpagesdetailCompanyIdCustomInformationRouteImport.update({
    id: '/custom-information',
    path: '/custom-information',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute =
  clientNetworkpagesdetailCompanyIdCustomInformationFieldsRouteImport.update({
    id: '/custom-information-fields',
    path: '/custom-information-fields',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdDocumentsRoute =
  clientNetworkpagesdetailCompanyIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdEsgInfoRoute =
  clientNetworkpagesdetailCompanyIdEsgInfoRouteImport.update({
    id: '/esg-info',
    path: '/esg-info',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdGeneralInfoRoute =
  clientNetworkpagesdetailCompanyIdGeneralInfoRouteImport.update({
    id: '/general-info',
    path: '/general-info',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdHistoryRoute =
  clientNetworkpagesdetailCompanyIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute =
  clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdProductsRoute =
  clientNetworkpagesdetailCompanyIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdQuestionnaireRoute =
  clientNetworkpagesdetailCompanyIdQuestionnaireRouteImport.update({
    id: '/questionnaire',
    path: '/questionnaire',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdRiskProfileRoute =
  clientNetworkpagesdetailCompanyIdRiskProfileRouteImport.update({
    id: '/risk-profile',
    path: '/risk-profile',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdSlcpRoute =
  clientNetworkpagesdetailCompanyIdSlcpRouteImport.update({
    id: '/slcp',
    path: '/slcp',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdUsersRoute =
  clientNetworkpagesdetailCompanyIdUsersRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdWebshopProfileRoute =
  clientNetworkpagesdetailCompanyIdWebshopProfileRouteImport.update({
    id: '/webshop-profile',
    path: '/webshop-profile',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpageslistMyNetworkIndexRoute =
  clientNetworkpageslistMyNetworkIndexRouteImport.update({
    id: '/my-network/',
    path: '/my-network/',
    getParentRoute: () => clientNetworkpageslistRouteRoute,
  } as any)
const clientOrdersHubpagesdetailIdAttachmentsRoute =
  clientOrdersHubpagesdetailIdAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => clientOrdersHubpagesdetailIdRouteRoute,
  } as any)
const clientOrdersHubpagesdetailIdLinesRoute =
  clientOrdersHubpagesdetailIdLinesRouteImport.update({
    id: '/lines',
    path: '/lines',
    getParentRoute: () => clientOrdersHubpagesdetailIdRouteRoute,
  } as any)
const clientOrdersHubpagesdetailIdOverviewRoute =
  clientOrdersHubpagesdetailIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientOrdersHubpagesdetailIdRouteRoute,
  } as any)
const clientOrderspagesdetailInternalOrdersIoIdRouteRoute =
  clientOrderspagesdetailInternalOrdersIoIdRouteRouteImport.update({
    id: '/(pages)/(detail)/internal-orders/$ioId',
    path: '/internal-orders/$ioId',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute =
  clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteImport.update({
    id: '/(pages)/(detail)/purchase-orders/$poId',
    path: '/purchase-orders/$poId',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagesdetailSalesOrdersSoIdRouteRoute =
  clientOrderspagesdetailSalesOrdersSoIdRouteRouteImport.update({
    id: '/(pages)/(detail)/sales-orders/$soId',
    path: '/sales-orders/$soId',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagesAttachmentTemplatesIdIndexRoute =
  clientOrderspagesAttachmentTemplatesIdIndexRouteImport.update({
    id: '/(pages)/attachment-templates/$id/',
    path: '/attachment-templates/$id/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagesAttachmentTemplatesCreateIndexRoute =
  clientOrderspagesAttachmentTemplatesCreateIndexRouteImport.update({
    id: '/(pages)/attachment-templates/create/',
    path: '/attachment-templates/create/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientProductMappingpagesdetailsCpmIdIndexRoute =
  clientProductMappingpagesdetailsCpmIdIndexRouteImport.update({
    id: '/(pages)/(details)/$cpmId/',
    path: '/$cpmId/',
    getParentRoute: () => clientProductMappingRouteRoute,
  } as any)
const clientProductMappingpageslistActiveIndexRoute =
  clientProductMappingpageslistActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientProductMappingpageslistRouteRoute,
  } as any)
const clientProductMappingpageslistArchiveIndexRoute =
  clientProductMappingpageslistArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientProductMappingpageslistRouteRoute,
  } as any)
const clientQuestionnairespageslistRequestsIndexRoute =
  clientQuestionnairespageslistRequestsIndexRouteImport.update({
    id: '/requests/',
    path: '/requests/',
    getParentRoute: () => clientQuestionnairespageslistRouteRoute,
  } as any)
const clientQuestionnairespageslistTemplatesIndexRoute =
  clientQuestionnairespageslistTemplatesIndexRouteImport.update({
    id: '/templates/',
    path: '/templates/',
    getParentRoute: () => clientQuestionnairespageslistRouteRoute,
  } as any)
const clientReportpagesanalyticsAuditComplianceIndexRoute =
  clientReportpagesanalyticsAuditComplianceIndexRouteImport.update({
    id: '/(analytics)/audit-compliance/',
    path: '/audit-compliance/',
    getParentRoute: () => clientReportpagesRouteRoute,
  } as any)
const clientReportpagesanalyticsCertificateComplianceIndexRoute =
  clientReportpagesanalyticsCertificateComplianceIndexRouteImport.update({
    id: '/(analytics)/certificate-compliance/',
    path: '/certificate-compliance/',
    getParentRoute: () => clientReportpagesRouteRoute,
  } as any)
const clientReportpagesanalyticsTracingComplianceIndexRoute =
  clientReportpagesanalyticsTracingComplianceIndexRouteImport.update({
    id: '/(analytics)/tracing-compliance/',
    path: '/tracing-compliance/',
    getParentRoute: () => clientReportpagesRouteRoute,
  } as any)
const clientReportpagesanalyticsTracingOperationsIndexRoute =
  clientReportpagesanalyticsTracingOperationsIndexRouteImport.update({
    id: '/(analytics)/tracing-operations/',
    path: '/tracing-operations/',
    getParentRoute: () => clientReportpagesRouteRoute,
  } as any)
const clientRiskpageslistAssessmentsIndexRoute =
  clientRiskpageslistAssessmentsIndexRouteImport.update({
    id: '/assessments/',
    path: '/assessments/',
    getParentRoute: () => clientRiskpageslistRouteRoute,
  } as any)
const clientRiskpageslistLandscapeIndexRoute =
  clientRiskpageslistLandscapeIndexRouteImport.update({
    id: '/landscape/',
    path: '/landscape/',
    getParentRoute: () => clientRiskpageslistRouteRoute,
  } as any)
const clientRiskpageslistRulesIndexRoute =
  clientRiskpageslistRulesIndexRouteImport.update({
    id: '/rules/',
    path: '/rules/',
    getParentRoute: () => clientRiskpageslistRouteRoute,
  } as any)
const clientSlcppageslistNetworkIndexRoute =
  clientSlcppageslistNetworkIndexRouteImport.update({
    id: '/network/',
    path: '/network/',
    getParentRoute: () => clientSlcppageslistRouteRoute,
  } as any)
const clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute =
  clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteImport.update({
    id: '/assessments/(details)/$assessmentId',
    path: '/assessments/$assessmentId',
    getParentRoute: () => clientSlcppagesRouteRoute,
  } as any)
const clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute =
  clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteImport.update({
    id: '/(pages)/(details)/supply-chains/$id',
    path: '/supply-chains/$id',
    getParentRoute: () => clientSupplyChainMappingRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistHistoryIndexRoute =
  clientSupplyChainMappingpageslistHistoryIndexRouteImport.update({
    id: '/history/',
    path: '/history/',
    getParentRoute: () => clientSupplyChainMappingpageslistRouteRoute,
  } as any)
const ManagementAttachmentTemplatespagesIdEditIndexRoute =
  ManagementAttachmentTemplatespagesIdEditIndexRouteImport.update({
    id: '/attachment-templates/(pages)/$id/edit/',
    path: '/attachment-templates/$id/edit/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementCertificationspageslistActiveIndexRoute =
  ManagementCertificationspageslistActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => ManagementCertificationspageslistRouteRoute,
  } as any)
const ManagementCertificationspageslistArchivedIndexRoute =
  ManagementCertificationspageslistArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => ManagementCertificationspageslistRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdApiKeysIndexRoute =
  ManagementCompaniespagesCompanyIdApiKeysIndexRouteImport.update({
    id: '/api-keys/',
    path: '/api-keys/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute =
  ManagementCompaniespagesCompanyIdAutomationRulesIndexRouteImport.update({
    id: '/automation-rules/',
    path: '/automation-rules/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdCreditsIndexRoute =
  ManagementCompaniespagesCompanyIdCreditsIndexRouteImport.update({
    id: '/credits/',
    path: '/credits/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdEmployeesIndexRoute =
  ManagementCompaniespagesCompanyIdEmployeesIndexRouteImport.update({
    id: '/employees/',
    path: '/employees/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute =
  ManagementCompaniespagesCompanyIdGeneralInfoIndexRouteImport.update({
    id: '/general-info/',
    path: '/general-info/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdNetworkIndexRoute =
  ManagementCompaniespagesCompanyIdNetworkIndexRouteImport.update({
    id: '/network/',
    path: '/network/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute =
  ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRouteImport.update({
    id: '/platform-features/',
    path: '/platform-features/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute =
  ManagementCompaniespagesCompanyIdSupplyChainsIndexRouteImport.update({
    id: '/supply-chains/',
    path: '/supply-chains/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdTechInsightsIndexRoute =
  ManagementCompaniespagesCompanyIdTechInsightsIndexRouteImport.update({
    id: '/tech-insights/',
    path: '/tech-insights/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute =
  ManagementCompaniespagesCompanyIdTracingOrdersIndexRouteImport.update({
    id: '/tracing-orders/',
    path: '/tracing-orders/',
    getParentRoute: () => ManagementCompaniespagesCompanyIdRouteRoute,
  } as any)
const ManagementDocumentspageslistActiveIndexRoute =
  ManagementDocumentspageslistActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => ManagementDocumentspageslistRouteRoute,
  } as any)
const ManagementDocumentspageslistArchivedIndexRoute =
  ManagementDocumentspageslistArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => ManagementDocumentspageslistRouteRoute,
  } as any)
const ManagementProductCategoriespagesCategoryIdFieldsIndexRoute =
  ManagementProductCategoriespagesCategoryIdFieldsIndexRouteImport.update({
    id: '/product-categories/(pages)/$categoryId/fields/',
    path: '/product-categories/$categoryId/fields/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementRiskManagementpageslistRiskGrossIndexRoute =
  ManagementRiskManagementpageslistRiskGrossIndexRouteImport.update({
    id: '/risk-gross/',
    path: '/risk-gross/',
    getParentRoute: () => ManagementRiskManagementpageslistRouteRoute,
  } as any)
const ManagementRiskManagementpageslistRisksIndexRoute =
  ManagementRiskManagementpageslistRisksIndexRouteImport.update({
    id: '/risks/',
    path: '/risks/',
    getParentRoute: () => ManagementRiskManagementpageslistRouteRoute,
  } as any)
const ManagementRiskManagementpageslistRuleTemplatesIndexRoute =
  ManagementRiskManagementpageslistRuleTemplatesIndexRouteImport.update({
    id: '/rule-templates/',
    path: '/rule-templates/',
    getParentRoute: () => ManagementRiskManagementpageslistRouteRoute,
  } as any)
const ManagementScoringTemplatespagesIdEditIndexRoute =
  ManagementScoringTemplatespagesIdEditIndexRouteImport.update({
    id: '/scoring-templates/(pages)/$id/edit/',
    path: '/scoring-templates/$id/edit/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementScoringTemplatespageslistGapsIndexRoute =
  ManagementScoringTemplatespageslistGapsIndexRouteImport.update({
    id: '/gaps/',
    path: '/gaps/',
    getParentRoute: () => ManagementScoringTemplatespageslistRouteRoute,
  } as any)
const ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute =
  ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRouteImport.update({
    id: '/supplier-questionnaire-templates/(pages)/$id/edit/',
    path: '/supplier-questionnaire-templates/$id/edit/',
    getParentRoute: () => ManagementRouteRoute,
  } as any)
const ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute =
  ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRouteImport.update(
    {
      id: '/supplier-questionnaire-templates/(pages)/$id/preview/',
      path: '/supplier-questionnaire-templates/$id/preview/',
      getParentRoute: () => ManagementRouteRoute,
    } as any,
  )
const clientAuditspagesdetailAuditIdCapaIndexRoute =
  clientAuditspagesdetailAuditIdCapaIndexRouteImport.update({
    id: '/capa/',
    path: '/capa/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdContentIndexRoute =
  clientAuditspagesdetailAuditIdContentIndexRouteImport.update({
    id: '/content/',
    path: '/content/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdFindingsIndexRoute =
  clientAuditspagesdetailAuditIdFindingsIndexRouteImport.update({
    id: '/findings/',
    path: '/findings/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdOverviewIndexRoute =
  clientAuditspagesdetailAuditIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdScoreIndexRoute =
  clientAuditspagesdetailAuditIdScoreIndexRouteImport.update({
    id: '/score/',
    path: '/score/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspagesdetailAuditIdViewIndexRoute =
  clientAuditspagesdetailAuditIdViewIndexRouteImport.update({
    id: '/view/',
    path: '/view/',
    getParentRoute: () => clientAuditspagesdetailAuditIdRouteRoute,
  } as any)
const clientAuditspageslistAuditsForCompanyActiveIndexRoute =
  clientAuditspageslistAuditsForCompanyActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientAuditspageslistAuditsForCompanyRouteRoute,
  } as any)
const clientAuditspageslistAuditsForCompanyArchiveIndexRoute =
  clientAuditspageslistAuditsForCompanyArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientAuditspageslistAuditsForCompanyRouteRoute,
  } as any)
const clientAuditspageslistNetworkAuditsActiveIndexRoute =
  clientAuditspageslistNetworkAuditsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientAuditspageslistNetworkAuditsRouteRoute,
  } as any)
const clientAuditspageslistNetworkAuditsArchiveIndexRoute =
  clientAuditspageslistNetworkAuditsArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientAuditspageslistNetworkAuditsRouteRoute,
  } as any)
const clientCapapagesdetailActionsIdIndexRoute =
  clientCapapagesdetailActionsIdIndexRouteImport.update({
    id: '/actions/$id/',
    path: '/actions/$id/',
    getParentRoute: () => clientCapapagesdetailRouteRoute,
  } as any)
const clientCapapagesdetailPlansIdIndexRoute =
  clientCapapagesdetailPlansIdIndexRouteImport.update({
    id: '/plans/$id/',
    path: '/plans/$id/',
    getParentRoute: () => clientCapapagesdetailRouteRoute,
  } as any)
const clientCapapageslistActionsActiveIndexRoute =
  clientCapapageslistActionsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientCapapageslistActionsRouteRoute,
  } as any)
const clientCapapageslistActionsArchivedIndexRoute =
  clientCapapageslistActionsArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientCapapageslistActionsRouteRoute,
  } as any)
const clientCapapageslistFindingsActiveIndexRoute =
  clientCapapageslistFindingsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientCapapageslistFindingsRouteRoute,
  } as any)
const clientCapapageslistFindingsArchivedIndexRoute =
  clientCapapageslistFindingsArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientCapapageslistFindingsRouteRoute,
  } as any)
const clientCapapageslistPlansActiveIndexRoute =
  clientCapapageslistPlansActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientCapapageslistPlansRouteRoute,
  } as any)
const clientCapapageslistPlansArchivedIndexRoute =
  clientCapapageslistPlansArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientCapapageslistPlansRouteRoute,
  } as any)
const clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute =
  clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRouteImport.update(
    {
      id: '/history/$syncHistoryId/',
      path: '/history/$syncHistoryId/',
      getParentRoute: () => clientCompanySettingspagesIntegrationsRouteRoute,
    } as any,
  )
const clientMyComponentspagesdetailKindIdBomRoute =
  clientMyComponentspagesdetailKindIdBomRouteImport.update({
    id: '/bom',
    path: '/bom',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdCertificationsRoute =
  clientMyComponentspagesdetailKindIdCertificationsRouteImport.update({
    id: '/certifications',
    path: '/certifications',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdDocumentsRouteRoute =
  clientMyComponentspagesdetailKindIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdMaterialsRoute =
  clientMyComponentspagesdetailKindIdMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdOverviewRoute =
  clientMyComponentspagesdetailKindIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdQrCodeRoute =
  clientMyComponentspagesdetailKindIdQrCodeRouteImport.update({
    id: '/qr-code',
    path: '/qr-code',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdSkusRoute =
  clientMyComponentspagesdetailKindIdSkusRouteImport.update({
    id: '/skus',
    path: '/skus',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdSupplyChainRoute =
  clientMyComponentspagesdetailKindIdSupplyChainRouteImport.update({
    id: '/supply-chain',
    path: '/supply-chain',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdVariantsRoute =
  clientMyComponentspagesdetailKindIdVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdWebshopPreviewRoute =
  clientMyComponentspagesdetailKindIdWebshopPreviewRouteImport.update({
    id: '/webshop-preview',
    path: '/webshop-preview',
    getParentRoute: () => clientMyComponentspagesdetailKindIdRouteRoute,
  } as any)
const clientMyComponentspageslistComponentSkusActiveIndexRoute =
  clientMyComponentspageslistComponentSkusActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientMyComponentspageslistComponentSkusRouteRoute,
  } as any)
const clientMyComponentspageslistComponentSkusArchivedIndexRoute =
  clientMyComponentspageslistComponentSkusArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientMyComponentspageslistComponentSkusRouteRoute,
  } as any)
const clientMyComponentspageslistComponentVariantsActiveIndexRoute =
  clientMyComponentspageslistComponentVariantsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () =>
      clientMyComponentspageslistComponentVariantsRouteRoute,
  } as any)
const clientMyComponentspageslistComponentVariantsArchivedIndexRoute =
  clientMyComponentspageslistComponentVariantsArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () =>
      clientMyComponentspageslistComponentVariantsRouteRoute,
  } as any)
const clientMyComponentspageslistComponentsActiveIndexRoute =
  clientMyComponentspageslistComponentsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientMyComponentspageslistComponentsRouteRoute,
  } as any)
const clientMyComponentspageslistComponentsArchivedIndexRoute =
  clientMyComponentspageslistComponentsArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientMyComponentspageslistComponentsRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdBomRoute =
  clientMyStylespagesdetailKindIdBomRouteImport.update({
    id: '/bom',
    path: '/bom',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdCertificationsRoute =
  clientMyStylespagesdetailKindIdCertificationsRouteImport.update({
    id: '/certifications',
    path: '/certifications',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdDocumentsRouteRoute =
  clientMyStylespagesdetailKindIdDocumentsRouteRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdMaterialsRoute =
  clientMyStylespagesdetailKindIdMaterialsRouteImport.update({
    id: '/materials',
    path: '/materials',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdOverviewRoute =
  clientMyStylespagesdetailKindIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdQrCodeRoute =
  clientMyStylespagesdetailKindIdQrCodeRouteImport.update({
    id: '/qr-code',
    path: '/qr-code',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdSkusRoute =
  clientMyStylespagesdetailKindIdSkusRouteImport.update({
    id: '/skus',
    path: '/skus',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdSupplyChainRoute =
  clientMyStylespagesdetailKindIdSupplyChainRouteImport.update({
    id: '/supply-chain',
    path: '/supply-chain',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdVariantsRoute =
  clientMyStylespagesdetailKindIdVariantsRouteImport.update({
    id: '/variants',
    path: '/variants',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdWebshopPreviewRoute =
  clientMyStylespagesdetailKindIdWebshopPreviewRouteImport.update({
    id: '/webshop-preview',
    path: '/webshop-preview',
    getParentRoute: () => clientMyStylespagesdetailKindIdRouteRoute,
  } as any)
const clientMyStylespageslistSkusActiveIndexRoute =
  clientMyStylespageslistSkusActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientMyStylespageslistSkusRouteRoute,
  } as any)
const clientMyStylespageslistSkusArchivedIndexRoute =
  clientMyStylespageslistSkusArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientMyStylespageslistSkusRouteRoute,
  } as any)
const clientMyStylespageslistStylesActiveIndexRoute =
  clientMyStylespageslistStylesActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientMyStylespageslistStylesRouteRoute,
  } as any)
const clientMyStylespageslistStylesArchivedIndexRoute =
  clientMyStylespageslistStylesArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientMyStylespageslistStylesRouteRoute,
  } as any)
const clientMyStylespageslistVariantsActiveIndexRoute =
  clientMyStylespageslistVariantsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientMyStylespageslistVariantsRouteRoute,
  } as any)
const clientMyStylespageslistVariantsArchivedIndexRoute =
  clientMyStylespageslistVariantsArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () => clientMyStylespageslistVariantsRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdAuditsIndexRoute =
  clientNetworkpagesdetailCompanyIdAuditsIndexRouteImport.update({
    id: '/audits/',
    path: '/audits/',
    getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute =
  clientNetworkpagesdetailCompanyIdIntegrationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute,
  } as any)
const clientOrderspagescreatePurchaseOrdersCreateIndexRoute =
  clientOrderspagescreatePurchaseOrdersCreateIndexRouteImport.update({
    id: '/(pages)/(create)/purchase-orders/create/',
    path: '/purchase-orders/create/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagescreateSalesOrdersCreateIndexRoute =
  clientOrderspagescreateSalesOrdersCreateIndexRouteImport.update({
    id: '/(pages)/(create)/sales-orders/create/',
    path: '/sales-orders/create/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute =
  clientOrderspagesdetailInternalOrdersIoIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => clientOrderspagesdetailInternalOrdersIoIdRouteRoute,
  } as any)
const clientOrderspagesdetailInternalOrdersIoIdOverviewRoute =
  clientOrderspagesdetailInternalOrdersIoIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientOrderspagesdetailInternalOrdersIoIdRouteRoute,
  } as any)
const clientOrderspagesdetailInternalOrdersIoIdProductsRoute =
  clientOrderspagesdetailInternalOrdersIoIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => clientOrderspagesdetailInternalOrdersIoIdRouteRoute,
  } as any)
const clientOrderspagesdetailInternalOrdersIoIdTracingRoute =
  clientOrderspagesdetailInternalOrdersIoIdTracingRouteImport.update({
    id: '/tracing',
    path: '/tracing',
    getParentRoute: () => clientOrderspagesdetailInternalOrdersIoIdRouteRoute,
  } as any)
const clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute =
  clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute,
  } as any)
const clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute =
  clientOrderspagesdetailPurchaseOrdersPoIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute,
  } as any)
const clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute =
  clientOrderspagesdetailPurchaseOrdersPoIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute,
  } as any)
const clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute =
  clientOrderspagesdetailPurchaseOrdersPoIdTracingRouteImport.update({
    id: '/tracing',
    path: '/tracing',
    getParentRoute: () => clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute,
  } as any)
const clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute =
  clientOrderspagesdetailSalesOrdersSoIdAttachmentsRouteImport.update({
    id: '/attachments',
    path: '/attachments',
    getParentRoute: () => clientOrderspagesdetailSalesOrdersSoIdRouteRoute,
  } as any)
const clientOrderspagesdetailSalesOrdersSoIdOverviewRoute =
  clientOrderspagesdetailSalesOrdersSoIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => clientOrderspagesdetailSalesOrdersSoIdRouteRoute,
  } as any)
const clientOrderspagesdetailSalesOrdersSoIdProductsRoute =
  clientOrderspagesdetailSalesOrdersSoIdProductsRouteImport.update({
    id: '/products',
    path: '/products',
    getParentRoute: () => clientOrderspagesdetailSalesOrdersSoIdRouteRoute,
  } as any)
const clientOrderspagesdetailSalesOrdersSoIdTracingRoute =
  clientOrderspagesdetailSalesOrdersSoIdTracingRouteImport.update({
    id: '/tracing',
    path: '/tracing',
    getParentRoute: () => clientOrderspagesdetailSalesOrdersSoIdRouteRoute,
  } as any)
const clientOrderspageslistInternalOrdersActiveIndexRoute =
  clientOrderspageslistInternalOrdersActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientOrderspageslistInternalOrdersRouteRoute,
  } as any)
const clientOrderspageslistInternalOrdersArchiveIndexRoute =
  clientOrderspageslistInternalOrdersArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientOrderspageslistInternalOrdersRouteRoute,
  } as any)
const clientOrderspageslistPurchaseOrdersActiveIndexRoute =
  clientOrderspageslistPurchaseOrdersActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientOrderspageslistPurchaseOrdersRouteRoute,
  } as any)
const clientOrderspageslistPurchaseOrdersArchiveIndexRoute =
  clientOrderspageslistPurchaseOrdersArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientOrderspageslistPurchaseOrdersRouteRoute,
  } as any)
const clientOrderspageslistSalesOrdersActiveIndexRoute =
  clientOrderspageslistSalesOrdersActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientOrderspageslistSalesOrdersRouteRoute,
  } as any)
const clientOrderspageslistSalesOrdersArchiveIndexRoute =
  clientOrderspageslistSalesOrdersArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientOrderspageslistSalesOrdersRouteRoute,
  } as any)
const clientOrderspagesAttachmentTemplatesIdEditIndexRoute =
  clientOrderspagesAttachmentTemplatesIdEditIndexRouteImport.update({
    id: '/(pages)/attachment-templates/$id/edit/',
    path: '/attachment-templates/$id/edit/',
    getParentRoute: () => clientOrdersRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdEditIndexRoute =
  clientQuestionnairespagesdetailIdEditIndexRouteImport.update({
    id: '/edit/',
    path: '/edit/',
    getParentRoute: () => clientQuestionnairespagesdetailIdRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdReviewIndexRoute =
  clientQuestionnairespagesdetailIdReviewIndexRouteImport.update({
    id: '/review/',
    path: '/review/',
    getParentRoute: () => clientQuestionnairespagesdetailIdRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdSummaryIndexRoute =
  clientQuestionnairespagesdetailIdSummaryIndexRouteImport.update({
    id: '/summary/',
    path: '/summary/',
    getParentRoute: () => clientQuestionnairespagesdetailIdRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdAnswerIndexRoute =
  clientQuestionnairespagesdetailIdAnswerIndexRouteImport.update({
    id: '/(detail)/$id_/answer/',
    path: '/$id/answer/',
    getParentRoute: () => clientQuestionnairespagesRouteRoute,
  } as any)
const clientQuestionnairespagesdetailIdPreviewIndexRoute =
  clientQuestionnairespagesdetailIdPreviewIndexRouteImport.update({
    id: '/(detail)/$id_/preview/',
    path: '/$id/preview/',
    getParentRoute: () => clientQuestionnairespagesRouteRoute,
  } as any)
const clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute =
  clientQuestionnairespageslistMyQuestionnairesActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () =>
      clientQuestionnairespageslistMyQuestionnairesRouteRoute,
  } as any)
const clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute =
  clientQuestionnairespageslistMyQuestionnairesArchivedIndexRouteImport.update({
    id: '/archived/',
    path: '/archived/',
    getParentRoute: () =>
      clientQuestionnairespageslistMyQuestionnairesRouteRoute,
  } as any)
const clientRiskpagesdetailAssessmentsIdIndexRoute =
  clientRiskpagesdetailAssessmentsIdIndexRouteImport.update({
    id: '/$id/',
    path: '/$id/',
    getParentRoute: () => clientRiskpagesdetailAssessmentsRouteRoute,
  } as any)
const clientRiskpagesdetailRulesIdIndexRoute =
  clientRiskpagesdetailRulesIdIndexRouteImport.update({
    id: '/rules/$id/',
    path: '/rules/$id/',
    getParentRoute: () => clientRiskpagesdetailRouteRoute,
  } as any)
const clientSlcppageslistMyOwnActiveIndexRoute =
  clientSlcppageslistMyOwnActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () => clientSlcppageslistMyOwnRouteRoute,
  } as any)
const clientSlcppageslistMyOwnArchiveIndexRoute =
  clientSlcppageslistMyOwnArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () => clientSlcppageslistMyOwnRouteRoute,
  } as any)
const clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute =
  clientSlcppagesAssessmentsdetailsAssessmentIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute =
  clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRouteImport.update(
    {
      id: '/collaborator-companies/',
      path: '/collaborator-companies/',
      getParentRoute: () => clientSupplyChainMappingpageslistInsightsRouteRoute,
    } as any,
  )
const clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute =
  clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRouteImport.update(
    {
      id: '/global-diagram/',
      path: '/global-diagram/',
      getParentRoute: () => clientSupplyChainMappingpageslistInsightsRouteRoute,
    } as any,
  )
const clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute =
  clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRouteImport.update(
    {
      id: '/mapped-companies/',
      path: '/mapped-companies/',
      getParentRoute: () => clientSupplyChainMappingpageslistInsightsRouteRoute,
    } as any,
  )
const clientSupplyChainMappingpageslistInsightsOverviewIndexRoute =
  clientSupplyChainMappingpageslistInsightsOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () => clientSupplyChainMappingpageslistInsightsRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute =
  clientSupplyChainMappingpageslistSupplyChainsActiveIndexRouteImport.update({
    id: '/active/',
    path: '/active/',
    getParentRoute: () =>
      clientSupplyChainMappingpageslistSupplyChainsRouteRoute,
  } as any)
const clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute =
  clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRouteImport.update({
    id: '/archive/',
    path: '/archive/',
    getParentRoute: () =>
      clientSupplyChainMappingpageslistSupplyChainsRouteRoute,
  } as any)
const ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute =
  ManagementRiskManagementpagesRuleTemplatesIdEditIndexRouteImport.update({
    id: '/rule-templates/$id/edit/',
    path: '/rule-templates/$id/edit/',
    getParentRoute: () => ManagementRiskManagementpagesRouteRoute,
  } as any)
const clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute =
  clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRouteImport.update(
    {
      id: '/(drilldown)/audit-compliance/drilldown/$chartType/',
      path: '/audit-compliance/drilldown/$chartType/',
      getParentRoute: () => clientReportpagesRouteRoute,
    } as any,
  )
const clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute =
  clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRouteImport.update(
    {
      id: '/(drilldown)/certificate-compliance/drilldown/$chartType/',
      path: '/certificate-compliance/drilldown/$chartType/',
      getParentRoute: () => clientReportpagesRouteRoute,
    } as any,
  )
const clientRiskpageseditRulesIdEditIndexRoute =
  clientRiskpageseditRulesIdEditIndexRouteImport.update({
    id: '/rules/$id/edit/',
    path: '/rules/$id/edit/',
    getParentRoute: () => clientRiskpageseditRouteRoute,
  } as any)
const clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute =
  clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRouteImport.update(
    {
      id: '/assessment/',
      path: '/assessment/',
      getParentRoute: () =>
        clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute,
    } as any,
  )
const clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute =
  clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRouteImport.update({
    id: '/overview/',
    path: '/overview/',
    getParentRoute: () =>
      clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute,
  } as any)
const clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute =
  clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRouteImport.update(
    {
      id: '/compare/',
      path: '/compare/',
      getParentRoute: () =>
        clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute,
    } as any,
  )
const clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute =
  clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRouteImport.update(
    {
      id: '/diagram/',
      path: '/diagram/',
      getParentRoute: () =>
        clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute,
    } as any,
  )
const clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute =
  clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRouteImport.update({
    id: '/map/',
    path: '/map/',
    getParentRoute: () =>
      clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute =
  clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRouteImport.update({
    id: '/linked/',
    path: '/linked/',
    getParentRoute: () =>
      clientMyComponentspagesdetailKindIdDocumentsRouteRoute,
  } as any)
const clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute =
  clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRouteImport.update(
    {
      id: '/product-only/',
      path: '/product-only/',
      getParentRoute: () =>
        clientMyComponentspagesdetailKindIdDocumentsRouteRoute,
    } as any,
  )
const clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute =
  clientMyStylespagesdetailKindIdDocumentsLinkedIndexRouteImport.update({
    id: '/linked/',
    path: '/linked/',
    getParentRoute: () => clientMyStylespagesdetailKindIdDocumentsRouteRoute,
  } as any)
const clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute =
  clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRouteImport.update({
    id: '/product-only/',
    path: '/product-only/',
    getParentRoute: () => clientMyStylespagesdetailKindIdDocumentsRouteRoute,
  } as any)
const clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute =
  clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRouteImport.update(
    {
      id: '/audits/$auditId/findings/',
      path: '/audits/$auditId/findings/',
      getParentRoute: () => clientNetworkpagesdetailCompanyIdRouteRoute,
    } as any,
  )
const clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute =
  clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRouteImport.update(
    {
      id: '/history/$syncHistoryId/',
      path: '/history/$syncHistoryId/',
      getParentRoute: () =>
        clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute,
    } as any,
  )
const clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute =
  clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRouteImport.update(
    {
      id: '/$id/assessed/$assessmentId/',
      path: '/$id/assessed/$assessmentId/',
      getParentRoute: () => clientRiskpagesdetailAssessmentsRouteRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/management': typeof ManagementRouteRouteWithChildren
  '/audits': typeof clientAuditspageslistRouteRouteWithChildren
  '/entity-screening': typeof clientEntityScreeningRouteRouteWithChildren
  '/files': typeof clientFilesRouteRouteWithChildren
  '/my-components': typeof clientMyComponentspageslistRouteRouteWithChildren
  '/my-styles': typeof clientMyStylespageslistRouteRouteWithChildren
  '/orders': typeof clientOrderspageslistRouteRouteWithChildren
  '/product-mapping': typeof clientProductMappingpageslistRouteRouteWithChildren
  '/risk': typeof clientRiskpageslistRouteRouteWithChildren
  '/supply-chain-mapping': typeof clientSupplyChainMappingpageslistRouteRouteWithChildren
  '/docs/': typeof DocsIndexRoute
  '/capa': typeof clientCapapageslistRouteRouteWithChildren
  '/certifications': typeof clientCertificationspagesRouteRouteWithChildren
  '/certified-materials': typeof clientCertifiedMaterialspagesRouteRouteWithChildren
  '/company-settings': typeof clientCompanySettingspagesRouteRouteWithChildren
  '/documents': typeof clientDocumentspageslistRouteRouteWithChildren
  '/network': typeof clientNetworkpageslistRouteRouteWithChildren
  '/profile': typeof clientProfilepagesRouteRouteWithChildren
  '/questionnaires': typeof clientQuestionnairespageslistRouteRouteWithChildren
  '/report': typeof clientReportpagesRouteRouteWithChildren
  '/slcp': typeof clientSlcppageslistRouteRouteWithChildren
  '/management/risk-management': typeof ManagementRiskManagementpageslistRouteRouteWithChildren
  '/': typeof loginpagesIndexRoute
  '/single-sign-on-callback/': typeof loginSingleSignOnCallbackIndexRoute
  '/unsubscribe/': typeof UnsubscribepagesIndexRoute
  '/company-settings/constants-mapping': typeof clientCompanySettingspagesConstantsMappingRouteRouteWithChildren
  '/company-settings/integrations': typeof clientCompanySettingspagesIntegrationsRouteRouteWithChildren
  '/management/certifications': typeof ManagementCertificationspageslistRouteRouteWithChildren
  '/management/companies/$companyId': typeof ManagementCompaniespagesCompanyIdRouteRouteWithChildren
  '/management/documents': typeof ManagementDocumentspageslistRouteRouteWithChildren
  '/management/scoring-templates': typeof ManagementScoringTemplatespageslistRouteRouteWithChildren
  '/company-settings/api-keys': typeof clientCompanySettingspagesApiKeysRoute
  '/company-settings/join-requests': typeof clientCompanySettingspagesJoinRequestsRoute
  '/company-settings/users': typeof clientCompanySettingspagesUsersRoute
  '/company-settings/webshop-settings': typeof clientCompanySettingspagesWebshopSettingsRoute
  '/orders-hub/create': typeof clientOrdersHubpagesCreateRoute
  '/activity-feed/': typeof clientActivityFeedpagesIndexRoute
  '/automation-rules/': typeof clientAutomationRulespagesIndexRoute
  '/certifications/': typeof clientCertificationspagesIndexRoute
  '/certified-materials/': typeof clientCertifiedMaterialspagesIndexRoute
  '/dashboard/': typeof clientDashboardpagesIndexRoute
  '/entity-screening/': typeof clientEntityScreeningpagesIndexRoute
  '/orders-hub/': typeof clientOrdersHubpagesIndexRoute
  '/docs/components/$slug/': typeof DocsComponentsSlugIndexRoute
  '/docs/foundations/$slug/': typeof DocsFoundationsSlugIndexRoute
  '/docs/guides/$slug/': typeof DocsGuidesSlugIndexRoute
  '/docs/patterns/$slug/': typeof DocsPatternsSlugIndexRoute
  '/management/attachment-templates/': typeof ManagementAttachmentTemplatespagesIndexRoute
  '/management/audit-types/': typeof ManagementAuditTypespagesIndexRoute
  '/management/audits/': typeof ManagementAuditspagesIndexRoute
  '/management/background-jobs/': typeof ManagementBackgroundJobspagesIndexRoute
  '/management/badges/': typeof ManagementBadgespagesIndexRoute
  '/management/companies/': typeof ManagementCompaniespagesIndexRoute
  '/management/company-merges/': typeof ManagementCompanyMergespagesIndexRoute
  '/management/cs-tools/': typeof ManagementCsToolspagesIndexRoute
  '/management/custom-information-fields/': typeof ManagementCustomInformationFieldspagesIndexRoute
  '/management/document-types/': typeof ManagementDocumentTypespagesIndexRoute
  '/management/email-bounce-tracking/': typeof ManagementEmailBounceTrackingpagesIndexRoute
  '/management/entity-history/': typeof ManagementEntityHistorypagesIndexRoute
  '/management/facility-processes/': typeof ManagementFacilityProcessespagesIndexRoute
  '/management/impersonate/': typeof ManagementImpersonatepagesIndexRoute
  '/management/materials/': typeof ManagementMaterialspagesIndexRoute
  '/management/origins/': typeof ManagementOriginspagesIndexRoute
  '/management/permissions/': typeof ManagementPermissionspagesIndexRoute
  '/management/platform-features/': typeof ManagementPlatformFeaturespagesIndexRoute
  '/management/product-categories/': typeof ManagementProductCategoriespagesIndexRoute
  '/management/product-data-points/': typeof ManagementProductDataPointspagesIndexRoute
  '/management/production-processes/': typeof ManagementProductionProcessespagesIndexRoute
  '/management/rules/': typeof ManagementRulespagesIndexRoute
  '/management/slcp-dashboard/': typeof ManagementSlcpDashboardpagesIndexRoute
  '/management/sso/': typeof ManagementSsopagesIndexRoute
  '/management/standards/': typeof ManagementStandardspagesIndexRoute
  '/management/supplier-questionnaire-templates/': typeof ManagementSupplierQuestionnaireTemplatespagesIndexRoute
  '/management/translations/': typeof ManagementTranslationspagesIndexRoute
  '/management/users/': typeof ManagementUserspagesIndexRoute
  '/management/webshops/': typeof ManagementWebshopspagesIndexRoute
  '/onboarding/company-search/': typeof OnboardingCompanySearchpagesIndexRoute
  '/sso-onboarding/$token/': typeof SsoOnboardingpagesTokenIndexRoute
  '/sso-onboarding/test-result/': typeof SsoOnboardingpagesTestResultIndexRoute
  '/audits/$auditId': typeof clientAuditspagesdetailAuditIdRouteRouteWithChildren
  '/audits/audits-for-company': typeof clientAuditspageslistAuditsForCompanyRouteRouteWithChildren
  '/audits/network-audits': typeof clientAuditspageslistNetworkAuditsRouteRouteWithChildren
  '/capa/actions': typeof clientCapapageslistActionsRouteRouteWithChildren
  '/capa/findings': typeof clientCapapageslistFindingsRouteRouteWithChildren
  '/capa/plans': typeof clientCapapageslistPlansRouteRouteWithChildren
  '/my-components/component-skus': typeof clientMyComponentspageslistComponentSkusRouteRouteWithChildren
  '/my-components/component-variants': typeof clientMyComponentspageslistComponentVariantsRouteRouteWithChildren
  '/my-components/components': typeof clientMyComponentspageslistComponentsRouteRouteWithChildren
  '/my-styles/skus': typeof clientMyStylespageslistSkusRouteRouteWithChildren
  '/my-styles/styles': typeof clientMyStylespageslistStylesRouteRouteWithChildren
  '/my-styles/variants': typeof clientMyStylespageslistVariantsRouteRouteWithChildren
  '/network/$companyId': typeof clientNetworkpagesdetailCompanyIdRouteRouteWithChildren
  '/orders-hub/$id': typeof clientOrdersHubpagesdetailIdRouteRouteWithChildren
  '/orders/internal-orders': typeof clientOrderspageslistInternalOrdersRouteRouteWithChildren
  '/orders/purchase-orders': typeof clientOrderspageslistPurchaseOrdersRouteRouteWithChildren
  '/orders/sales-orders': typeof clientOrderspageslistSalesOrdersRouteRouteWithChildren
  '/questionnaires/$id': typeof clientQuestionnairespagesdetailIdRouteRouteWithChildren
  '/questionnaires/my-questionnaires': typeof clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren
  '/risk/assessments': typeof clientRiskpagesdetailAssessmentsRouteRouteWithChildren
  '/slcp/my-own': typeof clientSlcppageslistMyOwnRouteRouteWithChildren
  '/supply-chain-mapping/insights': typeof clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren
  '/supply-chain-mapping/supply-chains': typeof clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren
  '/company-settings/permission-sets/new': typeof clientCompanySettingspagesPermissionSetsNewRoute
  '/certifications/$id/': typeof clientCertificationspagesIdIndexRoute
  '/company-settings/integrations/': typeof clientCompanySettingspagesIntegrationsIndexRoute
  '/company-settings/permission-sets/': typeof clientCompanySettingspagesPermissionSetsIndexRoute
  '/files/': typeof clientFilespageslistIndexRoute
  '/orders/attachment-templates/': typeof clientOrderspagesAttachmentTemplatesIndexRoute
  '/profile/overview/': typeof clientProfilepagesOverviewIndexRoute
  '/profile/settings/': typeof clientProfilepagesSettingsIndexRoute
  '/users/$id/': typeof clientUserspagesIdIndexRoute
  '/management/attachment-templates/$id/': typeof ManagementAttachmentTemplatespagesIdIndexRoute
  '/management/attachment-templates/create/': typeof ManagementAttachmentTemplatespagesCreateIndexRoute
  '/management/certifications/$id/': typeof ManagementCertificationspagesIdIndexRoute
  '/management/companies/$companyId/': typeof ManagementCompaniespagesCompanyIdIndexRoute
  '/management/company-merges/$mergeId/': typeof ManagementCompanyMergespagesMergeIdIndexRoute
  '/management/company-merges/new/': typeof ManagementCompanyMergespagesNewIndexRoute
  '/management/entity-history/$id/': typeof ManagementEntityHistorypagesIdIndexRoute
  '/management/platform-features/$featureId/': typeof ManagementPlatformFeaturespagesFeatureIdIndexRoute
  '/management/scoring-templates/': typeof ManagementScoringTemplatespageslistIndexRoute
  '/management/sso/$id/': typeof ManagementSsopagesIdIndexRoute
  '/management/users/$id/': typeof ManagementUserspagesIdIndexRoute
  '/my-components/$kind/$id': typeof clientMyComponentspagesdetailKindIdRouteRouteWithChildren
  '/my-styles/$kind/$id': typeof clientMyStylespagesdetailKindIdRouteRouteWithChildren
  '/network/$companyId/integrations': typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteWithChildren
  '/orders/internal-orders/$ioId': typeof clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren
  '/orders/purchase-orders/$poId': typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren
  '/orders/sales-orders/$soId': typeof clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren
  '/slcp/assessments/$assessmentId': typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteWithChildren
  '/supply-chain-mapping/supply-chains/$id': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren
  '/company-settings/permission-sets/$setKey/edit': typeof clientCompanySettingspagesPermissionSetsSetKeyEditRoute
  '/network/$companyId/badges': typeof clientNetworkpagesdetailCompanyIdBadgesRoute
  '/network/$companyId/capa': typeof clientNetworkpagesdetailCompanyIdCapaRoute
  '/network/$companyId/claims': typeof clientNetworkpagesdetailCompanyIdClaimsRoute
  '/network/$companyId/custom-information': typeof clientNetworkpagesdetailCompanyIdCustomInformationRoute
  '/network/$companyId/custom-information-fields': typeof clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute
  '/network/$companyId/documents': typeof clientNetworkpagesdetailCompanyIdDocumentsRoute
  '/network/$companyId/esg-info': typeof clientNetworkpagesdetailCompanyIdEsgInfoRoute
  '/network/$companyId/general-info': typeof clientNetworkpagesdetailCompanyIdGeneralInfoRoute
  '/network/$companyId/history': typeof clientNetworkpagesdetailCompanyIdHistoryRoute
  '/network/$companyId/products': typeof clientNetworkpagesdetailCompanyIdProductsRoute
  '/network/$companyId/questionnaire': typeof clientNetworkpagesdetailCompanyIdQuestionnaireRoute
  '/network/$companyId/risk-profile': typeof clientNetworkpagesdetailCompanyIdRiskProfileRoute
  '/network/$companyId/slcp': typeof clientNetworkpagesdetailCompanyIdSlcpRoute
  '/network/$companyId/users': typeof clientNetworkpagesdetailCompanyIdUsersRoute
  '/network/$companyId/webshop-profile': typeof clientNetworkpagesdetailCompanyIdWebshopProfileRoute
  '/orders-hub/$id/attachments': typeof clientOrdersHubpagesdetailIdAttachmentsRoute
  '/orders-hub/$id/lines': typeof clientOrdersHubpagesdetailIdLinesRoute
  '/orders-hub/$id/overview': typeof clientOrdersHubpagesdetailIdOverviewRoute
  '/audits/$auditId/': typeof clientAuditspagesdetailAuditIdIndexRoute
  '/company-settings/constants-mapping/facility-processes/': typeof clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute
  '/company-settings/constants-mapping/materials/': typeof clientCompanySettingspagesConstantsMappingMaterialsIndexRoute
  '/company-settings/constants-mapping/product-types/': typeof clientCompanySettingspagesConstantsMappingProductTypesIndexRoute
  '/company-settings/permission-sets/$setKey/': typeof clientCompanySettingspagesPermissionSetsSetKeyIndexRoute
  '/documents/archived/': typeof clientDocumentspageslistArchivedIndexRoute
  '/documents/my-documents/': typeof clientDocumentspageslistMyDocumentsIndexRoute
  '/documents/request-access/': typeof clientDocumentspageslistRequestAccessIndexRoute
  '/entity-screening/involved-orders/$companyId/': typeof clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute
  '/my-styles/styles-created-for-me/': typeof clientMyStylespageslistStylesCreatedForMeIndexRoute
  '/network/my-network/': typeof clientNetworkpageslistMyNetworkIndexRoute
  '/orders/attachment-templates/$id/': typeof clientOrderspagesAttachmentTemplatesIdIndexRoute
  '/orders/attachment-templates/create/': typeof clientOrderspagesAttachmentTemplatesCreateIndexRoute
  '/product-mapping/$cpmId/': typeof clientProductMappingpagesdetailsCpmIdIndexRoute
  '/product-mapping/active/': typeof clientProductMappingpageslistActiveIndexRoute
  '/product-mapping/archive/': typeof clientProductMappingpageslistArchiveIndexRoute
  '/questionnaires/requests/': typeof clientQuestionnairespageslistRequestsIndexRoute
  '/questionnaires/templates/': typeof clientQuestionnairespageslistTemplatesIndexRoute
  '/report/audit-compliance/': typeof clientReportpagesanalyticsAuditComplianceIndexRoute
  '/report/certificate-compliance/': typeof clientReportpagesanalyticsCertificateComplianceIndexRoute
  '/report/tracing-compliance/': typeof clientReportpagesanalyticsTracingComplianceIndexRoute
  '/report/tracing-operations/': typeof clientReportpagesanalyticsTracingOperationsIndexRoute
  '/risk/assessments/': typeof clientRiskpageslistAssessmentsIndexRoute
  '/risk/landscape/': typeof clientRiskpageslistLandscapeIndexRoute
  '/risk/rules/': typeof clientRiskpageslistRulesIndexRoute
  '/slcp/network/': typeof clientSlcppageslistNetworkIndexRoute
  '/supply-chain-mapping/history/': typeof clientSupplyChainMappingpageslistHistoryIndexRoute
  '/management/attachment-templates/$id/edit/': typeof ManagementAttachmentTemplatespagesIdEditIndexRoute
  '/management/certifications/active/': typeof ManagementCertificationspageslistActiveIndexRoute
  '/management/certifications/archived/': typeof ManagementCertificationspageslistArchivedIndexRoute
  '/management/companies/$companyId/api-keys/': typeof ManagementCompaniespagesCompanyIdApiKeysIndexRoute
  '/management/companies/$companyId/automation-rules/': typeof ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute
  '/management/companies/$companyId/credits/': typeof ManagementCompaniespagesCompanyIdCreditsIndexRoute
  '/management/companies/$companyId/employees/': typeof ManagementCompaniespagesCompanyIdEmployeesIndexRoute
  '/management/companies/$companyId/general-info/': typeof ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute
  '/management/companies/$companyId/network/': typeof ManagementCompaniespagesCompanyIdNetworkIndexRoute
  '/management/companies/$companyId/platform-features/': typeof ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute
  '/management/companies/$companyId/supply-chains/': typeof ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute
  '/management/companies/$companyId/tech-insights/': typeof ManagementCompaniespagesCompanyIdTechInsightsIndexRoute
  '/management/companies/$companyId/tracing-orders/': typeof ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute
  '/management/documents/active/': typeof ManagementDocumentspageslistActiveIndexRoute
  '/management/documents/archived/': typeof ManagementDocumentspageslistArchivedIndexRoute
  '/management/product-categories/$categoryId/fields/': typeof ManagementProductCategoriespagesCategoryIdFieldsIndexRoute
  '/management/risk-management/risk-gross/': typeof ManagementRiskManagementpageslistRiskGrossIndexRoute
  '/management/risk-management/risks/': typeof ManagementRiskManagementpageslistRisksIndexRoute
  '/management/risk-management/rule-templates/': typeof ManagementRiskManagementpageslistRuleTemplatesIndexRoute
  '/management/scoring-templates/$id/edit/': typeof ManagementScoringTemplatespagesIdEditIndexRoute
  '/management/scoring-templates/gaps/': typeof ManagementScoringTemplatespageslistGapsIndexRoute
  '/management/supplier-questionnaire-templates/$id/edit/': typeof ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute
  '/management/supplier-questionnaire-templates/$id/preview/': typeof ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute
  '/my-components/$kind/$id/documents': typeof clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren
  '/my-styles/$kind/$id/documents': typeof clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren
  '/my-components/$kind/$id/bom': typeof clientMyComponentspagesdetailKindIdBomRoute
  '/my-components/$kind/$id/certifications': typeof clientMyComponentspagesdetailKindIdCertificationsRoute
  '/my-components/$kind/$id/materials': typeof clientMyComponentspagesdetailKindIdMaterialsRoute
  '/my-components/$kind/$id/overview': typeof clientMyComponentspagesdetailKindIdOverviewRoute
  '/my-components/$kind/$id/qr-code': typeof clientMyComponentspagesdetailKindIdQrCodeRoute
  '/my-components/$kind/$id/skus': typeof clientMyComponentspagesdetailKindIdSkusRoute
  '/my-components/$kind/$id/supply-chain': typeof clientMyComponentspagesdetailKindIdSupplyChainRoute
  '/my-components/$kind/$id/variants': typeof clientMyComponentspagesdetailKindIdVariantsRoute
  '/my-components/$kind/$id/webshop-preview': typeof clientMyComponentspagesdetailKindIdWebshopPreviewRoute
  '/my-styles/$kind/$id/bom': typeof clientMyStylespagesdetailKindIdBomRoute
  '/my-styles/$kind/$id/certifications': typeof clientMyStylespagesdetailKindIdCertificationsRoute
  '/my-styles/$kind/$id/materials': typeof clientMyStylespagesdetailKindIdMaterialsRoute
  '/my-styles/$kind/$id/overview': typeof clientMyStylespagesdetailKindIdOverviewRoute
  '/my-styles/$kind/$id/qr-code': typeof clientMyStylespagesdetailKindIdQrCodeRoute
  '/my-styles/$kind/$id/skus': typeof clientMyStylespagesdetailKindIdSkusRoute
  '/my-styles/$kind/$id/supply-chain': typeof clientMyStylespagesdetailKindIdSupplyChainRoute
  '/my-styles/$kind/$id/variants': typeof clientMyStylespagesdetailKindIdVariantsRoute
  '/my-styles/$kind/$id/webshop-preview': typeof clientMyStylespagesdetailKindIdWebshopPreviewRoute
  '/orders/internal-orders/$ioId/documents': typeof clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute
  '/orders/internal-orders/$ioId/overview': typeof clientOrderspagesdetailInternalOrdersIoIdOverviewRoute
  '/orders/internal-orders/$ioId/products': typeof clientOrderspagesdetailInternalOrdersIoIdProductsRoute
  '/orders/internal-orders/$ioId/tracing': typeof clientOrderspagesdetailInternalOrdersIoIdTracingRoute
  '/orders/purchase-orders/$poId/documents': typeof clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute
  '/orders/purchase-orders/$poId/overview': typeof clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute
  '/orders/purchase-orders/$poId/products': typeof clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute
  '/orders/purchase-orders/$poId/tracing': typeof clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute
  '/orders/sales-orders/$soId/attachments': typeof clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute
  '/orders/sales-orders/$soId/overview': typeof clientOrderspagesdetailSalesOrdersSoIdOverviewRoute
  '/orders/sales-orders/$soId/products': typeof clientOrderspagesdetailSalesOrdersSoIdProductsRoute
  '/orders/sales-orders/$soId/tracing': typeof clientOrderspagesdetailSalesOrdersSoIdTracingRoute
  '/audits/$auditId/capa/': typeof clientAuditspagesdetailAuditIdCapaIndexRoute
  '/audits/$auditId/content/': typeof clientAuditspagesdetailAuditIdContentIndexRoute
  '/audits/$auditId/findings/': typeof clientAuditspagesdetailAuditIdFindingsIndexRoute
  '/audits/$auditId/overview/': typeof clientAuditspagesdetailAuditIdOverviewIndexRoute
  '/audits/$auditId/score/': typeof clientAuditspagesdetailAuditIdScoreIndexRoute
  '/audits/$auditId/view/': typeof clientAuditspagesdetailAuditIdViewIndexRoute
  '/audits/audits-for-company/active/': typeof clientAuditspageslistAuditsForCompanyActiveIndexRoute
  '/audits/audits-for-company/archive/': typeof clientAuditspageslistAuditsForCompanyArchiveIndexRoute
  '/audits/network-audits/active/': typeof clientAuditspageslistNetworkAuditsActiveIndexRoute
  '/audits/network-audits/archive/': typeof clientAuditspageslistNetworkAuditsArchiveIndexRoute
  '/capa/actions/$id/': typeof clientCapapagesdetailActionsIdIndexRoute
  '/capa/plans/$id/': typeof clientCapapagesdetailPlansIdIndexRoute
  '/capa/actions/active/': typeof clientCapapageslistActionsActiveIndexRoute
  '/capa/actions/archived/': typeof clientCapapageslistActionsArchivedIndexRoute
  '/capa/findings/active/': typeof clientCapapageslistFindingsActiveIndexRoute
  '/capa/findings/archived/': typeof clientCapapageslistFindingsArchivedIndexRoute
  '/capa/plans/active/': typeof clientCapapageslistPlansActiveIndexRoute
  '/capa/plans/archived/': typeof clientCapapageslistPlansArchivedIndexRoute
  '/company-settings/integrations/history/$syncHistoryId/': typeof clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute
  '/my-components/component-skus/active/': typeof clientMyComponentspageslistComponentSkusActiveIndexRoute
  '/my-components/component-skus/archived/': typeof clientMyComponentspageslistComponentSkusArchivedIndexRoute
  '/my-components/component-variants/active/': typeof clientMyComponentspageslistComponentVariantsActiveIndexRoute
  '/my-components/component-variants/archived/': typeof clientMyComponentspageslistComponentVariantsArchivedIndexRoute
  '/my-components/components/active/': typeof clientMyComponentspageslistComponentsActiveIndexRoute
  '/my-components/components/archived/': typeof clientMyComponentspageslistComponentsArchivedIndexRoute
  '/my-styles/skus/active/': typeof clientMyStylespageslistSkusActiveIndexRoute
  '/my-styles/skus/archived/': typeof clientMyStylespageslistSkusArchivedIndexRoute
  '/my-styles/styles/active/': typeof clientMyStylespageslistStylesActiveIndexRoute
  '/my-styles/styles/archived/': typeof clientMyStylespageslistStylesArchivedIndexRoute
  '/my-styles/variants/active/': typeof clientMyStylespageslistVariantsActiveIndexRoute
  '/my-styles/variants/archived/': typeof clientMyStylespageslistVariantsArchivedIndexRoute
  '/network/$companyId/audits/': typeof clientNetworkpagesdetailCompanyIdAuditsIndexRoute
  '/network/$companyId/integrations/': typeof clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute
  '/orders/purchase-orders/create/': typeof clientOrderspagescreatePurchaseOrdersCreateIndexRoute
  '/orders/sales-orders/create/': typeof clientOrderspagescreateSalesOrdersCreateIndexRoute
  '/orders/internal-orders/active/': typeof clientOrderspageslistInternalOrdersActiveIndexRoute
  '/orders/internal-orders/archive/': typeof clientOrderspageslistInternalOrdersArchiveIndexRoute
  '/orders/purchase-orders/active/': typeof clientOrderspageslistPurchaseOrdersActiveIndexRoute
  '/orders/purchase-orders/archive/': typeof clientOrderspageslistPurchaseOrdersArchiveIndexRoute
  '/orders/sales-orders/active/': typeof clientOrderspageslistSalesOrdersActiveIndexRoute
  '/orders/sales-orders/archive/': typeof clientOrderspageslistSalesOrdersArchiveIndexRoute
  '/orders/attachment-templates/$id/edit/': typeof clientOrderspagesAttachmentTemplatesIdEditIndexRoute
  '/questionnaires/$id/edit/': typeof clientQuestionnairespagesdetailIdEditIndexRoute
  '/questionnaires/$id/review/': typeof clientQuestionnairespagesdetailIdReviewIndexRoute
  '/questionnaires/$id/summary/': typeof clientQuestionnairespagesdetailIdSummaryIndexRoute
  '/questionnaires/$id/answer/': typeof clientQuestionnairespagesdetailIdAnswerIndexRoute
  '/questionnaires/$id/preview/': typeof clientQuestionnairespagesdetailIdPreviewIndexRoute
  '/questionnaires/my-questionnaires/active/': typeof clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute
  '/questionnaires/my-questionnaires/archived/': typeof clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute
  '/risk/assessments/$id/': typeof clientRiskpagesdetailAssessmentsIdIndexRoute
  '/risk/rules/$id/': typeof clientRiskpagesdetailRulesIdIndexRoute
  '/slcp/my-own/active/': typeof clientSlcppageslistMyOwnActiveIndexRoute
  '/slcp/my-own/archive/': typeof clientSlcppageslistMyOwnArchiveIndexRoute
  '/slcp/assessments/$assessmentId/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute
  '/supply-chain-mapping/insights/collaborator-companies/': typeof clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute
  '/supply-chain-mapping/insights/global-diagram/': typeof clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute
  '/supply-chain-mapping/insights/mapped-companies/': typeof clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute
  '/supply-chain-mapping/insights/overview/': typeof clientSupplyChainMappingpageslistInsightsOverviewIndexRoute
  '/supply-chain-mapping/supply-chains/active/': typeof clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute
  '/supply-chain-mapping/supply-chains/archive/': typeof clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute
  '/management/risk-management/rule-templates/$id/edit/': typeof ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute
  '/report/audit-compliance/drilldown/$chartType/': typeof clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute
  '/report/certificate-compliance/drilldown/$chartType/': typeof clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute
  '/risk/rules/$id/edit/': typeof clientRiskpageseditRulesIdEditIndexRoute
  '/slcp/assessments/$assessmentId/assessment/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute
  '/slcp/assessments/$assessmentId/overview/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute
  '/supply-chain-mapping/supply-chains/$id/compare/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute
  '/supply-chain-mapping/supply-chains/$id/diagram/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute
  '/supply-chain-mapping/supply-chains/$id/map/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute
  '/my-components/$kind/$id/documents/linked/': typeof clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute
  '/my-components/$kind/$id/documents/product-only/': typeof clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/my-styles/$kind/$id/documents/linked/': typeof clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute
  '/my-styles/$kind/$id/documents/product-only/': typeof clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/network/$companyId/audits/$auditId/findings/': typeof clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute
  '/network/$companyId/integrations/history/$syncHistoryId/': typeof clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute
  '/risk/assessments/$id/assessed/$assessmentId/': typeof clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute
}
export interface FileRoutesByTo {
  '/management': typeof ManagementRouteRouteWithChildren
  '/audits': typeof clientAuditspageslistRouteRouteWithChildren
  '/my-components': typeof clientMyComponentspageslistRouteRouteWithChildren
  '/my-styles': typeof clientMyStylespageslistRouteRouteWithChildren
  '/orders': typeof clientOrderspageslistRouteRouteWithChildren
  '/product-mapping': typeof clientProductMappingpageslistRouteRouteWithChildren
  '/risk': typeof clientRiskpageslistRouteRouteWithChildren
  '/supply-chain-mapping': typeof clientSupplyChainMappingpageslistRouteRouteWithChildren
  '/docs': typeof DocsIndexRoute
  '/capa': typeof clientCapapageslistRouteRouteWithChildren
  '/company-settings': typeof clientCompanySettingspagesRouteRouteWithChildren
  '/documents': typeof clientDocumentspageslistRouteRouteWithChildren
  '/network': typeof clientNetworkpageslistRouteRouteWithChildren
  '/profile': typeof clientProfilepagesRouteRouteWithChildren
  '/questionnaires': typeof clientQuestionnairespageslistRouteRouteWithChildren
  '/report': typeof clientReportpagesRouteRouteWithChildren
  '/slcp': typeof clientSlcppageslistRouteRouteWithChildren
  '/management/risk-management': typeof ManagementRiskManagementpageslistRouteRouteWithChildren
  '/': typeof loginpagesIndexRoute
  '/single-sign-on-callback': typeof loginSingleSignOnCallbackIndexRoute
  '/unsubscribe': typeof UnsubscribepagesIndexRoute
  '/company-settings/constants-mapping': typeof clientCompanySettingspagesConstantsMappingRouteRouteWithChildren
  '/management/certifications': typeof ManagementCertificationspageslistRouteRouteWithChildren
  '/management/documents': typeof ManagementDocumentspageslistRouteRouteWithChildren
  '/company-settings/api-keys': typeof clientCompanySettingspagesApiKeysRoute
  '/company-settings/join-requests': typeof clientCompanySettingspagesJoinRequestsRoute
  '/company-settings/users': typeof clientCompanySettingspagesUsersRoute
  '/company-settings/webshop-settings': typeof clientCompanySettingspagesWebshopSettingsRoute
  '/orders-hub/create': typeof clientOrdersHubpagesCreateRoute
  '/activity-feed': typeof clientActivityFeedpagesIndexRoute
  '/automation-rules': typeof clientAutomationRulespagesIndexRoute
  '/certifications': typeof clientCertificationspagesIndexRoute
  '/certified-materials': typeof clientCertifiedMaterialspagesIndexRoute
  '/dashboard': typeof clientDashboardpagesIndexRoute
  '/entity-screening': typeof clientEntityScreeningpagesIndexRoute
  '/orders-hub': typeof clientOrdersHubpagesIndexRoute
  '/docs/components/$slug': typeof DocsComponentsSlugIndexRoute
  '/docs/foundations/$slug': typeof DocsFoundationsSlugIndexRoute
  '/docs/guides/$slug': typeof DocsGuidesSlugIndexRoute
  '/docs/patterns/$slug': typeof DocsPatternsSlugIndexRoute
  '/management/attachment-templates': typeof ManagementAttachmentTemplatespagesIndexRoute
  '/management/audit-types': typeof ManagementAuditTypespagesIndexRoute
  '/management/audits': typeof ManagementAuditspagesIndexRoute
  '/management/background-jobs': typeof ManagementBackgroundJobspagesIndexRoute
  '/management/badges': typeof ManagementBadgespagesIndexRoute
  '/management/companies': typeof ManagementCompaniespagesIndexRoute
  '/management/company-merges': typeof ManagementCompanyMergespagesIndexRoute
  '/management/cs-tools': typeof ManagementCsToolspagesIndexRoute
  '/management/custom-information-fields': typeof ManagementCustomInformationFieldspagesIndexRoute
  '/management/document-types': typeof ManagementDocumentTypespagesIndexRoute
  '/management/email-bounce-tracking': typeof ManagementEmailBounceTrackingpagesIndexRoute
  '/management/entity-history': typeof ManagementEntityHistorypagesIndexRoute
  '/management/facility-processes': typeof ManagementFacilityProcessespagesIndexRoute
  '/management/impersonate': typeof ManagementImpersonatepagesIndexRoute
  '/management/materials': typeof ManagementMaterialspagesIndexRoute
  '/management/origins': typeof ManagementOriginspagesIndexRoute
  '/management/permissions': typeof ManagementPermissionspagesIndexRoute
  '/management/platform-features': typeof ManagementPlatformFeaturespagesIndexRoute
  '/management/product-categories': typeof ManagementProductCategoriespagesIndexRoute
  '/management/product-data-points': typeof ManagementProductDataPointspagesIndexRoute
  '/management/production-processes': typeof ManagementProductionProcessespagesIndexRoute
  '/management/rules': typeof ManagementRulespagesIndexRoute
  '/management/slcp-dashboard': typeof ManagementSlcpDashboardpagesIndexRoute
  '/management/sso': typeof ManagementSsopagesIndexRoute
  '/management/standards': typeof ManagementStandardspagesIndexRoute
  '/management/supplier-questionnaire-templates': typeof ManagementSupplierQuestionnaireTemplatespagesIndexRoute
  '/management/translations': typeof ManagementTranslationspagesIndexRoute
  '/management/users': typeof ManagementUserspagesIndexRoute
  '/management/webshops': typeof ManagementWebshopspagesIndexRoute
  '/onboarding/company-search': typeof OnboardingCompanySearchpagesIndexRoute
  '/sso-onboarding/$token': typeof SsoOnboardingpagesTokenIndexRoute
  '/sso-onboarding/test-result': typeof SsoOnboardingpagesTestResultIndexRoute
  '/audits/audits-for-company': typeof clientAuditspageslistAuditsForCompanyRouteRouteWithChildren
  '/audits/network-audits': typeof clientAuditspageslistNetworkAuditsRouteRouteWithChildren
  '/capa/actions': typeof clientCapapageslistActionsRouteRouteWithChildren
  '/capa/findings': typeof clientCapapageslistFindingsRouteRouteWithChildren
  '/capa/plans': typeof clientCapapageslistPlansRouteRouteWithChildren
  '/my-components/component-skus': typeof clientMyComponentspageslistComponentSkusRouteRouteWithChildren
  '/my-components/component-variants': typeof clientMyComponentspageslistComponentVariantsRouteRouteWithChildren
  '/my-components/components': typeof clientMyComponentspageslistComponentsRouteRouteWithChildren
  '/my-styles/skus': typeof clientMyStylespageslistSkusRouteRouteWithChildren
  '/my-styles/styles': typeof clientMyStylespageslistStylesRouteRouteWithChildren
  '/my-styles/variants': typeof clientMyStylespageslistVariantsRouteRouteWithChildren
  '/network/$companyId': typeof clientNetworkpagesdetailCompanyIdRouteRouteWithChildren
  '/orders-hub/$id': typeof clientOrdersHubpagesdetailIdRouteRouteWithChildren
  '/orders/internal-orders': typeof clientOrderspageslistInternalOrdersRouteRouteWithChildren
  '/orders/purchase-orders': typeof clientOrderspageslistPurchaseOrdersRouteRouteWithChildren
  '/orders/sales-orders': typeof clientOrderspageslistSalesOrdersRouteRouteWithChildren
  '/questionnaires/$id': typeof clientQuestionnairespagesdetailIdRouteRouteWithChildren
  '/questionnaires/my-questionnaires': typeof clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren
  '/risk/assessments': typeof clientRiskpageslistAssessmentsIndexRoute
  '/slcp/my-own': typeof clientSlcppageslistMyOwnRouteRouteWithChildren
  '/supply-chain-mapping/insights': typeof clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren
  '/supply-chain-mapping/supply-chains': typeof clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren
  '/company-settings/permission-sets/new': typeof clientCompanySettingspagesPermissionSetsNewRoute
  '/certifications/$id': typeof clientCertificationspagesIdIndexRoute
  '/company-settings/integrations': typeof clientCompanySettingspagesIntegrationsIndexRoute
  '/company-settings/permission-sets': typeof clientCompanySettingspagesPermissionSetsIndexRoute
  '/files': typeof clientFilespageslistIndexRoute
  '/orders/attachment-templates': typeof clientOrderspagesAttachmentTemplatesIndexRoute
  '/profile/overview': typeof clientProfilepagesOverviewIndexRoute
  '/profile/settings': typeof clientProfilepagesSettingsIndexRoute
  '/users/$id': typeof clientUserspagesIdIndexRoute
  '/management/attachment-templates/$id': typeof ManagementAttachmentTemplatespagesIdIndexRoute
  '/management/attachment-templates/create': typeof ManagementAttachmentTemplatespagesCreateIndexRoute
  '/management/certifications/$id': typeof ManagementCertificationspagesIdIndexRoute
  '/management/companies/$companyId': typeof ManagementCompaniespagesCompanyIdIndexRoute
  '/management/company-merges/$mergeId': typeof ManagementCompanyMergespagesMergeIdIndexRoute
  '/management/company-merges/new': typeof ManagementCompanyMergespagesNewIndexRoute
  '/management/entity-history/$id': typeof ManagementEntityHistorypagesIdIndexRoute
  '/management/platform-features/$featureId': typeof ManagementPlatformFeaturespagesFeatureIdIndexRoute
  '/management/scoring-templates': typeof ManagementScoringTemplatespageslistIndexRoute
  '/management/sso/$id': typeof ManagementSsopagesIdIndexRoute
  '/management/users/$id': typeof ManagementUserspagesIdIndexRoute
  '/my-components/$kind/$id': typeof clientMyComponentspagesdetailKindIdRouteRouteWithChildren
  '/my-styles/$kind/$id': typeof clientMyStylespagesdetailKindIdRouteRouteWithChildren
  '/orders/internal-orders/$ioId': typeof clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren
  '/orders/purchase-orders/$poId': typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren
  '/orders/sales-orders/$soId': typeof clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren
  '/supply-chain-mapping/supply-chains/$id': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren
  '/company-settings/permission-sets/$setKey/edit': typeof clientCompanySettingspagesPermissionSetsSetKeyEditRoute
  '/network/$companyId/badges': typeof clientNetworkpagesdetailCompanyIdBadgesRoute
  '/network/$companyId/capa': typeof clientNetworkpagesdetailCompanyIdCapaRoute
  '/network/$companyId/claims': typeof clientNetworkpagesdetailCompanyIdClaimsRoute
  '/network/$companyId/custom-information': typeof clientNetworkpagesdetailCompanyIdCustomInformationRoute
  '/network/$companyId/custom-information-fields': typeof clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute
  '/network/$companyId/documents': typeof clientNetworkpagesdetailCompanyIdDocumentsRoute
  '/network/$companyId/esg-info': typeof clientNetworkpagesdetailCompanyIdEsgInfoRoute
  '/network/$companyId/general-info': typeof clientNetworkpagesdetailCompanyIdGeneralInfoRoute
  '/network/$companyId/history': typeof clientNetworkpagesdetailCompanyIdHistoryRoute
  '/network/$companyId/products': typeof clientNetworkpagesdetailCompanyIdProductsRoute
  '/network/$companyId/questionnaire': typeof clientNetworkpagesdetailCompanyIdQuestionnaireRoute
  '/network/$companyId/risk-profile': typeof clientNetworkpagesdetailCompanyIdRiskProfileRoute
  '/network/$companyId/slcp': typeof clientNetworkpagesdetailCompanyIdSlcpRoute
  '/network/$companyId/users': typeof clientNetworkpagesdetailCompanyIdUsersRoute
  '/network/$companyId/webshop-profile': typeof clientNetworkpagesdetailCompanyIdWebshopProfileRoute
  '/orders-hub/$id/attachments': typeof clientOrdersHubpagesdetailIdAttachmentsRoute
  '/orders-hub/$id/lines': typeof clientOrdersHubpagesdetailIdLinesRoute
  '/orders-hub/$id/overview': typeof clientOrdersHubpagesdetailIdOverviewRoute
  '/audits/$auditId': typeof clientAuditspagesdetailAuditIdIndexRoute
  '/company-settings/constants-mapping/facility-processes': typeof clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute
  '/company-settings/constants-mapping/materials': typeof clientCompanySettingspagesConstantsMappingMaterialsIndexRoute
  '/company-settings/constants-mapping/product-types': typeof clientCompanySettingspagesConstantsMappingProductTypesIndexRoute
  '/company-settings/permission-sets/$setKey': typeof clientCompanySettingspagesPermissionSetsSetKeyIndexRoute
  '/documents/archived': typeof clientDocumentspageslistArchivedIndexRoute
  '/documents/my-documents': typeof clientDocumentspageslistMyDocumentsIndexRoute
  '/documents/request-access': typeof clientDocumentspageslistRequestAccessIndexRoute
  '/entity-screening/involved-orders/$companyId': typeof clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute
  '/my-styles/styles-created-for-me': typeof clientMyStylespageslistStylesCreatedForMeIndexRoute
  '/network/my-network': typeof clientNetworkpageslistMyNetworkIndexRoute
  '/orders/attachment-templates/$id': typeof clientOrderspagesAttachmentTemplatesIdIndexRoute
  '/orders/attachment-templates/create': typeof clientOrderspagesAttachmentTemplatesCreateIndexRoute
  '/product-mapping/$cpmId': typeof clientProductMappingpagesdetailsCpmIdIndexRoute
  '/product-mapping/active': typeof clientProductMappingpageslistActiveIndexRoute
  '/product-mapping/archive': typeof clientProductMappingpageslistArchiveIndexRoute
  '/questionnaires/requests': typeof clientQuestionnairespageslistRequestsIndexRoute
  '/questionnaires/templates': typeof clientQuestionnairespageslistTemplatesIndexRoute
  '/report/audit-compliance': typeof clientReportpagesanalyticsAuditComplianceIndexRoute
  '/report/certificate-compliance': typeof clientReportpagesanalyticsCertificateComplianceIndexRoute
  '/report/tracing-compliance': typeof clientReportpagesanalyticsTracingComplianceIndexRoute
  '/report/tracing-operations': typeof clientReportpagesanalyticsTracingOperationsIndexRoute
  '/risk/landscape': typeof clientRiskpageslistLandscapeIndexRoute
  '/risk/rules': typeof clientRiskpageslistRulesIndexRoute
  '/slcp/network': typeof clientSlcppageslistNetworkIndexRoute
  '/supply-chain-mapping/history': typeof clientSupplyChainMappingpageslistHistoryIndexRoute
  '/management/attachment-templates/$id/edit': typeof ManagementAttachmentTemplatespagesIdEditIndexRoute
  '/management/certifications/active': typeof ManagementCertificationspageslistActiveIndexRoute
  '/management/certifications/archived': typeof ManagementCertificationspageslistArchivedIndexRoute
  '/management/companies/$companyId/api-keys': typeof ManagementCompaniespagesCompanyIdApiKeysIndexRoute
  '/management/companies/$companyId/automation-rules': typeof ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute
  '/management/companies/$companyId/credits': typeof ManagementCompaniespagesCompanyIdCreditsIndexRoute
  '/management/companies/$companyId/employees': typeof ManagementCompaniespagesCompanyIdEmployeesIndexRoute
  '/management/companies/$companyId/general-info': typeof ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute
  '/management/companies/$companyId/network': typeof ManagementCompaniespagesCompanyIdNetworkIndexRoute
  '/management/companies/$companyId/platform-features': typeof ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute
  '/management/companies/$companyId/supply-chains': typeof ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute
  '/management/companies/$companyId/tech-insights': typeof ManagementCompaniespagesCompanyIdTechInsightsIndexRoute
  '/management/companies/$companyId/tracing-orders': typeof ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute
  '/management/documents/active': typeof ManagementDocumentspageslistActiveIndexRoute
  '/management/documents/archived': typeof ManagementDocumentspageslistArchivedIndexRoute
  '/management/product-categories/$categoryId/fields': typeof ManagementProductCategoriespagesCategoryIdFieldsIndexRoute
  '/management/risk-management/risk-gross': typeof ManagementRiskManagementpageslistRiskGrossIndexRoute
  '/management/risk-management/risks': typeof ManagementRiskManagementpageslistRisksIndexRoute
  '/management/risk-management/rule-templates': typeof ManagementRiskManagementpageslistRuleTemplatesIndexRoute
  '/management/scoring-templates/$id/edit': typeof ManagementScoringTemplatespagesIdEditIndexRoute
  '/management/scoring-templates/gaps': typeof ManagementScoringTemplatespageslistGapsIndexRoute
  '/management/supplier-questionnaire-templates/$id/edit': typeof ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute
  '/management/supplier-questionnaire-templates/$id/preview': typeof ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute
  '/my-components/$kind/$id/documents': typeof clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren
  '/my-styles/$kind/$id/documents': typeof clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren
  '/my-components/$kind/$id/bom': typeof clientMyComponentspagesdetailKindIdBomRoute
  '/my-components/$kind/$id/certifications': typeof clientMyComponentspagesdetailKindIdCertificationsRoute
  '/my-components/$kind/$id/materials': typeof clientMyComponentspagesdetailKindIdMaterialsRoute
  '/my-components/$kind/$id/overview': typeof clientMyComponentspagesdetailKindIdOverviewRoute
  '/my-components/$kind/$id/qr-code': typeof clientMyComponentspagesdetailKindIdQrCodeRoute
  '/my-components/$kind/$id/skus': typeof clientMyComponentspagesdetailKindIdSkusRoute
  '/my-components/$kind/$id/supply-chain': typeof clientMyComponentspagesdetailKindIdSupplyChainRoute
  '/my-components/$kind/$id/variants': typeof clientMyComponentspagesdetailKindIdVariantsRoute
  '/my-components/$kind/$id/webshop-preview': typeof clientMyComponentspagesdetailKindIdWebshopPreviewRoute
  '/my-styles/$kind/$id/bom': typeof clientMyStylespagesdetailKindIdBomRoute
  '/my-styles/$kind/$id/certifications': typeof clientMyStylespagesdetailKindIdCertificationsRoute
  '/my-styles/$kind/$id/materials': typeof clientMyStylespagesdetailKindIdMaterialsRoute
  '/my-styles/$kind/$id/overview': typeof clientMyStylespagesdetailKindIdOverviewRoute
  '/my-styles/$kind/$id/qr-code': typeof clientMyStylespagesdetailKindIdQrCodeRoute
  '/my-styles/$kind/$id/skus': typeof clientMyStylespagesdetailKindIdSkusRoute
  '/my-styles/$kind/$id/supply-chain': typeof clientMyStylespagesdetailKindIdSupplyChainRoute
  '/my-styles/$kind/$id/variants': typeof clientMyStylespagesdetailKindIdVariantsRoute
  '/my-styles/$kind/$id/webshop-preview': typeof clientMyStylespagesdetailKindIdWebshopPreviewRoute
  '/orders/internal-orders/$ioId/documents': typeof clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute
  '/orders/internal-orders/$ioId/overview': typeof clientOrderspagesdetailInternalOrdersIoIdOverviewRoute
  '/orders/internal-orders/$ioId/products': typeof clientOrderspagesdetailInternalOrdersIoIdProductsRoute
  '/orders/internal-orders/$ioId/tracing': typeof clientOrderspagesdetailInternalOrdersIoIdTracingRoute
  '/orders/purchase-orders/$poId/documents': typeof clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute
  '/orders/purchase-orders/$poId/overview': typeof clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute
  '/orders/purchase-orders/$poId/products': typeof clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute
  '/orders/purchase-orders/$poId/tracing': typeof clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute
  '/orders/sales-orders/$soId/attachments': typeof clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute
  '/orders/sales-orders/$soId/overview': typeof clientOrderspagesdetailSalesOrdersSoIdOverviewRoute
  '/orders/sales-orders/$soId/products': typeof clientOrderspagesdetailSalesOrdersSoIdProductsRoute
  '/orders/sales-orders/$soId/tracing': typeof clientOrderspagesdetailSalesOrdersSoIdTracingRoute
  '/audits/$auditId/capa': typeof clientAuditspagesdetailAuditIdCapaIndexRoute
  '/audits/$auditId/content': typeof clientAuditspagesdetailAuditIdContentIndexRoute
  '/audits/$auditId/findings': typeof clientAuditspagesdetailAuditIdFindingsIndexRoute
  '/audits/$auditId/overview': typeof clientAuditspagesdetailAuditIdOverviewIndexRoute
  '/audits/$auditId/score': typeof clientAuditspagesdetailAuditIdScoreIndexRoute
  '/audits/$auditId/view': typeof clientAuditspagesdetailAuditIdViewIndexRoute
  '/audits/audits-for-company/active': typeof clientAuditspageslistAuditsForCompanyActiveIndexRoute
  '/audits/audits-for-company/archive': typeof clientAuditspageslistAuditsForCompanyArchiveIndexRoute
  '/audits/network-audits/active': typeof clientAuditspageslistNetworkAuditsActiveIndexRoute
  '/audits/network-audits/archive': typeof clientAuditspageslistNetworkAuditsArchiveIndexRoute
  '/capa/actions/$id': typeof clientCapapagesdetailActionsIdIndexRoute
  '/capa/plans/$id': typeof clientCapapagesdetailPlansIdIndexRoute
  '/capa/actions/active': typeof clientCapapageslistActionsActiveIndexRoute
  '/capa/actions/archived': typeof clientCapapageslistActionsArchivedIndexRoute
  '/capa/findings/active': typeof clientCapapageslistFindingsActiveIndexRoute
  '/capa/findings/archived': typeof clientCapapageslistFindingsArchivedIndexRoute
  '/capa/plans/active': typeof clientCapapageslistPlansActiveIndexRoute
  '/capa/plans/archived': typeof clientCapapageslistPlansArchivedIndexRoute
  '/company-settings/integrations/history/$syncHistoryId': typeof clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute
  '/my-components/component-skus/active': typeof clientMyComponentspageslistComponentSkusActiveIndexRoute
  '/my-components/component-skus/archived': typeof clientMyComponentspageslistComponentSkusArchivedIndexRoute
  '/my-components/component-variants/active': typeof clientMyComponentspageslistComponentVariantsActiveIndexRoute
  '/my-components/component-variants/archived': typeof clientMyComponentspageslistComponentVariantsArchivedIndexRoute
  '/my-components/components/active': typeof clientMyComponentspageslistComponentsActiveIndexRoute
  '/my-components/components/archived': typeof clientMyComponentspageslistComponentsArchivedIndexRoute
  '/my-styles/skus/active': typeof clientMyStylespageslistSkusActiveIndexRoute
  '/my-styles/skus/archived': typeof clientMyStylespageslistSkusArchivedIndexRoute
  '/my-styles/styles/active': typeof clientMyStylespageslistStylesActiveIndexRoute
  '/my-styles/styles/archived': typeof clientMyStylespageslistStylesArchivedIndexRoute
  '/my-styles/variants/active': typeof clientMyStylespageslistVariantsActiveIndexRoute
  '/my-styles/variants/archived': typeof clientMyStylespageslistVariantsArchivedIndexRoute
  '/network/$companyId/audits': typeof clientNetworkpagesdetailCompanyIdAuditsIndexRoute
  '/network/$companyId/integrations': typeof clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute
  '/orders/purchase-orders/create': typeof clientOrderspagescreatePurchaseOrdersCreateIndexRoute
  '/orders/sales-orders/create': typeof clientOrderspagescreateSalesOrdersCreateIndexRoute
  '/orders/internal-orders/active': typeof clientOrderspageslistInternalOrdersActiveIndexRoute
  '/orders/internal-orders/archive': typeof clientOrderspageslistInternalOrdersArchiveIndexRoute
  '/orders/purchase-orders/active': typeof clientOrderspageslistPurchaseOrdersActiveIndexRoute
  '/orders/purchase-orders/archive': typeof clientOrderspageslistPurchaseOrdersArchiveIndexRoute
  '/orders/sales-orders/active': typeof clientOrderspageslistSalesOrdersActiveIndexRoute
  '/orders/sales-orders/archive': typeof clientOrderspageslistSalesOrdersArchiveIndexRoute
  '/orders/attachment-templates/$id/edit': typeof clientOrderspagesAttachmentTemplatesIdEditIndexRoute
  '/questionnaires/$id/edit': typeof clientQuestionnairespagesdetailIdEditIndexRoute
  '/questionnaires/$id/review': typeof clientQuestionnairespagesdetailIdReviewIndexRoute
  '/questionnaires/$id/summary': typeof clientQuestionnairespagesdetailIdSummaryIndexRoute
  '/questionnaires/$id/answer': typeof clientQuestionnairespagesdetailIdAnswerIndexRoute
  '/questionnaires/$id/preview': typeof clientQuestionnairespagesdetailIdPreviewIndexRoute
  '/questionnaires/my-questionnaires/active': typeof clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute
  '/questionnaires/my-questionnaires/archived': typeof clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute
  '/risk/assessments/$id': typeof clientRiskpagesdetailAssessmentsIdIndexRoute
  '/risk/rules/$id': typeof clientRiskpagesdetailRulesIdIndexRoute
  '/slcp/my-own/active': typeof clientSlcppageslistMyOwnActiveIndexRoute
  '/slcp/my-own/archive': typeof clientSlcppageslistMyOwnArchiveIndexRoute
  '/slcp/assessments/$assessmentId': typeof clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute
  '/supply-chain-mapping/insights/collaborator-companies': typeof clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute
  '/supply-chain-mapping/insights/global-diagram': typeof clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute
  '/supply-chain-mapping/insights/mapped-companies': typeof clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute
  '/supply-chain-mapping/insights/overview': typeof clientSupplyChainMappingpageslistInsightsOverviewIndexRoute
  '/supply-chain-mapping/supply-chains/active': typeof clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute
  '/supply-chain-mapping/supply-chains/archive': typeof clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute
  '/management/risk-management/rule-templates/$id/edit': typeof ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute
  '/report/audit-compliance/drilldown/$chartType': typeof clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute
  '/report/certificate-compliance/drilldown/$chartType': typeof clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute
  '/risk/rules/$id/edit': typeof clientRiskpageseditRulesIdEditIndexRoute
  '/slcp/assessments/$assessmentId/assessment': typeof clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute
  '/slcp/assessments/$assessmentId/overview': typeof clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute
  '/supply-chain-mapping/supply-chains/$id/compare': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute
  '/supply-chain-mapping/supply-chains/$id/diagram': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute
  '/supply-chain-mapping/supply-chains/$id/map': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute
  '/my-components/$kind/$id/documents/linked': typeof clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute
  '/my-components/$kind/$id/documents/product-only': typeof clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/my-styles/$kind/$id/documents/linked': typeof clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute
  '/my-styles/$kind/$id/documents/product-only': typeof clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/network/$companyId/audits/$auditId/findings': typeof clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute
  '/network/$companyId/integrations/history/$syncHistoryId': typeof clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute
  '/risk/assessments/$id/assessed/$assessmentId': typeof clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/(client)': typeof clientRouteRouteWithChildren
  '/management': typeof ManagementRouteRouteWithChildren
  '/(client)/audits': typeof clientAuditsRouteRouteWithChildren
  '/(client)/entity-screening': typeof clientEntityScreeningRouteRouteWithChildren
  '/(client)/files': typeof clientFilesRouteRouteWithChildren
  '/(client)/my-components': typeof clientMyComponentsRouteRouteWithChildren
  '/(client)/my-styles': typeof clientMyStylesRouteRouteWithChildren
  '/(client)/orders': typeof clientOrdersRouteRouteWithChildren
  '/(client)/product-mapping': typeof clientProductMappingRouteRouteWithChildren
  '/(client)/risk': typeof clientRiskRouteRouteWithChildren
  '/(client)/supply-chain-mapping': typeof clientSupplyChainMappingRouteRouteWithChildren
  '/docs/': typeof DocsIndexRoute
  '/(client)/capa/(pages)': typeof clientCapapagesRouteRouteWithChildren
  '/(client)/certifications/(pages)': typeof clientCertificationspagesRouteRouteWithChildren
  '/(client)/certified-materials/(pages)': typeof clientCertifiedMaterialspagesRouteRouteWithChildren
  '/(client)/company-settings/(pages)': typeof clientCompanySettingspagesRouteRouteWithChildren
  '/(client)/documents/(pages)': typeof clientDocumentspagesRouteRouteWithChildren
  '/(client)/my-components/(pages)': typeof clientMyComponentspagesRouteRouteWithChildren
  '/(client)/my-styles/(pages)': typeof clientMyStylespagesRouteRouteWithChildren
  '/(client)/network/(pages)': typeof clientNetworkpagesRouteRouteWithChildren
  '/(client)/profile/(pages)': typeof clientProfilepagesRouteRouteWithChildren
  '/(client)/questionnaires/(pages)': typeof clientQuestionnairespagesRouteRouteWithChildren
  '/(client)/report/(pages)': typeof clientReportpagesRouteRouteWithChildren
  '/(client)/slcp/(pages)': typeof clientSlcppagesRouteRouteWithChildren
  '/management/risk-management/(pages)': typeof ManagementRiskManagementpagesRouteRouteWithChildren
  '/(login)/(pages)/': typeof loginpagesIndexRoute
  '/(login)/single-sign-on-callback/': typeof loginSingleSignOnCallbackIndexRoute
  '/unsubscribe/(pages)/': typeof UnsubscribepagesIndexRoute
  '/(client)/audits/(pages)/(list)': typeof clientAuditspageslistRouteRouteWithChildren
  '/(client)/capa/(pages)/(detail)': typeof clientCapapagesdetailRouteRouteWithChildren
  '/(client)/capa/(pages)/(list)': typeof clientCapapageslistRouteRouteWithChildren
  '/(client)/company-settings/(pages)/constants-mapping': typeof clientCompanySettingspagesConstantsMappingRouteRouteWithChildren
  '/(client)/company-settings/(pages)/integrations': typeof clientCompanySettingspagesIntegrationsRouteRouteWithChildren
  '/(client)/documents/(pages)/(list)': typeof clientDocumentspageslistRouteRouteWithChildren
  '/(client)/my-components/(pages)/(detail)': typeof clientMyComponentspagesdetailRouteRouteWithChildren
  '/(client)/my-components/(pages)/(list)': typeof clientMyComponentspageslistRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(detail)': typeof clientMyStylespagesdetailRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(list)': typeof clientMyStylespageslistRouteRouteWithChildren
  '/(client)/network/(pages)/(detail)': typeof clientNetworkpagesdetailRouteRouteWithChildren
  '/(client)/network/(pages)/(list)': typeof clientNetworkpageslistRouteRouteWithChildren
  '/(client)/orders/(pages)/(list)': typeof clientOrderspageslistRouteRouteWithChildren
  '/(client)/product-mapping/(pages)/(list)': typeof clientProductMappingpageslistRouteRouteWithChildren
  '/(client)/questionnaires/(pages)/(list)': typeof clientQuestionnairespageslistRouteRouteWithChildren
  '/(client)/risk/(pages)/(detail)': typeof clientRiskpagesdetailRouteRouteWithChildren
  '/(client)/risk/(pages)/(edit)': typeof clientRiskpageseditRouteRouteWithChildren
  '/(client)/risk/(pages)/(list)': typeof clientRiskpageslistRouteRouteWithChildren
  '/(client)/slcp/(pages)/(list)': typeof clientSlcppageslistRouteRouteWithChildren
  '/(client)/supply-chain-mapping/(pages)/(list)': typeof clientSupplyChainMappingpageslistRouteRouteWithChildren
  '/management/certifications/(pages)/(list)': typeof ManagementCertificationspageslistRouteRouteWithChildren
  '/management/companies/(pages)/$companyId': typeof ManagementCompaniespagesCompanyIdRouteRouteWithChildren
  '/management/documents/(pages)/(list)': typeof ManagementDocumentspageslistRouteRouteWithChildren
  '/management/risk-management/(pages)/(list)': typeof ManagementRiskManagementpageslistRouteRouteWithChildren
  '/management/scoring-templates/(pages)/(list)': typeof ManagementScoringTemplatespageslistRouteRouteWithChildren
  '/(client)/company-settings/(pages)/api-keys': typeof clientCompanySettingspagesApiKeysRoute
  '/(client)/company-settings/(pages)/join-requests': typeof clientCompanySettingspagesJoinRequestsRoute
  '/(client)/company-settings/(pages)/users': typeof clientCompanySettingspagesUsersRoute
  '/(client)/company-settings/(pages)/webshop-settings': typeof clientCompanySettingspagesWebshopSettingsRoute
  '/(client)/orders-hub/(pages)/create': typeof clientOrdersHubpagesCreateRoute
  '/(client)/activity-feed/(pages)/': typeof clientActivityFeedpagesIndexRoute
  '/(client)/automation-rules/(pages)/': typeof clientAutomationRulespagesIndexRoute
  '/(client)/certifications/(pages)/': typeof clientCertificationspagesIndexRoute
  '/(client)/certified-materials/(pages)/': typeof clientCertifiedMaterialspagesIndexRoute
  '/(client)/dashboard/(pages)/': typeof clientDashboardpagesIndexRoute
  '/(client)/entity-screening/(pages)/': typeof clientEntityScreeningpagesIndexRoute
  '/(client)/orders-hub/(pages)/': typeof clientOrdersHubpagesIndexRoute
  '/docs/components/$slug/': typeof DocsComponentsSlugIndexRoute
  '/docs/foundations/$slug/': typeof DocsFoundationsSlugIndexRoute
  '/docs/guides/$slug/': typeof DocsGuidesSlugIndexRoute
  '/docs/patterns/$slug/': typeof DocsPatternsSlugIndexRoute
  '/management/attachment-templates/(pages)/': typeof ManagementAttachmentTemplatespagesIndexRoute
  '/management/audit-types/(pages)/': typeof ManagementAuditTypespagesIndexRoute
  '/management/audits/(pages)/': typeof ManagementAuditspagesIndexRoute
  '/management/background-jobs/(pages)/': typeof ManagementBackgroundJobspagesIndexRoute
  '/management/badges/(pages)/': typeof ManagementBadgespagesIndexRoute
  '/management/companies/(pages)/': typeof ManagementCompaniespagesIndexRoute
  '/management/company-merges/(pages)/': typeof ManagementCompanyMergespagesIndexRoute
  '/management/cs-tools/(pages)/': typeof ManagementCsToolspagesIndexRoute
  '/management/custom-information-fields/(pages)/': typeof ManagementCustomInformationFieldspagesIndexRoute
  '/management/document-types/(pages)/': typeof ManagementDocumentTypespagesIndexRoute
  '/management/email-bounce-tracking/(pages)/': typeof ManagementEmailBounceTrackingpagesIndexRoute
  '/management/entity-history/(pages)/': typeof ManagementEntityHistorypagesIndexRoute
  '/management/facility-processes/(pages)/': typeof ManagementFacilityProcessespagesIndexRoute
  '/management/impersonate/(pages)/': typeof ManagementImpersonatepagesIndexRoute
  '/management/materials/(pages)/': typeof ManagementMaterialspagesIndexRoute
  '/management/origins/(pages)/': typeof ManagementOriginspagesIndexRoute
  '/management/permissions/(pages)/': typeof ManagementPermissionspagesIndexRoute
  '/management/platform-features/(pages)/': typeof ManagementPlatformFeaturespagesIndexRoute
  '/management/product-categories/(pages)/': typeof ManagementProductCategoriespagesIndexRoute
  '/management/product-data-points/(pages)/': typeof ManagementProductDataPointspagesIndexRoute
  '/management/production-processes/(pages)/': typeof ManagementProductionProcessespagesIndexRoute
  '/management/rules/(pages)/': typeof ManagementRulespagesIndexRoute
  '/management/slcp-dashboard/(pages)/': typeof ManagementSlcpDashboardpagesIndexRoute
  '/management/sso/(pages)/': typeof ManagementSsopagesIndexRoute
  '/management/standards/(pages)/': typeof ManagementStandardspagesIndexRoute
  '/management/supplier-questionnaire-templates/(pages)/': typeof ManagementSupplierQuestionnaireTemplatespagesIndexRoute
  '/management/translations/(pages)/': typeof ManagementTranslationspagesIndexRoute
  '/management/users/(pages)/': typeof ManagementUserspagesIndexRoute
  '/management/webshops/(pages)/': typeof ManagementWebshopspagesIndexRoute
  '/onboarding/company-search/(pages)/': typeof OnboardingCompanySearchpagesIndexRoute
  '/sso-onboarding/(pages)/$token/': typeof SsoOnboardingpagesTokenIndexRoute
  '/sso-onboarding/(pages)/test-result/': typeof SsoOnboardingpagesTestResultIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId': typeof clientAuditspagesdetailAuditIdRouteRouteWithChildren
  '/(client)/audits/(pages)/(list)/audits-for-company': typeof clientAuditspageslistAuditsForCompanyRouteRouteWithChildren
  '/(client)/audits/(pages)/(list)/network-audits': typeof clientAuditspageslistNetworkAuditsRouteRouteWithChildren
  '/(client)/capa/(pages)/(list)/actions': typeof clientCapapageslistActionsRouteRouteWithChildren
  '/(client)/capa/(pages)/(list)/findings': typeof clientCapapageslistFindingsRouteRouteWithChildren
  '/(client)/capa/(pages)/(list)/plans': typeof clientCapapageslistPlansRouteRouteWithChildren
  '/(client)/my-components/(pages)/(list)/component-skus': typeof clientMyComponentspageslistComponentSkusRouteRouteWithChildren
  '/(client)/my-components/(pages)/(list)/component-variants': typeof clientMyComponentspageslistComponentVariantsRouteRouteWithChildren
  '/(client)/my-components/(pages)/(list)/components': typeof clientMyComponentspageslistComponentsRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(list)/skus': typeof clientMyStylespageslistSkusRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(list)/styles': typeof clientMyStylespageslistStylesRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(list)/variants': typeof clientMyStylespageslistVariantsRouteRouteWithChildren
  '/(client)/network/(pages)/(detail)/$companyId': typeof clientNetworkpagesdetailCompanyIdRouteRouteWithChildren
  '/(client)/orders-hub/(pages)/(detail)/$id': typeof clientOrdersHubpagesdetailIdRouteRouteWithChildren
  '/(client)/orders/(pages)/(list)/internal-orders': typeof clientOrderspageslistInternalOrdersRouteRouteWithChildren
  '/(client)/orders/(pages)/(list)/purchase-orders': typeof clientOrderspageslistPurchaseOrdersRouteRouteWithChildren
  '/(client)/orders/(pages)/(list)/sales-orders': typeof clientOrderspageslistSalesOrdersRouteRouteWithChildren
  '/(client)/questionnaires/(pages)/(detail)/$id': typeof clientQuestionnairespagesdetailIdRouteRouteWithChildren
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires': typeof clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren
  '/(client)/risk/(pages)/(detail)/assessments': typeof clientRiskpagesdetailAssessmentsRouteRouteWithChildren
  '/(client)/slcp/(pages)/(list)/my-own': typeof clientSlcppageslistMyOwnRouteRouteWithChildren
  '/(client)/supply-chain-mapping/(pages)/(list)/insights': typeof clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains': typeof clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren
  '/(client)/company-settings/(pages)/permission-sets/new': typeof clientCompanySettingspagesPermissionSetsNewRoute
  '/(client)/certifications/(pages)/$id/': typeof clientCertificationspagesIdIndexRoute
  '/(client)/company-settings/(pages)/integrations/': typeof clientCompanySettingspagesIntegrationsIndexRoute
  '/(client)/company-settings/(pages)/permission-sets/': typeof clientCompanySettingspagesPermissionSetsIndexRoute
  '/(client)/files/(pages)/(list)/': typeof clientFilespageslistIndexRoute
  '/(client)/orders/(pages)/attachment-templates/': typeof clientOrderspagesAttachmentTemplatesIndexRoute
  '/(client)/profile/(pages)/overview/': typeof clientProfilepagesOverviewIndexRoute
  '/(client)/profile/(pages)/settings/': typeof clientProfilepagesSettingsIndexRoute
  '/(client)/users/(pages)/$id/': typeof clientUserspagesIdIndexRoute
  '/management/attachment-templates/(pages)/$id/': typeof ManagementAttachmentTemplatespagesIdIndexRoute
  '/management/attachment-templates/(pages)/create/': typeof ManagementAttachmentTemplatespagesCreateIndexRoute
  '/management/certifications/(pages)/$id/': typeof ManagementCertificationspagesIdIndexRoute
  '/management/companies/(pages)/$companyId/': typeof ManagementCompaniespagesCompanyIdIndexRoute
  '/management/company-merges/(pages)/$mergeId/': typeof ManagementCompanyMergespagesMergeIdIndexRoute
  '/management/company-merges/(pages)/new/': typeof ManagementCompanyMergespagesNewIndexRoute
  '/management/entity-history/(pages)/$id/': typeof ManagementEntityHistorypagesIdIndexRoute
  '/management/platform-features/(pages)/$featureId/': typeof ManagementPlatformFeaturespagesFeatureIdIndexRoute
  '/management/scoring-templates/(pages)/(list)/': typeof ManagementScoringTemplatespageslistIndexRoute
  '/management/sso/(pages)/$id/': typeof ManagementSsopagesIdIndexRoute
  '/management/users/(pages)/$id/': typeof ManagementUserspagesIdIndexRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id': typeof clientMyComponentspagesdetailKindIdRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(detail)/$kind/$id': typeof clientMyStylespagesdetailKindIdRouteRouteWithChildren
  '/(client)/network/(pages)/(detail)/$companyId/integrations': typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteWithChildren
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId': typeof clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId': typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId': typeof clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId': typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteWithChildren
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren
  '/(client)/company-settings/(pages)/permission-sets/$setKey/edit': typeof clientCompanySettingspagesPermissionSetsSetKeyEditRoute
  '/(client)/network/(pages)/(detail)/$companyId/badges': typeof clientNetworkpagesdetailCompanyIdBadgesRoute
  '/(client)/network/(pages)/(detail)/$companyId/capa': typeof clientNetworkpagesdetailCompanyIdCapaRoute
  '/(client)/network/(pages)/(detail)/$companyId/claims': typeof clientNetworkpagesdetailCompanyIdClaimsRoute
  '/(client)/network/(pages)/(detail)/$companyId/custom-information': typeof clientNetworkpagesdetailCompanyIdCustomInformationRoute
  '/(client)/network/(pages)/(detail)/$companyId/custom-information-fields': typeof clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute
  '/(client)/network/(pages)/(detail)/$companyId/documents': typeof clientNetworkpagesdetailCompanyIdDocumentsRoute
  '/(client)/network/(pages)/(detail)/$companyId/esg-info': typeof clientNetworkpagesdetailCompanyIdEsgInfoRoute
  '/(client)/network/(pages)/(detail)/$companyId/general-info': typeof clientNetworkpagesdetailCompanyIdGeneralInfoRoute
  '/(client)/network/(pages)/(detail)/$companyId/history': typeof clientNetworkpagesdetailCompanyIdHistoryRoute
  '/(client)/network/(pages)/(detail)/$companyId/products': typeof clientNetworkpagesdetailCompanyIdProductsRoute
  '/(client)/network/(pages)/(detail)/$companyId/questionnaire': typeof clientNetworkpagesdetailCompanyIdQuestionnaireRoute
  '/(client)/network/(pages)/(detail)/$companyId/risk-profile': typeof clientNetworkpagesdetailCompanyIdRiskProfileRoute
  '/(client)/network/(pages)/(detail)/$companyId/slcp': typeof clientNetworkpagesdetailCompanyIdSlcpRoute
  '/(client)/network/(pages)/(detail)/$companyId/users': typeof clientNetworkpagesdetailCompanyIdUsersRoute
  '/(client)/network/(pages)/(detail)/$companyId/webshop-profile': typeof clientNetworkpagesdetailCompanyIdWebshopProfileRoute
  '/(client)/orders-hub/(pages)/(detail)/$id/attachments': typeof clientOrdersHubpagesdetailIdAttachmentsRoute
  '/(client)/orders-hub/(pages)/(detail)/$id/lines': typeof clientOrdersHubpagesdetailIdLinesRoute
  '/(client)/orders-hub/(pages)/(detail)/$id/overview': typeof clientOrdersHubpagesdetailIdOverviewRoute
  '/(client)/audits/(pages)/(detail)/$auditId/': typeof clientAuditspagesdetailAuditIdIndexRoute
  '/(client)/company-settings/(pages)/constants-mapping/facility-processes/': typeof clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute
  '/(client)/company-settings/(pages)/constants-mapping/materials/': typeof clientCompanySettingspagesConstantsMappingMaterialsIndexRoute
  '/(client)/company-settings/(pages)/constants-mapping/product-types/': typeof clientCompanySettingspagesConstantsMappingProductTypesIndexRoute
  '/(client)/company-settings/(pages)/permission-sets/$setKey/': typeof clientCompanySettingspagesPermissionSetsSetKeyIndexRoute
  '/(client)/documents/(pages)/(list)/archived/': typeof clientDocumentspageslistArchivedIndexRoute
  '/(client)/documents/(pages)/(list)/my-documents/': typeof clientDocumentspageslistMyDocumentsIndexRoute
  '/(client)/documents/(pages)/(list)/request-access/': typeof clientDocumentspageslistRequestAccessIndexRoute
  '/(client)/entity-screening/(pages)/involved-orders/$companyId/': typeof clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute
  '/(client)/my-styles/(pages)/(list)/styles-created-for-me/': typeof clientMyStylespageslistStylesCreatedForMeIndexRoute
  '/(client)/network/(pages)/(list)/my-network/': typeof clientNetworkpageslistMyNetworkIndexRoute
  '/(client)/orders/(pages)/attachment-templates/$id/': typeof clientOrderspagesAttachmentTemplatesIdIndexRoute
  '/(client)/orders/(pages)/attachment-templates/create/': typeof clientOrderspagesAttachmentTemplatesCreateIndexRoute
  '/(client)/product-mapping/(pages)/(details)/$cpmId/': typeof clientProductMappingpagesdetailsCpmIdIndexRoute
  '/(client)/product-mapping/(pages)/(list)/active/': typeof clientProductMappingpageslistActiveIndexRoute
  '/(client)/product-mapping/(pages)/(list)/archive/': typeof clientProductMappingpageslistArchiveIndexRoute
  '/(client)/questionnaires/(pages)/(list)/requests/': typeof clientQuestionnairespageslistRequestsIndexRoute
  '/(client)/questionnaires/(pages)/(list)/templates/': typeof clientQuestionnairespageslistTemplatesIndexRoute
  '/(client)/report/(pages)/(analytics)/audit-compliance/': typeof clientReportpagesanalyticsAuditComplianceIndexRoute
  '/(client)/report/(pages)/(analytics)/certificate-compliance/': typeof clientReportpagesanalyticsCertificateComplianceIndexRoute
  '/(client)/report/(pages)/(analytics)/tracing-compliance/': typeof clientReportpagesanalyticsTracingComplianceIndexRoute
  '/(client)/report/(pages)/(analytics)/tracing-operations/': typeof clientReportpagesanalyticsTracingOperationsIndexRoute
  '/(client)/risk/(pages)/(list)/assessments/': typeof clientRiskpageslistAssessmentsIndexRoute
  '/(client)/risk/(pages)/(list)/landscape/': typeof clientRiskpageslistLandscapeIndexRoute
  '/(client)/risk/(pages)/(list)/rules/': typeof clientRiskpageslistRulesIndexRoute
  '/(client)/slcp/(pages)/(list)/network/': typeof clientSlcppageslistNetworkIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/history/': typeof clientSupplyChainMappingpageslistHistoryIndexRoute
  '/management/attachment-templates/(pages)/$id/edit/': typeof ManagementAttachmentTemplatespagesIdEditIndexRoute
  '/management/certifications/(pages)/(list)/active/': typeof ManagementCertificationspageslistActiveIndexRoute
  '/management/certifications/(pages)/(list)/archived/': typeof ManagementCertificationspageslistArchivedIndexRoute
  '/management/companies/(pages)/$companyId/api-keys/': typeof ManagementCompaniespagesCompanyIdApiKeysIndexRoute
  '/management/companies/(pages)/$companyId/automation-rules/': typeof ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute
  '/management/companies/(pages)/$companyId/credits/': typeof ManagementCompaniespagesCompanyIdCreditsIndexRoute
  '/management/companies/(pages)/$companyId/employees/': typeof ManagementCompaniespagesCompanyIdEmployeesIndexRoute
  '/management/companies/(pages)/$companyId/general-info/': typeof ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute
  '/management/companies/(pages)/$companyId/network/': typeof ManagementCompaniespagesCompanyIdNetworkIndexRoute
  '/management/companies/(pages)/$companyId/platform-features/': typeof ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute
  '/management/companies/(pages)/$companyId/supply-chains/': typeof ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute
  '/management/companies/(pages)/$companyId/tech-insights/': typeof ManagementCompaniespagesCompanyIdTechInsightsIndexRoute
  '/management/companies/(pages)/$companyId/tracing-orders/': typeof ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute
  '/management/documents/(pages)/(list)/active/': typeof ManagementDocumentspageslistActiveIndexRoute
  '/management/documents/(pages)/(list)/archived/': typeof ManagementDocumentspageslistArchivedIndexRoute
  '/management/product-categories/(pages)/$categoryId/fields/': typeof ManagementProductCategoriespagesCategoryIdFieldsIndexRoute
  '/management/risk-management/(pages)/(list)/risk-gross/': typeof ManagementRiskManagementpageslistRiskGrossIndexRoute
  '/management/risk-management/(pages)/(list)/risks/': typeof ManagementRiskManagementpageslistRisksIndexRoute
  '/management/risk-management/(pages)/(list)/rule-templates/': typeof ManagementRiskManagementpageslistRuleTemplatesIndexRoute
  '/management/scoring-templates/(pages)/$id/edit/': typeof ManagementScoringTemplatespagesIdEditIndexRoute
  '/management/scoring-templates/(pages)/(list)/gaps/': typeof ManagementScoringTemplatespageslistGapsIndexRoute
  '/management/supplier-questionnaire-templates/(pages)/$id/edit/': typeof ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute
  '/management/supplier-questionnaire-templates/(pages)/$id/preview/': typeof ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/documents': typeof clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents': typeof clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren
  '/(client)/my-components/(pages)/(detail)/$kind/$id/bom': typeof clientMyComponentspagesdetailKindIdBomRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/certifications': typeof clientMyComponentspagesdetailKindIdCertificationsRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/materials': typeof clientMyComponentspagesdetailKindIdMaterialsRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/overview': typeof clientMyComponentspagesdetailKindIdOverviewRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code': typeof clientMyComponentspagesdetailKindIdQrCodeRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/skus': typeof clientMyComponentspagesdetailKindIdSkusRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain': typeof clientMyComponentspagesdetailKindIdSupplyChainRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/variants': typeof clientMyComponentspagesdetailKindIdVariantsRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/webshop-preview': typeof clientMyComponentspagesdetailKindIdWebshopPreviewRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/bom': typeof clientMyStylespagesdetailKindIdBomRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications': typeof clientMyStylespagesdetailKindIdCertificationsRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/materials': typeof clientMyStylespagesdetailKindIdMaterialsRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/overview': typeof clientMyStylespagesdetailKindIdOverviewRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code': typeof clientMyStylespagesdetailKindIdQrCodeRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/skus': typeof clientMyStylespagesdetailKindIdSkusRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain': typeof clientMyStylespagesdetailKindIdSupplyChainRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/variants': typeof clientMyStylespagesdetailKindIdVariantsRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview': typeof clientMyStylespagesdetailKindIdWebshopPreviewRoute
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents': typeof clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview': typeof clientOrderspagesdetailInternalOrdersIoIdOverviewRoute
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products': typeof clientOrderspagesdetailInternalOrdersIoIdProductsRoute
  '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/tracing': typeof clientOrderspagesdetailInternalOrdersIoIdTracingRoute
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents': typeof clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview': typeof clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products': typeof clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute
  '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/tracing': typeof clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments': typeof clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/overview': typeof clientOrderspagesdetailSalesOrdersSoIdOverviewRoute
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/products': typeof clientOrderspagesdetailSalesOrdersSoIdProductsRoute
  '/(client)/orders/(pages)/(detail)/sales-orders/$soId/tracing': typeof clientOrderspagesdetailSalesOrdersSoIdTracingRoute
  '/(client)/audits/(pages)/(detail)/$auditId/capa/': typeof clientAuditspagesdetailAuditIdCapaIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId/content/': typeof clientAuditspagesdetailAuditIdContentIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId/findings/': typeof clientAuditspagesdetailAuditIdFindingsIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId/overview/': typeof clientAuditspagesdetailAuditIdOverviewIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId/score/': typeof clientAuditspagesdetailAuditIdScoreIndexRoute
  '/(client)/audits/(pages)/(detail)/$auditId/view/': typeof clientAuditspagesdetailAuditIdViewIndexRoute
  '/(client)/audits/(pages)/(list)/audits-for-company/active/': typeof clientAuditspageslistAuditsForCompanyActiveIndexRoute
  '/(client)/audits/(pages)/(list)/audits-for-company/archive/': typeof clientAuditspageslistAuditsForCompanyArchiveIndexRoute
  '/(client)/audits/(pages)/(list)/network-audits/active/': typeof clientAuditspageslistNetworkAuditsActiveIndexRoute
  '/(client)/audits/(pages)/(list)/network-audits/archive/': typeof clientAuditspageslistNetworkAuditsArchiveIndexRoute
  '/(client)/capa/(pages)/(detail)/actions/$id/': typeof clientCapapagesdetailActionsIdIndexRoute
  '/(client)/capa/(pages)/(detail)/plans/$id/': typeof clientCapapagesdetailPlansIdIndexRoute
  '/(client)/capa/(pages)/(list)/actions/active/': typeof clientCapapageslistActionsActiveIndexRoute
  '/(client)/capa/(pages)/(list)/actions/archived/': typeof clientCapapageslistActionsArchivedIndexRoute
  '/(client)/capa/(pages)/(list)/findings/active/': typeof clientCapapageslistFindingsActiveIndexRoute
  '/(client)/capa/(pages)/(list)/findings/archived/': typeof clientCapapageslistFindingsArchivedIndexRoute
  '/(client)/capa/(pages)/(list)/plans/active/': typeof clientCapapageslistPlansActiveIndexRoute
  '/(client)/capa/(pages)/(list)/plans/archived/': typeof clientCapapageslistPlansArchivedIndexRoute
  '/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/': typeof clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute
  '/(client)/my-components/(pages)/(list)/component-skus/active/': typeof clientMyComponentspageslistComponentSkusActiveIndexRoute
  '/(client)/my-components/(pages)/(list)/component-skus/archived/': typeof clientMyComponentspageslistComponentSkusArchivedIndexRoute
  '/(client)/my-components/(pages)/(list)/component-variants/active/': typeof clientMyComponentspageslistComponentVariantsActiveIndexRoute
  '/(client)/my-components/(pages)/(list)/component-variants/archived/': typeof clientMyComponentspageslistComponentVariantsArchivedIndexRoute
  '/(client)/my-components/(pages)/(list)/components/active/': typeof clientMyComponentspageslistComponentsActiveIndexRoute
  '/(client)/my-components/(pages)/(list)/components/archived/': typeof clientMyComponentspageslistComponentsArchivedIndexRoute
  '/(client)/my-styles/(pages)/(list)/skus/active/': typeof clientMyStylespageslistSkusActiveIndexRoute
  '/(client)/my-styles/(pages)/(list)/skus/archived/': typeof clientMyStylespageslistSkusArchivedIndexRoute
  '/(client)/my-styles/(pages)/(list)/styles/active/': typeof clientMyStylespageslistStylesActiveIndexRoute
  '/(client)/my-styles/(pages)/(list)/styles/archived/': typeof clientMyStylespageslistStylesArchivedIndexRoute
  '/(client)/my-styles/(pages)/(list)/variants/active/': typeof clientMyStylespageslistVariantsActiveIndexRoute
  '/(client)/my-styles/(pages)/(list)/variants/archived/': typeof clientMyStylespageslistVariantsArchivedIndexRoute
  '/(client)/network/(pages)/(detail)/$companyId/audits/': typeof clientNetworkpagesdetailCompanyIdAuditsIndexRoute
  '/(client)/network/(pages)/(detail)/$companyId/integrations/': typeof clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute
  '/(client)/orders/(pages)/(create)/purchase-orders/create/': typeof clientOrderspagescreatePurchaseOrdersCreateIndexRoute
  '/(client)/orders/(pages)/(create)/sales-orders/create/': typeof clientOrderspagescreateSalesOrdersCreateIndexRoute
  '/(client)/orders/(pages)/(list)/internal-orders/active/': typeof clientOrderspageslistInternalOrdersActiveIndexRoute
  '/(client)/orders/(pages)/(list)/internal-orders/archive/': typeof clientOrderspageslistInternalOrdersArchiveIndexRoute
  '/(client)/orders/(pages)/(list)/purchase-orders/active/': typeof clientOrderspageslistPurchaseOrdersActiveIndexRoute
  '/(client)/orders/(pages)/(list)/purchase-orders/archive/': typeof clientOrderspageslistPurchaseOrdersArchiveIndexRoute
  '/(client)/orders/(pages)/(list)/sales-orders/active/': typeof clientOrderspageslistSalesOrdersActiveIndexRoute
  '/(client)/orders/(pages)/(list)/sales-orders/archive/': typeof clientOrderspageslistSalesOrdersArchiveIndexRoute
  '/(client)/orders/(pages)/attachment-templates/$id/edit/': typeof clientOrderspagesAttachmentTemplatesIdEditIndexRoute
  '/(client)/questionnaires/(pages)/(detail)/$id/edit/': typeof clientQuestionnairespagesdetailIdEditIndexRoute
  '/(client)/questionnaires/(pages)/(detail)/$id/review/': typeof clientQuestionnairespagesdetailIdReviewIndexRoute
  '/(client)/questionnaires/(pages)/(detail)/$id/summary/': typeof clientQuestionnairespagesdetailIdSummaryIndexRoute
  '/(client)/questionnaires/(pages)/(detail)/$id_/answer/': typeof clientQuestionnairespagesdetailIdAnswerIndexRoute
  '/(client)/questionnaires/(pages)/(detail)/$id_/preview/': typeof clientQuestionnairespagesdetailIdPreviewIndexRoute
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/': typeof clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute
  '/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/': typeof clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute
  '/(client)/risk/(pages)/(detail)/assessments/$id/': typeof clientRiskpagesdetailAssessmentsIdIndexRoute
  '/(client)/risk/(pages)/(detail)/rules/$id/': typeof clientRiskpagesdetailRulesIdIndexRoute
  '/(client)/slcp/(pages)/(list)/my-own/active/': typeof clientSlcppageslistMyOwnActiveIndexRoute
  '/(client)/slcp/(pages)/(list)/my-own/archive/': typeof clientSlcppageslistMyOwnArchiveIndexRoute
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/collaborator-companies/': typeof clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/': typeof clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/': typeof clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/insights/overview/': typeof clientSupplyChainMappingpageslistInsightsOverviewIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/': typeof clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/': typeof clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute
  '/management/risk-management/(pages)/rule-templates/$id/edit/': typeof ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute
  '/(client)/report/(pages)/(drilldown)/audit-compliance/drilldown/$chartType/': typeof clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute
  '/(client)/report/(pages)/(drilldown)/certificate-compliance/drilldown/$chartType/': typeof clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute
  '/(client)/risk/(pages)/(edit)/rules/$id/edit/': typeof clientRiskpageseditRulesIdEditIndexRoute
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/assessment/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute
  '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/': typeof clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute
  '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/map/': typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/linked/': typeof clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute
  '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/product-only/': typeof clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/': typeof clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute
  '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/': typeof clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute
  '/(client)/network/(pages)/(detail)/$companyId/audits/$auditId/findings/': typeof clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute
  '/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/': typeof clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute
  '/(client)/risk/(pages)/(detail)/assessments/$id/assessed/$assessmentId/': typeof clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/management'
    | '/audits'
    | '/entity-screening'
    | '/files'
    | '/my-components'
    | '/my-styles'
    | '/orders'
    | '/product-mapping'
    | '/risk'
    | '/supply-chain-mapping'
    | '/docs/'
    | '/capa'
    | '/certifications'
    | '/certified-materials'
    | '/company-settings'
    | '/documents'
    | '/network'
    | '/profile'
    | '/questionnaires'
    | '/report'
    | '/slcp'
    | '/management/risk-management'
    | '/'
    | '/single-sign-on-callback/'
    | '/unsubscribe/'
    | '/company-settings/constants-mapping'
    | '/company-settings/integrations'
    | '/management/certifications'
    | '/management/companies/$companyId'
    | '/management/documents'
    | '/management/scoring-templates'
    | '/company-settings/api-keys'
    | '/company-settings/join-requests'
    | '/company-settings/users'
    | '/company-settings/webshop-settings'
    | '/orders-hub/create'
    | '/activity-feed/'
    | '/automation-rules/'
    | '/certifications/'
    | '/certified-materials/'
    | '/dashboard/'
    | '/entity-screening/'
    | '/orders-hub/'
    | '/docs/components/$slug/'
    | '/docs/foundations/$slug/'
    | '/docs/guides/$slug/'
    | '/docs/patterns/$slug/'
    | '/management/attachment-templates/'
    | '/management/audit-types/'
    | '/management/audits/'
    | '/management/background-jobs/'
    | '/management/badges/'
    | '/management/companies/'
    | '/management/company-merges/'
    | '/management/cs-tools/'
    | '/management/custom-information-fields/'
    | '/management/document-types/'
    | '/management/email-bounce-tracking/'
    | '/management/entity-history/'
    | '/management/facility-processes/'
    | '/management/impersonate/'
    | '/management/materials/'
    | '/management/origins/'
    | '/management/permissions/'
    | '/management/platform-features/'
    | '/management/product-categories/'
    | '/management/product-data-points/'
    | '/management/production-processes/'
    | '/management/rules/'
    | '/management/slcp-dashboard/'
    | '/management/sso/'
    | '/management/standards/'
    | '/management/supplier-questionnaire-templates/'
    | '/management/translations/'
    | '/management/users/'
    | '/management/webshops/'
    | '/onboarding/company-search/'
    | '/sso-onboarding/$token/'
    | '/sso-onboarding/test-result/'
    | '/audits/$auditId'
    | '/audits/audits-for-company'
    | '/audits/network-audits'
    | '/capa/actions'
    | '/capa/findings'
    | '/capa/plans'
    | '/my-components/component-skus'
    | '/my-components/component-variants'
    | '/my-components/components'
    | '/my-styles/skus'
    | '/my-styles/styles'
    | '/my-styles/variants'
    | '/network/$companyId'
    | '/orders-hub/$id'
    | '/orders/internal-orders'
    | '/orders/purchase-orders'
    | '/orders/sales-orders'
    | '/questionnaires/$id'
    | '/questionnaires/my-questionnaires'
    | '/risk/assessments'
    | '/slcp/my-own'
    | '/supply-chain-mapping/insights'
    | '/supply-chain-mapping/supply-chains'
    | '/company-settings/permission-sets/new'
    | '/certifications/$id/'
    | '/company-settings/integrations/'
    | '/company-settings/permission-sets/'
    | '/files/'
    | '/orders/attachment-templates/'
    | '/profile/overview/'
    | '/profile/settings/'
    | '/users/$id/'
    | '/management/attachment-templates/$id/'
    | '/management/attachment-templates/create/'
    | '/management/certifications/$id/'
    | '/management/companies/$companyId/'
    | '/management/company-merges/$mergeId/'
    | '/management/company-merges/new/'
    | '/management/entity-history/$id/'
    | '/management/platform-features/$featureId/'
    | '/management/scoring-templates/'
    | '/management/sso/$id/'
    | '/management/users/$id/'
    | '/my-components/$kind/$id'
    | '/my-styles/$kind/$id'
    | '/network/$companyId/integrations'
    | '/orders/internal-orders/$ioId'
    | '/orders/purchase-orders/$poId'
    | '/orders/sales-orders/$soId'
    | '/slcp/assessments/$assessmentId'
    | '/supply-chain-mapping/supply-chains/$id'
    | '/company-settings/permission-sets/$setKey/edit'
    | '/network/$companyId/badges'
    | '/network/$companyId/capa'
    | '/network/$companyId/claims'
    | '/network/$companyId/custom-information'
    | '/network/$companyId/custom-information-fields'
    | '/network/$companyId/documents'
    | '/network/$companyId/esg-info'
    | '/network/$companyId/general-info'
    | '/network/$companyId/history'
    | '/network/$companyId/products'
    | '/network/$companyId/questionnaire'
    | '/network/$companyId/risk-profile'
    | '/network/$companyId/slcp'
    | '/network/$companyId/users'
    | '/network/$companyId/webshop-profile'
    | '/orders-hub/$id/attachments'
    | '/orders-hub/$id/lines'
    | '/orders-hub/$id/overview'
    | '/audits/$auditId/'
    | '/company-settings/constants-mapping/facility-processes/'
    | '/company-settings/constants-mapping/materials/'
    | '/company-settings/constants-mapping/product-types/'
    | '/company-settings/permission-sets/$setKey/'
    | '/documents/archived/'
    | '/documents/my-documents/'
    | '/documents/request-access/'
    | '/entity-screening/involved-orders/$companyId/'
    | '/my-styles/styles-created-for-me/'
    | '/network/my-network/'
    | '/orders/attachment-templates/$id/'
    | '/orders/attachment-templates/create/'
    | '/product-mapping/$cpmId/'
    | '/product-mapping/active/'
    | '/product-mapping/archive/'
    | '/questionnaires/requests/'
    | '/questionnaires/templates/'
    | '/report/audit-compliance/'
    | '/report/certificate-compliance/'
    | '/report/tracing-compliance/'
    | '/report/tracing-operations/'
    | '/risk/assessments/'
    | '/risk/landscape/'
    | '/risk/rules/'
    | '/slcp/network/'
    | '/supply-chain-mapping/history/'
    | '/management/attachment-templates/$id/edit/'
    | '/management/certifications/active/'
    | '/management/certifications/archived/'
    | '/management/companies/$companyId/api-keys/'
    | '/management/companies/$companyId/automation-rules/'
    | '/management/companies/$companyId/credits/'
    | '/management/companies/$companyId/employees/'
    | '/management/companies/$companyId/general-info/'
    | '/management/companies/$companyId/network/'
    | '/management/companies/$companyId/platform-features/'
    | '/management/companies/$companyId/supply-chains/'
    | '/management/companies/$companyId/tech-insights/'
    | '/management/companies/$companyId/tracing-orders/'
    | '/management/documents/active/'
    | '/management/documents/archived/'
    | '/management/product-categories/$categoryId/fields/'
    | '/management/risk-management/risk-gross/'
    | '/management/risk-management/risks/'
    | '/management/risk-management/rule-templates/'
    | '/management/scoring-templates/$id/edit/'
    | '/management/scoring-templates/gaps/'
    | '/management/supplier-questionnaire-templates/$id/edit/'
    | '/management/supplier-questionnaire-templates/$id/preview/'
    | '/my-components/$kind/$id/documents'
    | '/my-styles/$kind/$id/documents'
    | '/my-components/$kind/$id/bom'
    | '/my-components/$kind/$id/certifications'
    | '/my-components/$kind/$id/materials'
    | '/my-components/$kind/$id/overview'
    | '/my-components/$kind/$id/qr-code'
    | '/my-components/$kind/$id/skus'
    | '/my-components/$kind/$id/supply-chain'
    | '/my-components/$kind/$id/variants'
    | '/my-components/$kind/$id/webshop-preview'
    | '/my-styles/$kind/$id/bom'
    | '/my-styles/$kind/$id/certifications'
    | '/my-styles/$kind/$id/materials'
    | '/my-styles/$kind/$id/overview'
    | '/my-styles/$kind/$id/qr-code'
    | '/my-styles/$kind/$id/skus'
    | '/my-styles/$kind/$id/supply-chain'
    | '/my-styles/$kind/$id/variants'
    | '/my-styles/$kind/$id/webshop-preview'
    | '/orders/internal-orders/$ioId/documents'
    | '/orders/internal-orders/$ioId/overview'
    | '/orders/internal-orders/$ioId/products'
    | '/orders/internal-orders/$ioId/tracing'
    | '/orders/purchase-orders/$poId/documents'
    | '/orders/purchase-orders/$poId/overview'
    | '/orders/purchase-orders/$poId/products'
    | '/orders/purchase-orders/$poId/tracing'
    | '/orders/sales-orders/$soId/attachments'
    | '/orders/sales-orders/$soId/overview'
    | '/orders/sales-orders/$soId/products'
    | '/orders/sales-orders/$soId/tracing'
    | '/audits/$auditId/capa/'
    | '/audits/$auditId/content/'
    | '/audits/$auditId/findings/'
    | '/audits/$auditId/overview/'
    | '/audits/$auditId/score/'
    | '/audits/$auditId/view/'
    | '/audits/audits-for-company/active/'
    | '/audits/audits-for-company/archive/'
    | '/audits/network-audits/active/'
    | '/audits/network-audits/archive/'
    | '/capa/actions/$id/'
    | '/capa/plans/$id/'
    | '/capa/actions/active/'
    | '/capa/actions/archived/'
    | '/capa/findings/active/'
    | '/capa/findings/archived/'
    | '/capa/plans/active/'
    | '/capa/plans/archived/'
    | '/company-settings/integrations/history/$syncHistoryId/'
    | '/my-components/component-skus/active/'
    | '/my-components/component-skus/archived/'
    | '/my-components/component-variants/active/'
    | '/my-components/component-variants/archived/'
    | '/my-components/components/active/'
    | '/my-components/components/archived/'
    | '/my-styles/skus/active/'
    | '/my-styles/skus/archived/'
    | '/my-styles/styles/active/'
    | '/my-styles/styles/archived/'
    | '/my-styles/variants/active/'
    | '/my-styles/variants/archived/'
    | '/network/$companyId/audits/'
    | '/network/$companyId/integrations/'
    | '/orders/purchase-orders/create/'
    | '/orders/sales-orders/create/'
    | '/orders/internal-orders/active/'
    | '/orders/internal-orders/archive/'
    | '/orders/purchase-orders/active/'
    | '/orders/purchase-orders/archive/'
    | '/orders/sales-orders/active/'
    | '/orders/sales-orders/archive/'
    | '/orders/attachment-templates/$id/edit/'
    | '/questionnaires/$id/edit/'
    | '/questionnaires/$id/review/'
    | '/questionnaires/$id/summary/'
    | '/questionnaires/$id/answer/'
    | '/questionnaires/$id/preview/'
    | '/questionnaires/my-questionnaires/active/'
    | '/questionnaires/my-questionnaires/archived/'
    | '/risk/assessments/$id/'
    | '/risk/rules/$id/'
    | '/slcp/my-own/active/'
    | '/slcp/my-own/archive/'
    | '/slcp/assessments/$assessmentId/'
    | '/supply-chain-mapping/insights/collaborator-companies/'
    | '/supply-chain-mapping/insights/global-diagram/'
    | '/supply-chain-mapping/insights/mapped-companies/'
    | '/supply-chain-mapping/insights/overview/'
    | '/supply-chain-mapping/supply-chains/active/'
    | '/supply-chain-mapping/supply-chains/archive/'
    | '/management/risk-management/rule-templates/$id/edit/'
    | '/report/audit-compliance/drilldown/$chartType/'
    | '/report/certificate-compliance/drilldown/$chartType/'
    | '/risk/rules/$id/edit/'
    | '/slcp/assessments/$assessmentId/assessment/'
    | '/slcp/assessments/$assessmentId/overview/'
    | '/supply-chain-mapping/supply-chains/$id/compare/'
    | '/supply-chain-mapping/supply-chains/$id/diagram/'
    | '/supply-chain-mapping/supply-chains/$id/map/'
    | '/my-components/$kind/$id/documents/linked/'
    | '/my-components/$kind/$id/documents/product-only/'
    | '/my-styles/$kind/$id/documents/linked/'
    | '/my-styles/$kind/$id/documents/product-only/'
    | '/network/$companyId/audits/$auditId/findings/'
    | '/network/$companyId/integrations/history/$syncHistoryId/'
    | '/risk/assessments/$id/assessed/$assessmentId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/management'
    | '/audits'
    | '/my-components'
    | '/my-styles'
    | '/orders'
    | '/product-mapping'
    | '/risk'
    | '/supply-chain-mapping'
    | '/docs'
    | '/capa'
    | '/company-settings'
    | '/documents'
    | '/network'
    | '/profile'
    | '/questionnaires'
    | '/report'
    | '/slcp'
    | '/management/risk-management'
    | '/'
    | '/single-sign-on-callback'
    | '/unsubscribe'
    | '/company-settings/constants-mapping'
    | '/management/certifications'
    | '/management/documents'
    | '/company-settings/api-keys'
    | '/company-settings/join-requests'
    | '/company-settings/users'
    | '/company-settings/webshop-settings'
    | '/orders-hub/create'
    | '/activity-feed'
    | '/automation-rules'
    | '/certifications'
    | '/certified-materials'
    | '/dashboard'
    | '/entity-screening'
    | '/orders-hub'
    | '/docs/components/$slug'
    | '/docs/foundations/$slug'
    | '/docs/guides/$slug'
    | '/docs/patterns/$slug'
    | '/management/attachment-templates'
    | '/management/audit-types'
    | '/management/audits'
    | '/management/background-jobs'
    | '/management/badges'
    | '/management/companies'
    | '/management/company-merges'
    | '/management/cs-tools'
    | '/management/custom-information-fields'
    | '/management/document-types'
    | '/management/email-bounce-tracking'
    | '/management/entity-history'
    | '/management/facility-processes'
    | '/management/impersonate'
    | '/management/materials'
    | '/management/origins'
    | '/management/permissions'
    | '/management/platform-features'
    | '/management/product-categories'
    | '/management/product-data-points'
    | '/management/production-processes'
    | '/management/rules'
    | '/management/slcp-dashboard'
    | '/management/sso'
    | '/management/standards'
    | '/management/supplier-questionnaire-templates'
    | '/management/translations'
    | '/management/users'
    | '/management/webshops'
    | '/onboarding/company-search'
    | '/sso-onboarding/$token'
    | '/sso-onboarding/test-result'
    | '/audits/audits-for-company'
    | '/audits/network-audits'
    | '/capa/actions'
    | '/capa/findings'
    | '/capa/plans'
    | '/my-components/component-skus'
    | '/my-components/component-variants'
    | '/my-components/components'
    | '/my-styles/skus'
    | '/my-styles/styles'
    | '/my-styles/variants'
    | '/network/$companyId'
    | '/orders-hub/$id'
    | '/orders/internal-orders'
    | '/orders/purchase-orders'
    | '/orders/sales-orders'
    | '/questionnaires/$id'
    | '/questionnaires/my-questionnaires'
    | '/risk/assessments'
    | '/slcp/my-own'
    | '/supply-chain-mapping/insights'
    | '/supply-chain-mapping/supply-chains'
    | '/company-settings/permission-sets/new'
    | '/certifications/$id'
    | '/company-settings/integrations'
    | '/company-settings/permission-sets'
    | '/files'
    | '/orders/attachment-templates'
    | '/profile/overview'
    | '/profile/settings'
    | '/users/$id'
    | '/management/attachment-templates/$id'
    | '/management/attachment-templates/create'
    | '/management/certifications/$id'
    | '/management/companies/$companyId'
    | '/management/company-merges/$mergeId'
    | '/management/company-merges/new'
    | '/management/entity-history/$id'
    | '/management/platform-features/$featureId'
    | '/management/scoring-templates'
    | '/management/sso/$id'
    | '/management/users/$id'
    | '/my-components/$kind/$id'
    | '/my-styles/$kind/$id'
    | '/orders/internal-orders/$ioId'
    | '/orders/purchase-orders/$poId'
    | '/orders/sales-orders/$soId'
    | '/supply-chain-mapping/supply-chains/$id'
    | '/company-settings/permission-sets/$setKey/edit'
    | '/network/$companyId/badges'
    | '/network/$companyId/capa'
    | '/network/$companyId/claims'
    | '/network/$companyId/custom-information'
    | '/network/$companyId/custom-information-fields'
    | '/network/$companyId/documents'
    | '/network/$companyId/esg-info'
    | '/network/$companyId/general-info'
    | '/network/$companyId/history'
    | '/network/$companyId/products'
    | '/network/$companyId/questionnaire'
    | '/network/$companyId/risk-profile'
    | '/network/$companyId/slcp'
    | '/network/$companyId/users'
    | '/network/$companyId/webshop-profile'
    | '/orders-hub/$id/attachments'
    | '/orders-hub/$id/lines'
    | '/orders-hub/$id/overview'
    | '/audits/$auditId'
    | '/company-settings/constants-mapping/facility-processes'
    | '/company-settings/constants-mapping/materials'
    | '/company-settings/constants-mapping/product-types'
    | '/company-settings/permission-sets/$setKey'
    | '/documents/archived'
    | '/documents/my-documents'
    | '/documents/request-access'
    | '/entity-screening/involved-orders/$companyId'
    | '/my-styles/styles-created-for-me'
    | '/network/my-network'
    | '/orders/attachment-templates/$id'
    | '/orders/attachment-templates/create'
    | '/product-mapping/$cpmId'
    | '/product-mapping/active'
    | '/product-mapping/archive'
    | '/questionnaires/requests'
    | '/questionnaires/templates'
    | '/report/audit-compliance'
    | '/report/certificate-compliance'
    | '/report/tracing-compliance'
    | '/report/tracing-operations'
    | '/risk/landscape'
    | '/risk/rules'
    | '/slcp/network'
    | '/supply-chain-mapping/history'
    | '/management/attachment-templates/$id/edit'
    | '/management/certifications/active'
    | '/management/certifications/archived'
    | '/management/companies/$companyId/api-keys'
    | '/management/companies/$companyId/automation-rules'
    | '/management/companies/$companyId/credits'
    | '/management/companies/$companyId/employees'
    | '/management/companies/$companyId/general-info'
    | '/management/companies/$companyId/network'
    | '/management/companies/$companyId/platform-features'
    | '/management/companies/$companyId/supply-chains'
    | '/management/companies/$companyId/tech-insights'
    | '/management/companies/$companyId/tracing-orders'
    | '/management/documents/active'
    | '/management/documents/archived'
    | '/management/product-categories/$categoryId/fields'
    | '/management/risk-management/risk-gross'
    | '/management/risk-management/risks'
    | '/management/risk-management/rule-templates'
    | '/management/scoring-templates/$id/edit'
    | '/management/scoring-templates/gaps'
    | '/management/supplier-questionnaire-templates/$id/edit'
    | '/management/supplier-questionnaire-templates/$id/preview'
    | '/my-components/$kind/$id/documents'
    | '/my-styles/$kind/$id/documents'
    | '/my-components/$kind/$id/bom'
    | '/my-components/$kind/$id/certifications'
    | '/my-components/$kind/$id/materials'
    | '/my-components/$kind/$id/overview'
    | '/my-components/$kind/$id/qr-code'
    | '/my-components/$kind/$id/skus'
    | '/my-components/$kind/$id/supply-chain'
    | '/my-components/$kind/$id/variants'
    | '/my-components/$kind/$id/webshop-preview'
    | '/my-styles/$kind/$id/bom'
    | '/my-styles/$kind/$id/certifications'
    | '/my-styles/$kind/$id/materials'
    | '/my-styles/$kind/$id/overview'
    | '/my-styles/$kind/$id/qr-code'
    | '/my-styles/$kind/$id/skus'
    | '/my-styles/$kind/$id/supply-chain'
    | '/my-styles/$kind/$id/variants'
    | '/my-styles/$kind/$id/webshop-preview'
    | '/orders/internal-orders/$ioId/documents'
    | '/orders/internal-orders/$ioId/overview'
    | '/orders/internal-orders/$ioId/products'
    | '/orders/internal-orders/$ioId/tracing'
    | '/orders/purchase-orders/$poId/documents'
    | '/orders/purchase-orders/$poId/overview'
    | '/orders/purchase-orders/$poId/products'
    | '/orders/purchase-orders/$poId/tracing'
    | '/orders/sales-orders/$soId/attachments'
    | '/orders/sales-orders/$soId/overview'
    | '/orders/sales-orders/$soId/products'
    | '/orders/sales-orders/$soId/tracing'
    | '/audits/$auditId/capa'
    | '/audits/$auditId/content'
    | '/audits/$auditId/findings'
    | '/audits/$auditId/overview'
    | '/audits/$auditId/score'
    | '/audits/$auditId/view'
    | '/audits/audits-for-company/active'
    | '/audits/audits-for-company/archive'
    | '/audits/network-audits/active'
    | '/audits/network-audits/archive'
    | '/capa/actions/$id'
    | '/capa/plans/$id'
    | '/capa/actions/active'
    | '/capa/actions/archived'
    | '/capa/findings/active'
    | '/capa/findings/archived'
    | '/capa/plans/active'
    | '/capa/plans/archived'
    | '/company-settings/integrations/history/$syncHistoryId'
    | '/my-components/component-skus/active'
    | '/my-components/component-skus/archived'
    | '/my-components/component-variants/active'
    | '/my-components/component-variants/archived'
    | '/my-components/components/active'
    | '/my-components/components/archived'
    | '/my-styles/skus/active'
    | '/my-styles/skus/archived'
    | '/my-styles/styles/active'
    | '/my-styles/styles/archived'
    | '/my-styles/variants/active'
    | '/my-styles/variants/archived'
    | '/network/$companyId/audits'
    | '/network/$companyId/integrations'
    | '/orders/purchase-orders/create'
    | '/orders/sales-orders/create'
    | '/orders/internal-orders/active'
    | '/orders/internal-orders/archive'
    | '/orders/purchase-orders/active'
    | '/orders/purchase-orders/archive'
    | '/orders/sales-orders/active'
    | '/orders/sales-orders/archive'
    | '/orders/attachment-templates/$id/edit'
    | '/questionnaires/$id/edit'
    | '/questionnaires/$id/review'
    | '/questionnaires/$id/summary'
    | '/questionnaires/$id/answer'
    | '/questionnaires/$id/preview'
    | '/questionnaires/my-questionnaires/active'
    | '/questionnaires/my-questionnaires/archived'
    | '/risk/assessments/$id'
    | '/risk/rules/$id'
    | '/slcp/my-own/active'
    | '/slcp/my-own/archive'
    | '/slcp/assessments/$assessmentId'
    | '/supply-chain-mapping/insights/collaborator-companies'
    | '/supply-chain-mapping/insights/global-diagram'
    | '/supply-chain-mapping/insights/mapped-companies'
    | '/supply-chain-mapping/insights/overview'
    | '/supply-chain-mapping/supply-chains/active'
    | '/supply-chain-mapping/supply-chains/archive'
    | '/management/risk-management/rule-templates/$id/edit'
    | '/report/audit-compliance/drilldown/$chartType'
    | '/report/certificate-compliance/drilldown/$chartType'
    | '/risk/rules/$id/edit'
    | '/slcp/assessments/$assessmentId/assessment'
    | '/slcp/assessments/$assessmentId/overview'
    | '/supply-chain-mapping/supply-chains/$id/compare'
    | '/supply-chain-mapping/supply-chains/$id/diagram'
    | '/supply-chain-mapping/supply-chains/$id/map'
    | '/my-components/$kind/$id/documents/linked'
    | '/my-components/$kind/$id/documents/product-only'
    | '/my-styles/$kind/$id/documents/linked'
    | '/my-styles/$kind/$id/documents/product-only'
    | '/network/$companyId/audits/$auditId/findings'
    | '/network/$companyId/integrations/history/$syncHistoryId'
    | '/risk/assessments/$id/assessed/$assessmentId'
  id:
    | '__root__'
    | '/(client)'
    | '/management'
    | '/(client)/audits'
    | '/(client)/entity-screening'
    | '/(client)/files'
    | '/(client)/my-components'
    | '/(client)/my-styles'
    | '/(client)/orders'
    | '/(client)/product-mapping'
    | '/(client)/risk'
    | '/(client)/supply-chain-mapping'
    | '/docs/'
    | '/(client)/capa/(pages)'
    | '/(client)/certifications/(pages)'
    | '/(client)/certified-materials/(pages)'
    | '/(client)/company-settings/(pages)'
    | '/(client)/documents/(pages)'
    | '/(client)/my-components/(pages)'
    | '/(client)/my-styles/(pages)'
    | '/(client)/network/(pages)'
    | '/(client)/profile/(pages)'
    | '/(client)/questionnaires/(pages)'
    | '/(client)/report/(pages)'
    | '/(client)/slcp/(pages)'
    | '/management/risk-management/(pages)'
    | '/(login)/(pages)/'
    | '/(login)/single-sign-on-callback/'
    | '/unsubscribe/(pages)/'
    | '/(client)/audits/(pages)/(list)'
    | '/(client)/capa/(pages)/(detail)'
    | '/(client)/capa/(pages)/(list)'
    | '/(client)/company-settings/(pages)/constants-mapping'
    | '/(client)/company-settings/(pages)/integrations'
    | '/(client)/documents/(pages)/(list)'
    | '/(client)/my-components/(pages)/(detail)'
    | '/(client)/my-components/(pages)/(list)'
    | '/(client)/my-styles/(pages)/(detail)'
    | '/(client)/my-styles/(pages)/(list)'
    | '/(client)/network/(pages)/(detail)'
    | '/(client)/network/(pages)/(list)'
    | '/(client)/orders/(pages)/(list)'
    | '/(client)/product-mapping/(pages)/(list)'
    | '/(client)/questionnaires/(pages)/(list)'
    | '/(client)/risk/(pages)/(detail)'
    | '/(client)/risk/(pages)/(edit)'
    | '/(client)/risk/(pages)/(list)'
    | '/(client)/slcp/(pages)/(list)'
    | '/(client)/supply-chain-mapping/(pages)/(list)'
    | '/management/certifications/(pages)/(list)'
    | '/management/companies/(pages)/$companyId'
    | '/management/documents/(pages)/(list)'
    | '/management/risk-management/(pages)/(list)'
    | '/management/scoring-templates/(pages)/(list)'
    | '/(client)/company-settings/(pages)/api-keys'
    | '/(client)/company-settings/(pages)/join-requests'
    | '/(client)/company-settings/(pages)/users'
    | '/(client)/company-settings/(pages)/webshop-settings'
    | '/(client)/orders-hub/(pages)/create'
    | '/(client)/activity-feed/(pages)/'
    | '/(client)/automation-rules/(pages)/'
    | '/(client)/certifications/(pages)/'
    | '/(client)/certified-materials/(pages)/'
    | '/(client)/dashboard/(pages)/'
    | '/(client)/entity-screening/(pages)/'
    | '/(client)/orders-hub/(pages)/'
    | '/docs/components/$slug/'
    | '/docs/foundations/$slug/'
    | '/docs/guides/$slug/'
    | '/docs/patterns/$slug/'
    | '/management/attachment-templates/(pages)/'
    | '/management/audit-types/(pages)/'
    | '/management/audits/(pages)/'
    | '/management/background-jobs/(pages)/'
    | '/management/badges/(pages)/'
    | '/management/companies/(pages)/'
    | '/management/company-merges/(pages)/'
    | '/management/cs-tools/(pages)/'
    | '/management/custom-information-fields/(pages)/'
    | '/management/document-types/(pages)/'
    | '/management/email-bounce-tracking/(pages)/'
    | '/management/entity-history/(pages)/'
    | '/management/facility-processes/(pages)/'
    | '/management/impersonate/(pages)/'
    | '/management/materials/(pages)/'
    | '/management/origins/(pages)/'
    | '/management/permissions/(pages)/'
    | '/management/platform-features/(pages)/'
    | '/management/product-categories/(pages)/'
    | '/management/product-data-points/(pages)/'
    | '/management/production-processes/(pages)/'
    | '/management/rules/(pages)/'
    | '/management/slcp-dashboard/(pages)/'
    | '/management/sso/(pages)/'
    | '/management/standards/(pages)/'
    | '/management/supplier-questionnaire-templates/(pages)/'
    | '/management/translations/(pages)/'
    | '/management/users/(pages)/'
    | '/management/webshops/(pages)/'
    | '/onboarding/company-search/(pages)/'
    | '/sso-onboarding/(pages)/$token/'
    | '/sso-onboarding/(pages)/test-result/'
    | '/(client)/audits/(pages)/(detail)/$auditId'
    | '/(client)/audits/(pages)/(list)/audits-for-company'
    | '/(client)/audits/(pages)/(list)/network-audits'
    | '/(client)/capa/(pages)/(list)/actions'
    | '/(client)/capa/(pages)/(list)/findings'
    | '/(client)/capa/(pages)/(list)/plans'
    | '/(client)/my-components/(pages)/(list)/component-skus'
    | '/(client)/my-components/(pages)/(list)/component-variants'
    | '/(client)/my-components/(pages)/(list)/components'
    | '/(client)/my-styles/(pages)/(list)/skus'
    | '/(client)/my-styles/(pages)/(list)/styles'
    | '/(client)/my-styles/(pages)/(list)/variants'
    | '/(client)/network/(pages)/(detail)/$companyId'
    | '/(client)/orders-hub/(pages)/(detail)/$id'
    | '/(client)/orders/(pages)/(list)/internal-orders'
    | '/(client)/orders/(pages)/(list)/purchase-orders'
    | '/(client)/orders/(pages)/(list)/sales-orders'
    | '/(client)/questionnaires/(pages)/(detail)/$id'
    | '/(client)/questionnaires/(pages)/(list)/my-questionnaires'
    | '/(client)/risk/(pages)/(detail)/assessments'
    | '/(client)/slcp/(pages)/(list)/my-own'
    | '/(client)/supply-chain-mapping/(pages)/(list)/insights'
    | '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains'
    | '/(client)/company-settings/(pages)/permission-sets/new'
    | '/(client)/certifications/(pages)/$id/'
    | '/(client)/company-settings/(pages)/integrations/'
    | '/(client)/company-settings/(pages)/permission-sets/'
    | '/(client)/files/(pages)/(list)/'
    | '/(client)/orders/(pages)/attachment-templates/'
    | '/(client)/profile/(pages)/overview/'
    | '/(client)/profile/(pages)/settings/'
    | '/(client)/users/(pages)/$id/'
    | '/management/attachment-templates/(pages)/$id/'
    | '/management/attachment-templates/(pages)/create/'
    | '/management/certifications/(pages)/$id/'
    | '/management/companies/(pages)/$companyId/'
    | '/management/company-merges/(pages)/$mergeId/'
    | '/management/company-merges/(pages)/new/'
    | '/management/entity-history/(pages)/$id/'
    | '/management/platform-features/(pages)/$featureId/'
    | '/management/scoring-templates/(pages)/(list)/'
    | '/management/sso/(pages)/$id/'
    | '/management/users/(pages)/$id/'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id'
    | '/(client)/network/(pages)/(detail)/$companyId/integrations'
    | '/(client)/orders/(pages)/(detail)/internal-orders/$ioId'
    | '/(client)/orders/(pages)/(detail)/purchase-orders/$poId'
    | '/(client)/orders/(pages)/(detail)/sales-orders/$soId'
    | '/(client)/slcp/(pages)/assessments/(details)/$assessmentId'
    | '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id'
    | '/(client)/company-settings/(pages)/permission-sets/$setKey/edit'
    | '/(client)/network/(pages)/(detail)/$companyId/badges'
    | '/(client)/network/(pages)/(detail)/$companyId/capa'
    | '/(client)/network/(pages)/(detail)/$companyId/claims'
    | '/(client)/network/(pages)/(detail)/$companyId/custom-information'
    | '/(client)/network/(pages)/(detail)/$companyId/custom-information-fields'
    | '/(client)/network/(pages)/(detail)/$companyId/documents'
    | '/(client)/network/(pages)/(detail)/$companyId/esg-info'
    | '/(client)/network/(pages)/(detail)/$companyId/general-info'
    | '/(client)/network/(pages)/(detail)/$companyId/history'
    | '/(client)/network/(pages)/(detail)/$companyId/products'
    | '/(client)/network/(pages)/(detail)/$companyId/questionnaire'
    | '/(client)/network/(pages)/(detail)/$companyId/risk-profile'
    | '/(client)/network/(pages)/(detail)/$companyId/slcp'
    | '/(client)/network/(pages)/(detail)/$companyId/users'
    | '/(client)/network/(pages)/(detail)/$companyId/webshop-profile'
    | '/(client)/orders-hub/(pages)/(detail)/$id/attachments'
    | '/(client)/orders-hub/(pages)/(detail)/$id/lines'
    | '/(client)/orders-hub/(pages)/(detail)/$id/overview'
    | '/(client)/audits/(pages)/(detail)/$auditId/'
    | '/(client)/company-settings/(pages)/constants-mapping/facility-processes/'
    | '/(client)/company-settings/(pages)/constants-mapping/materials/'
    | '/(client)/company-settings/(pages)/constants-mapping/product-types/'
    | '/(client)/company-settings/(pages)/permission-sets/$setKey/'
    | '/(client)/documents/(pages)/(list)/archived/'
    | '/(client)/documents/(pages)/(list)/my-documents/'
    | '/(client)/documents/(pages)/(list)/request-access/'
    | '/(client)/entity-screening/(pages)/involved-orders/$companyId/'
    | '/(client)/my-styles/(pages)/(list)/styles-created-for-me/'
    | '/(client)/network/(pages)/(list)/my-network/'
    | '/(client)/orders/(pages)/attachment-templates/$id/'
    | '/(client)/orders/(pages)/attachment-templates/create/'
    | '/(client)/product-mapping/(pages)/(details)/$cpmId/'
    | '/(client)/product-mapping/(pages)/(list)/active/'
    | '/(client)/product-mapping/(pages)/(list)/archive/'
    | '/(client)/questionnaires/(pages)/(list)/requests/'
    | '/(client)/questionnaires/(pages)/(list)/templates/'
    | '/(client)/report/(pages)/(analytics)/audit-compliance/'
    | '/(client)/report/(pages)/(analytics)/certificate-compliance/'
    | '/(client)/report/(pages)/(analytics)/tracing-compliance/'
    | '/(client)/report/(pages)/(analytics)/tracing-operations/'
    | '/(client)/risk/(pages)/(list)/assessments/'
    | '/(client)/risk/(pages)/(list)/landscape/'
    | '/(client)/risk/(pages)/(list)/rules/'
    | '/(client)/slcp/(pages)/(list)/network/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/history/'
    | '/management/attachment-templates/(pages)/$id/edit/'
    | '/management/certifications/(pages)/(list)/active/'
    | '/management/certifications/(pages)/(list)/archived/'
    | '/management/companies/(pages)/$companyId/api-keys/'
    | '/management/companies/(pages)/$companyId/automation-rules/'
    | '/management/companies/(pages)/$companyId/credits/'
    | '/management/companies/(pages)/$companyId/employees/'
    | '/management/companies/(pages)/$companyId/general-info/'
    | '/management/companies/(pages)/$companyId/network/'
    | '/management/companies/(pages)/$companyId/platform-features/'
    | '/management/companies/(pages)/$companyId/supply-chains/'
    | '/management/companies/(pages)/$companyId/tech-insights/'
    | '/management/companies/(pages)/$companyId/tracing-orders/'
    | '/management/documents/(pages)/(list)/active/'
    | '/management/documents/(pages)/(list)/archived/'
    | '/management/product-categories/(pages)/$categoryId/fields/'
    | '/management/risk-management/(pages)/(list)/risk-gross/'
    | '/management/risk-management/(pages)/(list)/risks/'
    | '/management/risk-management/(pages)/(list)/rule-templates/'
    | '/management/scoring-templates/(pages)/$id/edit/'
    | '/management/scoring-templates/(pages)/(list)/gaps/'
    | '/management/supplier-questionnaire-templates/(pages)/$id/edit/'
    | '/management/supplier-questionnaire-templates/(pages)/$id/preview/'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/documents'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/bom'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/certifications'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/materials'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/overview'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/skus'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/variants'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/webshop-preview'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/bom'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/materials'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/overview'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/skus'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/variants'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview'
    | '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents'
    | '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview'
    | '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products'
    | '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/tracing'
    | '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents'
    | '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview'
    | '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products'
    | '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/tracing'
    | '/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments'
    | '/(client)/orders/(pages)/(detail)/sales-orders/$soId/overview'
    | '/(client)/orders/(pages)/(detail)/sales-orders/$soId/products'
    | '/(client)/orders/(pages)/(detail)/sales-orders/$soId/tracing'
    | '/(client)/audits/(pages)/(detail)/$auditId/capa/'
    | '/(client)/audits/(pages)/(detail)/$auditId/content/'
    | '/(client)/audits/(pages)/(detail)/$auditId/findings/'
    | '/(client)/audits/(pages)/(detail)/$auditId/overview/'
    | '/(client)/audits/(pages)/(detail)/$auditId/score/'
    | '/(client)/audits/(pages)/(detail)/$auditId/view/'
    | '/(client)/audits/(pages)/(list)/audits-for-company/active/'
    | '/(client)/audits/(pages)/(list)/audits-for-company/archive/'
    | '/(client)/audits/(pages)/(list)/network-audits/active/'
    | '/(client)/audits/(pages)/(list)/network-audits/archive/'
    | '/(client)/capa/(pages)/(detail)/actions/$id/'
    | '/(client)/capa/(pages)/(detail)/plans/$id/'
    | '/(client)/capa/(pages)/(list)/actions/active/'
    | '/(client)/capa/(pages)/(list)/actions/archived/'
    | '/(client)/capa/(pages)/(list)/findings/active/'
    | '/(client)/capa/(pages)/(list)/findings/archived/'
    | '/(client)/capa/(pages)/(list)/plans/active/'
    | '/(client)/capa/(pages)/(list)/plans/archived/'
    | '/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/'
    | '/(client)/my-components/(pages)/(list)/component-skus/active/'
    | '/(client)/my-components/(pages)/(list)/component-skus/archived/'
    | '/(client)/my-components/(pages)/(list)/component-variants/active/'
    | '/(client)/my-components/(pages)/(list)/component-variants/archived/'
    | '/(client)/my-components/(pages)/(list)/components/active/'
    | '/(client)/my-components/(pages)/(list)/components/archived/'
    | '/(client)/my-styles/(pages)/(list)/skus/active/'
    | '/(client)/my-styles/(pages)/(list)/skus/archived/'
    | '/(client)/my-styles/(pages)/(list)/styles/active/'
    | '/(client)/my-styles/(pages)/(list)/styles/archived/'
    | '/(client)/my-styles/(pages)/(list)/variants/active/'
    | '/(client)/my-styles/(pages)/(list)/variants/archived/'
    | '/(client)/network/(pages)/(detail)/$companyId/audits/'
    | '/(client)/network/(pages)/(detail)/$companyId/integrations/'
    | '/(client)/orders/(pages)/(create)/purchase-orders/create/'
    | '/(client)/orders/(pages)/(create)/sales-orders/create/'
    | '/(client)/orders/(pages)/(list)/internal-orders/active/'
    | '/(client)/orders/(pages)/(list)/internal-orders/archive/'
    | '/(client)/orders/(pages)/(list)/purchase-orders/active/'
    | '/(client)/orders/(pages)/(list)/purchase-orders/archive/'
    | '/(client)/orders/(pages)/(list)/sales-orders/active/'
    | '/(client)/orders/(pages)/(list)/sales-orders/archive/'
    | '/(client)/orders/(pages)/attachment-templates/$id/edit/'
    | '/(client)/questionnaires/(pages)/(detail)/$id/edit/'
    | '/(client)/questionnaires/(pages)/(detail)/$id/review/'
    | '/(client)/questionnaires/(pages)/(detail)/$id/summary/'
    | '/(client)/questionnaires/(pages)/(detail)/$id_/answer/'
    | '/(client)/questionnaires/(pages)/(detail)/$id_/preview/'
    | '/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/'
    | '/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/'
    | '/(client)/risk/(pages)/(detail)/assessments/$id/'
    | '/(client)/risk/(pages)/(detail)/rules/$id/'
    | '/(client)/slcp/(pages)/(list)/my-own/active/'
    | '/(client)/slcp/(pages)/(list)/my-own/archive/'
    | '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/insights/collaborator-companies/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/insights/overview/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/'
    | '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/'
    | '/management/risk-management/(pages)/rule-templates/$id/edit/'
    | '/(client)/report/(pages)/(drilldown)/audit-compliance/drilldown/$chartType/'
    | '/(client)/report/(pages)/(drilldown)/certificate-compliance/drilldown/$chartType/'
    | '/(client)/risk/(pages)/(edit)/rules/$id/edit/'
    | '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/assessment/'
    | '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/'
    | '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/'
    | '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/'
    | '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/map/'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/linked/'
    | '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/product-only/'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/'
    | '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/'
    | '/(client)/network/(pages)/(detail)/$companyId/audits/$auditId/findings/'
    | '/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/'
    | '/(client)/risk/(pages)/(detail)/assessments/$id/assessed/$assessmentId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  clientRouteRoute: typeof clientRouteRouteWithChildren
  ManagementRouteRoute: typeof ManagementRouteRouteWithChildren
  DocsIndexRoute: typeof DocsIndexRoute
  loginpagesIndexRoute: typeof loginpagesIndexRoute
  loginSingleSignOnCallbackIndexRoute: typeof loginSingleSignOnCallbackIndexRoute
  UnsubscribepagesIndexRoute: typeof UnsubscribepagesIndexRoute
  DocsComponentsSlugIndexRoute: typeof DocsComponentsSlugIndexRoute
  DocsFoundationsSlugIndexRoute: typeof DocsFoundationsSlugIndexRoute
  DocsGuidesSlugIndexRoute: typeof DocsGuidesSlugIndexRoute
  DocsPatternsSlugIndexRoute: typeof DocsPatternsSlugIndexRoute
  OnboardingCompanySearchpagesIndexRoute: typeof OnboardingCompanySearchpagesIndexRoute
  SsoOnboardingpagesTokenIndexRoute: typeof SsoOnboardingpagesTokenIndexRoute
  SsoOnboardingpagesTestResultIndexRoute: typeof SsoOnboardingpagesTestResultIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(client)': {
      id: '/(client)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof clientRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management': {
      id: '/management'
      path: '/management'
      fullPath: '/management'
      preLoaderRoute: typeof ManagementRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(client)/audits': {
      id: '/(client)/audits'
      path: '/audits'
      fullPath: '/audits'
      preLoaderRoute: typeof clientAuditsRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/entity-screening': {
      id: '/(client)/entity-screening'
      path: '/entity-screening'
      fullPath: '/entity-screening'
      preLoaderRoute: typeof clientEntityScreeningRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/files': {
      id: '/(client)/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof clientFilesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/my-components': {
      id: '/(client)/my-components'
      path: '/my-components'
      fullPath: '/my-components'
      preLoaderRoute: typeof clientMyComponentsRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/my-styles': {
      id: '/(client)/my-styles'
      path: '/my-styles'
      fullPath: '/my-styles'
      preLoaderRoute: typeof clientMyStylesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/orders': {
      id: '/(client)/orders'
      path: '/orders'
      fullPath: '/orders'
      preLoaderRoute: typeof clientOrdersRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/product-mapping': {
      id: '/(client)/product-mapping'
      path: '/product-mapping'
      fullPath: '/product-mapping'
      preLoaderRoute: typeof clientProductMappingRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/risk': {
      id: '/(client)/risk'
      path: '/risk'
      fullPath: '/risk'
      preLoaderRoute: typeof clientRiskRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/supply-chain-mapping': {
      id: '/(client)/supply-chain-mapping'
      path: '/supply-chain-mapping'
      fullPath: '/supply-chain-mapping'
      preLoaderRoute: typeof clientSupplyChainMappingRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/docs/': {
      id: '/docs/'
      path: '/docs'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(client)/capa/(pages)': {
      id: '/(client)/capa/(pages)'
      path: '/capa'
      fullPath: '/capa'
      preLoaderRoute: typeof clientCapapagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/certifications/(pages)': {
      id: '/(client)/certifications/(pages)'
      path: '/certifications'
      fullPath: '/certifications'
      preLoaderRoute: typeof clientCertificationspagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/certified-materials/(pages)': {
      id: '/(client)/certified-materials/(pages)'
      path: '/certified-materials'
      fullPath: '/certified-materials'
      preLoaderRoute: typeof clientCertifiedMaterialspagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/company-settings/(pages)': {
      id: '/(client)/company-settings/(pages)'
      path: '/company-settings'
      fullPath: '/company-settings'
      preLoaderRoute: typeof clientCompanySettingspagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/documents/(pages)': {
      id: '/(client)/documents/(pages)'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof clientDocumentspagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/my-components/(pages)': {
      id: '/(client)/my-components/(pages)'
      path: ''
      fullPath: '/my-components'
      preLoaderRoute: typeof clientMyComponentspagesRouteRouteImport
      parentRoute: typeof clientMyComponentsRouteRoute
    }
    '/(client)/my-styles/(pages)': {
      id: '/(client)/my-styles/(pages)'
      path: ''
      fullPath: '/my-styles'
      preLoaderRoute: typeof clientMyStylespagesRouteRouteImport
      parentRoute: typeof clientMyStylesRouteRoute
    }
    '/(client)/network/(pages)': {
      id: '/(client)/network/(pages)'
      path: '/network'
      fullPath: '/network'
      preLoaderRoute: typeof clientNetworkpagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/profile/(pages)': {
      id: '/(client)/profile/(pages)'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof clientProfilepagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/questionnaires/(pages)': {
      id: '/(client)/questionnaires/(pages)'
      path: '/questionnaires'
      fullPath: '/questionnaires'
      preLoaderRoute: typeof clientQuestionnairespagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/report/(pages)': {
      id: '/(client)/report/(pages)'
      path: '/report'
      fullPath: '/report'
      preLoaderRoute: typeof clientReportpagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/slcp/(pages)': {
      id: '/(client)/slcp/(pages)'
      path: '/slcp'
      fullPath: '/slcp'
      preLoaderRoute: typeof clientSlcppagesRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(login)/(pages)/': {
      id: '/(login)/(pages)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof loginpagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(login)/single-sign-on-callback/': {
      id: '/(login)/single-sign-on-callback/'
      path: '/single-sign-on-callback'
      fullPath: '/single-sign-on-callback/'
      preLoaderRoute: typeof loginSingleSignOnCallbackIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management/risk-management/(pages)': {
      id: '/management/risk-management/(pages)'
      path: '/risk-management'
      fullPath: '/management/risk-management'
      preLoaderRoute: typeof ManagementRiskManagementpagesRouteRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/unsubscribe/(pages)/': {
      id: '/unsubscribe/(pages)/'
      path: '/unsubscribe'
      fullPath: '/unsubscribe/'
      preLoaderRoute: typeof UnsubscribepagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(client)/activity-feed/(pages)/': {
      id: '/(client)/activity-feed/(pages)/'
      path: '/activity-feed'
      fullPath: '/activity-feed/'
      preLoaderRoute: typeof clientActivityFeedpagesIndexRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/audits/(pages)/(list)': {
      id: '/(client)/audits/(pages)/(list)'
      path: ''
      fullPath: '/audits'
      preLoaderRoute: typeof clientAuditspageslistRouteRouteImport
      parentRoute: typeof clientAuditsRouteRoute
    }
    '/(client)/automation-rules/(pages)/': {
      id: '/(client)/automation-rules/(pages)/'
      path: '/automation-rules'
      fullPath: '/automation-rules/'
      preLoaderRoute: typeof clientAutomationRulespagesIndexRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/capa/(pages)/(detail)': {
      id: '/(client)/capa/(pages)/(detail)'
      path: ''
      fullPath: '/capa'
      preLoaderRoute: typeof clientCapapagesdetailRouteRouteImport
      parentRoute: typeof clientCapapagesRouteRoute
    }
    '/(client)/capa/(pages)/(list)': {
      id: '/(client)/capa/(pages)/(list)'
      path: ''
      fullPath: '/capa'
      preLoaderRoute: typeof clientCapapageslistRouteRouteImport
      parentRoute: typeof clientCapapagesRouteRoute
    }
    '/(client)/certifications/(pages)/': {
      id: '/(client)/certifications/(pages)/'
      path: '/'
      fullPath: '/certifications/'
      preLoaderRoute: typeof clientCertificationspagesIndexRouteImport
      parentRoute: typeof clientCertificationspagesRouteRoute
    }
    '/(client)/certified-materials/(pages)/': {
      id: '/(client)/certified-materials/(pages)/'
      path: '/'
      fullPath: '/certified-materials/'
      preLoaderRoute: typeof clientCertifiedMaterialspagesIndexRouteImport
      parentRoute: typeof clientCertifiedMaterialspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/api-keys': {
      id: '/(client)/company-settings/(pages)/api-keys'
      path: '/api-keys'
      fullPath: '/company-settings/api-keys'
      preLoaderRoute: typeof clientCompanySettingspagesApiKeysRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/constants-mapping': {
      id: '/(client)/company-settings/(pages)/constants-mapping'
      path: '/constants-mapping'
      fullPath: '/company-settings/constants-mapping'
      preLoaderRoute: typeof clientCompanySettingspagesConstantsMappingRouteRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/integrations': {
      id: '/(client)/company-settings/(pages)/integrations'
      path: '/integrations'
      fullPath: '/company-settings/integrations'
      preLoaderRoute: typeof clientCompanySettingspagesIntegrationsRouteRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/join-requests': {
      id: '/(client)/company-settings/(pages)/join-requests'
      path: '/join-requests'
      fullPath: '/company-settings/join-requests'
      preLoaderRoute: typeof clientCompanySettingspagesJoinRequestsRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/users': {
      id: '/(client)/company-settings/(pages)/users'
      path: '/users'
      fullPath: '/company-settings/users'
      preLoaderRoute: typeof clientCompanySettingspagesUsersRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/webshop-settings': {
      id: '/(client)/company-settings/(pages)/webshop-settings'
      path: '/webshop-settings'
      fullPath: '/company-settings/webshop-settings'
      preLoaderRoute: typeof clientCompanySettingspagesWebshopSettingsRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/dashboard/(pages)/': {
      id: '/(client)/dashboard/(pages)/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof clientDashboardpagesIndexRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/documents/(pages)/(list)': {
      id: '/(client)/documents/(pages)/(list)'
      path: ''
      fullPath: '/documents'
      preLoaderRoute: typeof clientDocumentspageslistRouteRouteImport
      parentRoute: typeof clientDocumentspagesRouteRoute
    }
    '/(client)/entity-screening/(pages)/': {
      id: '/(client)/entity-screening/(pages)/'
      path: '/'
      fullPath: '/entity-screening/'
      preLoaderRoute: typeof clientEntityScreeningpagesIndexRouteImport
      parentRoute: typeof clientEntityScreeningRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)': {
      id: '/(client)/my-components/(pages)/(detail)'
      path: ''
      fullPath: '/my-components'
      preLoaderRoute: typeof clientMyComponentspagesdetailRouteRouteImport
      parentRoute: typeof clientMyComponentspagesRouteRoute
    }
    '/(client)/my-components/(pages)/(list)': {
      id: '/(client)/my-components/(pages)/(list)'
      path: ''
      fullPath: '/my-components'
      preLoaderRoute: typeof clientMyComponentspageslistRouteRouteImport
      parentRoute: typeof clientMyComponentspagesRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)': {
      id: '/(client)/my-styles/(pages)/(detail)'
      path: ''
      fullPath: '/my-styles'
      preLoaderRoute: typeof clientMyStylespagesdetailRouteRouteImport
      parentRoute: typeof clientMyStylespagesRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)': {
      id: '/(client)/my-styles/(pages)/(list)'
      path: ''
      fullPath: '/my-styles'
      preLoaderRoute: typeof clientMyStylespageslistRouteRouteImport
      parentRoute: typeof clientMyStylespagesRouteRoute
    }
    '/(client)/network/(pages)/(detail)': {
      id: '/(client)/network/(pages)/(detail)'
      path: ''
      fullPath: '/network'
      preLoaderRoute: typeof clientNetworkpagesdetailRouteRouteImport
      parentRoute: typeof clientNetworkpagesRouteRoute
    }
    '/(client)/network/(pages)/(list)': {
      id: '/(client)/network/(pages)/(list)'
      path: ''
      fullPath: '/network'
      preLoaderRoute: typeof clientNetworkpageslistRouteRouteImport
      parentRoute: typeof clientNetworkpagesRouteRoute
    }
    '/(client)/orders-hub/(pages)/': {
      id: '/(client)/orders-hub/(pages)/'
      path: '/orders-hub'
      fullPath: '/orders-hub/'
      preLoaderRoute: typeof clientOrdersHubpagesIndexRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/orders-hub/(pages)/create': {
      id: '/(client)/orders-hub/(pages)/create'
      path: '/orders-hub/create'
      fullPath: '/orders-hub/create'
      preLoaderRoute: typeof clientOrdersHubpagesCreateRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/orders/(pages)/(list)': {
      id: '/(client)/orders/(pages)/(list)'
      path: ''
      fullPath: '/orders'
      preLoaderRoute: typeof clientOrderspageslistRouteRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/product-mapping/(pages)/(list)': {
      id: '/(client)/product-mapping/(pages)/(list)'
      path: ''
      fullPath: '/product-mapping'
      preLoaderRoute: typeof clientProductMappingpageslistRouteRouteImport
      parentRoute: typeof clientProductMappingRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)': {
      id: '/(client)/questionnaires/(pages)/(list)'
      path: ''
      fullPath: '/questionnaires'
      preLoaderRoute: typeof clientQuestionnairespageslistRouteRouteImport
      parentRoute: typeof clientQuestionnairespagesRouteRoute
    }
    '/(client)/risk/(pages)/(detail)': {
      id: '/(client)/risk/(pages)/(detail)'
      path: ''
      fullPath: '/risk'
      preLoaderRoute: typeof clientRiskpagesdetailRouteRouteImport
      parentRoute: typeof clientRiskRouteRoute
    }
    '/(client)/risk/(pages)/(edit)': {
      id: '/(client)/risk/(pages)/(edit)'
      path: ''
      fullPath: '/risk'
      preLoaderRoute: typeof clientRiskpageseditRouteRouteImport
      parentRoute: typeof clientRiskRouteRoute
    }
    '/(client)/risk/(pages)/(list)': {
      id: '/(client)/risk/(pages)/(list)'
      path: ''
      fullPath: '/risk'
      preLoaderRoute: typeof clientRiskpageslistRouteRouteImport
      parentRoute: typeof clientRiskRouteRoute
    }
    '/(client)/slcp/(pages)/(list)': {
      id: '/(client)/slcp/(pages)/(list)'
      path: ''
      fullPath: '/slcp'
      preLoaderRoute: typeof clientSlcppageslistRouteRouteImport
      parentRoute: typeof clientSlcppagesRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)'
      path: ''
      fullPath: '/supply-chain-mapping'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistRouteRouteImport
      parentRoute: typeof clientSupplyChainMappingRouteRoute
    }
    '/docs/components/$slug/': {
      id: '/docs/components/$slug/'
      path: '/docs/components/$slug'
      fullPath: '/docs/components/$slug/'
      preLoaderRoute: typeof DocsComponentsSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/foundations/$slug/': {
      id: '/docs/foundations/$slug/'
      path: '/docs/foundations/$slug'
      fullPath: '/docs/foundations/$slug/'
      preLoaderRoute: typeof DocsFoundationsSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/guides/$slug/': {
      id: '/docs/guides/$slug/'
      path: '/docs/guides/$slug'
      fullPath: '/docs/guides/$slug/'
      preLoaderRoute: typeof DocsGuidesSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/patterns/$slug/': {
      id: '/docs/patterns/$slug/'
      path: '/docs/patterns/$slug'
      fullPath: '/docs/patterns/$slug/'
      preLoaderRoute: typeof DocsPatternsSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/management/attachment-templates/(pages)/': {
      id: '/management/attachment-templates/(pages)/'
      path: '/attachment-templates'
      fullPath: '/management/attachment-templates/'
      preLoaderRoute: typeof ManagementAttachmentTemplatespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/audit-types/(pages)/': {
      id: '/management/audit-types/(pages)/'
      path: '/audit-types'
      fullPath: '/management/audit-types/'
      preLoaderRoute: typeof ManagementAuditTypespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/audits/(pages)/': {
      id: '/management/audits/(pages)/'
      path: '/audits'
      fullPath: '/management/audits/'
      preLoaderRoute: typeof ManagementAuditspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/background-jobs/(pages)/': {
      id: '/management/background-jobs/(pages)/'
      path: '/background-jobs'
      fullPath: '/management/background-jobs/'
      preLoaderRoute: typeof ManagementBackgroundJobspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/badges/(pages)/': {
      id: '/management/badges/(pages)/'
      path: '/badges'
      fullPath: '/management/badges/'
      preLoaderRoute: typeof ManagementBadgespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/certifications/(pages)/(list)': {
      id: '/management/certifications/(pages)/(list)'
      path: '/certifications'
      fullPath: '/management/certifications'
      preLoaderRoute: typeof ManagementCertificationspageslistRouteRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/companies/(pages)/': {
      id: '/management/companies/(pages)/'
      path: '/companies'
      fullPath: '/management/companies/'
      preLoaderRoute: typeof ManagementCompaniespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/companies/(pages)/$companyId': {
      id: '/management/companies/(pages)/$companyId'
      path: '/companies/$companyId'
      fullPath: '/management/companies/$companyId'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdRouteRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/company-merges/(pages)/': {
      id: '/management/company-merges/(pages)/'
      path: '/company-merges'
      fullPath: '/management/company-merges/'
      preLoaderRoute: typeof ManagementCompanyMergespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/cs-tools/(pages)/': {
      id: '/management/cs-tools/(pages)/'
      path: '/cs-tools'
      fullPath: '/management/cs-tools/'
      preLoaderRoute: typeof ManagementCsToolspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/custom-information-fields/(pages)/': {
      id: '/management/custom-information-fields/(pages)/'
      path: '/custom-information-fields'
      fullPath: '/management/custom-information-fields/'
      preLoaderRoute: typeof ManagementCustomInformationFieldspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/document-types/(pages)/': {
      id: '/management/document-types/(pages)/'
      path: '/document-types'
      fullPath: '/management/document-types/'
      preLoaderRoute: typeof ManagementDocumentTypespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/documents/(pages)/(list)': {
      id: '/management/documents/(pages)/(list)'
      path: '/documents'
      fullPath: '/management/documents'
      preLoaderRoute: typeof ManagementDocumentspageslistRouteRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/email-bounce-tracking/(pages)/': {
      id: '/management/email-bounce-tracking/(pages)/'
      path: '/email-bounce-tracking'
      fullPath: '/management/email-bounce-tracking/'
      preLoaderRoute: typeof ManagementEmailBounceTrackingpagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/entity-history/(pages)/': {
      id: '/management/entity-history/(pages)/'
      path: '/entity-history'
      fullPath: '/management/entity-history/'
      preLoaderRoute: typeof ManagementEntityHistorypagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/facility-processes/(pages)/': {
      id: '/management/facility-processes/(pages)/'
      path: '/facility-processes'
      fullPath: '/management/facility-processes/'
      preLoaderRoute: typeof ManagementFacilityProcessespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/impersonate/(pages)/': {
      id: '/management/impersonate/(pages)/'
      path: '/impersonate'
      fullPath: '/management/impersonate/'
      preLoaderRoute: typeof ManagementImpersonatepagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/materials/(pages)/': {
      id: '/management/materials/(pages)/'
      path: '/materials'
      fullPath: '/management/materials/'
      preLoaderRoute: typeof ManagementMaterialspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/origins/(pages)/': {
      id: '/management/origins/(pages)/'
      path: '/origins'
      fullPath: '/management/origins/'
      preLoaderRoute: typeof ManagementOriginspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/permissions/(pages)/': {
      id: '/management/permissions/(pages)/'
      path: '/permissions'
      fullPath: '/management/permissions/'
      preLoaderRoute: typeof ManagementPermissionspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/platform-features/(pages)/': {
      id: '/management/platform-features/(pages)/'
      path: '/platform-features'
      fullPath: '/management/platform-features/'
      preLoaderRoute: typeof ManagementPlatformFeaturespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/product-categories/(pages)/': {
      id: '/management/product-categories/(pages)/'
      path: '/product-categories'
      fullPath: '/management/product-categories/'
      preLoaderRoute: typeof ManagementProductCategoriespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/product-data-points/(pages)/': {
      id: '/management/product-data-points/(pages)/'
      path: '/product-data-points'
      fullPath: '/management/product-data-points/'
      preLoaderRoute: typeof ManagementProductDataPointspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/production-processes/(pages)/': {
      id: '/management/production-processes/(pages)/'
      path: '/production-processes'
      fullPath: '/management/production-processes/'
      preLoaderRoute: typeof ManagementProductionProcessespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/risk-management/(pages)/(list)': {
      id: '/management/risk-management/(pages)/(list)'
      path: ''
      fullPath: '/management/risk-management'
      preLoaderRoute: typeof ManagementRiskManagementpageslistRouteRouteImport
      parentRoute: typeof ManagementRiskManagementpagesRouteRoute
    }
    '/management/rules/(pages)/': {
      id: '/management/rules/(pages)/'
      path: '/rules'
      fullPath: '/management/rules/'
      preLoaderRoute: typeof ManagementRulespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/scoring-templates/(pages)/(list)': {
      id: '/management/scoring-templates/(pages)/(list)'
      path: '/scoring-templates'
      fullPath: '/management/scoring-templates'
      preLoaderRoute: typeof ManagementScoringTemplatespageslistRouteRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/slcp-dashboard/(pages)/': {
      id: '/management/slcp-dashboard/(pages)/'
      path: '/slcp-dashboard'
      fullPath: '/management/slcp-dashboard/'
      preLoaderRoute: typeof ManagementSlcpDashboardpagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/sso/(pages)/': {
      id: '/management/sso/(pages)/'
      path: '/sso'
      fullPath: '/management/sso/'
      preLoaderRoute: typeof ManagementSsopagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/standards/(pages)/': {
      id: '/management/standards/(pages)/'
      path: '/standards'
      fullPath: '/management/standards/'
      preLoaderRoute: typeof ManagementStandardspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/supplier-questionnaire-templates/(pages)/': {
      id: '/management/supplier-questionnaire-templates/(pages)/'
      path: '/supplier-questionnaire-templates'
      fullPath: '/management/supplier-questionnaire-templates/'
      preLoaderRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/translations/(pages)/': {
      id: '/management/translations/(pages)/'
      path: '/translations'
      fullPath: '/management/translations/'
      preLoaderRoute: typeof ManagementTranslationspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/users/(pages)/': {
      id: '/management/users/(pages)/'
      path: '/users'
      fullPath: '/management/users/'
      preLoaderRoute: typeof ManagementUserspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/webshops/(pages)/': {
      id: '/management/webshops/(pages)/'
      path: '/webshops'
      fullPath: '/management/webshops/'
      preLoaderRoute: typeof ManagementWebshopspagesIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/onboarding/company-search/(pages)/': {
      id: '/onboarding/company-search/(pages)/'
      path: '/onboarding/company-search'
      fullPath: '/onboarding/company-search/'
      preLoaderRoute: typeof OnboardingCompanySearchpagesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-onboarding/(pages)/$token/': {
      id: '/sso-onboarding/(pages)/$token/'
      path: '/sso-onboarding/$token'
      fullPath: '/sso-onboarding/$token/'
      preLoaderRoute: typeof SsoOnboardingpagesTokenIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sso-onboarding/(pages)/test-result/': {
      id: '/sso-onboarding/(pages)/test-result/'
      path: '/sso-onboarding/test-result'
      fullPath: '/sso-onboarding/test-result/'
      preLoaderRoute: typeof SsoOnboardingpagesTestResultIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(client)/audits/(pages)/(detail)/$auditId': {
      id: '/(client)/audits/(pages)/(detail)/$auditId'
      path: '/$auditId'
      fullPath: '/audits/$auditId'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdRouteRouteImport
      parentRoute: typeof clientAuditsRouteRoute
    }
    '/(client)/audits/(pages)/(list)/audits-for-company': {
      id: '/(client)/audits/(pages)/(list)/audits-for-company'
      path: '/audits-for-company'
      fullPath: '/audits/audits-for-company'
      preLoaderRoute: typeof clientAuditspageslistAuditsForCompanyRouteRouteImport
      parentRoute: typeof clientAuditspageslistRouteRoute
    }
    '/(client)/audits/(pages)/(list)/network-audits': {
      id: '/(client)/audits/(pages)/(list)/network-audits'
      path: '/network-audits'
      fullPath: '/audits/network-audits'
      preLoaderRoute: typeof clientAuditspageslistNetworkAuditsRouteRouteImport
      parentRoute: typeof clientAuditspageslistRouteRoute
    }
    '/(client)/capa/(pages)/(list)/actions': {
      id: '/(client)/capa/(pages)/(list)/actions'
      path: '/actions'
      fullPath: '/capa/actions'
      preLoaderRoute: typeof clientCapapageslistActionsRouteRouteImport
      parentRoute: typeof clientCapapageslistRouteRoute
    }
    '/(client)/capa/(pages)/(list)/findings': {
      id: '/(client)/capa/(pages)/(list)/findings'
      path: '/findings'
      fullPath: '/capa/findings'
      preLoaderRoute: typeof clientCapapageslistFindingsRouteRouteImport
      parentRoute: typeof clientCapapageslistRouteRoute
    }
    '/(client)/capa/(pages)/(list)/plans': {
      id: '/(client)/capa/(pages)/(list)/plans'
      path: '/plans'
      fullPath: '/capa/plans'
      preLoaderRoute: typeof clientCapapageslistPlansRouteRouteImport
      parentRoute: typeof clientCapapageslistRouteRoute
    }
    '/(client)/certifications/(pages)/$id/': {
      id: '/(client)/certifications/(pages)/$id/'
      path: '/$id'
      fullPath: '/certifications/$id/'
      preLoaderRoute: typeof clientCertificationspagesIdIndexRouteImport
      parentRoute: typeof clientCertificationspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/integrations/': {
      id: '/(client)/company-settings/(pages)/integrations/'
      path: '/'
      fullPath: '/company-settings/integrations/'
      preLoaderRoute: typeof clientCompanySettingspagesIntegrationsIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesIntegrationsRouteRoute
    }
    '/(client)/company-settings/(pages)/permission-sets/': {
      id: '/(client)/company-settings/(pages)/permission-sets/'
      path: '/permission-sets'
      fullPath: '/company-settings/permission-sets/'
      preLoaderRoute: typeof clientCompanySettingspagesPermissionSetsIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/permission-sets/new': {
      id: '/(client)/company-settings/(pages)/permission-sets/new'
      path: '/permission-sets/new'
      fullPath: '/company-settings/permission-sets/new'
      preLoaderRoute: typeof clientCompanySettingspagesPermissionSetsNewRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/files/(pages)/(list)/': {
      id: '/(client)/files/(pages)/(list)/'
      path: '/'
      fullPath: '/files/'
      preLoaderRoute: typeof clientFilespageslistIndexRouteImport
      parentRoute: typeof clientFilesRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-skus': {
      id: '/(client)/my-components/(pages)/(list)/component-skus'
      path: '/component-skus'
      fullPath: '/my-components/component-skus'
      preLoaderRoute: typeof clientMyComponentspageslistComponentSkusRouteRouteImport
      parentRoute: typeof clientMyComponentspageslistRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-variants': {
      id: '/(client)/my-components/(pages)/(list)/component-variants'
      path: '/component-variants'
      fullPath: '/my-components/component-variants'
      preLoaderRoute: typeof clientMyComponentspageslistComponentVariantsRouteRouteImport
      parentRoute: typeof clientMyComponentspageslistRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/components': {
      id: '/(client)/my-components/(pages)/(list)/components'
      path: '/components'
      fullPath: '/my-components/components'
      preLoaderRoute: typeof clientMyComponentspageslistComponentsRouteRouteImport
      parentRoute: typeof clientMyComponentspageslistRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/skus': {
      id: '/(client)/my-styles/(pages)/(list)/skus'
      path: '/skus'
      fullPath: '/my-styles/skus'
      preLoaderRoute: typeof clientMyStylespageslistSkusRouteRouteImport
      parentRoute: typeof clientMyStylespageslistRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/styles': {
      id: '/(client)/my-styles/(pages)/(list)/styles'
      path: '/styles'
      fullPath: '/my-styles/styles'
      preLoaderRoute: typeof clientMyStylespageslistStylesRouteRouteImport
      parentRoute: typeof clientMyStylespageslistRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/variants': {
      id: '/(client)/my-styles/(pages)/(list)/variants'
      path: '/variants'
      fullPath: '/my-styles/variants'
      preLoaderRoute: typeof clientMyStylespageslistVariantsRouteRouteImport
      parentRoute: typeof clientMyStylespageslistRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId': {
      id: '/(client)/network/(pages)/(detail)/$companyId'
      path: '/$companyId'
      fullPath: '/network/$companyId'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdRouteRouteImport
      parentRoute: typeof clientNetworkpagesdetailRouteRoute
    }
    '/(client)/orders-hub/(pages)/(detail)/$id': {
      id: '/(client)/orders-hub/(pages)/(detail)/$id'
      path: '/orders-hub/$id'
      fullPath: '/orders-hub/$id'
      preLoaderRoute: typeof clientOrdersHubpagesdetailIdRouteRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/(client)/orders/(pages)/(list)/internal-orders': {
      id: '/(client)/orders/(pages)/(list)/internal-orders'
      path: '/internal-orders'
      fullPath: '/orders/internal-orders'
      preLoaderRoute: typeof clientOrderspageslistInternalOrdersRouteRouteImport
      parentRoute: typeof clientOrderspageslistRouteRoute
    }
    '/(client)/orders/(pages)/(list)/purchase-orders': {
      id: '/(client)/orders/(pages)/(list)/purchase-orders'
      path: '/purchase-orders'
      fullPath: '/orders/purchase-orders'
      preLoaderRoute: typeof clientOrderspageslistPurchaseOrdersRouteRouteImport
      parentRoute: typeof clientOrderspageslistRouteRoute
    }
    '/(client)/orders/(pages)/(list)/sales-orders': {
      id: '/(client)/orders/(pages)/(list)/sales-orders'
      path: '/sales-orders'
      fullPath: '/orders/sales-orders'
      preLoaderRoute: typeof clientOrderspageslistSalesOrdersRouteRouteImport
      parentRoute: typeof clientOrderspageslistRouteRoute
    }
    '/(client)/orders/(pages)/attachment-templates/': {
      id: '/(client)/orders/(pages)/attachment-templates/'
      path: '/attachment-templates'
      fullPath: '/orders/attachment-templates/'
      preLoaderRoute: typeof clientOrderspagesAttachmentTemplatesIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/profile/(pages)/overview/': {
      id: '/(client)/profile/(pages)/overview/'
      path: '/overview'
      fullPath: '/profile/overview/'
      preLoaderRoute: typeof clientProfilepagesOverviewIndexRouteImport
      parentRoute: typeof clientProfilepagesRouteRoute
    }
    '/(client)/profile/(pages)/settings/': {
      id: '/(client)/profile/(pages)/settings/'
      path: '/settings'
      fullPath: '/profile/settings/'
      preLoaderRoute: typeof clientProfilepagesSettingsIndexRouteImport
      parentRoute: typeof clientProfilepagesRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id'
      path: '/$id'
      fullPath: '/questionnaires/$id'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdRouteRouteImport
      parentRoute: typeof clientQuestionnairespagesRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)/my-questionnaires': {
      id: '/(client)/questionnaires/(pages)/(list)/my-questionnaires'
      path: '/my-questionnaires'
      fullPath: '/questionnaires/my-questionnaires'
      preLoaderRoute: typeof clientQuestionnairespageslistMyQuestionnairesRouteRouteImport
      parentRoute: typeof clientQuestionnairespageslistRouteRoute
    }
    '/(client)/risk/(pages)/(detail)/assessments': {
      id: '/(client)/risk/(pages)/(detail)/assessments'
      path: '/assessments'
      fullPath: '/risk/assessments'
      preLoaderRoute: typeof clientRiskpagesdetailAssessmentsRouteRouteImport
      parentRoute: typeof clientRiskpagesdetailRouteRoute
    }
    '/(client)/slcp/(pages)/(list)/my-own': {
      id: '/(client)/slcp/(pages)/(list)/my-own'
      path: '/my-own'
      fullPath: '/slcp/my-own'
      preLoaderRoute: typeof clientSlcppageslistMyOwnRouteRouteImport
      parentRoute: typeof clientSlcppageslistRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/insights': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/insights'
      path: '/insights'
      fullPath: '/supply-chain-mapping/insights'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains'
      path: '/supply-chains'
      fullPath: '/supply-chain-mapping/supply-chains'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistSupplyChainsRouteRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistRouteRoute
    }
    '/(client)/users/(pages)/$id/': {
      id: '/(client)/users/(pages)/$id/'
      path: '/users/$id'
      fullPath: '/users/$id/'
      preLoaderRoute: typeof clientUserspagesIdIndexRouteImport
      parentRoute: typeof clientRouteRoute
    }
    '/management/attachment-templates/(pages)/$id/': {
      id: '/management/attachment-templates/(pages)/$id/'
      path: '/attachment-templates/$id'
      fullPath: '/management/attachment-templates/$id/'
      preLoaderRoute: typeof ManagementAttachmentTemplatespagesIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/attachment-templates/(pages)/create/': {
      id: '/management/attachment-templates/(pages)/create/'
      path: '/attachment-templates/create'
      fullPath: '/management/attachment-templates/create/'
      preLoaderRoute: typeof ManagementAttachmentTemplatespagesCreateIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/certifications/(pages)/$id/': {
      id: '/management/certifications/(pages)/$id/'
      path: '/certifications/$id'
      fullPath: '/management/certifications/$id/'
      preLoaderRoute: typeof ManagementCertificationspagesIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/companies/(pages)/$companyId/': {
      id: '/management/companies/(pages)/$companyId/'
      path: '/'
      fullPath: '/management/companies/$companyId/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/company-merges/(pages)/$mergeId/': {
      id: '/management/company-merges/(pages)/$mergeId/'
      path: '/company-merges/$mergeId'
      fullPath: '/management/company-merges/$mergeId/'
      preLoaderRoute: typeof ManagementCompanyMergespagesMergeIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/company-merges/(pages)/new/': {
      id: '/management/company-merges/(pages)/new/'
      path: '/company-merges/new'
      fullPath: '/management/company-merges/new/'
      preLoaderRoute: typeof ManagementCompanyMergespagesNewIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/entity-history/(pages)/$id/': {
      id: '/management/entity-history/(pages)/$id/'
      path: '/entity-history/$id'
      fullPath: '/management/entity-history/$id/'
      preLoaderRoute: typeof ManagementEntityHistorypagesIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/platform-features/(pages)/$featureId/': {
      id: '/management/platform-features/(pages)/$featureId/'
      path: '/platform-features/$featureId'
      fullPath: '/management/platform-features/$featureId/'
      preLoaderRoute: typeof ManagementPlatformFeaturespagesFeatureIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/scoring-templates/(pages)/(list)/': {
      id: '/management/scoring-templates/(pages)/(list)/'
      path: '/'
      fullPath: '/management/scoring-templates/'
      preLoaderRoute: typeof ManagementScoringTemplatespageslistIndexRouteImport
      parentRoute: typeof ManagementScoringTemplatespageslistRouteRoute
    }
    '/management/sso/(pages)/$id/': {
      id: '/management/sso/(pages)/$id/'
      path: '/sso/$id'
      fullPath: '/management/sso/$id/'
      preLoaderRoute: typeof ManagementSsopagesIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/users/(pages)/$id/': {
      id: '/management/users/(pages)/$id/'
      path: '/users/$id'
      fullPath: '/management/users/$id/'
      preLoaderRoute: typeof ManagementUserspagesIdIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/'
      path: '/'
      fullPath: '/audits/$auditId/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/company-settings/(pages)/constants-mapping/facility-processes/': {
      id: '/(client)/company-settings/(pages)/constants-mapping/facility-processes/'
      path: '/facility-processes'
      fullPath: '/company-settings/constants-mapping/facility-processes/'
      preLoaderRoute: typeof clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesConstantsMappingRouteRoute
    }
    '/(client)/company-settings/(pages)/constants-mapping/materials/': {
      id: '/(client)/company-settings/(pages)/constants-mapping/materials/'
      path: '/materials'
      fullPath: '/company-settings/constants-mapping/materials/'
      preLoaderRoute: typeof clientCompanySettingspagesConstantsMappingMaterialsIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesConstantsMappingRouteRoute
    }
    '/(client)/company-settings/(pages)/constants-mapping/product-types/': {
      id: '/(client)/company-settings/(pages)/constants-mapping/product-types/'
      path: '/product-types'
      fullPath: '/company-settings/constants-mapping/product-types/'
      preLoaderRoute: typeof clientCompanySettingspagesConstantsMappingProductTypesIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesConstantsMappingRouteRoute
    }
    '/(client)/company-settings/(pages)/permission-sets/$setKey/': {
      id: '/(client)/company-settings/(pages)/permission-sets/$setKey/'
      path: '/permission-sets/$setKey'
      fullPath: '/company-settings/permission-sets/$setKey/'
      preLoaderRoute: typeof clientCompanySettingspagesPermissionSetsSetKeyIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/company-settings/(pages)/permission-sets/$setKey/edit': {
      id: '/(client)/company-settings/(pages)/permission-sets/$setKey/edit'
      path: '/permission-sets/$setKey/edit'
      fullPath: '/company-settings/permission-sets/$setKey/edit'
      preLoaderRoute: typeof clientCompanySettingspagesPermissionSetsSetKeyEditRouteImport
      parentRoute: typeof clientCompanySettingspagesRouteRoute
    }
    '/(client)/documents/(pages)/(list)/archived/': {
      id: '/(client)/documents/(pages)/(list)/archived/'
      path: '/archived'
      fullPath: '/documents/archived/'
      preLoaderRoute: typeof clientDocumentspageslistArchivedIndexRouteImport
      parentRoute: typeof clientDocumentspageslistRouteRoute
    }
    '/(client)/documents/(pages)/(list)/my-documents/': {
      id: '/(client)/documents/(pages)/(list)/my-documents/'
      path: '/my-documents'
      fullPath: '/documents/my-documents/'
      preLoaderRoute: typeof clientDocumentspageslistMyDocumentsIndexRouteImport
      parentRoute: typeof clientDocumentspageslistRouteRoute
    }
    '/(client)/documents/(pages)/(list)/request-access/': {
      id: '/(client)/documents/(pages)/(list)/request-access/'
      path: '/request-access'
      fullPath: '/documents/request-access/'
      preLoaderRoute: typeof clientDocumentspageslistRequestAccessIndexRouteImport
      parentRoute: typeof clientDocumentspageslistRouteRoute
    }
    '/(client)/entity-screening/(pages)/involved-orders/$companyId/': {
      id: '/(client)/entity-screening/(pages)/involved-orders/$companyId/'
      path: '/involved-orders/$companyId'
      fullPath: '/entity-screening/involved-orders/$companyId/'
      preLoaderRoute: typeof clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRouteImport
      parentRoute: typeof clientEntityScreeningRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id'
      path: '/$kind/$id'
      fullPath: '/my-components/$kind/$id'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdRouteRouteImport
      parentRoute: typeof clientMyComponentspagesdetailRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id'
      path: '/$kind/$id'
      fullPath: '/my-styles/$kind/$id'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdRouteRouteImport
      parentRoute: typeof clientMyStylespagesdetailRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/styles-created-for-me/': {
      id: '/(client)/my-styles/(pages)/(list)/styles-created-for-me/'
      path: '/styles-created-for-me'
      fullPath: '/my-styles/styles-created-for-me/'
      preLoaderRoute: typeof clientMyStylespageslistStylesCreatedForMeIndexRouteImport
      parentRoute: typeof clientMyStylespageslistRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/badges': {
      id: '/(client)/network/(pages)/(detail)/$companyId/badges'
      path: '/badges'
      fullPath: '/network/$companyId/badges'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdBadgesRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/capa': {
      id: '/(client)/network/(pages)/(detail)/$companyId/capa'
      path: '/capa'
      fullPath: '/network/$companyId/capa'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdCapaRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/claims': {
      id: '/(client)/network/(pages)/(detail)/$companyId/claims'
      path: '/claims'
      fullPath: '/network/$companyId/claims'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdClaimsRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/custom-information': {
      id: '/(client)/network/(pages)/(detail)/$companyId/custom-information'
      path: '/custom-information'
      fullPath: '/network/$companyId/custom-information'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdCustomInformationRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/custom-information-fields': {
      id: '/(client)/network/(pages)/(detail)/$companyId/custom-information-fields'
      path: '/custom-information-fields'
      fullPath: '/network/$companyId/custom-information-fields'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdCustomInformationFieldsRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/documents': {
      id: '/(client)/network/(pages)/(detail)/$companyId/documents'
      path: '/documents'
      fullPath: '/network/$companyId/documents'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdDocumentsRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/esg-info': {
      id: '/(client)/network/(pages)/(detail)/$companyId/esg-info'
      path: '/esg-info'
      fullPath: '/network/$companyId/esg-info'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdEsgInfoRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/general-info': {
      id: '/(client)/network/(pages)/(detail)/$companyId/general-info'
      path: '/general-info'
      fullPath: '/network/$companyId/general-info'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdGeneralInfoRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/history': {
      id: '/(client)/network/(pages)/(detail)/$companyId/history'
      path: '/history'
      fullPath: '/network/$companyId/history'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdHistoryRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/integrations': {
      id: '/(client)/network/(pages)/(detail)/$companyId/integrations'
      path: '/integrations'
      fullPath: '/network/$companyId/integrations'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/products': {
      id: '/(client)/network/(pages)/(detail)/$companyId/products'
      path: '/products'
      fullPath: '/network/$companyId/products'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdProductsRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/questionnaire': {
      id: '/(client)/network/(pages)/(detail)/$companyId/questionnaire'
      path: '/questionnaire'
      fullPath: '/network/$companyId/questionnaire'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdQuestionnaireRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/risk-profile': {
      id: '/(client)/network/(pages)/(detail)/$companyId/risk-profile'
      path: '/risk-profile'
      fullPath: '/network/$companyId/risk-profile'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdRiskProfileRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/slcp': {
      id: '/(client)/network/(pages)/(detail)/$companyId/slcp'
      path: '/slcp'
      fullPath: '/network/$companyId/slcp'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdSlcpRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/users': {
      id: '/(client)/network/(pages)/(detail)/$companyId/users'
      path: '/users'
      fullPath: '/network/$companyId/users'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdUsersRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/webshop-profile': {
      id: '/(client)/network/(pages)/(detail)/$companyId/webshop-profile'
      path: '/webshop-profile'
      fullPath: '/network/$companyId/webshop-profile'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdWebshopProfileRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(list)/my-network/': {
      id: '/(client)/network/(pages)/(list)/my-network/'
      path: '/my-network'
      fullPath: '/network/my-network/'
      preLoaderRoute: typeof clientNetworkpageslistMyNetworkIndexRouteImport
      parentRoute: typeof clientNetworkpageslistRouteRoute
    }
    '/(client)/orders-hub/(pages)/(detail)/$id/attachments': {
      id: '/(client)/orders-hub/(pages)/(detail)/$id/attachments'
      path: '/attachments'
      fullPath: '/orders-hub/$id/attachments'
      preLoaderRoute: typeof clientOrdersHubpagesdetailIdAttachmentsRouteImport
      parentRoute: typeof clientOrdersHubpagesdetailIdRouteRoute
    }
    '/(client)/orders-hub/(pages)/(detail)/$id/lines': {
      id: '/(client)/orders-hub/(pages)/(detail)/$id/lines'
      path: '/lines'
      fullPath: '/orders-hub/$id/lines'
      preLoaderRoute: typeof clientOrdersHubpagesdetailIdLinesRouteImport
      parentRoute: typeof clientOrdersHubpagesdetailIdRouteRoute
    }
    '/(client)/orders-hub/(pages)/(detail)/$id/overview': {
      id: '/(client)/orders-hub/(pages)/(detail)/$id/overview'
      path: '/overview'
      fullPath: '/orders-hub/$id/overview'
      preLoaderRoute: typeof clientOrdersHubpagesdetailIdOverviewRouteImport
      parentRoute: typeof clientOrdersHubpagesdetailIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/internal-orders/$ioId': {
      id: '/(client)/orders/(pages)/(detail)/internal-orders/$ioId'
      path: '/internal-orders/$ioId'
      fullPath: '/orders/internal-orders/$ioId'
      preLoaderRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/purchase-orders/$poId': {
      id: '/(client)/orders/(pages)/(detail)/purchase-orders/$poId'
      path: '/purchase-orders/$poId'
      fullPath: '/orders/purchase-orders/$poId'
      preLoaderRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/sales-orders/$soId': {
      id: '/(client)/orders/(pages)/(detail)/sales-orders/$soId'
      path: '/sales-orders/$soId'
      fullPath: '/orders/sales-orders/$soId'
      preLoaderRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/attachment-templates/$id/': {
      id: '/(client)/orders/(pages)/attachment-templates/$id/'
      path: '/attachment-templates/$id'
      fullPath: '/orders/attachment-templates/$id/'
      preLoaderRoute: typeof clientOrderspagesAttachmentTemplatesIdIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/attachment-templates/create/': {
      id: '/(client)/orders/(pages)/attachment-templates/create/'
      path: '/attachment-templates/create'
      fullPath: '/orders/attachment-templates/create/'
      preLoaderRoute: typeof clientOrderspagesAttachmentTemplatesCreateIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/product-mapping/(pages)/(details)/$cpmId/': {
      id: '/(client)/product-mapping/(pages)/(details)/$cpmId/'
      path: '/$cpmId'
      fullPath: '/product-mapping/$cpmId/'
      preLoaderRoute: typeof clientProductMappingpagesdetailsCpmIdIndexRouteImport
      parentRoute: typeof clientProductMappingRouteRoute
    }
    '/(client)/product-mapping/(pages)/(list)/active/': {
      id: '/(client)/product-mapping/(pages)/(list)/active/'
      path: '/active'
      fullPath: '/product-mapping/active/'
      preLoaderRoute: typeof clientProductMappingpageslistActiveIndexRouteImport
      parentRoute: typeof clientProductMappingpageslistRouteRoute
    }
    '/(client)/product-mapping/(pages)/(list)/archive/': {
      id: '/(client)/product-mapping/(pages)/(list)/archive/'
      path: '/archive'
      fullPath: '/product-mapping/archive/'
      preLoaderRoute: typeof clientProductMappingpageslistArchiveIndexRouteImport
      parentRoute: typeof clientProductMappingpageslistRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)/requests/': {
      id: '/(client)/questionnaires/(pages)/(list)/requests/'
      path: '/requests'
      fullPath: '/questionnaires/requests/'
      preLoaderRoute: typeof clientQuestionnairespageslistRequestsIndexRouteImport
      parentRoute: typeof clientQuestionnairespageslistRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)/templates/': {
      id: '/(client)/questionnaires/(pages)/(list)/templates/'
      path: '/templates'
      fullPath: '/questionnaires/templates/'
      preLoaderRoute: typeof clientQuestionnairespageslistTemplatesIndexRouteImport
      parentRoute: typeof clientQuestionnairespageslistRouteRoute
    }
    '/(client)/report/(pages)/(analytics)/audit-compliance/': {
      id: '/(client)/report/(pages)/(analytics)/audit-compliance/'
      path: '/audit-compliance'
      fullPath: '/report/audit-compliance/'
      preLoaderRoute: typeof clientReportpagesanalyticsAuditComplianceIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/report/(pages)/(analytics)/certificate-compliance/': {
      id: '/(client)/report/(pages)/(analytics)/certificate-compliance/'
      path: '/certificate-compliance'
      fullPath: '/report/certificate-compliance/'
      preLoaderRoute: typeof clientReportpagesanalyticsCertificateComplianceIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/report/(pages)/(analytics)/tracing-compliance/': {
      id: '/(client)/report/(pages)/(analytics)/tracing-compliance/'
      path: '/tracing-compliance'
      fullPath: '/report/tracing-compliance/'
      preLoaderRoute: typeof clientReportpagesanalyticsTracingComplianceIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/report/(pages)/(analytics)/tracing-operations/': {
      id: '/(client)/report/(pages)/(analytics)/tracing-operations/'
      path: '/tracing-operations'
      fullPath: '/report/tracing-operations/'
      preLoaderRoute: typeof clientReportpagesanalyticsTracingOperationsIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/risk/(pages)/(list)/assessments/': {
      id: '/(client)/risk/(pages)/(list)/assessments/'
      path: '/assessments'
      fullPath: '/risk/assessments/'
      preLoaderRoute: typeof clientRiskpageslistAssessmentsIndexRouteImport
      parentRoute: typeof clientRiskpageslistRouteRoute
    }
    '/(client)/risk/(pages)/(list)/landscape/': {
      id: '/(client)/risk/(pages)/(list)/landscape/'
      path: '/landscape'
      fullPath: '/risk/landscape/'
      preLoaderRoute: typeof clientRiskpageslistLandscapeIndexRouteImport
      parentRoute: typeof clientRiskpageslistRouteRoute
    }
    '/(client)/risk/(pages)/(list)/rules/': {
      id: '/(client)/risk/(pages)/(list)/rules/'
      path: '/rules'
      fullPath: '/risk/rules/'
      preLoaderRoute: typeof clientRiskpageslistRulesIndexRouteImport
      parentRoute: typeof clientRiskpageslistRouteRoute
    }
    '/(client)/slcp/(pages)/(list)/network/': {
      id: '/(client)/slcp/(pages)/(list)/network/'
      path: '/network'
      fullPath: '/slcp/network/'
      preLoaderRoute: typeof clientSlcppageslistNetworkIndexRouteImport
      parentRoute: typeof clientSlcppageslistRouteRoute
    }
    '/(client)/slcp/(pages)/assessments/(details)/$assessmentId': {
      id: '/(client)/slcp/(pages)/assessments/(details)/$assessmentId'
      path: '/assessments/$assessmentId'
      fullPath: '/slcp/assessments/$assessmentId'
      preLoaderRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteImport
      parentRoute: typeof clientSlcppagesRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id': {
      id: '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id'
      path: '/supply-chains/$id'
      fullPath: '/supply-chain-mapping/supply-chains/$id'
      preLoaderRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteImport
      parentRoute: typeof clientSupplyChainMappingRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/history/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/history/'
      path: '/history'
      fullPath: '/supply-chain-mapping/history/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistHistoryIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistRouteRoute
    }
    '/management/attachment-templates/(pages)/$id/edit/': {
      id: '/management/attachment-templates/(pages)/$id/edit/'
      path: '/attachment-templates/$id/edit'
      fullPath: '/management/attachment-templates/$id/edit/'
      preLoaderRoute: typeof ManagementAttachmentTemplatespagesIdEditIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/certifications/(pages)/(list)/active/': {
      id: '/management/certifications/(pages)/(list)/active/'
      path: '/active'
      fullPath: '/management/certifications/active/'
      preLoaderRoute: typeof ManagementCertificationspageslistActiveIndexRouteImport
      parentRoute: typeof ManagementCertificationspageslistRouteRoute
    }
    '/management/certifications/(pages)/(list)/archived/': {
      id: '/management/certifications/(pages)/(list)/archived/'
      path: '/archived'
      fullPath: '/management/certifications/archived/'
      preLoaderRoute: typeof ManagementCertificationspageslistArchivedIndexRouteImport
      parentRoute: typeof ManagementCertificationspageslistRouteRoute
    }
    '/management/companies/(pages)/$companyId/api-keys/': {
      id: '/management/companies/(pages)/$companyId/api-keys/'
      path: '/api-keys'
      fullPath: '/management/companies/$companyId/api-keys/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdApiKeysIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/automation-rules/': {
      id: '/management/companies/(pages)/$companyId/automation-rules/'
      path: '/automation-rules'
      fullPath: '/management/companies/$companyId/automation-rules/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdAutomationRulesIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/credits/': {
      id: '/management/companies/(pages)/$companyId/credits/'
      path: '/credits'
      fullPath: '/management/companies/$companyId/credits/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdCreditsIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/employees/': {
      id: '/management/companies/(pages)/$companyId/employees/'
      path: '/employees'
      fullPath: '/management/companies/$companyId/employees/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdEmployeesIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/general-info/': {
      id: '/management/companies/(pages)/$companyId/general-info/'
      path: '/general-info'
      fullPath: '/management/companies/$companyId/general-info/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdGeneralInfoIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/network/': {
      id: '/management/companies/(pages)/$companyId/network/'
      path: '/network'
      fullPath: '/management/companies/$companyId/network/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdNetworkIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/platform-features/': {
      id: '/management/companies/(pages)/$companyId/platform-features/'
      path: '/platform-features'
      fullPath: '/management/companies/$companyId/platform-features/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/supply-chains/': {
      id: '/management/companies/(pages)/$companyId/supply-chains/'
      path: '/supply-chains'
      fullPath: '/management/companies/$companyId/supply-chains/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdSupplyChainsIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/tech-insights/': {
      id: '/management/companies/(pages)/$companyId/tech-insights/'
      path: '/tech-insights'
      fullPath: '/management/companies/$companyId/tech-insights/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdTechInsightsIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/companies/(pages)/$companyId/tracing-orders/': {
      id: '/management/companies/(pages)/$companyId/tracing-orders/'
      path: '/tracing-orders'
      fullPath: '/management/companies/$companyId/tracing-orders/'
      preLoaderRoute: typeof ManagementCompaniespagesCompanyIdTracingOrdersIndexRouteImport
      parentRoute: typeof ManagementCompaniespagesCompanyIdRouteRoute
    }
    '/management/documents/(pages)/(list)/active/': {
      id: '/management/documents/(pages)/(list)/active/'
      path: '/active'
      fullPath: '/management/documents/active/'
      preLoaderRoute: typeof ManagementDocumentspageslistActiveIndexRouteImport
      parentRoute: typeof ManagementDocumentspageslistRouteRoute
    }
    '/management/documents/(pages)/(list)/archived/': {
      id: '/management/documents/(pages)/(list)/archived/'
      path: '/archived'
      fullPath: '/management/documents/archived/'
      preLoaderRoute: typeof ManagementDocumentspageslistArchivedIndexRouteImport
      parentRoute: typeof ManagementDocumentspageslistRouteRoute
    }
    '/management/product-categories/(pages)/$categoryId/fields/': {
      id: '/management/product-categories/(pages)/$categoryId/fields/'
      path: '/product-categories/$categoryId/fields'
      fullPath: '/management/product-categories/$categoryId/fields/'
      preLoaderRoute: typeof ManagementProductCategoriespagesCategoryIdFieldsIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/risk-management/(pages)/(list)/risk-gross/': {
      id: '/management/risk-management/(pages)/(list)/risk-gross/'
      path: '/risk-gross'
      fullPath: '/management/risk-management/risk-gross/'
      preLoaderRoute: typeof ManagementRiskManagementpageslistRiskGrossIndexRouteImport
      parentRoute: typeof ManagementRiskManagementpageslistRouteRoute
    }
    '/management/risk-management/(pages)/(list)/risks/': {
      id: '/management/risk-management/(pages)/(list)/risks/'
      path: '/risks'
      fullPath: '/management/risk-management/risks/'
      preLoaderRoute: typeof ManagementRiskManagementpageslistRisksIndexRouteImport
      parentRoute: typeof ManagementRiskManagementpageslistRouteRoute
    }
    '/management/risk-management/(pages)/(list)/rule-templates/': {
      id: '/management/risk-management/(pages)/(list)/rule-templates/'
      path: '/rule-templates'
      fullPath: '/management/risk-management/rule-templates/'
      preLoaderRoute: typeof ManagementRiskManagementpageslistRuleTemplatesIndexRouteImport
      parentRoute: typeof ManagementRiskManagementpageslistRouteRoute
    }
    '/management/scoring-templates/(pages)/$id/edit/': {
      id: '/management/scoring-templates/(pages)/$id/edit/'
      path: '/scoring-templates/$id/edit'
      fullPath: '/management/scoring-templates/$id/edit/'
      preLoaderRoute: typeof ManagementScoringTemplatespagesIdEditIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/scoring-templates/(pages)/(list)/gaps/': {
      id: '/management/scoring-templates/(pages)/(list)/gaps/'
      path: '/gaps'
      fullPath: '/management/scoring-templates/gaps/'
      preLoaderRoute: typeof ManagementScoringTemplatespageslistGapsIndexRouteImport
      parentRoute: typeof ManagementScoringTemplatespageslistRouteRoute
    }
    '/management/supplier-questionnaire-templates/(pages)/$id/edit/': {
      id: '/management/supplier-questionnaire-templates/(pages)/$id/edit/'
      path: '/supplier-questionnaire-templates/$id/edit'
      fullPath: '/management/supplier-questionnaire-templates/$id/edit/'
      preLoaderRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/management/supplier-questionnaire-templates/(pages)/$id/preview/': {
      id: '/management/supplier-questionnaire-templates/(pages)/$id/preview/'
      path: '/supplier-questionnaire-templates/$id/preview'
      fullPath: '/management/supplier-questionnaire-templates/$id/preview/'
      preLoaderRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRouteImport
      parentRoute: typeof ManagementRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/capa/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/capa/'
      path: '/capa'
      fullPath: '/audits/$auditId/capa/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdCapaIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/content/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/content/'
      path: '/content'
      fullPath: '/audits/$auditId/content/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdContentIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/findings/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/findings/'
      path: '/findings'
      fullPath: '/audits/$auditId/findings/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdFindingsIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/overview/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/overview/'
      path: '/overview'
      fullPath: '/audits/$auditId/overview/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdOverviewIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/score/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/score/'
      path: '/score'
      fullPath: '/audits/$auditId/score/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdScoreIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(detail)/$auditId/view/': {
      id: '/(client)/audits/(pages)/(detail)/$auditId/view/'
      path: '/view'
      fullPath: '/audits/$auditId/view/'
      preLoaderRoute: typeof clientAuditspagesdetailAuditIdViewIndexRouteImport
      parentRoute: typeof clientAuditspagesdetailAuditIdRouteRoute
    }
    '/(client)/audits/(pages)/(list)/audits-for-company/active/': {
      id: '/(client)/audits/(pages)/(list)/audits-for-company/active/'
      path: '/active'
      fullPath: '/audits/audits-for-company/active/'
      preLoaderRoute: typeof clientAuditspageslistAuditsForCompanyActiveIndexRouteImport
      parentRoute: typeof clientAuditspageslistAuditsForCompanyRouteRoute
    }
    '/(client)/audits/(pages)/(list)/audits-for-company/archive/': {
      id: '/(client)/audits/(pages)/(list)/audits-for-company/archive/'
      path: '/archive'
      fullPath: '/audits/audits-for-company/archive/'
      preLoaderRoute: typeof clientAuditspageslistAuditsForCompanyArchiveIndexRouteImport
      parentRoute: typeof clientAuditspageslistAuditsForCompanyRouteRoute
    }
    '/(client)/audits/(pages)/(list)/network-audits/active/': {
      id: '/(client)/audits/(pages)/(list)/network-audits/active/'
      path: '/active'
      fullPath: '/audits/network-audits/active/'
      preLoaderRoute: typeof clientAuditspageslistNetworkAuditsActiveIndexRouteImport
      parentRoute: typeof clientAuditspageslistNetworkAuditsRouteRoute
    }
    '/(client)/audits/(pages)/(list)/network-audits/archive/': {
      id: '/(client)/audits/(pages)/(list)/network-audits/archive/'
      path: '/archive'
      fullPath: '/audits/network-audits/archive/'
      preLoaderRoute: typeof clientAuditspageslistNetworkAuditsArchiveIndexRouteImport
      parentRoute: typeof clientAuditspageslistNetworkAuditsRouteRoute
    }
    '/(client)/capa/(pages)/(detail)/actions/$id/': {
      id: '/(client)/capa/(pages)/(detail)/actions/$id/'
      path: '/actions/$id'
      fullPath: '/capa/actions/$id/'
      preLoaderRoute: typeof clientCapapagesdetailActionsIdIndexRouteImport
      parentRoute: typeof clientCapapagesdetailRouteRoute
    }
    '/(client)/capa/(pages)/(detail)/plans/$id/': {
      id: '/(client)/capa/(pages)/(detail)/plans/$id/'
      path: '/plans/$id'
      fullPath: '/capa/plans/$id/'
      preLoaderRoute: typeof clientCapapagesdetailPlansIdIndexRouteImport
      parentRoute: typeof clientCapapagesdetailRouteRoute
    }
    '/(client)/capa/(pages)/(list)/actions/active/': {
      id: '/(client)/capa/(pages)/(list)/actions/active/'
      path: '/active'
      fullPath: '/capa/actions/active/'
      preLoaderRoute: typeof clientCapapageslistActionsActiveIndexRouteImport
      parentRoute: typeof clientCapapageslistActionsRouteRoute
    }
    '/(client)/capa/(pages)/(list)/actions/archived/': {
      id: '/(client)/capa/(pages)/(list)/actions/archived/'
      path: '/archived'
      fullPath: '/capa/actions/archived/'
      preLoaderRoute: typeof clientCapapageslistActionsArchivedIndexRouteImport
      parentRoute: typeof clientCapapageslistActionsRouteRoute
    }
    '/(client)/capa/(pages)/(list)/findings/active/': {
      id: '/(client)/capa/(pages)/(list)/findings/active/'
      path: '/active'
      fullPath: '/capa/findings/active/'
      preLoaderRoute: typeof clientCapapageslistFindingsActiveIndexRouteImport
      parentRoute: typeof clientCapapageslistFindingsRouteRoute
    }
    '/(client)/capa/(pages)/(list)/findings/archived/': {
      id: '/(client)/capa/(pages)/(list)/findings/archived/'
      path: '/archived'
      fullPath: '/capa/findings/archived/'
      preLoaderRoute: typeof clientCapapageslistFindingsArchivedIndexRouteImport
      parentRoute: typeof clientCapapageslistFindingsRouteRoute
    }
    '/(client)/capa/(pages)/(list)/plans/active/': {
      id: '/(client)/capa/(pages)/(list)/plans/active/'
      path: '/active'
      fullPath: '/capa/plans/active/'
      preLoaderRoute: typeof clientCapapageslistPlansActiveIndexRouteImport
      parentRoute: typeof clientCapapageslistPlansRouteRoute
    }
    '/(client)/capa/(pages)/(list)/plans/archived/': {
      id: '/(client)/capa/(pages)/(list)/plans/archived/'
      path: '/archived'
      fullPath: '/capa/plans/archived/'
      preLoaderRoute: typeof clientCapapageslistPlansArchivedIndexRouteImport
      parentRoute: typeof clientCapapageslistPlansRouteRoute
    }
    '/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/': {
      id: '/(client)/company-settings/(pages)/integrations/history/$syncHistoryId/'
      path: '/history/$syncHistoryId'
      fullPath: '/company-settings/integrations/history/$syncHistoryId/'
      preLoaderRoute: typeof clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRouteImport
      parentRoute: typeof clientCompanySettingspagesIntegrationsRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/bom': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/bom'
      path: '/bom'
      fullPath: '/my-components/$kind/$id/bom'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdBomRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/certifications': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/certifications'
      path: '/certifications'
      fullPath: '/my-components/$kind/$id/certifications'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdCertificationsRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/documents': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/documents'
      path: '/documents'
      fullPath: '/my-components/$kind/$id/documents'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdDocumentsRouteRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/materials': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/materials'
      path: '/materials'
      fullPath: '/my-components/$kind/$id/materials'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdMaterialsRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/overview': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/overview'
      path: '/overview'
      fullPath: '/my-components/$kind/$id/overview'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdOverviewRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/qr-code'
      path: '/qr-code'
      fullPath: '/my-components/$kind/$id/qr-code'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdQrCodeRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/skus': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/skus'
      path: '/skus'
      fullPath: '/my-components/$kind/$id/skus'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdSkusRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/supply-chain'
      path: '/supply-chain'
      fullPath: '/my-components/$kind/$id/supply-chain'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdSupplyChainRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/variants': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/variants'
      path: '/variants'
      fullPath: '/my-components/$kind/$id/variants'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdVariantsRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/webshop-preview': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/webshop-preview'
      path: '/webshop-preview'
      fullPath: '/my-components/$kind/$id/webshop-preview'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdWebshopPreviewRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-skus/active/': {
      id: '/(client)/my-components/(pages)/(list)/component-skus/active/'
      path: '/active'
      fullPath: '/my-components/component-skus/active/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentSkusActiveIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentSkusRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-skus/archived/': {
      id: '/(client)/my-components/(pages)/(list)/component-skus/archived/'
      path: '/archived'
      fullPath: '/my-components/component-skus/archived/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentSkusArchivedIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentSkusRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-variants/active/': {
      id: '/(client)/my-components/(pages)/(list)/component-variants/active/'
      path: '/active'
      fullPath: '/my-components/component-variants/active/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentVariantsActiveIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentVariantsRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/component-variants/archived/': {
      id: '/(client)/my-components/(pages)/(list)/component-variants/archived/'
      path: '/archived'
      fullPath: '/my-components/component-variants/archived/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentVariantsArchivedIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentVariantsRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/components/active/': {
      id: '/(client)/my-components/(pages)/(list)/components/active/'
      path: '/active'
      fullPath: '/my-components/components/active/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentsActiveIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentsRouteRoute
    }
    '/(client)/my-components/(pages)/(list)/components/archived/': {
      id: '/(client)/my-components/(pages)/(list)/components/archived/'
      path: '/archived'
      fullPath: '/my-components/components/archived/'
      preLoaderRoute: typeof clientMyComponentspageslistComponentsArchivedIndexRouteImport
      parentRoute: typeof clientMyComponentspageslistComponentsRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/bom': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/bom'
      path: '/bom'
      fullPath: '/my-styles/$kind/$id/bom'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdBomRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/certifications'
      path: '/certifications'
      fullPath: '/my-styles/$kind/$id/certifications'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdCertificationsRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents'
      path: '/documents'
      fullPath: '/my-styles/$kind/$id/documents'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdDocumentsRouteRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/materials': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/materials'
      path: '/materials'
      fullPath: '/my-styles/$kind/$id/materials'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdMaterialsRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/overview': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/overview'
      path: '/overview'
      fullPath: '/my-styles/$kind/$id/overview'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdOverviewRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/qr-code'
      path: '/qr-code'
      fullPath: '/my-styles/$kind/$id/qr-code'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdQrCodeRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/skus': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/skus'
      path: '/skus'
      fullPath: '/my-styles/$kind/$id/skus'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdSkusRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/supply-chain'
      path: '/supply-chain'
      fullPath: '/my-styles/$kind/$id/supply-chain'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdSupplyChainRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/variants': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/variants'
      path: '/variants'
      fullPath: '/my-styles/$kind/$id/variants'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdVariantsRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/webshop-preview'
      path: '/webshop-preview'
      fullPath: '/my-styles/$kind/$id/webshop-preview'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdWebshopPreviewRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/skus/active/': {
      id: '/(client)/my-styles/(pages)/(list)/skus/active/'
      path: '/active'
      fullPath: '/my-styles/skus/active/'
      preLoaderRoute: typeof clientMyStylespageslistSkusActiveIndexRouteImport
      parentRoute: typeof clientMyStylespageslistSkusRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/skus/archived/': {
      id: '/(client)/my-styles/(pages)/(list)/skus/archived/'
      path: '/archived'
      fullPath: '/my-styles/skus/archived/'
      preLoaderRoute: typeof clientMyStylespageslistSkusArchivedIndexRouteImport
      parentRoute: typeof clientMyStylespageslistSkusRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/styles/active/': {
      id: '/(client)/my-styles/(pages)/(list)/styles/active/'
      path: '/active'
      fullPath: '/my-styles/styles/active/'
      preLoaderRoute: typeof clientMyStylespageslistStylesActiveIndexRouteImport
      parentRoute: typeof clientMyStylespageslistStylesRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/styles/archived/': {
      id: '/(client)/my-styles/(pages)/(list)/styles/archived/'
      path: '/archived'
      fullPath: '/my-styles/styles/archived/'
      preLoaderRoute: typeof clientMyStylespageslistStylesArchivedIndexRouteImport
      parentRoute: typeof clientMyStylespageslistStylesRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/variants/active/': {
      id: '/(client)/my-styles/(pages)/(list)/variants/active/'
      path: '/active'
      fullPath: '/my-styles/variants/active/'
      preLoaderRoute: typeof clientMyStylespageslistVariantsActiveIndexRouteImport
      parentRoute: typeof clientMyStylespageslistVariantsRouteRoute
    }
    '/(client)/my-styles/(pages)/(list)/variants/archived/': {
      id: '/(client)/my-styles/(pages)/(list)/variants/archived/'
      path: '/archived'
      fullPath: '/my-styles/variants/archived/'
      preLoaderRoute: typeof clientMyStylespageslistVariantsArchivedIndexRouteImport
      parentRoute: typeof clientMyStylespageslistVariantsRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/audits/': {
      id: '/(client)/network/(pages)/(detail)/$companyId/audits/'
      path: '/audits'
      fullPath: '/network/$companyId/audits/'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdAuditsIndexRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/integrations/': {
      id: '/(client)/network/(pages)/(detail)/$companyId/integrations/'
      path: '/'
      fullPath: '/network/$companyId/integrations/'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsIndexRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute
    }
    '/(client)/orders/(pages)/(create)/purchase-orders/create/': {
      id: '/(client)/orders/(pages)/(create)/purchase-orders/create/'
      path: '/purchase-orders/create'
      fullPath: '/orders/purchase-orders/create/'
      preLoaderRoute: typeof clientOrderspagescreatePurchaseOrdersCreateIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(create)/sales-orders/create/': {
      id: '/(client)/orders/(pages)/(create)/sales-orders/create/'
      path: '/sales-orders/create'
      fullPath: '/orders/sales-orders/create/'
      preLoaderRoute: typeof clientOrderspagescreateSalesOrdersCreateIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents': {
      id: '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/documents'
      path: '/documents'
      fullPath: '/orders/internal-orders/$ioId/documents'
      preLoaderRoute: typeof clientOrderspagesdetailInternalOrdersIoIdDocumentsRouteImport
      parentRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview': {
      id: '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/overview'
      path: '/overview'
      fullPath: '/orders/internal-orders/$ioId/overview'
      preLoaderRoute: typeof clientOrderspagesdetailInternalOrdersIoIdOverviewRouteImport
      parentRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products': {
      id: '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/products'
      path: '/products'
      fullPath: '/orders/internal-orders/$ioId/products'
      preLoaderRoute: typeof clientOrderspagesdetailInternalOrdersIoIdProductsRouteImport
      parentRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/tracing': {
      id: '/(client)/orders/(pages)/(detail)/internal-orders/$ioId/tracing'
      path: '/tracing'
      fullPath: '/orders/internal-orders/$ioId/tracing'
      preLoaderRoute: typeof clientOrderspagesdetailInternalOrdersIoIdTracingRouteImport
      parentRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents': {
      id: '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/documents'
      path: '/documents'
      fullPath: '/orders/purchase-orders/$poId/documents'
      preLoaderRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRouteImport
      parentRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview': {
      id: '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/overview'
      path: '/overview'
      fullPath: '/orders/purchase-orders/$poId/overview'
      preLoaderRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdOverviewRouteImport
      parentRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products': {
      id: '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/products'
      path: '/products'
      fullPath: '/orders/purchase-orders/$poId/products'
      preLoaderRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdProductsRouteImport
      parentRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/tracing': {
      id: '/(client)/orders/(pages)/(detail)/purchase-orders/$poId/tracing'
      path: '/tracing'
      fullPath: '/orders/purchase-orders/$poId/tracing'
      preLoaderRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdTracingRouteImport
      parentRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments': {
      id: '/(client)/orders/(pages)/(detail)/sales-orders/$soId/attachments'
      path: '/attachments'
      fullPath: '/orders/sales-orders/$soId/attachments'
      preLoaderRoute: typeof clientOrderspagesdetailSalesOrdersSoIdAttachmentsRouteImport
      parentRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/sales-orders/$soId/overview': {
      id: '/(client)/orders/(pages)/(detail)/sales-orders/$soId/overview'
      path: '/overview'
      fullPath: '/orders/sales-orders/$soId/overview'
      preLoaderRoute: typeof clientOrderspagesdetailSalesOrdersSoIdOverviewRouteImport
      parentRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/sales-orders/$soId/products': {
      id: '/(client)/orders/(pages)/(detail)/sales-orders/$soId/products'
      path: '/products'
      fullPath: '/orders/sales-orders/$soId/products'
      preLoaderRoute: typeof clientOrderspagesdetailSalesOrdersSoIdProductsRouteImport
      parentRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRoute
    }
    '/(client)/orders/(pages)/(detail)/sales-orders/$soId/tracing': {
      id: '/(client)/orders/(pages)/(detail)/sales-orders/$soId/tracing'
      path: '/tracing'
      fullPath: '/orders/sales-orders/$soId/tracing'
      preLoaderRoute: typeof clientOrderspagesdetailSalesOrdersSoIdTracingRouteImport
      parentRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRoute
    }
    '/(client)/orders/(pages)/(list)/internal-orders/active/': {
      id: '/(client)/orders/(pages)/(list)/internal-orders/active/'
      path: '/active'
      fullPath: '/orders/internal-orders/active/'
      preLoaderRoute: typeof clientOrderspageslistInternalOrdersActiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistInternalOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(list)/internal-orders/archive/': {
      id: '/(client)/orders/(pages)/(list)/internal-orders/archive/'
      path: '/archive'
      fullPath: '/orders/internal-orders/archive/'
      preLoaderRoute: typeof clientOrderspageslistInternalOrdersArchiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistInternalOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(list)/purchase-orders/active/': {
      id: '/(client)/orders/(pages)/(list)/purchase-orders/active/'
      path: '/active'
      fullPath: '/orders/purchase-orders/active/'
      preLoaderRoute: typeof clientOrderspageslistPurchaseOrdersActiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistPurchaseOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(list)/purchase-orders/archive/': {
      id: '/(client)/orders/(pages)/(list)/purchase-orders/archive/'
      path: '/archive'
      fullPath: '/orders/purchase-orders/archive/'
      preLoaderRoute: typeof clientOrderspageslistPurchaseOrdersArchiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistPurchaseOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(list)/sales-orders/active/': {
      id: '/(client)/orders/(pages)/(list)/sales-orders/active/'
      path: '/active'
      fullPath: '/orders/sales-orders/active/'
      preLoaderRoute: typeof clientOrderspageslistSalesOrdersActiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistSalesOrdersRouteRoute
    }
    '/(client)/orders/(pages)/(list)/sales-orders/archive/': {
      id: '/(client)/orders/(pages)/(list)/sales-orders/archive/'
      path: '/archive'
      fullPath: '/orders/sales-orders/archive/'
      preLoaderRoute: typeof clientOrderspageslistSalesOrdersArchiveIndexRouteImport
      parentRoute: typeof clientOrderspageslistSalesOrdersRouteRoute
    }
    '/(client)/orders/(pages)/attachment-templates/$id/edit/': {
      id: '/(client)/orders/(pages)/attachment-templates/$id/edit/'
      path: '/attachment-templates/$id/edit'
      fullPath: '/orders/attachment-templates/$id/edit/'
      preLoaderRoute: typeof clientOrderspagesAttachmentTemplatesIdEditIndexRouteImport
      parentRoute: typeof clientOrdersRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id/edit/': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id/edit/'
      path: '/edit'
      fullPath: '/questionnaires/$id/edit/'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdEditIndexRouteImport
      parentRoute: typeof clientQuestionnairespagesdetailIdRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id/review/': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id/review/'
      path: '/review'
      fullPath: '/questionnaires/$id/review/'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdReviewIndexRouteImport
      parentRoute: typeof clientQuestionnairespagesdetailIdRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id/summary/': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id/summary/'
      path: '/summary'
      fullPath: '/questionnaires/$id/summary/'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdSummaryIndexRouteImport
      parentRoute: typeof clientQuestionnairespagesdetailIdRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id_/answer/': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id_/answer/'
      path: '/$id/answer'
      fullPath: '/questionnaires/$id/answer/'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdAnswerIndexRouteImport
      parentRoute: typeof clientQuestionnairespagesRouteRoute
    }
    '/(client)/questionnaires/(pages)/(detail)/$id_/preview/': {
      id: '/(client)/questionnaires/(pages)/(detail)/$id_/preview/'
      path: '/$id/preview'
      fullPath: '/questionnaires/$id/preview/'
      preLoaderRoute: typeof clientQuestionnairespagesdetailIdPreviewIndexRouteImport
      parentRoute: typeof clientQuestionnairespagesRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/': {
      id: '/(client)/questionnaires/(pages)/(list)/my-questionnaires/active/'
      path: '/active'
      fullPath: '/questionnaires/my-questionnaires/active/'
      preLoaderRoute: typeof clientQuestionnairespageslistMyQuestionnairesActiveIndexRouteImport
      parentRoute: typeof clientQuestionnairespageslistMyQuestionnairesRouteRoute
    }
    '/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/': {
      id: '/(client)/questionnaires/(pages)/(list)/my-questionnaires/archived/'
      path: '/archived'
      fullPath: '/questionnaires/my-questionnaires/archived/'
      preLoaderRoute: typeof clientQuestionnairespageslistMyQuestionnairesArchivedIndexRouteImport
      parentRoute: typeof clientQuestionnairespageslistMyQuestionnairesRouteRoute
    }
    '/(client)/risk/(pages)/(detail)/assessments/$id/': {
      id: '/(client)/risk/(pages)/(detail)/assessments/$id/'
      path: '/$id'
      fullPath: '/risk/assessments/$id/'
      preLoaderRoute: typeof clientRiskpagesdetailAssessmentsIdIndexRouteImport
      parentRoute: typeof clientRiskpagesdetailAssessmentsRouteRoute
    }
    '/(client)/risk/(pages)/(detail)/rules/$id/': {
      id: '/(client)/risk/(pages)/(detail)/rules/$id/'
      path: '/rules/$id'
      fullPath: '/risk/rules/$id/'
      preLoaderRoute: typeof clientRiskpagesdetailRulesIdIndexRouteImport
      parentRoute: typeof clientRiskpagesdetailRouteRoute
    }
    '/(client)/slcp/(pages)/(list)/my-own/active/': {
      id: '/(client)/slcp/(pages)/(list)/my-own/active/'
      path: '/active'
      fullPath: '/slcp/my-own/active/'
      preLoaderRoute: typeof clientSlcppageslistMyOwnActiveIndexRouteImport
      parentRoute: typeof clientSlcppageslistMyOwnRouteRoute
    }
    '/(client)/slcp/(pages)/(list)/my-own/archive/': {
      id: '/(client)/slcp/(pages)/(list)/my-own/archive/'
      path: '/archive'
      fullPath: '/slcp/my-own/archive/'
      preLoaderRoute: typeof clientSlcppageslistMyOwnArchiveIndexRouteImport
      parentRoute: typeof clientSlcppageslistMyOwnRouteRoute
    }
    '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/': {
      id: '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/'
      path: '/'
      fullPath: '/slcp/assessments/$assessmentId/'
      preLoaderRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdIndexRouteImport
      parentRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/insights/collaborator-companies/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/insights/collaborator-companies/'
      path: '/collaborator-companies'
      fullPath: '/supply-chain-mapping/insights/collaborator-companies/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/insights/global-diagram/'
      path: '/global-diagram'
      fullPath: '/supply-chain-mapping/insights/global-diagram/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/insights/mapped-companies/'
      path: '/mapped-companies'
      fullPath: '/supply-chain-mapping/insights/mapped-companies/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/insights/overview/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/insights/overview/'
      path: '/overview'
      fullPath: '/supply-chain-mapping/insights/overview/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistInsightsOverviewIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/active/'
      path: '/active'
      fullPath: '/supply-chain-mapping/supply-chains/active/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistSupplyChainsActiveIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistSupplyChainsRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/': {
      id: '/(client)/supply-chain-mapping/(pages)/(list)/supply-chains/archive/'
      path: '/archive'
      fullPath: '/supply-chain-mapping/supply-chains/archive/'
      preLoaderRoute: typeof clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpageslistSupplyChainsRouteRoute
    }
    '/management/risk-management/(pages)/rule-templates/$id/edit/': {
      id: '/management/risk-management/(pages)/rule-templates/$id/edit/'
      path: '/rule-templates/$id/edit'
      fullPath: '/management/risk-management/rule-templates/$id/edit/'
      preLoaderRoute: typeof ManagementRiskManagementpagesRuleTemplatesIdEditIndexRouteImport
      parentRoute: typeof ManagementRiskManagementpagesRouteRoute
    }
    '/(client)/report/(pages)/(drilldown)/audit-compliance/drilldown/$chartType/': {
      id: '/(client)/report/(pages)/(drilldown)/audit-compliance/drilldown/$chartType/'
      path: '/audit-compliance/drilldown/$chartType'
      fullPath: '/report/audit-compliance/drilldown/$chartType/'
      preLoaderRoute: typeof clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/report/(pages)/(drilldown)/certificate-compliance/drilldown/$chartType/': {
      id: '/(client)/report/(pages)/(drilldown)/certificate-compliance/drilldown/$chartType/'
      path: '/certificate-compliance/drilldown/$chartType'
      fullPath: '/report/certificate-compliance/drilldown/$chartType/'
      preLoaderRoute: typeof clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRouteImport
      parentRoute: typeof clientReportpagesRouteRoute
    }
    '/(client)/risk/(pages)/(edit)/rules/$id/edit/': {
      id: '/(client)/risk/(pages)/(edit)/rules/$id/edit/'
      path: '/rules/$id/edit'
      fullPath: '/risk/rules/$id/edit/'
      preLoaderRoute: typeof clientRiskpageseditRulesIdEditIndexRouteImport
      parentRoute: typeof clientRiskpageseditRouteRoute
    }
    '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/assessment/': {
      id: '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/assessment/'
      path: '/assessment'
      fullPath: '/slcp/assessments/$assessmentId/assessment/'
      preLoaderRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRouteImport
      parentRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute
    }
    '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/': {
      id: '/(client)/slcp/(pages)/assessments/(details)/$assessmentId/overview/'
      path: '/overview'
      fullPath: '/slcp/assessments/$assessmentId/overview/'
      preLoaderRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRouteImport
      parentRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/': {
      id: '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/compare/'
      path: '/compare'
      fullPath: '/supply-chain-mapping/supply-chains/$id/compare/'
      preLoaderRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/': {
      id: '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/diagram/'
      path: '/diagram'
      fullPath: '/supply-chain-mapping/supply-chains/$id/diagram/'
      preLoaderRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute
    }
    '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/map/': {
      id: '/(client)/supply-chain-mapping/(pages)/(details)/supply-chains/$id/map/'
      path: '/map'
      fullPath: '/supply-chain-mapping/supply-chains/$id/map/'
      preLoaderRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRouteImport
      parentRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/linked/': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/linked/'
      path: '/linked'
      fullPath: '/my-components/$kind/$id/documents/linked/'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdDocumentsRouteRoute
    }
    '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/product-only/': {
      id: '/(client)/my-components/(pages)/(detail)/$kind/$id/documents/product-only/'
      path: '/product-only'
      fullPath: '/my-components/$kind/$id/documents/product-only/'
      preLoaderRoute: typeof clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRouteImport
      parentRoute: typeof clientMyComponentspagesdetailKindIdDocumentsRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/linked/'
      path: '/linked'
      fullPath: '/my-styles/$kind/$id/documents/linked/'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdDocumentsLinkedIndexRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdDocumentsRouteRoute
    }
    '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/': {
      id: '/(client)/my-styles/(pages)/(detail)/$kind/$id/documents/product-only/'
      path: '/product-only'
      fullPath: '/my-styles/$kind/$id/documents/product-only/'
      preLoaderRoute: typeof clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRouteImport
      parentRoute: typeof clientMyStylespagesdetailKindIdDocumentsRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/audits/$auditId/findings/': {
      id: '/(client)/network/(pages)/(detail)/$companyId/audits/$auditId/findings/'
      path: '/audits/$auditId/findings'
      fullPath: '/network/$companyId/audits/$auditId/findings/'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdRouteRoute
    }
    '/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/': {
      id: '/(client)/network/(pages)/(detail)/$companyId/integrations/history/$syncHistoryId/'
      path: '/history/$syncHistoryId'
      fullPath: '/network/$companyId/integrations/history/$syncHistoryId/'
      preLoaderRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRouteImport
      parentRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute
    }
    '/(client)/risk/(pages)/(detail)/assessments/$id/assessed/$assessmentId/': {
      id: '/(client)/risk/(pages)/(detail)/assessments/$id/assessed/$assessmentId/'
      path: '/$id/assessed/$assessmentId'
      fullPath: '/risk/assessments/$id/assessed/$assessmentId/'
      preLoaderRoute: typeof clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRouteImport
      parentRoute: typeof clientRiskpagesdetailAssessmentsRouteRoute
    }
  }
}

interface clientAuditspageslistAuditsForCompanyRouteRouteChildren {
  clientAuditspageslistAuditsForCompanyActiveIndexRoute: typeof clientAuditspageslistAuditsForCompanyActiveIndexRoute
  clientAuditspageslistAuditsForCompanyArchiveIndexRoute: typeof clientAuditspageslistAuditsForCompanyArchiveIndexRoute
}

const clientAuditspageslistAuditsForCompanyRouteRouteChildren: clientAuditspageslistAuditsForCompanyRouteRouteChildren =
  {
    clientAuditspageslistAuditsForCompanyActiveIndexRoute:
      clientAuditspageslistAuditsForCompanyActiveIndexRoute,
    clientAuditspageslistAuditsForCompanyArchiveIndexRoute:
      clientAuditspageslistAuditsForCompanyArchiveIndexRoute,
  }

const clientAuditspageslistAuditsForCompanyRouteRouteWithChildren =
  clientAuditspageslistAuditsForCompanyRouteRoute._addFileChildren(
    clientAuditspageslistAuditsForCompanyRouteRouteChildren,
  )

interface clientAuditspageslistNetworkAuditsRouteRouteChildren {
  clientAuditspageslistNetworkAuditsActiveIndexRoute: typeof clientAuditspageslistNetworkAuditsActiveIndexRoute
  clientAuditspageslistNetworkAuditsArchiveIndexRoute: typeof clientAuditspageslistNetworkAuditsArchiveIndexRoute
}

const clientAuditspageslistNetworkAuditsRouteRouteChildren: clientAuditspageslistNetworkAuditsRouteRouteChildren =
  {
    clientAuditspageslistNetworkAuditsActiveIndexRoute:
      clientAuditspageslistNetworkAuditsActiveIndexRoute,
    clientAuditspageslistNetworkAuditsArchiveIndexRoute:
      clientAuditspageslistNetworkAuditsArchiveIndexRoute,
  }

const clientAuditspageslistNetworkAuditsRouteRouteWithChildren =
  clientAuditspageslistNetworkAuditsRouteRoute._addFileChildren(
    clientAuditspageslistNetworkAuditsRouteRouteChildren,
  )

interface clientAuditspageslistRouteRouteChildren {
  clientAuditspageslistAuditsForCompanyRouteRoute: typeof clientAuditspageslistAuditsForCompanyRouteRouteWithChildren
  clientAuditspageslistNetworkAuditsRouteRoute: typeof clientAuditspageslistNetworkAuditsRouteRouteWithChildren
}

const clientAuditspageslistRouteRouteChildren: clientAuditspageslistRouteRouteChildren =
  {
    clientAuditspageslistAuditsForCompanyRouteRoute:
      clientAuditspageslistAuditsForCompanyRouteRouteWithChildren,
    clientAuditspageslistNetworkAuditsRouteRoute:
      clientAuditspageslistNetworkAuditsRouteRouteWithChildren,
  }

const clientAuditspageslistRouteRouteWithChildren =
  clientAuditspageslistRouteRoute._addFileChildren(
    clientAuditspageslistRouteRouteChildren,
  )

interface clientAuditspagesdetailAuditIdRouteRouteChildren {
  clientAuditspagesdetailAuditIdIndexRoute: typeof clientAuditspagesdetailAuditIdIndexRoute
  clientAuditspagesdetailAuditIdCapaIndexRoute: typeof clientAuditspagesdetailAuditIdCapaIndexRoute
  clientAuditspagesdetailAuditIdContentIndexRoute: typeof clientAuditspagesdetailAuditIdContentIndexRoute
  clientAuditspagesdetailAuditIdFindingsIndexRoute: typeof clientAuditspagesdetailAuditIdFindingsIndexRoute
  clientAuditspagesdetailAuditIdOverviewIndexRoute: typeof clientAuditspagesdetailAuditIdOverviewIndexRoute
  clientAuditspagesdetailAuditIdScoreIndexRoute: typeof clientAuditspagesdetailAuditIdScoreIndexRoute
  clientAuditspagesdetailAuditIdViewIndexRoute: typeof clientAuditspagesdetailAuditIdViewIndexRoute
}

const clientAuditspagesdetailAuditIdRouteRouteChildren: clientAuditspagesdetailAuditIdRouteRouteChildren =
  {
    clientAuditspagesdetailAuditIdIndexRoute:
      clientAuditspagesdetailAuditIdIndexRoute,
    clientAuditspagesdetailAuditIdCapaIndexRoute:
      clientAuditspagesdetailAuditIdCapaIndexRoute,
    clientAuditspagesdetailAuditIdContentIndexRoute:
      clientAuditspagesdetailAuditIdContentIndexRoute,
    clientAuditspagesdetailAuditIdFindingsIndexRoute:
      clientAuditspagesdetailAuditIdFindingsIndexRoute,
    clientAuditspagesdetailAuditIdOverviewIndexRoute:
      clientAuditspagesdetailAuditIdOverviewIndexRoute,
    clientAuditspagesdetailAuditIdScoreIndexRoute:
      clientAuditspagesdetailAuditIdScoreIndexRoute,
    clientAuditspagesdetailAuditIdViewIndexRoute:
      clientAuditspagesdetailAuditIdViewIndexRoute,
  }

const clientAuditspagesdetailAuditIdRouteRouteWithChildren =
  clientAuditspagesdetailAuditIdRouteRoute._addFileChildren(
    clientAuditspagesdetailAuditIdRouteRouteChildren,
  )

interface clientAuditsRouteRouteChildren {
  clientAuditspageslistRouteRoute: typeof clientAuditspageslistRouteRouteWithChildren
  clientAuditspagesdetailAuditIdRouteRoute: typeof clientAuditspagesdetailAuditIdRouteRouteWithChildren
}

const clientAuditsRouteRouteChildren: clientAuditsRouteRouteChildren = {
  clientAuditspageslistRouteRoute: clientAuditspageslistRouteRouteWithChildren,
  clientAuditspagesdetailAuditIdRouteRoute:
    clientAuditspagesdetailAuditIdRouteRouteWithChildren,
}

const clientAuditsRouteRouteWithChildren =
  clientAuditsRouteRoute._addFileChildren(clientAuditsRouteRouteChildren)

interface clientEntityScreeningRouteRouteChildren {
  clientEntityScreeningpagesIndexRoute: typeof clientEntityScreeningpagesIndexRoute
  clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute: typeof clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute
}

const clientEntityScreeningRouteRouteChildren: clientEntityScreeningRouteRouteChildren =
  {
    clientEntityScreeningpagesIndexRoute: clientEntityScreeningpagesIndexRoute,
    clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute:
      clientEntityScreeningpagesInvolvedOrdersCompanyIdIndexRoute,
  }

const clientEntityScreeningRouteRouteWithChildren =
  clientEntityScreeningRouteRoute._addFileChildren(
    clientEntityScreeningRouteRouteChildren,
  )

interface clientFilesRouteRouteChildren {
  clientFilespageslistIndexRoute: typeof clientFilespageslistIndexRoute
}

const clientFilesRouteRouteChildren: clientFilesRouteRouteChildren = {
  clientFilespageslistIndexRoute: clientFilespageslistIndexRoute,
}

const clientFilesRouteRouteWithChildren =
  clientFilesRouteRoute._addFileChildren(clientFilesRouteRouteChildren)

interface clientMyComponentspagesdetailKindIdDocumentsRouteRouteChildren {
  clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute: typeof clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute
  clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute: typeof clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute
}

const clientMyComponentspagesdetailKindIdDocumentsRouteRouteChildren: clientMyComponentspagesdetailKindIdDocumentsRouteRouteChildren =
  {
    clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute:
      clientMyComponentspagesdetailKindIdDocumentsLinkedIndexRoute,
    clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute:
      clientMyComponentspagesdetailKindIdDocumentsProductOnlyIndexRoute,
  }

const clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren =
  clientMyComponentspagesdetailKindIdDocumentsRouteRoute._addFileChildren(
    clientMyComponentspagesdetailKindIdDocumentsRouteRouteChildren,
  )

interface clientMyComponentspagesdetailKindIdRouteRouteChildren {
  clientMyComponentspagesdetailKindIdDocumentsRouteRoute: typeof clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren
  clientMyComponentspagesdetailKindIdBomRoute: typeof clientMyComponentspagesdetailKindIdBomRoute
  clientMyComponentspagesdetailKindIdCertificationsRoute: typeof clientMyComponentspagesdetailKindIdCertificationsRoute
  clientMyComponentspagesdetailKindIdMaterialsRoute: typeof clientMyComponentspagesdetailKindIdMaterialsRoute
  clientMyComponentspagesdetailKindIdOverviewRoute: typeof clientMyComponentspagesdetailKindIdOverviewRoute
  clientMyComponentspagesdetailKindIdQrCodeRoute: typeof clientMyComponentspagesdetailKindIdQrCodeRoute
  clientMyComponentspagesdetailKindIdSkusRoute: typeof clientMyComponentspagesdetailKindIdSkusRoute
  clientMyComponentspagesdetailKindIdSupplyChainRoute: typeof clientMyComponentspagesdetailKindIdSupplyChainRoute
  clientMyComponentspagesdetailKindIdVariantsRoute: typeof clientMyComponentspagesdetailKindIdVariantsRoute
  clientMyComponentspagesdetailKindIdWebshopPreviewRoute: typeof clientMyComponentspagesdetailKindIdWebshopPreviewRoute
}

const clientMyComponentspagesdetailKindIdRouteRouteChildren: clientMyComponentspagesdetailKindIdRouteRouteChildren =
  {
    clientMyComponentspagesdetailKindIdDocumentsRouteRoute:
      clientMyComponentspagesdetailKindIdDocumentsRouteRouteWithChildren,
    clientMyComponentspagesdetailKindIdBomRoute:
      clientMyComponentspagesdetailKindIdBomRoute,
    clientMyComponentspagesdetailKindIdCertificationsRoute:
      clientMyComponentspagesdetailKindIdCertificationsRoute,
    clientMyComponentspagesdetailKindIdMaterialsRoute:
      clientMyComponentspagesdetailKindIdMaterialsRoute,
    clientMyComponentspagesdetailKindIdOverviewRoute:
      clientMyComponentspagesdetailKindIdOverviewRoute,
    clientMyComponentspagesdetailKindIdQrCodeRoute:
      clientMyComponentspagesdetailKindIdQrCodeRoute,
    clientMyComponentspagesdetailKindIdSkusRoute:
      clientMyComponentspagesdetailKindIdSkusRoute,
    clientMyComponentspagesdetailKindIdSupplyChainRoute:
      clientMyComponentspagesdetailKindIdSupplyChainRoute,
    clientMyComponentspagesdetailKindIdVariantsRoute:
      clientMyComponentspagesdetailKindIdVariantsRoute,
    clientMyComponentspagesdetailKindIdWebshopPreviewRoute:
      clientMyComponentspagesdetailKindIdWebshopPreviewRoute,
  }

const clientMyComponentspagesdetailKindIdRouteRouteWithChildren =
  clientMyComponentspagesdetailKindIdRouteRoute._addFileChildren(
    clientMyComponentspagesdetailKindIdRouteRouteChildren,
  )

interface clientMyComponentspagesdetailRouteRouteChildren {
  clientMyComponentspagesdetailKindIdRouteRoute: typeof clientMyComponentspagesdetailKindIdRouteRouteWithChildren
}

const clientMyComponentspagesdetailRouteRouteChildren: clientMyComponentspagesdetailRouteRouteChildren =
  {
    clientMyComponentspagesdetailKindIdRouteRoute:
      clientMyComponentspagesdetailKindIdRouteRouteWithChildren,
  }

const clientMyComponentspagesdetailRouteRouteWithChildren =
  clientMyComponentspagesdetailRouteRoute._addFileChildren(
    clientMyComponentspagesdetailRouteRouteChildren,
  )

interface clientMyComponentspageslistComponentSkusRouteRouteChildren {
  clientMyComponentspageslistComponentSkusActiveIndexRoute: typeof clientMyComponentspageslistComponentSkusActiveIndexRoute
  clientMyComponentspageslistComponentSkusArchivedIndexRoute: typeof clientMyComponentspageslistComponentSkusArchivedIndexRoute
}

const clientMyComponentspageslistComponentSkusRouteRouteChildren: clientMyComponentspageslistComponentSkusRouteRouteChildren =
  {
    clientMyComponentspageslistComponentSkusActiveIndexRoute:
      clientMyComponentspageslistComponentSkusActiveIndexRoute,
    clientMyComponentspageslistComponentSkusArchivedIndexRoute:
      clientMyComponentspageslistComponentSkusArchivedIndexRoute,
  }

const clientMyComponentspageslistComponentSkusRouteRouteWithChildren =
  clientMyComponentspageslistComponentSkusRouteRoute._addFileChildren(
    clientMyComponentspageslistComponentSkusRouteRouteChildren,
  )

interface clientMyComponentspageslistComponentVariantsRouteRouteChildren {
  clientMyComponentspageslistComponentVariantsActiveIndexRoute: typeof clientMyComponentspageslistComponentVariantsActiveIndexRoute
  clientMyComponentspageslistComponentVariantsArchivedIndexRoute: typeof clientMyComponentspageslistComponentVariantsArchivedIndexRoute
}

const clientMyComponentspageslistComponentVariantsRouteRouteChildren: clientMyComponentspageslistComponentVariantsRouteRouteChildren =
  {
    clientMyComponentspageslistComponentVariantsActiveIndexRoute:
      clientMyComponentspageslistComponentVariantsActiveIndexRoute,
    clientMyComponentspageslistComponentVariantsArchivedIndexRoute:
      clientMyComponentspageslistComponentVariantsArchivedIndexRoute,
  }

const clientMyComponentspageslistComponentVariantsRouteRouteWithChildren =
  clientMyComponentspageslistComponentVariantsRouteRoute._addFileChildren(
    clientMyComponentspageslistComponentVariantsRouteRouteChildren,
  )

interface clientMyComponentspageslistComponentsRouteRouteChildren {
  clientMyComponentspageslistComponentsActiveIndexRoute: typeof clientMyComponentspageslistComponentsActiveIndexRoute
  clientMyComponentspageslistComponentsArchivedIndexRoute: typeof clientMyComponentspageslistComponentsArchivedIndexRoute
}

const clientMyComponentspageslistComponentsRouteRouteChildren: clientMyComponentspageslistComponentsRouteRouteChildren =
  {
    clientMyComponentspageslistComponentsActiveIndexRoute:
      clientMyComponentspageslistComponentsActiveIndexRoute,
    clientMyComponentspageslistComponentsArchivedIndexRoute:
      clientMyComponentspageslistComponentsArchivedIndexRoute,
  }

const clientMyComponentspageslistComponentsRouteRouteWithChildren =
  clientMyComponentspageslistComponentsRouteRoute._addFileChildren(
    clientMyComponentspageslistComponentsRouteRouteChildren,
  )

interface clientMyComponentspageslistRouteRouteChildren {
  clientMyComponentspageslistComponentSkusRouteRoute: typeof clientMyComponentspageslistComponentSkusRouteRouteWithChildren
  clientMyComponentspageslistComponentVariantsRouteRoute: typeof clientMyComponentspageslistComponentVariantsRouteRouteWithChildren
  clientMyComponentspageslistComponentsRouteRoute: typeof clientMyComponentspageslistComponentsRouteRouteWithChildren
}

const clientMyComponentspageslistRouteRouteChildren: clientMyComponentspageslistRouteRouteChildren =
  {
    clientMyComponentspageslistComponentSkusRouteRoute:
      clientMyComponentspageslistComponentSkusRouteRouteWithChildren,
    clientMyComponentspageslistComponentVariantsRouteRoute:
      clientMyComponentspageslistComponentVariantsRouteRouteWithChildren,
    clientMyComponentspageslistComponentsRouteRoute:
      clientMyComponentspageslistComponentsRouteRouteWithChildren,
  }

const clientMyComponentspageslistRouteRouteWithChildren =
  clientMyComponentspageslistRouteRoute._addFileChildren(
    clientMyComponentspageslistRouteRouteChildren,
  )

interface clientMyComponentspagesRouteRouteChildren {
  clientMyComponentspagesdetailRouteRoute: typeof clientMyComponentspagesdetailRouteRouteWithChildren
  clientMyComponentspageslistRouteRoute: typeof clientMyComponentspageslistRouteRouteWithChildren
}

const clientMyComponentspagesRouteRouteChildren: clientMyComponentspagesRouteRouteChildren =
  {
    clientMyComponentspagesdetailRouteRoute:
      clientMyComponentspagesdetailRouteRouteWithChildren,
    clientMyComponentspageslistRouteRoute:
      clientMyComponentspageslistRouteRouteWithChildren,
  }

const clientMyComponentspagesRouteRouteWithChildren =
  clientMyComponentspagesRouteRoute._addFileChildren(
    clientMyComponentspagesRouteRouteChildren,
  )

interface clientMyComponentsRouteRouteChildren {
  clientMyComponentspagesRouteRoute: typeof clientMyComponentspagesRouteRouteWithChildren
}

const clientMyComponentsRouteRouteChildren: clientMyComponentsRouteRouteChildren =
  {
    clientMyComponentspagesRouteRoute:
      clientMyComponentspagesRouteRouteWithChildren,
  }

const clientMyComponentsRouteRouteWithChildren =
  clientMyComponentsRouteRoute._addFileChildren(
    clientMyComponentsRouteRouteChildren,
  )

interface clientMyStylespagesdetailKindIdDocumentsRouteRouteChildren {
  clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute: typeof clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute
  clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute: typeof clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute
}

const clientMyStylespagesdetailKindIdDocumentsRouteRouteChildren: clientMyStylespagesdetailKindIdDocumentsRouteRouteChildren =
  {
    clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute:
      clientMyStylespagesdetailKindIdDocumentsLinkedIndexRoute,
    clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute:
      clientMyStylespagesdetailKindIdDocumentsProductOnlyIndexRoute,
  }

const clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren =
  clientMyStylespagesdetailKindIdDocumentsRouteRoute._addFileChildren(
    clientMyStylespagesdetailKindIdDocumentsRouteRouteChildren,
  )

interface clientMyStylespagesdetailKindIdRouteRouteChildren {
  clientMyStylespagesdetailKindIdDocumentsRouteRoute: typeof clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren
  clientMyStylespagesdetailKindIdBomRoute: typeof clientMyStylespagesdetailKindIdBomRoute
  clientMyStylespagesdetailKindIdCertificationsRoute: typeof clientMyStylespagesdetailKindIdCertificationsRoute
  clientMyStylespagesdetailKindIdMaterialsRoute: typeof clientMyStylespagesdetailKindIdMaterialsRoute
  clientMyStylespagesdetailKindIdOverviewRoute: typeof clientMyStylespagesdetailKindIdOverviewRoute
  clientMyStylespagesdetailKindIdQrCodeRoute: typeof clientMyStylespagesdetailKindIdQrCodeRoute
  clientMyStylespagesdetailKindIdSkusRoute: typeof clientMyStylespagesdetailKindIdSkusRoute
  clientMyStylespagesdetailKindIdSupplyChainRoute: typeof clientMyStylespagesdetailKindIdSupplyChainRoute
  clientMyStylespagesdetailKindIdVariantsRoute: typeof clientMyStylespagesdetailKindIdVariantsRoute
  clientMyStylespagesdetailKindIdWebshopPreviewRoute: typeof clientMyStylespagesdetailKindIdWebshopPreviewRoute
}

const clientMyStylespagesdetailKindIdRouteRouteChildren: clientMyStylespagesdetailKindIdRouteRouteChildren =
  {
    clientMyStylespagesdetailKindIdDocumentsRouteRoute:
      clientMyStylespagesdetailKindIdDocumentsRouteRouteWithChildren,
    clientMyStylespagesdetailKindIdBomRoute:
      clientMyStylespagesdetailKindIdBomRoute,
    clientMyStylespagesdetailKindIdCertificationsRoute:
      clientMyStylespagesdetailKindIdCertificationsRoute,
    clientMyStylespagesdetailKindIdMaterialsRoute:
      clientMyStylespagesdetailKindIdMaterialsRoute,
    clientMyStylespagesdetailKindIdOverviewRoute:
      clientMyStylespagesdetailKindIdOverviewRoute,
    clientMyStylespagesdetailKindIdQrCodeRoute:
      clientMyStylespagesdetailKindIdQrCodeRoute,
    clientMyStylespagesdetailKindIdSkusRoute:
      clientMyStylespagesdetailKindIdSkusRoute,
    clientMyStylespagesdetailKindIdSupplyChainRoute:
      clientMyStylespagesdetailKindIdSupplyChainRoute,
    clientMyStylespagesdetailKindIdVariantsRoute:
      clientMyStylespagesdetailKindIdVariantsRoute,
    clientMyStylespagesdetailKindIdWebshopPreviewRoute:
      clientMyStylespagesdetailKindIdWebshopPreviewRoute,
  }

const clientMyStylespagesdetailKindIdRouteRouteWithChildren =
  clientMyStylespagesdetailKindIdRouteRoute._addFileChildren(
    clientMyStylespagesdetailKindIdRouteRouteChildren,
  )

interface clientMyStylespagesdetailRouteRouteChildren {
  clientMyStylespagesdetailKindIdRouteRoute: typeof clientMyStylespagesdetailKindIdRouteRouteWithChildren
}

const clientMyStylespagesdetailRouteRouteChildren: clientMyStylespagesdetailRouteRouteChildren =
  {
    clientMyStylespagesdetailKindIdRouteRoute:
      clientMyStylespagesdetailKindIdRouteRouteWithChildren,
  }

const clientMyStylespagesdetailRouteRouteWithChildren =
  clientMyStylespagesdetailRouteRoute._addFileChildren(
    clientMyStylespagesdetailRouteRouteChildren,
  )

interface clientMyStylespageslistSkusRouteRouteChildren {
  clientMyStylespageslistSkusActiveIndexRoute: typeof clientMyStylespageslistSkusActiveIndexRoute
  clientMyStylespageslistSkusArchivedIndexRoute: typeof clientMyStylespageslistSkusArchivedIndexRoute
}

const clientMyStylespageslistSkusRouteRouteChildren: clientMyStylespageslistSkusRouteRouteChildren =
  {
    clientMyStylespageslistSkusActiveIndexRoute:
      clientMyStylespageslistSkusActiveIndexRoute,
    clientMyStylespageslistSkusArchivedIndexRoute:
      clientMyStylespageslistSkusArchivedIndexRoute,
  }

const clientMyStylespageslistSkusRouteRouteWithChildren =
  clientMyStylespageslistSkusRouteRoute._addFileChildren(
    clientMyStylespageslistSkusRouteRouteChildren,
  )

interface clientMyStylespageslistStylesRouteRouteChildren {
  clientMyStylespageslistStylesActiveIndexRoute: typeof clientMyStylespageslistStylesActiveIndexRoute
  clientMyStylespageslistStylesArchivedIndexRoute: typeof clientMyStylespageslistStylesArchivedIndexRoute
}

const clientMyStylespageslistStylesRouteRouteChildren: clientMyStylespageslistStylesRouteRouteChildren =
  {
    clientMyStylespageslistStylesActiveIndexRoute:
      clientMyStylespageslistStylesActiveIndexRoute,
    clientMyStylespageslistStylesArchivedIndexRoute:
      clientMyStylespageslistStylesArchivedIndexRoute,
  }

const clientMyStylespageslistStylesRouteRouteWithChildren =
  clientMyStylespageslistStylesRouteRoute._addFileChildren(
    clientMyStylespageslistStylesRouteRouteChildren,
  )

interface clientMyStylespageslistVariantsRouteRouteChildren {
  clientMyStylespageslistVariantsActiveIndexRoute: typeof clientMyStylespageslistVariantsActiveIndexRoute
  clientMyStylespageslistVariantsArchivedIndexRoute: typeof clientMyStylespageslistVariantsArchivedIndexRoute
}

const clientMyStylespageslistVariantsRouteRouteChildren: clientMyStylespageslistVariantsRouteRouteChildren =
  {
    clientMyStylespageslistVariantsActiveIndexRoute:
      clientMyStylespageslistVariantsActiveIndexRoute,
    clientMyStylespageslistVariantsArchivedIndexRoute:
      clientMyStylespageslistVariantsArchivedIndexRoute,
  }

const clientMyStylespageslistVariantsRouteRouteWithChildren =
  clientMyStylespageslistVariantsRouteRoute._addFileChildren(
    clientMyStylespageslistVariantsRouteRouteChildren,
  )

interface clientMyStylespageslistRouteRouteChildren {
  clientMyStylespageslistSkusRouteRoute: typeof clientMyStylespageslistSkusRouteRouteWithChildren
  clientMyStylespageslistStylesRouteRoute: typeof clientMyStylespageslistStylesRouteRouteWithChildren
  clientMyStylespageslistVariantsRouteRoute: typeof clientMyStylespageslistVariantsRouteRouteWithChildren
  clientMyStylespageslistStylesCreatedForMeIndexRoute: typeof clientMyStylespageslistStylesCreatedForMeIndexRoute
}

const clientMyStylespageslistRouteRouteChildren: clientMyStylespageslistRouteRouteChildren =
  {
    clientMyStylespageslistSkusRouteRoute:
      clientMyStylespageslistSkusRouteRouteWithChildren,
    clientMyStylespageslistStylesRouteRoute:
      clientMyStylespageslistStylesRouteRouteWithChildren,
    clientMyStylespageslistVariantsRouteRoute:
      clientMyStylespageslistVariantsRouteRouteWithChildren,
    clientMyStylespageslistStylesCreatedForMeIndexRoute:
      clientMyStylespageslistStylesCreatedForMeIndexRoute,
  }

const clientMyStylespageslistRouteRouteWithChildren =
  clientMyStylespageslistRouteRoute._addFileChildren(
    clientMyStylespageslistRouteRouteChildren,
  )

interface clientMyStylespagesRouteRouteChildren {
  clientMyStylespagesdetailRouteRoute: typeof clientMyStylespagesdetailRouteRouteWithChildren
  clientMyStylespageslistRouteRoute: typeof clientMyStylespageslistRouteRouteWithChildren
}

const clientMyStylespagesRouteRouteChildren: clientMyStylespagesRouteRouteChildren =
  {
    clientMyStylespagesdetailRouteRoute:
      clientMyStylespagesdetailRouteRouteWithChildren,
    clientMyStylespageslistRouteRoute:
      clientMyStylespageslistRouteRouteWithChildren,
  }

const clientMyStylespagesRouteRouteWithChildren =
  clientMyStylespagesRouteRoute._addFileChildren(
    clientMyStylespagesRouteRouteChildren,
  )

interface clientMyStylesRouteRouteChildren {
  clientMyStylespagesRouteRoute: typeof clientMyStylespagesRouteRouteWithChildren
}

const clientMyStylesRouteRouteChildren: clientMyStylesRouteRouteChildren = {
  clientMyStylespagesRouteRoute: clientMyStylespagesRouteRouteWithChildren,
}

const clientMyStylesRouteRouteWithChildren =
  clientMyStylesRouteRoute._addFileChildren(clientMyStylesRouteRouteChildren)

interface clientOrderspageslistInternalOrdersRouteRouteChildren {
  clientOrderspageslistInternalOrdersActiveIndexRoute: typeof clientOrderspageslistInternalOrdersActiveIndexRoute
  clientOrderspageslistInternalOrdersArchiveIndexRoute: typeof clientOrderspageslistInternalOrdersArchiveIndexRoute
}

const clientOrderspageslistInternalOrdersRouteRouteChildren: clientOrderspageslistInternalOrdersRouteRouteChildren =
  {
    clientOrderspageslistInternalOrdersActiveIndexRoute:
      clientOrderspageslistInternalOrdersActiveIndexRoute,
    clientOrderspageslistInternalOrdersArchiveIndexRoute:
      clientOrderspageslistInternalOrdersArchiveIndexRoute,
  }

const clientOrderspageslistInternalOrdersRouteRouteWithChildren =
  clientOrderspageslistInternalOrdersRouteRoute._addFileChildren(
    clientOrderspageslistInternalOrdersRouteRouteChildren,
  )

interface clientOrderspageslistPurchaseOrdersRouteRouteChildren {
  clientOrderspageslistPurchaseOrdersActiveIndexRoute: typeof clientOrderspageslistPurchaseOrdersActiveIndexRoute
  clientOrderspageslistPurchaseOrdersArchiveIndexRoute: typeof clientOrderspageslistPurchaseOrdersArchiveIndexRoute
}

const clientOrderspageslistPurchaseOrdersRouteRouteChildren: clientOrderspageslistPurchaseOrdersRouteRouteChildren =
  {
    clientOrderspageslistPurchaseOrdersActiveIndexRoute:
      clientOrderspageslistPurchaseOrdersActiveIndexRoute,
    clientOrderspageslistPurchaseOrdersArchiveIndexRoute:
      clientOrderspageslistPurchaseOrdersArchiveIndexRoute,
  }

const clientOrderspageslistPurchaseOrdersRouteRouteWithChildren =
  clientOrderspageslistPurchaseOrdersRouteRoute._addFileChildren(
    clientOrderspageslistPurchaseOrdersRouteRouteChildren,
  )

interface clientOrderspageslistSalesOrdersRouteRouteChildren {
  clientOrderspageslistSalesOrdersActiveIndexRoute: typeof clientOrderspageslistSalesOrdersActiveIndexRoute
  clientOrderspageslistSalesOrdersArchiveIndexRoute: typeof clientOrderspageslistSalesOrdersArchiveIndexRoute
}

const clientOrderspageslistSalesOrdersRouteRouteChildren: clientOrderspageslistSalesOrdersRouteRouteChildren =
  {
    clientOrderspageslistSalesOrdersActiveIndexRoute:
      clientOrderspageslistSalesOrdersActiveIndexRoute,
    clientOrderspageslistSalesOrdersArchiveIndexRoute:
      clientOrderspageslistSalesOrdersArchiveIndexRoute,
  }

const clientOrderspageslistSalesOrdersRouteRouteWithChildren =
  clientOrderspageslistSalesOrdersRouteRoute._addFileChildren(
    clientOrderspageslistSalesOrdersRouteRouteChildren,
  )

interface clientOrderspageslistRouteRouteChildren {
  clientOrderspageslistInternalOrdersRouteRoute: typeof clientOrderspageslistInternalOrdersRouteRouteWithChildren
  clientOrderspageslistPurchaseOrdersRouteRoute: typeof clientOrderspageslistPurchaseOrdersRouteRouteWithChildren
  clientOrderspageslistSalesOrdersRouteRoute: typeof clientOrderspageslistSalesOrdersRouteRouteWithChildren
}

const clientOrderspageslistRouteRouteChildren: clientOrderspageslistRouteRouteChildren =
  {
    clientOrderspageslistInternalOrdersRouteRoute:
      clientOrderspageslistInternalOrdersRouteRouteWithChildren,
    clientOrderspageslistPurchaseOrdersRouteRoute:
      clientOrderspageslistPurchaseOrdersRouteRouteWithChildren,
    clientOrderspageslistSalesOrdersRouteRoute:
      clientOrderspageslistSalesOrdersRouteRouteWithChildren,
  }

const clientOrderspageslistRouteRouteWithChildren =
  clientOrderspageslistRouteRoute._addFileChildren(
    clientOrderspageslistRouteRouteChildren,
  )

interface clientOrderspagesdetailInternalOrdersIoIdRouteRouteChildren {
  clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute: typeof clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute
  clientOrderspagesdetailInternalOrdersIoIdOverviewRoute: typeof clientOrderspagesdetailInternalOrdersIoIdOverviewRoute
  clientOrderspagesdetailInternalOrdersIoIdProductsRoute: typeof clientOrderspagesdetailInternalOrdersIoIdProductsRoute
  clientOrderspagesdetailInternalOrdersIoIdTracingRoute: typeof clientOrderspagesdetailInternalOrdersIoIdTracingRoute
}

const clientOrderspagesdetailInternalOrdersIoIdRouteRouteChildren: clientOrderspagesdetailInternalOrdersIoIdRouteRouteChildren =
  {
    clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute:
      clientOrderspagesdetailInternalOrdersIoIdDocumentsRoute,
    clientOrderspagesdetailInternalOrdersIoIdOverviewRoute:
      clientOrderspagesdetailInternalOrdersIoIdOverviewRoute,
    clientOrderspagesdetailInternalOrdersIoIdProductsRoute:
      clientOrderspagesdetailInternalOrdersIoIdProductsRoute,
    clientOrderspagesdetailInternalOrdersIoIdTracingRoute:
      clientOrderspagesdetailInternalOrdersIoIdTracingRoute,
  }

const clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren =
  clientOrderspagesdetailInternalOrdersIoIdRouteRoute._addFileChildren(
    clientOrderspagesdetailInternalOrdersIoIdRouteRouteChildren,
  )

interface clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteChildren {
  clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute
  clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute
  clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute
  clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute
}

const clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteChildren: clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteChildren =
  {
    clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute:
      clientOrderspagesdetailPurchaseOrdersPoIdDocumentsRoute,
    clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute:
      clientOrderspagesdetailPurchaseOrdersPoIdOverviewRoute,
    clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute:
      clientOrderspagesdetailPurchaseOrdersPoIdProductsRoute,
    clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute:
      clientOrderspagesdetailPurchaseOrdersPoIdTracingRoute,
  }

const clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren =
  clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute._addFileChildren(
    clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteChildren,
  )

interface clientOrderspagesdetailSalesOrdersSoIdRouteRouteChildren {
  clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute: typeof clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute
  clientOrderspagesdetailSalesOrdersSoIdOverviewRoute: typeof clientOrderspagesdetailSalesOrdersSoIdOverviewRoute
  clientOrderspagesdetailSalesOrdersSoIdProductsRoute: typeof clientOrderspagesdetailSalesOrdersSoIdProductsRoute
  clientOrderspagesdetailSalesOrdersSoIdTracingRoute: typeof clientOrderspagesdetailSalesOrdersSoIdTracingRoute
}

const clientOrderspagesdetailSalesOrdersSoIdRouteRouteChildren: clientOrderspagesdetailSalesOrdersSoIdRouteRouteChildren =
  {
    clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute:
      clientOrderspagesdetailSalesOrdersSoIdAttachmentsRoute,
    clientOrderspagesdetailSalesOrdersSoIdOverviewRoute:
      clientOrderspagesdetailSalesOrdersSoIdOverviewRoute,
    clientOrderspagesdetailSalesOrdersSoIdProductsRoute:
      clientOrderspagesdetailSalesOrdersSoIdProductsRoute,
    clientOrderspagesdetailSalesOrdersSoIdTracingRoute:
      clientOrderspagesdetailSalesOrdersSoIdTracingRoute,
  }

const clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren =
  clientOrderspagesdetailSalesOrdersSoIdRouteRoute._addFileChildren(
    clientOrderspagesdetailSalesOrdersSoIdRouteRouteChildren,
  )

interface clientOrdersRouteRouteChildren {
  clientOrderspageslistRouteRoute: typeof clientOrderspageslistRouteRouteWithChildren
  clientOrderspagesAttachmentTemplatesIndexRoute: typeof clientOrderspagesAttachmentTemplatesIndexRoute
  clientOrderspagesdetailInternalOrdersIoIdRouteRoute: typeof clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren
  clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute: typeof clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren
  clientOrderspagesdetailSalesOrdersSoIdRouteRoute: typeof clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren
  clientOrderspagesAttachmentTemplatesIdIndexRoute: typeof clientOrderspagesAttachmentTemplatesIdIndexRoute
  clientOrderspagesAttachmentTemplatesCreateIndexRoute: typeof clientOrderspagesAttachmentTemplatesCreateIndexRoute
  clientOrderspagescreatePurchaseOrdersCreateIndexRoute: typeof clientOrderspagescreatePurchaseOrdersCreateIndexRoute
  clientOrderspagescreateSalesOrdersCreateIndexRoute: typeof clientOrderspagescreateSalesOrdersCreateIndexRoute
  clientOrderspagesAttachmentTemplatesIdEditIndexRoute: typeof clientOrderspagesAttachmentTemplatesIdEditIndexRoute
}

const clientOrdersRouteRouteChildren: clientOrdersRouteRouteChildren = {
  clientOrderspageslistRouteRoute: clientOrderspageslistRouteRouteWithChildren,
  clientOrderspagesAttachmentTemplatesIndexRoute:
    clientOrderspagesAttachmentTemplatesIndexRoute,
  clientOrderspagesdetailInternalOrdersIoIdRouteRoute:
    clientOrderspagesdetailInternalOrdersIoIdRouteRouteWithChildren,
  clientOrderspagesdetailPurchaseOrdersPoIdRouteRoute:
    clientOrderspagesdetailPurchaseOrdersPoIdRouteRouteWithChildren,
  clientOrderspagesdetailSalesOrdersSoIdRouteRoute:
    clientOrderspagesdetailSalesOrdersSoIdRouteRouteWithChildren,
  clientOrderspagesAttachmentTemplatesIdIndexRoute:
    clientOrderspagesAttachmentTemplatesIdIndexRoute,
  clientOrderspagesAttachmentTemplatesCreateIndexRoute:
    clientOrderspagesAttachmentTemplatesCreateIndexRoute,
  clientOrderspagescreatePurchaseOrdersCreateIndexRoute:
    clientOrderspagescreatePurchaseOrdersCreateIndexRoute,
  clientOrderspagescreateSalesOrdersCreateIndexRoute:
    clientOrderspagescreateSalesOrdersCreateIndexRoute,
  clientOrderspagesAttachmentTemplatesIdEditIndexRoute:
    clientOrderspagesAttachmentTemplatesIdEditIndexRoute,
}

const clientOrdersRouteRouteWithChildren =
  clientOrdersRouteRoute._addFileChildren(clientOrdersRouteRouteChildren)

interface clientProductMappingpageslistRouteRouteChildren {
  clientProductMappingpageslistActiveIndexRoute: typeof clientProductMappingpageslistActiveIndexRoute
  clientProductMappingpageslistArchiveIndexRoute: typeof clientProductMappingpageslistArchiveIndexRoute
}

const clientProductMappingpageslistRouteRouteChildren: clientProductMappingpageslistRouteRouteChildren =
  {
    clientProductMappingpageslistActiveIndexRoute:
      clientProductMappingpageslistActiveIndexRoute,
    clientProductMappingpageslistArchiveIndexRoute:
      clientProductMappingpageslistArchiveIndexRoute,
  }

const clientProductMappingpageslistRouteRouteWithChildren =
  clientProductMappingpageslistRouteRoute._addFileChildren(
    clientProductMappingpageslistRouteRouteChildren,
  )

interface clientProductMappingRouteRouteChildren {
  clientProductMappingpageslistRouteRoute: typeof clientProductMappingpageslistRouteRouteWithChildren
  clientProductMappingpagesdetailsCpmIdIndexRoute: typeof clientProductMappingpagesdetailsCpmIdIndexRoute
}

const clientProductMappingRouteRouteChildren: clientProductMappingRouteRouteChildren =
  {
    clientProductMappingpageslistRouteRoute:
      clientProductMappingpageslistRouteRouteWithChildren,
    clientProductMappingpagesdetailsCpmIdIndexRoute:
      clientProductMappingpagesdetailsCpmIdIndexRoute,
  }

const clientProductMappingRouteRouteWithChildren =
  clientProductMappingRouteRoute._addFileChildren(
    clientProductMappingRouteRouteChildren,
  )

interface clientRiskpagesdetailAssessmentsRouteRouteChildren {
  clientRiskpagesdetailAssessmentsIdIndexRoute: typeof clientRiskpagesdetailAssessmentsIdIndexRoute
  clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute: typeof clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute
}

const clientRiskpagesdetailAssessmentsRouteRouteChildren: clientRiskpagesdetailAssessmentsRouteRouteChildren =
  {
    clientRiskpagesdetailAssessmentsIdIndexRoute:
      clientRiskpagesdetailAssessmentsIdIndexRoute,
    clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute:
      clientRiskpagesdetailAssessmentsIdAssessedAssessmentIdIndexRoute,
  }

const clientRiskpagesdetailAssessmentsRouteRouteWithChildren =
  clientRiskpagesdetailAssessmentsRouteRoute._addFileChildren(
    clientRiskpagesdetailAssessmentsRouteRouteChildren,
  )

interface clientRiskpagesdetailRouteRouteChildren {
  clientRiskpagesdetailAssessmentsRouteRoute: typeof clientRiskpagesdetailAssessmentsRouteRouteWithChildren
  clientRiskpagesdetailRulesIdIndexRoute: typeof clientRiskpagesdetailRulesIdIndexRoute
}

const clientRiskpagesdetailRouteRouteChildren: clientRiskpagesdetailRouteRouteChildren =
  {
    clientRiskpagesdetailAssessmentsRouteRoute:
      clientRiskpagesdetailAssessmentsRouteRouteWithChildren,
    clientRiskpagesdetailRulesIdIndexRoute:
      clientRiskpagesdetailRulesIdIndexRoute,
  }

const clientRiskpagesdetailRouteRouteWithChildren =
  clientRiskpagesdetailRouteRoute._addFileChildren(
    clientRiskpagesdetailRouteRouteChildren,
  )

interface clientRiskpageseditRouteRouteChildren {
  clientRiskpageseditRulesIdEditIndexRoute: typeof clientRiskpageseditRulesIdEditIndexRoute
}

const clientRiskpageseditRouteRouteChildren: clientRiskpageseditRouteRouteChildren =
  {
    clientRiskpageseditRulesIdEditIndexRoute:
      clientRiskpageseditRulesIdEditIndexRoute,
  }

const clientRiskpageseditRouteRouteWithChildren =
  clientRiskpageseditRouteRoute._addFileChildren(
    clientRiskpageseditRouteRouteChildren,
  )

interface clientRiskpageslistRouteRouteChildren {
  clientRiskpageslistAssessmentsIndexRoute: typeof clientRiskpageslistAssessmentsIndexRoute
  clientRiskpageslistLandscapeIndexRoute: typeof clientRiskpageslistLandscapeIndexRoute
  clientRiskpageslistRulesIndexRoute: typeof clientRiskpageslistRulesIndexRoute
}

const clientRiskpageslistRouteRouteChildren: clientRiskpageslistRouteRouteChildren =
  {
    clientRiskpageslistAssessmentsIndexRoute:
      clientRiskpageslistAssessmentsIndexRoute,
    clientRiskpageslistLandscapeIndexRoute:
      clientRiskpageslistLandscapeIndexRoute,
    clientRiskpageslistRulesIndexRoute: clientRiskpageslistRulesIndexRoute,
  }

const clientRiskpageslistRouteRouteWithChildren =
  clientRiskpageslistRouteRoute._addFileChildren(
    clientRiskpageslistRouteRouteChildren,
  )

interface clientRiskRouteRouteChildren {
  clientRiskpagesdetailRouteRoute: typeof clientRiskpagesdetailRouteRouteWithChildren
  clientRiskpageseditRouteRoute: typeof clientRiskpageseditRouteRouteWithChildren
  clientRiskpageslistRouteRoute: typeof clientRiskpageslistRouteRouteWithChildren
}

const clientRiskRouteRouteChildren: clientRiskRouteRouteChildren = {
  clientRiskpagesdetailRouteRoute: clientRiskpagesdetailRouteRouteWithChildren,
  clientRiskpageseditRouteRoute: clientRiskpageseditRouteRouteWithChildren,
  clientRiskpageslistRouteRoute: clientRiskpageslistRouteRouteWithChildren,
}

const clientRiskRouteRouteWithChildren = clientRiskRouteRoute._addFileChildren(
  clientRiskRouteRouteChildren,
)

interface clientSupplyChainMappingpageslistInsightsRouteRouteChildren {
  clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute: typeof clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute
  clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute: typeof clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute
  clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute: typeof clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute
  clientSupplyChainMappingpageslistInsightsOverviewIndexRoute: typeof clientSupplyChainMappingpageslistInsightsOverviewIndexRoute
}

const clientSupplyChainMappingpageslistInsightsRouteRouteChildren: clientSupplyChainMappingpageslistInsightsRouteRouteChildren =
  {
    clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute:
      clientSupplyChainMappingpageslistInsightsCollaboratorCompaniesIndexRoute,
    clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute:
      clientSupplyChainMappingpageslistInsightsGlobalDiagramIndexRoute,
    clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute:
      clientSupplyChainMappingpageslistInsightsMappedCompaniesIndexRoute,
    clientSupplyChainMappingpageslistInsightsOverviewIndexRoute:
      clientSupplyChainMappingpageslistInsightsOverviewIndexRoute,
  }

const clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren =
  clientSupplyChainMappingpageslistInsightsRouteRoute._addFileChildren(
    clientSupplyChainMappingpageslistInsightsRouteRouteChildren,
  )

interface clientSupplyChainMappingpageslistSupplyChainsRouteRouteChildren {
  clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute: typeof clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute
  clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute: typeof clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute
}

const clientSupplyChainMappingpageslistSupplyChainsRouteRouteChildren: clientSupplyChainMappingpageslistSupplyChainsRouteRouteChildren =
  {
    clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute:
      clientSupplyChainMappingpageslistSupplyChainsActiveIndexRoute,
    clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute:
      clientSupplyChainMappingpageslistSupplyChainsArchiveIndexRoute,
  }

const clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren =
  clientSupplyChainMappingpageslistSupplyChainsRouteRoute._addFileChildren(
    clientSupplyChainMappingpageslistSupplyChainsRouteRouteChildren,
  )

interface clientSupplyChainMappingpageslistRouteRouteChildren {
  clientSupplyChainMappingpageslistInsightsRouteRoute: typeof clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren
  clientSupplyChainMappingpageslistSupplyChainsRouteRoute: typeof clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren
  clientSupplyChainMappingpageslistHistoryIndexRoute: typeof clientSupplyChainMappingpageslistHistoryIndexRoute
}

const clientSupplyChainMappingpageslistRouteRouteChildren: clientSupplyChainMappingpageslistRouteRouteChildren =
  {
    clientSupplyChainMappingpageslistInsightsRouteRoute:
      clientSupplyChainMappingpageslistInsightsRouteRouteWithChildren,
    clientSupplyChainMappingpageslistSupplyChainsRouteRoute:
      clientSupplyChainMappingpageslistSupplyChainsRouteRouteWithChildren,
    clientSupplyChainMappingpageslistHistoryIndexRoute:
      clientSupplyChainMappingpageslistHistoryIndexRoute,
  }

const clientSupplyChainMappingpageslistRouteRouteWithChildren =
  clientSupplyChainMappingpageslistRouteRoute._addFileChildren(
    clientSupplyChainMappingpageslistRouteRouteChildren,
  )

interface clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteChildren {
  clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute
  clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute
  clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute
}

const clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteChildren: clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteChildren =
  {
    clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute:
      clientSupplyChainMappingpagesdetailsSupplyChainsIdCompareIndexRoute,
    clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute:
      clientSupplyChainMappingpagesdetailsSupplyChainsIdDiagramIndexRoute,
    clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute:
      clientSupplyChainMappingpagesdetailsSupplyChainsIdMapIndexRoute,
  }

const clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren =
  clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute._addFileChildren(
    clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteChildren,
  )

interface clientSupplyChainMappingRouteRouteChildren {
  clientSupplyChainMappingpageslistRouteRoute: typeof clientSupplyChainMappingpageslistRouteRouteWithChildren
  clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute: typeof clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren
}

const clientSupplyChainMappingRouteRouteChildren: clientSupplyChainMappingRouteRouteChildren =
  {
    clientSupplyChainMappingpageslistRouteRoute:
      clientSupplyChainMappingpageslistRouteRouteWithChildren,
    clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRoute:
      clientSupplyChainMappingpagesdetailsSupplyChainsIdRouteRouteWithChildren,
  }

const clientSupplyChainMappingRouteRouteWithChildren =
  clientSupplyChainMappingRouteRoute._addFileChildren(
    clientSupplyChainMappingRouteRouteChildren,
  )

interface clientCapapagesdetailRouteRouteChildren {
  clientCapapagesdetailActionsIdIndexRoute: typeof clientCapapagesdetailActionsIdIndexRoute
  clientCapapagesdetailPlansIdIndexRoute: typeof clientCapapagesdetailPlansIdIndexRoute
}

const clientCapapagesdetailRouteRouteChildren: clientCapapagesdetailRouteRouteChildren =
  {
    clientCapapagesdetailActionsIdIndexRoute:
      clientCapapagesdetailActionsIdIndexRoute,
    clientCapapagesdetailPlansIdIndexRoute:
      clientCapapagesdetailPlansIdIndexRoute,
  }

const clientCapapagesdetailRouteRouteWithChildren =
  clientCapapagesdetailRouteRoute._addFileChildren(
    clientCapapagesdetailRouteRouteChildren,
  )

interface clientCapapageslistActionsRouteRouteChildren {
  clientCapapageslistActionsActiveIndexRoute: typeof clientCapapageslistActionsActiveIndexRoute
  clientCapapageslistActionsArchivedIndexRoute: typeof clientCapapageslistActionsArchivedIndexRoute
}

const clientCapapageslistActionsRouteRouteChildren: clientCapapageslistActionsRouteRouteChildren =
  {
    clientCapapageslistActionsActiveIndexRoute:
      clientCapapageslistActionsActiveIndexRoute,
    clientCapapageslistActionsArchivedIndexRoute:
      clientCapapageslistActionsArchivedIndexRoute,
  }

const clientCapapageslistActionsRouteRouteWithChildren =
  clientCapapageslistActionsRouteRoute._addFileChildren(
    clientCapapageslistActionsRouteRouteChildren,
  )

interface clientCapapageslistFindingsRouteRouteChildren {
  clientCapapageslistFindingsActiveIndexRoute: typeof clientCapapageslistFindingsActiveIndexRoute
  clientCapapageslistFindingsArchivedIndexRoute: typeof clientCapapageslistFindingsArchivedIndexRoute
}

const clientCapapageslistFindingsRouteRouteChildren: clientCapapageslistFindingsRouteRouteChildren =
  {
    clientCapapageslistFindingsActiveIndexRoute:
      clientCapapageslistFindingsActiveIndexRoute,
    clientCapapageslistFindingsArchivedIndexRoute:
      clientCapapageslistFindingsArchivedIndexRoute,
  }

const clientCapapageslistFindingsRouteRouteWithChildren =
  clientCapapageslistFindingsRouteRoute._addFileChildren(
    clientCapapageslistFindingsRouteRouteChildren,
  )

interface clientCapapageslistPlansRouteRouteChildren {
  clientCapapageslistPlansActiveIndexRoute: typeof clientCapapageslistPlansActiveIndexRoute
  clientCapapageslistPlansArchivedIndexRoute: typeof clientCapapageslistPlansArchivedIndexRoute
}

const clientCapapageslistPlansRouteRouteChildren: clientCapapageslistPlansRouteRouteChildren =
  {
    clientCapapageslistPlansActiveIndexRoute:
      clientCapapageslistPlansActiveIndexRoute,
    clientCapapageslistPlansArchivedIndexRoute:
      clientCapapageslistPlansArchivedIndexRoute,
  }

const clientCapapageslistPlansRouteRouteWithChildren =
  clientCapapageslistPlansRouteRoute._addFileChildren(
    clientCapapageslistPlansRouteRouteChildren,
  )

interface clientCapapageslistRouteRouteChildren {
  clientCapapageslistActionsRouteRoute: typeof clientCapapageslistActionsRouteRouteWithChildren
  clientCapapageslistFindingsRouteRoute: typeof clientCapapageslistFindingsRouteRouteWithChildren
  clientCapapageslistPlansRouteRoute: typeof clientCapapageslistPlansRouteRouteWithChildren
}

const clientCapapageslistRouteRouteChildren: clientCapapageslistRouteRouteChildren =
  {
    clientCapapageslistActionsRouteRoute:
      clientCapapageslistActionsRouteRouteWithChildren,
    clientCapapageslistFindingsRouteRoute:
      clientCapapageslistFindingsRouteRouteWithChildren,
    clientCapapageslistPlansRouteRoute:
      clientCapapageslistPlansRouteRouteWithChildren,
  }

const clientCapapageslistRouteRouteWithChildren =
  clientCapapageslistRouteRoute._addFileChildren(
    clientCapapageslistRouteRouteChildren,
  )

interface clientCapapagesRouteRouteChildren {
  clientCapapagesdetailRouteRoute: typeof clientCapapagesdetailRouteRouteWithChildren
  clientCapapageslistRouteRoute: typeof clientCapapageslistRouteRouteWithChildren
}

const clientCapapagesRouteRouteChildren: clientCapapagesRouteRouteChildren = {
  clientCapapagesdetailRouteRoute: clientCapapagesdetailRouteRouteWithChildren,
  clientCapapageslistRouteRoute: clientCapapageslistRouteRouteWithChildren,
}

const clientCapapagesRouteRouteWithChildren =
  clientCapapagesRouteRoute._addFileChildren(clientCapapagesRouteRouteChildren)

interface clientCertificationspagesRouteRouteChildren {
  clientCertificationspagesIndexRoute: typeof clientCertificationspagesIndexRoute
  clientCertificationspagesIdIndexRoute: typeof clientCertificationspagesIdIndexRoute
}

const clientCertificationspagesRouteRouteChildren: clientCertificationspagesRouteRouteChildren =
  {
    clientCertificationspagesIndexRoute: clientCertificationspagesIndexRoute,
    clientCertificationspagesIdIndexRoute:
      clientCertificationspagesIdIndexRoute,
  }

const clientCertificationspagesRouteRouteWithChildren =
  clientCertificationspagesRouteRoute._addFileChildren(
    clientCertificationspagesRouteRouteChildren,
  )

interface clientCertifiedMaterialspagesRouteRouteChildren {
  clientCertifiedMaterialspagesIndexRoute: typeof clientCertifiedMaterialspagesIndexRoute
}

const clientCertifiedMaterialspagesRouteRouteChildren: clientCertifiedMaterialspagesRouteRouteChildren =
  {
    clientCertifiedMaterialspagesIndexRoute:
      clientCertifiedMaterialspagesIndexRoute,
  }

const clientCertifiedMaterialspagesRouteRouteWithChildren =
  clientCertifiedMaterialspagesRouteRoute._addFileChildren(
    clientCertifiedMaterialspagesRouteRouteChildren,
  )

interface clientCompanySettingspagesConstantsMappingRouteRouteChildren {
  clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute: typeof clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute
  clientCompanySettingspagesConstantsMappingMaterialsIndexRoute: typeof clientCompanySettingspagesConstantsMappingMaterialsIndexRoute
  clientCompanySettingspagesConstantsMappingProductTypesIndexRoute: typeof clientCompanySettingspagesConstantsMappingProductTypesIndexRoute
}

const clientCompanySettingspagesConstantsMappingRouteRouteChildren: clientCompanySettingspagesConstantsMappingRouteRouteChildren =
  {
    clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute:
      clientCompanySettingspagesConstantsMappingFacilityProcessesIndexRoute,
    clientCompanySettingspagesConstantsMappingMaterialsIndexRoute:
      clientCompanySettingspagesConstantsMappingMaterialsIndexRoute,
    clientCompanySettingspagesConstantsMappingProductTypesIndexRoute:
      clientCompanySettingspagesConstantsMappingProductTypesIndexRoute,
  }

const clientCompanySettingspagesConstantsMappingRouteRouteWithChildren =
  clientCompanySettingspagesConstantsMappingRouteRoute._addFileChildren(
    clientCompanySettingspagesConstantsMappingRouteRouteChildren,
  )

interface clientCompanySettingspagesIntegrationsRouteRouteChildren {
  clientCompanySettingspagesIntegrationsIndexRoute: typeof clientCompanySettingspagesIntegrationsIndexRoute
  clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute: typeof clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute
}

const clientCompanySettingspagesIntegrationsRouteRouteChildren: clientCompanySettingspagesIntegrationsRouteRouteChildren =
  {
    clientCompanySettingspagesIntegrationsIndexRoute:
      clientCompanySettingspagesIntegrationsIndexRoute,
    clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute:
      clientCompanySettingspagesIntegrationsHistorySyncHistoryIdIndexRoute,
  }

const clientCompanySettingspagesIntegrationsRouteRouteWithChildren =
  clientCompanySettingspagesIntegrationsRouteRoute._addFileChildren(
    clientCompanySettingspagesIntegrationsRouteRouteChildren,
  )

interface clientCompanySettingspagesRouteRouteChildren {
  clientCompanySettingspagesConstantsMappingRouteRoute: typeof clientCompanySettingspagesConstantsMappingRouteRouteWithChildren
  clientCompanySettingspagesIntegrationsRouteRoute: typeof clientCompanySettingspagesIntegrationsRouteRouteWithChildren
  clientCompanySettingspagesApiKeysRoute: typeof clientCompanySettingspagesApiKeysRoute
  clientCompanySettingspagesJoinRequestsRoute: typeof clientCompanySettingspagesJoinRequestsRoute
  clientCompanySettingspagesUsersRoute: typeof clientCompanySettingspagesUsersRoute
  clientCompanySettingspagesWebshopSettingsRoute: typeof clientCompanySettingspagesWebshopSettingsRoute
  clientCompanySettingspagesPermissionSetsNewRoute: typeof clientCompanySettingspagesPermissionSetsNewRoute
  clientCompanySettingspagesPermissionSetsIndexRoute: typeof clientCompanySettingspagesPermissionSetsIndexRoute
  clientCompanySettingspagesPermissionSetsSetKeyEditRoute: typeof clientCompanySettingspagesPermissionSetsSetKeyEditRoute
  clientCompanySettingspagesPermissionSetsSetKeyIndexRoute: typeof clientCompanySettingspagesPermissionSetsSetKeyIndexRoute
}

const clientCompanySettingspagesRouteRouteChildren: clientCompanySettingspagesRouteRouteChildren =
  {
    clientCompanySettingspagesConstantsMappingRouteRoute:
      clientCompanySettingspagesConstantsMappingRouteRouteWithChildren,
    clientCompanySettingspagesIntegrationsRouteRoute:
      clientCompanySettingspagesIntegrationsRouteRouteWithChildren,
    clientCompanySettingspagesApiKeysRoute:
      clientCompanySettingspagesApiKeysRoute,
    clientCompanySettingspagesJoinRequestsRoute:
      clientCompanySettingspagesJoinRequestsRoute,
    clientCompanySettingspagesUsersRoute: clientCompanySettingspagesUsersRoute,
    clientCompanySettingspagesWebshopSettingsRoute:
      clientCompanySettingspagesWebshopSettingsRoute,
    clientCompanySettingspagesPermissionSetsNewRoute:
      clientCompanySettingspagesPermissionSetsNewRoute,
    clientCompanySettingspagesPermissionSetsIndexRoute:
      clientCompanySettingspagesPermissionSetsIndexRoute,
    clientCompanySettingspagesPermissionSetsSetKeyEditRoute:
      clientCompanySettingspagesPermissionSetsSetKeyEditRoute,
    clientCompanySettingspagesPermissionSetsSetKeyIndexRoute:
      clientCompanySettingspagesPermissionSetsSetKeyIndexRoute,
  }

const clientCompanySettingspagesRouteRouteWithChildren =
  clientCompanySettingspagesRouteRoute._addFileChildren(
    clientCompanySettingspagesRouteRouteChildren,
  )

interface clientDocumentspageslistRouteRouteChildren {
  clientDocumentspageslistArchivedIndexRoute: typeof clientDocumentspageslistArchivedIndexRoute
  clientDocumentspageslistMyDocumentsIndexRoute: typeof clientDocumentspageslistMyDocumentsIndexRoute
  clientDocumentspageslistRequestAccessIndexRoute: typeof clientDocumentspageslistRequestAccessIndexRoute
}

const clientDocumentspageslistRouteRouteChildren: clientDocumentspageslistRouteRouteChildren =
  {
    clientDocumentspageslistArchivedIndexRoute:
      clientDocumentspageslistArchivedIndexRoute,
    clientDocumentspageslistMyDocumentsIndexRoute:
      clientDocumentspageslistMyDocumentsIndexRoute,
    clientDocumentspageslistRequestAccessIndexRoute:
      clientDocumentspageslistRequestAccessIndexRoute,
  }

const clientDocumentspageslistRouteRouteWithChildren =
  clientDocumentspageslistRouteRoute._addFileChildren(
    clientDocumentspageslistRouteRouteChildren,
  )

interface clientDocumentspagesRouteRouteChildren {
  clientDocumentspageslistRouteRoute: typeof clientDocumentspageslistRouteRouteWithChildren
}

const clientDocumentspagesRouteRouteChildren: clientDocumentspagesRouteRouteChildren =
  {
    clientDocumentspageslistRouteRoute:
      clientDocumentspageslistRouteRouteWithChildren,
  }

const clientDocumentspagesRouteRouteWithChildren =
  clientDocumentspagesRouteRoute._addFileChildren(
    clientDocumentspagesRouteRouteChildren,
  )

interface clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteChildren {
  clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute
  clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute
}

const clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteChildren: clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteChildren =
  {
    clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute:
      clientNetworkpagesdetailCompanyIdIntegrationsIndexRoute,
    clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute:
      clientNetworkpagesdetailCompanyIdIntegrationsHistorySyncHistoryIdIndexRoute,
  }

const clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteWithChildren =
  clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute._addFileChildren(
    clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteChildren,
  )

interface clientNetworkpagesdetailCompanyIdRouteRouteChildren {
  clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute: typeof clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteWithChildren
  clientNetworkpagesdetailCompanyIdBadgesRoute: typeof clientNetworkpagesdetailCompanyIdBadgesRoute
  clientNetworkpagesdetailCompanyIdCapaRoute: typeof clientNetworkpagesdetailCompanyIdCapaRoute
  clientNetworkpagesdetailCompanyIdClaimsRoute: typeof clientNetworkpagesdetailCompanyIdClaimsRoute
  clientNetworkpagesdetailCompanyIdCustomInformationRoute: typeof clientNetworkpagesdetailCompanyIdCustomInformationRoute
  clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute: typeof clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute
  clientNetworkpagesdetailCompanyIdDocumentsRoute: typeof clientNetworkpagesdetailCompanyIdDocumentsRoute
  clientNetworkpagesdetailCompanyIdEsgInfoRoute: typeof clientNetworkpagesdetailCompanyIdEsgInfoRoute
  clientNetworkpagesdetailCompanyIdGeneralInfoRoute: typeof clientNetworkpagesdetailCompanyIdGeneralInfoRoute
  clientNetworkpagesdetailCompanyIdHistoryRoute: typeof clientNetworkpagesdetailCompanyIdHistoryRoute
  clientNetworkpagesdetailCompanyIdProductsRoute: typeof clientNetworkpagesdetailCompanyIdProductsRoute
  clientNetworkpagesdetailCompanyIdQuestionnaireRoute: typeof clientNetworkpagesdetailCompanyIdQuestionnaireRoute
  clientNetworkpagesdetailCompanyIdRiskProfileRoute: typeof clientNetworkpagesdetailCompanyIdRiskProfileRoute
  clientNetworkpagesdetailCompanyIdSlcpRoute: typeof clientNetworkpagesdetailCompanyIdSlcpRoute
  clientNetworkpagesdetailCompanyIdUsersRoute: typeof clientNetworkpagesdetailCompanyIdUsersRoute
  clientNetworkpagesdetailCompanyIdWebshopProfileRoute: typeof clientNetworkpagesdetailCompanyIdWebshopProfileRoute
  clientNetworkpagesdetailCompanyIdAuditsIndexRoute: typeof clientNetworkpagesdetailCompanyIdAuditsIndexRoute
  clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute: typeof clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute
}

const clientNetworkpagesdetailCompanyIdRouteRouteChildren: clientNetworkpagesdetailCompanyIdRouteRouteChildren =
  {
    clientNetworkpagesdetailCompanyIdIntegrationsRouteRoute:
      clientNetworkpagesdetailCompanyIdIntegrationsRouteRouteWithChildren,
    clientNetworkpagesdetailCompanyIdBadgesRoute:
      clientNetworkpagesdetailCompanyIdBadgesRoute,
    clientNetworkpagesdetailCompanyIdCapaRoute:
      clientNetworkpagesdetailCompanyIdCapaRoute,
    clientNetworkpagesdetailCompanyIdClaimsRoute:
      clientNetworkpagesdetailCompanyIdClaimsRoute,
    clientNetworkpagesdetailCompanyIdCustomInformationRoute:
      clientNetworkpagesdetailCompanyIdCustomInformationRoute,
    clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute:
      clientNetworkpagesdetailCompanyIdCustomInformationFieldsRoute,
    clientNetworkpagesdetailCompanyIdDocumentsRoute:
      clientNetworkpagesdetailCompanyIdDocumentsRoute,
    clientNetworkpagesdetailCompanyIdEsgInfoRoute:
      clientNetworkpagesdetailCompanyIdEsgInfoRoute,
    clientNetworkpagesdetailCompanyIdGeneralInfoRoute:
      clientNetworkpagesdetailCompanyIdGeneralInfoRoute,
    clientNetworkpagesdetailCompanyIdHistoryRoute:
      clientNetworkpagesdetailCompanyIdHistoryRoute,
    clientNetworkpagesdetailCompanyIdProductsRoute:
      clientNetworkpagesdetailCompanyIdProductsRoute,
    clientNetworkpagesdetailCompanyIdQuestionnaireRoute:
      clientNetworkpagesdetailCompanyIdQuestionnaireRoute,
    clientNetworkpagesdetailCompanyIdRiskProfileRoute:
      clientNetworkpagesdetailCompanyIdRiskProfileRoute,
    clientNetworkpagesdetailCompanyIdSlcpRoute:
      clientNetworkpagesdetailCompanyIdSlcpRoute,
    clientNetworkpagesdetailCompanyIdUsersRoute:
      clientNetworkpagesdetailCompanyIdUsersRoute,
    clientNetworkpagesdetailCompanyIdWebshopProfileRoute:
      clientNetworkpagesdetailCompanyIdWebshopProfileRoute,
    clientNetworkpagesdetailCompanyIdAuditsIndexRoute:
      clientNetworkpagesdetailCompanyIdAuditsIndexRoute,
    clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute:
      clientNetworkpagesdetailCompanyIdAuditsAuditIdFindingsIndexRoute,
  }

const clientNetworkpagesdetailCompanyIdRouteRouteWithChildren =
  clientNetworkpagesdetailCompanyIdRouteRoute._addFileChildren(
    clientNetworkpagesdetailCompanyIdRouteRouteChildren,
  )

interface clientNetworkpagesdetailRouteRouteChildren {
  clientNetworkpagesdetailCompanyIdRouteRoute: typeof clientNetworkpagesdetailCompanyIdRouteRouteWithChildren
}

const clientNetworkpagesdetailRouteRouteChildren: clientNetworkpagesdetailRouteRouteChildren =
  {
    clientNetworkpagesdetailCompanyIdRouteRoute:
      clientNetworkpagesdetailCompanyIdRouteRouteWithChildren,
  }

const clientNetworkpagesdetailRouteRouteWithChildren =
  clientNetworkpagesdetailRouteRoute._addFileChildren(
    clientNetworkpagesdetailRouteRouteChildren,
  )

interface clientNetworkpageslistRouteRouteChildren {
  clientNetworkpageslistMyNetworkIndexRoute: typeof clientNetworkpageslistMyNetworkIndexRoute
}

const clientNetworkpageslistRouteRouteChildren: clientNetworkpageslistRouteRouteChildren =
  {
    clientNetworkpageslistMyNetworkIndexRoute:
      clientNetworkpageslistMyNetworkIndexRoute,
  }

const clientNetworkpageslistRouteRouteWithChildren =
  clientNetworkpageslistRouteRoute._addFileChildren(
    clientNetworkpageslistRouteRouteChildren,
  )

interface clientNetworkpagesRouteRouteChildren {
  clientNetworkpagesdetailRouteRoute: typeof clientNetworkpagesdetailRouteRouteWithChildren
  clientNetworkpageslistRouteRoute: typeof clientNetworkpageslistRouteRouteWithChildren
}

const clientNetworkpagesRouteRouteChildren: clientNetworkpagesRouteRouteChildren =
  {
    clientNetworkpagesdetailRouteRoute:
      clientNetworkpagesdetailRouteRouteWithChildren,
    clientNetworkpageslistRouteRoute:
      clientNetworkpageslistRouteRouteWithChildren,
  }

const clientNetworkpagesRouteRouteWithChildren =
  clientNetworkpagesRouteRoute._addFileChildren(
    clientNetworkpagesRouteRouteChildren,
  )

interface clientProfilepagesRouteRouteChildren {
  clientProfilepagesOverviewIndexRoute: typeof clientProfilepagesOverviewIndexRoute
  clientProfilepagesSettingsIndexRoute: typeof clientProfilepagesSettingsIndexRoute
}

const clientProfilepagesRouteRouteChildren: clientProfilepagesRouteRouteChildren =
  {
    clientProfilepagesOverviewIndexRoute: clientProfilepagesOverviewIndexRoute,
    clientProfilepagesSettingsIndexRoute: clientProfilepagesSettingsIndexRoute,
  }

const clientProfilepagesRouteRouteWithChildren =
  clientProfilepagesRouteRoute._addFileChildren(
    clientProfilepagesRouteRouteChildren,
  )

interface clientQuestionnairespageslistMyQuestionnairesRouteRouteChildren {
  clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute: typeof clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute
  clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute: typeof clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute
}

const clientQuestionnairespageslistMyQuestionnairesRouteRouteChildren: clientQuestionnairespageslistMyQuestionnairesRouteRouteChildren =
  {
    clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute:
      clientQuestionnairespageslistMyQuestionnairesActiveIndexRoute,
    clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute:
      clientQuestionnairespageslistMyQuestionnairesArchivedIndexRoute,
  }

const clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren =
  clientQuestionnairespageslistMyQuestionnairesRouteRoute._addFileChildren(
    clientQuestionnairespageslistMyQuestionnairesRouteRouteChildren,
  )

interface clientQuestionnairespageslistRouteRouteChildren {
  clientQuestionnairespageslistMyQuestionnairesRouteRoute: typeof clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren
  clientQuestionnairespageslistRequestsIndexRoute: typeof clientQuestionnairespageslistRequestsIndexRoute
  clientQuestionnairespageslistTemplatesIndexRoute: typeof clientQuestionnairespageslistTemplatesIndexRoute
}

const clientQuestionnairespageslistRouteRouteChildren: clientQuestionnairespageslistRouteRouteChildren =
  {
    clientQuestionnairespageslistMyQuestionnairesRouteRoute:
      clientQuestionnairespageslistMyQuestionnairesRouteRouteWithChildren,
    clientQuestionnairespageslistRequestsIndexRoute:
      clientQuestionnairespageslistRequestsIndexRoute,
    clientQuestionnairespageslistTemplatesIndexRoute:
      clientQuestionnairespageslistTemplatesIndexRoute,
  }

const clientQuestionnairespageslistRouteRouteWithChildren =
  clientQuestionnairespageslistRouteRoute._addFileChildren(
    clientQuestionnairespageslistRouteRouteChildren,
  )

interface clientQuestionnairespagesdetailIdRouteRouteChildren {
  clientQuestionnairespagesdetailIdEditIndexRoute: typeof clientQuestionnairespagesdetailIdEditIndexRoute
  clientQuestionnairespagesdetailIdReviewIndexRoute: typeof clientQuestionnairespagesdetailIdReviewIndexRoute
  clientQuestionnairespagesdetailIdSummaryIndexRoute: typeof clientQuestionnairespagesdetailIdSummaryIndexRoute
}

const clientQuestionnairespagesdetailIdRouteRouteChildren: clientQuestionnairespagesdetailIdRouteRouteChildren =
  {
    clientQuestionnairespagesdetailIdEditIndexRoute:
      clientQuestionnairespagesdetailIdEditIndexRoute,
    clientQuestionnairespagesdetailIdReviewIndexRoute:
      clientQuestionnairespagesdetailIdReviewIndexRoute,
    clientQuestionnairespagesdetailIdSummaryIndexRoute:
      clientQuestionnairespagesdetailIdSummaryIndexRoute,
  }

const clientQuestionnairespagesdetailIdRouteRouteWithChildren =
  clientQuestionnairespagesdetailIdRouteRoute._addFileChildren(
    clientQuestionnairespagesdetailIdRouteRouteChildren,
  )

interface clientQuestionnairespagesRouteRouteChildren {
  clientQuestionnairespageslistRouteRoute: typeof clientQuestionnairespageslistRouteRouteWithChildren
  clientQuestionnairespagesdetailIdRouteRoute: typeof clientQuestionnairespagesdetailIdRouteRouteWithChildren
  clientQuestionnairespagesdetailIdAnswerIndexRoute: typeof clientQuestionnairespagesdetailIdAnswerIndexRoute
  clientQuestionnairespagesdetailIdPreviewIndexRoute: typeof clientQuestionnairespagesdetailIdPreviewIndexRoute
}

const clientQuestionnairespagesRouteRouteChildren: clientQuestionnairespagesRouteRouteChildren =
  {
    clientQuestionnairespageslistRouteRoute:
      clientQuestionnairespageslistRouteRouteWithChildren,
    clientQuestionnairespagesdetailIdRouteRoute:
      clientQuestionnairespagesdetailIdRouteRouteWithChildren,
    clientQuestionnairespagesdetailIdAnswerIndexRoute:
      clientQuestionnairespagesdetailIdAnswerIndexRoute,
    clientQuestionnairespagesdetailIdPreviewIndexRoute:
      clientQuestionnairespagesdetailIdPreviewIndexRoute,
  }

const clientQuestionnairespagesRouteRouteWithChildren =
  clientQuestionnairespagesRouteRoute._addFileChildren(
    clientQuestionnairespagesRouteRouteChildren,
  )

interface clientReportpagesRouteRouteChildren {
  clientReportpagesanalyticsAuditComplianceIndexRoute: typeof clientReportpagesanalyticsAuditComplianceIndexRoute
  clientReportpagesanalyticsCertificateComplianceIndexRoute: typeof clientReportpagesanalyticsCertificateComplianceIndexRoute
  clientReportpagesanalyticsTracingComplianceIndexRoute: typeof clientReportpagesanalyticsTracingComplianceIndexRoute
  clientReportpagesanalyticsTracingOperationsIndexRoute: typeof clientReportpagesanalyticsTracingOperationsIndexRoute
  clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute: typeof clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute
  clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute: typeof clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute
}

const clientReportpagesRouteRouteChildren: clientReportpagesRouteRouteChildren =
  {
    clientReportpagesanalyticsAuditComplianceIndexRoute:
      clientReportpagesanalyticsAuditComplianceIndexRoute,
    clientReportpagesanalyticsCertificateComplianceIndexRoute:
      clientReportpagesanalyticsCertificateComplianceIndexRoute,
    clientReportpagesanalyticsTracingComplianceIndexRoute:
      clientReportpagesanalyticsTracingComplianceIndexRoute,
    clientReportpagesanalyticsTracingOperationsIndexRoute:
      clientReportpagesanalyticsTracingOperationsIndexRoute,
    clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute:
      clientReportpagesdrilldownAuditComplianceDrilldownChartTypeIndexRoute,
    clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute:
      clientReportpagesdrilldownCertificateComplianceDrilldownChartTypeIndexRoute,
  }

const clientReportpagesRouteRouteWithChildren =
  clientReportpagesRouteRoute._addFileChildren(
    clientReportpagesRouteRouteChildren,
  )

interface clientSlcppageslistMyOwnRouteRouteChildren {
  clientSlcppageslistMyOwnActiveIndexRoute: typeof clientSlcppageslistMyOwnActiveIndexRoute
  clientSlcppageslistMyOwnArchiveIndexRoute: typeof clientSlcppageslistMyOwnArchiveIndexRoute
}

const clientSlcppageslistMyOwnRouteRouteChildren: clientSlcppageslistMyOwnRouteRouteChildren =
  {
    clientSlcppageslistMyOwnActiveIndexRoute:
      clientSlcppageslistMyOwnActiveIndexRoute,
    clientSlcppageslistMyOwnArchiveIndexRoute:
      clientSlcppageslistMyOwnArchiveIndexRoute,
  }

const clientSlcppageslistMyOwnRouteRouteWithChildren =
  clientSlcppageslistMyOwnRouteRoute._addFileChildren(
    clientSlcppageslistMyOwnRouteRouteChildren,
  )

interface clientSlcppageslistRouteRouteChildren {
  clientSlcppageslistMyOwnRouteRoute: typeof clientSlcppageslistMyOwnRouteRouteWithChildren
  clientSlcppageslistNetworkIndexRoute: typeof clientSlcppageslistNetworkIndexRoute
}

const clientSlcppageslistRouteRouteChildren: clientSlcppageslistRouteRouteChildren =
  {
    clientSlcppageslistMyOwnRouteRoute:
      clientSlcppageslistMyOwnRouteRouteWithChildren,
    clientSlcppageslistNetworkIndexRoute: clientSlcppageslistNetworkIndexRoute,
  }

const clientSlcppageslistRouteRouteWithChildren =
  clientSlcppageslistRouteRoute._addFileChildren(
    clientSlcppageslistRouteRouteChildren,
  )

interface clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteChildren {
  clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute
  clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute
  clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute
}

const clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteChildren: clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteChildren =
  {
    clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute:
      clientSlcppagesAssessmentsdetailsAssessmentIdIndexRoute,
    clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute:
      clientSlcppagesAssessmentsdetailsAssessmentIdAssessmentIndexRoute,
    clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute:
      clientSlcppagesAssessmentsdetailsAssessmentIdOverviewIndexRoute,
  }

const clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteWithChildren =
  clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute._addFileChildren(
    clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteChildren,
  )

interface clientSlcppagesRouteRouteChildren {
  clientSlcppageslistRouteRoute: typeof clientSlcppageslistRouteRouteWithChildren
  clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute: typeof clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteWithChildren
}

const clientSlcppagesRouteRouteChildren: clientSlcppagesRouteRouteChildren = {
  clientSlcppageslistRouteRoute: clientSlcppageslistRouteRouteWithChildren,
  clientSlcppagesAssessmentsdetailsAssessmentIdRouteRoute:
    clientSlcppagesAssessmentsdetailsAssessmentIdRouteRouteWithChildren,
}

const clientSlcppagesRouteRouteWithChildren =
  clientSlcppagesRouteRoute._addFileChildren(clientSlcppagesRouteRouteChildren)

interface clientOrdersHubpagesdetailIdRouteRouteChildren {
  clientOrdersHubpagesdetailIdAttachmentsRoute: typeof clientOrdersHubpagesdetailIdAttachmentsRoute
  clientOrdersHubpagesdetailIdLinesRoute: typeof clientOrdersHubpagesdetailIdLinesRoute
  clientOrdersHubpagesdetailIdOverviewRoute: typeof clientOrdersHubpagesdetailIdOverviewRoute
}

const clientOrdersHubpagesdetailIdRouteRouteChildren: clientOrdersHubpagesdetailIdRouteRouteChildren =
  {
    clientOrdersHubpagesdetailIdAttachmentsRoute:
      clientOrdersHubpagesdetailIdAttachmentsRoute,
    clientOrdersHubpagesdetailIdLinesRoute:
      clientOrdersHubpagesdetailIdLinesRoute,
    clientOrdersHubpagesdetailIdOverviewRoute:
      clientOrdersHubpagesdetailIdOverviewRoute,
  }

const clientOrdersHubpagesdetailIdRouteRouteWithChildren =
  clientOrdersHubpagesdetailIdRouteRoute._addFileChildren(
    clientOrdersHubpagesdetailIdRouteRouteChildren,
  )

interface clientRouteRouteChildren {
  clientAuditsRouteRoute: typeof clientAuditsRouteRouteWithChildren
  clientEntityScreeningRouteRoute: typeof clientEntityScreeningRouteRouteWithChildren
  clientFilesRouteRoute: typeof clientFilesRouteRouteWithChildren
  clientMyComponentsRouteRoute: typeof clientMyComponentsRouteRouteWithChildren
  clientMyStylesRouteRoute: typeof clientMyStylesRouteRouteWithChildren
  clientOrdersRouteRoute: typeof clientOrdersRouteRouteWithChildren
  clientProductMappingRouteRoute: typeof clientProductMappingRouteRouteWithChildren
  clientRiskRouteRoute: typeof clientRiskRouteRouteWithChildren
  clientSupplyChainMappingRouteRoute: typeof clientSupplyChainMappingRouteRouteWithChildren
  clientCapapagesRouteRoute: typeof clientCapapagesRouteRouteWithChildren
  clientCertificationspagesRouteRoute: typeof clientCertificationspagesRouteRouteWithChildren
  clientCertifiedMaterialspagesRouteRoute: typeof clientCertifiedMaterialspagesRouteRouteWithChildren
  clientCompanySettingspagesRouteRoute: typeof clientCompanySettingspagesRouteRouteWithChildren
  clientDocumentspagesRouteRoute: typeof clientDocumentspagesRouteRouteWithChildren
  clientNetworkpagesRouteRoute: typeof clientNetworkpagesRouteRouteWithChildren
  clientProfilepagesRouteRoute: typeof clientProfilepagesRouteRouteWithChildren
  clientQuestionnairespagesRouteRoute: typeof clientQuestionnairespagesRouteRouteWithChildren
  clientReportpagesRouteRoute: typeof clientReportpagesRouteRouteWithChildren
  clientSlcppagesRouteRoute: typeof clientSlcppagesRouteRouteWithChildren
  clientOrdersHubpagesCreateRoute: typeof clientOrdersHubpagesCreateRoute
  clientActivityFeedpagesIndexRoute: typeof clientActivityFeedpagesIndexRoute
  clientAutomationRulespagesIndexRoute: typeof clientAutomationRulespagesIndexRoute
  clientDashboardpagesIndexRoute: typeof clientDashboardpagesIndexRoute
  clientOrdersHubpagesIndexRoute: typeof clientOrdersHubpagesIndexRoute
  clientOrdersHubpagesdetailIdRouteRoute: typeof clientOrdersHubpagesdetailIdRouteRouteWithChildren
  clientUserspagesIdIndexRoute: typeof clientUserspagesIdIndexRoute
}

const clientRouteRouteChildren: clientRouteRouteChildren = {
  clientAuditsRouteRoute: clientAuditsRouteRouteWithChildren,
  clientEntityScreeningRouteRoute: clientEntityScreeningRouteRouteWithChildren,
  clientFilesRouteRoute: clientFilesRouteRouteWithChildren,
  clientMyComponentsRouteRoute: clientMyComponentsRouteRouteWithChildren,
  clientMyStylesRouteRoute: clientMyStylesRouteRouteWithChildren,
  clientOrdersRouteRoute: clientOrdersRouteRouteWithChildren,
  clientProductMappingRouteRoute: clientProductMappingRouteRouteWithChildren,
  clientRiskRouteRoute: clientRiskRouteRouteWithChildren,
  clientSupplyChainMappingRouteRoute:
    clientSupplyChainMappingRouteRouteWithChildren,
  clientCapapagesRouteRoute: clientCapapagesRouteRouteWithChildren,
  clientCertificationspagesRouteRoute:
    clientCertificationspagesRouteRouteWithChildren,
  clientCertifiedMaterialspagesRouteRoute:
    clientCertifiedMaterialspagesRouteRouteWithChildren,
  clientCompanySettingspagesRouteRoute:
    clientCompanySettingspagesRouteRouteWithChildren,
  clientDocumentspagesRouteRoute: clientDocumentspagesRouteRouteWithChildren,
  clientNetworkpagesRouteRoute: clientNetworkpagesRouteRouteWithChildren,
  clientProfilepagesRouteRoute: clientProfilepagesRouteRouteWithChildren,
  clientQuestionnairespagesRouteRoute:
    clientQuestionnairespagesRouteRouteWithChildren,
  clientReportpagesRouteRoute: clientReportpagesRouteRouteWithChildren,
  clientSlcppagesRouteRoute: clientSlcppagesRouteRouteWithChildren,
  clientOrdersHubpagesCreateRoute: clientOrdersHubpagesCreateRoute,
  clientActivityFeedpagesIndexRoute: clientActivityFeedpagesIndexRoute,
  clientAutomationRulespagesIndexRoute: clientAutomationRulespagesIndexRoute,
  clientDashboardpagesIndexRoute: clientDashboardpagesIndexRoute,
  clientOrdersHubpagesIndexRoute: clientOrdersHubpagesIndexRoute,
  clientOrdersHubpagesdetailIdRouteRoute:
    clientOrdersHubpagesdetailIdRouteRouteWithChildren,
  clientUserspagesIdIndexRoute: clientUserspagesIdIndexRoute,
}

const clientRouteRouteWithChildren = clientRouteRoute._addFileChildren(
  clientRouteRouteChildren,
)

interface ManagementRiskManagementpageslistRouteRouteChildren {
  ManagementRiskManagementpageslistRiskGrossIndexRoute: typeof ManagementRiskManagementpageslistRiskGrossIndexRoute
  ManagementRiskManagementpageslistRisksIndexRoute: typeof ManagementRiskManagementpageslistRisksIndexRoute
  ManagementRiskManagementpageslistRuleTemplatesIndexRoute: typeof ManagementRiskManagementpageslistRuleTemplatesIndexRoute
}

const ManagementRiskManagementpageslistRouteRouteChildren: ManagementRiskManagementpageslistRouteRouteChildren =
  {
    ManagementRiskManagementpageslistRiskGrossIndexRoute:
      ManagementRiskManagementpageslistRiskGrossIndexRoute,
    ManagementRiskManagementpageslistRisksIndexRoute:
      ManagementRiskManagementpageslistRisksIndexRoute,
    ManagementRiskManagementpageslistRuleTemplatesIndexRoute:
      ManagementRiskManagementpageslistRuleTemplatesIndexRoute,
  }

const ManagementRiskManagementpageslistRouteRouteWithChildren =
  ManagementRiskManagementpageslistRouteRoute._addFileChildren(
    ManagementRiskManagementpageslistRouteRouteChildren,
  )

interface ManagementRiskManagementpagesRouteRouteChildren {
  ManagementRiskManagementpageslistRouteRoute: typeof ManagementRiskManagementpageslistRouteRouteWithChildren
  ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute: typeof ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute
}

const ManagementRiskManagementpagesRouteRouteChildren: ManagementRiskManagementpagesRouteRouteChildren =
  {
    ManagementRiskManagementpageslistRouteRoute:
      ManagementRiskManagementpageslistRouteRouteWithChildren,
    ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute:
      ManagementRiskManagementpagesRuleTemplatesIdEditIndexRoute,
  }

const ManagementRiskManagementpagesRouteRouteWithChildren =
  ManagementRiskManagementpagesRouteRoute._addFileChildren(
    ManagementRiskManagementpagesRouteRouteChildren,
  )

interface ManagementCertificationspageslistRouteRouteChildren {
  ManagementCertificationspageslistActiveIndexRoute: typeof ManagementCertificationspageslistActiveIndexRoute
  ManagementCertificationspageslistArchivedIndexRoute: typeof ManagementCertificationspageslistArchivedIndexRoute
}

const ManagementCertificationspageslistRouteRouteChildren: ManagementCertificationspageslistRouteRouteChildren =
  {
    ManagementCertificationspageslistActiveIndexRoute:
      ManagementCertificationspageslistActiveIndexRoute,
    ManagementCertificationspageslistArchivedIndexRoute:
      ManagementCertificationspageslistArchivedIndexRoute,
  }

const ManagementCertificationspageslistRouteRouteWithChildren =
  ManagementCertificationspageslistRouteRoute._addFileChildren(
    ManagementCertificationspageslistRouteRouteChildren,
  )

interface ManagementCompaniespagesCompanyIdRouteRouteChildren {
  ManagementCompaniespagesCompanyIdIndexRoute: typeof ManagementCompaniespagesCompanyIdIndexRoute
  ManagementCompaniespagesCompanyIdApiKeysIndexRoute: typeof ManagementCompaniespagesCompanyIdApiKeysIndexRoute
  ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute: typeof ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute
  ManagementCompaniespagesCompanyIdCreditsIndexRoute: typeof ManagementCompaniespagesCompanyIdCreditsIndexRoute
  ManagementCompaniespagesCompanyIdEmployeesIndexRoute: typeof ManagementCompaniespagesCompanyIdEmployeesIndexRoute
  ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute: typeof ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute
  ManagementCompaniespagesCompanyIdNetworkIndexRoute: typeof ManagementCompaniespagesCompanyIdNetworkIndexRoute
  ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute: typeof ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute
  ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute: typeof ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute
  ManagementCompaniespagesCompanyIdTechInsightsIndexRoute: typeof ManagementCompaniespagesCompanyIdTechInsightsIndexRoute
  ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute: typeof ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute
}

const ManagementCompaniespagesCompanyIdRouteRouteChildren: ManagementCompaniespagesCompanyIdRouteRouteChildren =
  {
    ManagementCompaniespagesCompanyIdIndexRoute:
      ManagementCompaniespagesCompanyIdIndexRoute,
    ManagementCompaniespagesCompanyIdApiKeysIndexRoute:
      ManagementCompaniespagesCompanyIdApiKeysIndexRoute,
    ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute:
      ManagementCompaniespagesCompanyIdAutomationRulesIndexRoute,
    ManagementCompaniespagesCompanyIdCreditsIndexRoute:
      ManagementCompaniespagesCompanyIdCreditsIndexRoute,
    ManagementCompaniespagesCompanyIdEmployeesIndexRoute:
      ManagementCompaniespagesCompanyIdEmployeesIndexRoute,
    ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute:
      ManagementCompaniespagesCompanyIdGeneralInfoIndexRoute,
    ManagementCompaniespagesCompanyIdNetworkIndexRoute:
      ManagementCompaniespagesCompanyIdNetworkIndexRoute,
    ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute:
      ManagementCompaniespagesCompanyIdPlatformFeaturesIndexRoute,
    ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute:
      ManagementCompaniespagesCompanyIdSupplyChainsIndexRoute,
    ManagementCompaniespagesCompanyIdTechInsightsIndexRoute:
      ManagementCompaniespagesCompanyIdTechInsightsIndexRoute,
    ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute:
      ManagementCompaniespagesCompanyIdTracingOrdersIndexRoute,
  }

const ManagementCompaniespagesCompanyIdRouteRouteWithChildren =
  ManagementCompaniespagesCompanyIdRouteRoute._addFileChildren(
    ManagementCompaniespagesCompanyIdRouteRouteChildren,
  )

interface ManagementDocumentspageslistRouteRouteChildren {
  ManagementDocumentspageslistActiveIndexRoute: typeof ManagementDocumentspageslistActiveIndexRoute
  ManagementDocumentspageslistArchivedIndexRoute: typeof ManagementDocumentspageslistArchivedIndexRoute
}

const ManagementDocumentspageslistRouteRouteChildren: ManagementDocumentspageslistRouteRouteChildren =
  {
    ManagementDocumentspageslistActiveIndexRoute:
      ManagementDocumentspageslistActiveIndexRoute,
    ManagementDocumentspageslistArchivedIndexRoute:
      ManagementDocumentspageslistArchivedIndexRoute,
  }

const ManagementDocumentspageslistRouteRouteWithChildren =
  ManagementDocumentspageslistRouteRoute._addFileChildren(
    ManagementDocumentspageslistRouteRouteChildren,
  )

interface ManagementScoringTemplatespageslistRouteRouteChildren {
  ManagementScoringTemplatespageslistIndexRoute: typeof ManagementScoringTemplatespageslistIndexRoute
  ManagementScoringTemplatespageslistGapsIndexRoute: typeof ManagementScoringTemplatespageslistGapsIndexRoute
}

const ManagementScoringTemplatespageslistRouteRouteChildren: ManagementScoringTemplatespageslistRouteRouteChildren =
  {
    ManagementScoringTemplatespageslistIndexRoute:
      ManagementScoringTemplatespageslistIndexRoute,
    ManagementScoringTemplatespageslistGapsIndexRoute:
      ManagementScoringTemplatespageslistGapsIndexRoute,
  }

const ManagementScoringTemplatespageslistRouteRouteWithChildren =
  ManagementScoringTemplatespageslistRouteRoute._addFileChildren(
    ManagementScoringTemplatespageslistRouteRouteChildren,
  )

interface ManagementRouteRouteChildren {
  ManagementRiskManagementpagesRouteRoute: typeof ManagementRiskManagementpagesRouteRouteWithChildren
  ManagementCertificationspageslistRouteRoute: typeof ManagementCertificationspageslistRouteRouteWithChildren
  ManagementCompaniespagesCompanyIdRouteRoute: typeof ManagementCompaniespagesCompanyIdRouteRouteWithChildren
  ManagementDocumentspageslistRouteRoute: typeof ManagementDocumentspageslistRouteRouteWithChildren
  ManagementScoringTemplatespageslistRouteRoute: typeof ManagementScoringTemplatespageslistRouteRouteWithChildren
  ManagementAttachmentTemplatespagesIndexRoute: typeof ManagementAttachmentTemplatespagesIndexRoute
  ManagementAuditTypespagesIndexRoute: typeof ManagementAuditTypespagesIndexRoute
  ManagementAuditspagesIndexRoute: typeof ManagementAuditspagesIndexRoute
  ManagementBackgroundJobspagesIndexRoute: typeof ManagementBackgroundJobspagesIndexRoute
  ManagementBadgespagesIndexRoute: typeof ManagementBadgespagesIndexRoute
  ManagementCompaniespagesIndexRoute: typeof ManagementCompaniespagesIndexRoute
  ManagementCompanyMergespagesIndexRoute: typeof ManagementCompanyMergespagesIndexRoute
  ManagementCsToolspagesIndexRoute: typeof ManagementCsToolspagesIndexRoute
  ManagementCustomInformationFieldspagesIndexRoute: typeof ManagementCustomInformationFieldspagesIndexRoute
  ManagementDocumentTypespagesIndexRoute: typeof ManagementDocumentTypespagesIndexRoute
  ManagementEmailBounceTrackingpagesIndexRoute: typeof ManagementEmailBounceTrackingpagesIndexRoute
  ManagementEntityHistorypagesIndexRoute: typeof ManagementEntityHistorypagesIndexRoute
  ManagementFacilityProcessespagesIndexRoute: typeof ManagementFacilityProcessespagesIndexRoute
  ManagementImpersonatepagesIndexRoute: typeof ManagementImpersonatepagesIndexRoute
  ManagementMaterialspagesIndexRoute: typeof ManagementMaterialspagesIndexRoute
  ManagementOriginspagesIndexRoute: typeof ManagementOriginspagesIndexRoute
  ManagementPermissionspagesIndexRoute: typeof ManagementPermissionspagesIndexRoute
  ManagementPlatformFeaturespagesIndexRoute: typeof ManagementPlatformFeaturespagesIndexRoute
  ManagementProductCategoriespagesIndexRoute: typeof ManagementProductCategoriespagesIndexRoute
  ManagementProductDataPointspagesIndexRoute: typeof ManagementProductDataPointspagesIndexRoute
  ManagementProductionProcessespagesIndexRoute: typeof ManagementProductionProcessespagesIndexRoute
  ManagementRulespagesIndexRoute: typeof ManagementRulespagesIndexRoute
  ManagementSlcpDashboardpagesIndexRoute: typeof ManagementSlcpDashboardpagesIndexRoute
  ManagementSsopagesIndexRoute: typeof ManagementSsopagesIndexRoute
  ManagementStandardspagesIndexRoute: typeof ManagementStandardspagesIndexRoute
  ManagementSupplierQuestionnaireTemplatespagesIndexRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIndexRoute
  ManagementTranslationspagesIndexRoute: typeof ManagementTranslationspagesIndexRoute
  ManagementUserspagesIndexRoute: typeof ManagementUserspagesIndexRoute
  ManagementWebshopspagesIndexRoute: typeof ManagementWebshopspagesIndexRoute
  ManagementAttachmentTemplatespagesIdIndexRoute: typeof ManagementAttachmentTemplatespagesIdIndexRoute
  ManagementAttachmentTemplatespagesCreateIndexRoute: typeof ManagementAttachmentTemplatespagesCreateIndexRoute
  ManagementCertificationspagesIdIndexRoute: typeof ManagementCertificationspagesIdIndexRoute
  ManagementCompanyMergespagesMergeIdIndexRoute: typeof ManagementCompanyMergespagesMergeIdIndexRoute
  ManagementCompanyMergespagesNewIndexRoute: typeof ManagementCompanyMergespagesNewIndexRoute
  ManagementEntityHistorypagesIdIndexRoute: typeof ManagementEntityHistorypagesIdIndexRoute
  ManagementPlatformFeaturespagesFeatureIdIndexRoute: typeof ManagementPlatformFeaturespagesFeatureIdIndexRoute
  ManagementSsopagesIdIndexRoute: typeof ManagementSsopagesIdIndexRoute
  ManagementUserspagesIdIndexRoute: typeof ManagementUserspagesIdIndexRoute
  ManagementAttachmentTemplatespagesIdEditIndexRoute: typeof ManagementAttachmentTemplatespagesIdEditIndexRoute
  ManagementProductCategoriespagesCategoryIdFieldsIndexRoute: typeof ManagementProductCategoriespagesCategoryIdFieldsIndexRoute
  ManagementScoringTemplatespagesIdEditIndexRoute: typeof ManagementScoringTemplatespagesIdEditIndexRoute
  ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute
  ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute: typeof ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute
}

const ManagementRouteRouteChildren: ManagementRouteRouteChildren = {
  ManagementRiskManagementpagesRouteRoute:
    ManagementRiskManagementpagesRouteRouteWithChildren,
  ManagementCertificationspageslistRouteRoute:
    ManagementCertificationspageslistRouteRouteWithChildren,
  ManagementCompaniespagesCompanyIdRouteRoute:
    ManagementCompaniespagesCompanyIdRouteRouteWithChildren,
  ManagementDocumentspageslistRouteRoute:
    ManagementDocumentspageslistRouteRouteWithChildren,
  ManagementScoringTemplatespageslistRouteRoute:
    ManagementScoringTemplatespageslistRouteRouteWithChildren,
  ManagementAttachmentTemplatespagesIndexRoute:
    ManagementAttachmentTemplatespagesIndexRoute,
  ManagementAuditTypespagesIndexRoute: ManagementAuditTypespagesIndexRoute,
  ManagementAuditspagesIndexRoute: ManagementAuditspagesIndexRoute,
  ManagementBackgroundJobspagesIndexRoute:
    ManagementBackgroundJobspagesIndexRoute,
  ManagementBadgespagesIndexRoute: ManagementBadgespagesIndexRoute,
  ManagementCompaniespagesIndexRoute: ManagementCompaniespagesIndexRoute,
  ManagementCompanyMergespagesIndexRoute:
    ManagementCompanyMergespagesIndexRoute,
  ManagementCsToolspagesIndexRoute: ManagementCsToolspagesIndexRoute,
  ManagementCustomInformationFieldspagesIndexRoute:
    ManagementCustomInformationFieldspagesIndexRoute,
  ManagementDocumentTypespagesIndexRoute:
    ManagementDocumentTypespagesIndexRoute,
  ManagementEmailBounceTrackingpagesIndexRoute:
    ManagementEmailBounceTrackingpagesIndexRoute,
  ManagementEntityHistorypagesIndexRoute:
    ManagementEntityHistorypagesIndexRoute,
  ManagementFacilityProcessespagesIndexRoute:
    ManagementFacilityProcessespagesIndexRoute,
  ManagementImpersonatepagesIndexRoute: ManagementImpersonatepagesIndexRoute,
  ManagementMaterialspagesIndexRoute: ManagementMaterialspagesIndexRoute,
  ManagementOriginspagesIndexRoute: ManagementOriginspagesIndexRoute,
  ManagementPermissionspagesIndexRoute: ManagementPermissionspagesIndexRoute,
  ManagementPlatformFeaturespagesIndexRoute:
    ManagementPlatformFeaturespagesIndexRoute,
  ManagementProductCategoriespagesIndexRoute:
    ManagementProductCategoriespagesIndexRoute,
  ManagementProductDataPointspagesIndexRoute:
    ManagementProductDataPointspagesIndexRoute,
  ManagementProductionProcessespagesIndexRoute:
    ManagementProductionProcessespagesIndexRoute,
  ManagementRulespagesIndexRoute: ManagementRulespagesIndexRoute,
  ManagementSlcpDashboardpagesIndexRoute:
    ManagementSlcpDashboardpagesIndexRoute,
  ManagementSsopagesIndexRoute: ManagementSsopagesIndexRoute,
  ManagementStandardspagesIndexRoute: ManagementStandardspagesIndexRoute,
  ManagementSupplierQuestionnaireTemplatespagesIndexRoute:
    ManagementSupplierQuestionnaireTemplatespagesIndexRoute,
  ManagementTranslationspagesIndexRoute: ManagementTranslationspagesIndexRoute,
  ManagementUserspagesIndexRoute: ManagementUserspagesIndexRoute,
  ManagementWebshopspagesIndexRoute: ManagementWebshopspagesIndexRoute,
  ManagementAttachmentTemplatespagesIdIndexRoute:
    ManagementAttachmentTemplatespagesIdIndexRoute,
  ManagementAttachmentTemplatespagesCreateIndexRoute:
    ManagementAttachmentTemplatespagesCreateIndexRoute,
  ManagementCertificationspagesIdIndexRoute:
    ManagementCertificationspagesIdIndexRoute,
  ManagementCompanyMergespagesMergeIdIndexRoute:
    ManagementCompanyMergespagesMergeIdIndexRoute,
  ManagementCompanyMergespagesNewIndexRoute:
    ManagementCompanyMergespagesNewIndexRoute,
  ManagementEntityHistorypagesIdIndexRoute:
    ManagementEntityHistorypagesIdIndexRoute,
  ManagementPlatformFeaturespagesFeatureIdIndexRoute:
    ManagementPlatformFeaturespagesFeatureIdIndexRoute,
  ManagementSsopagesIdIndexRoute: ManagementSsopagesIdIndexRoute,
  ManagementUserspagesIdIndexRoute: ManagementUserspagesIdIndexRoute,
  ManagementAttachmentTemplatespagesIdEditIndexRoute:
    ManagementAttachmentTemplatespagesIdEditIndexRoute,
  ManagementProductCategoriespagesCategoryIdFieldsIndexRoute:
    ManagementProductCategoriespagesCategoryIdFieldsIndexRoute,
  ManagementScoringTemplatespagesIdEditIndexRoute:
    ManagementScoringTemplatespagesIdEditIndexRoute,
  ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute:
    ManagementSupplierQuestionnaireTemplatespagesIdEditIndexRoute,
  ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute:
    ManagementSupplierQuestionnaireTemplatespagesIdPreviewIndexRoute,
}

const ManagementRouteRouteWithChildren = ManagementRouteRoute._addFileChildren(
  ManagementRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  clientRouteRoute: clientRouteRouteWithChildren,
  ManagementRouteRoute: ManagementRouteRouteWithChildren,
  DocsIndexRoute: DocsIndexRoute,
  loginpagesIndexRoute: loginpagesIndexRoute,
  loginSingleSignOnCallbackIndexRoute: loginSingleSignOnCallbackIndexRoute,
  UnsubscribepagesIndexRoute: UnsubscribepagesIndexRoute,
  DocsComponentsSlugIndexRoute: DocsComponentsSlugIndexRoute,
  DocsFoundationsSlugIndexRoute: DocsFoundationsSlugIndexRoute,
  DocsGuidesSlugIndexRoute: DocsGuidesSlugIndexRoute,
  DocsPatternsSlugIndexRoute: DocsPatternsSlugIndexRoute,
  OnboardingCompanySearchpagesIndexRoute:
    OnboardingCompanySearchpagesIndexRoute,
  SsoOnboardingpagesTokenIndexRoute: SsoOnboardingpagesTokenIndexRoute,
  SsoOnboardingpagesTestResultIndexRoute:
    SsoOnboardingpagesTestResultIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
